'use strict';

/**
 * Copyright (c) 2024 Salesforce, Inc.
 */
/**
 * Copyright (c) 2024 Salesforce, Inc.
 */
/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 *
 * @param value
 * @param msg
 */
var _globalThis$__lwc_ins, _globalThis$__lwc_ins2, _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf2(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf2(o) { _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf2(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function invariant(value, msg) {
  if (!value) {
    throw new Error("Invariant Violation: ".concat(msg));
  }
}
/**
 *
 * @param value
 * @param msg
 */
function isTrue$1(value, msg) {
  if (!value) {
    throw new Error("Assert Violation: ".concat(msg));
  }
}
/**
 *
 * @param value
 * @param msg
 */
function isFalse$1(value, msg) {
  if (value) {
    throw new Error("Assert Violation: ".concat(msg));
  }
}
/**
 *
 * @param msg
 */
function fail(msg) {
  throw new Error(msg);
}
var assert = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fail: fail,
  invariant: invariant,
  isFalse: isFalse$1,
  isTrue: isTrue$1
});

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var assign = Object.assign,
  create = Object.create,
  defineProperties = Object.defineProperties,
  defineProperty = Object.defineProperty,
  entries = Object.entries,
  freeze = Object.freeze,
  getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor,
  getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors,
  getOwnPropertyNames$1 = Object.getOwnPropertyNames,
  getPrototypeOf$1 = Object.getPrototypeOf,
  hasOwnProperty$1 = Object.hasOwnProperty,
  isFrozen = Object.isFrozen,
  keys = Object.keys,
  seal = Object.seal,
  setPrototypeOf = Object.setPrototypeOf;
/** Detached {@linkcode Array.isArray}; see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray MDN Reference}. */
var isArray$1 = Array.isArray;
// For some reason, JSDoc don't get picked up for multiple renamed destructured constants (even
// though it works fine for one, e.g. isArray), so comments for these are added to the export
// statement, rather than this declaration.
var _Array$prototype = Array.prototype,
  ArrayConcat$1 = _Array$prototype.concat,
  ArrayCopyWithin = _Array$prototype.copyWithin,
  ArrayEvery = _Array$prototype.every,
  ArrayFill = _Array$prototype.fill,
  ArrayFilter = _Array$prototype.filter,
  ArrayFind = _Array$prototype.find,
  ArrayFindIndex = _Array$prototype.findIndex,
  ArrayIncludes = _Array$prototype.includes,
  ArrayIndexOf = _Array$prototype.indexOf,
  ArrayJoin = _Array$prototype.join,
  ArrayMap = _Array$prototype.map,
  ArrayPop = _Array$prototype.pop,
  ArrayPush$1 = _Array$prototype.push,
  ArrayReduce = _Array$prototype.reduce,
  ArrayReverse = _Array$prototype.reverse,
  ArrayShift = _Array$prototype.shift,
  ArraySlice = _Array$prototype.slice,
  ArraySome = _Array$prototype.some,
  ArraySort = _Array$prototype.sort,
  ArraySplice = _Array$prototype.splice,
  ArrayUnshift = _Array$prototype.unshift,
  forEach = _Array$prototype.forEach;
/** Detached {@linkcode String.fromCharCode}; see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCharCode MDN Reference}. */
var StringFromCharCode = String.fromCharCode;
// No JSDocs here - see comment for Array.prototype
var _String$prototype = String.prototype,
  StringCharAt = _String$prototype.charAt,
  StringCharCodeAt = _String$prototype.charCodeAt,
  StringReplace = _String$prototype.replace,
  StringSplit = _String$prototype.split,
  StringSlice = _String$prototype.slice,
  StringToLowerCase = _String$prototype.toLowerCase;
/**
 * Determines whether the argument is `undefined`.
 * @param obj Value to test
 * @returns `true` if the value is `undefined`.
 */
function isUndefined$1(obj) {
  return obj === undefined;
}
/**
 * Determines whether the argument is `null`.
 * @param obj Value to test
 * @returns `true` if the value is `null`.
 */
function isNull(obj) {
  return obj === null;
}
/**
 * Determines whether the argument is `true`.
 * @param obj Value to test
 * @returns `true` if the value is `true`.
 */
function isTrue(obj) {
  return obj === true;
}
/**
 * Determines whether the argument is `false`.
 * @param obj Value to test
 * @returns `true` if the value is `false`.
 */
function isFalse(obj) {
  return obj === false;
}
/**
 * Determines whether the argument is a function.
 * @param obj Value to test
 * @returns `true` if the value is a function.
 */
// Replacing `Function` with a narrower type that works for all our use cases is tricky...
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction$1(obj) {
  return typeof obj === 'function';
}
/**
 * Determines whether the argument is an object or null.
 * @param obj Value to test
 * @returns `true` if the value is an object or null.
 */
function isObject(obj) {
  return _typeof(obj) === 'object';
}
/**
 * Determines whether the argument is a string.
 * @param obj Value to test
 * @returns `true` if the value is a string.
 */
function isString(obj) {
  return typeof obj === 'string';
}
/**
 * Determines whether the argument is a number.
 * @param obj Value to test
 * @returns `true` if the value is a number.
 */
function isNumber(obj) {
  return typeof obj === 'number';
}
/** Does nothing! 🚀 */
function noop() {
  /* Do nothing */
}
var OtS$1 = {}.toString;
/**
 * Converts the argument to a string, safely accounting for objects with "null" prototype.
 * Note that `toString(null)` returns `"[object Null]"` rather than `"null"`.
 * @param obj Value to convert to a string.
 * @returns String representation of the value.
 */
function toString$1(obj) {
  if (obj !== null && obj !== void 0 && obj.toString) {
    // Arrays might hold objects with "null" prototype So using
    // Array.prototype.toString directly will cause an error Iterate through
    // all the items and handle individually.
    if (isArray$1(obj)) {
      // This behavior is slightly different from Array#toString:
      // 1. Array#toString calls `this.join`, rather than Array#join
      // Ex: arr = []; arr.join = () => 1; arr.toString() === 1; toString(arr) === ''
      // 2. Array#toString delegates to Object#toString if `this.join` is not a function
      // Ex: arr = []; arr.join = 'no'; arr.toString() === '[object Array]; toString(arr) = ''
      // 3. Array#toString converts null/undefined to ''
      // Ex: arr = [null, undefined]; arr.toString() === ','; toString(arr) === '[object Null],undefined'
      // 4. Array#toString converts recursive references to arrays to ''
      // Ex: arr = [1]; arr.push(arr, 2); arr.toString() === '1,,2'; toString(arr) throws
      // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toString
      return ArrayJoin.call(ArrayMap.call(obj, toString$1), ',');
    }
    return obj.toString();
  } else if (_typeof(obj) === 'object') {
    // This catches null and returns "[object Null]". Weird, but kept for backwards compatibility.
    return OtS$1.call(obj);
  } else {
    return String(obj);
  }
}
/**
 * Gets the property descriptor for the given object and property key. Similar to
 * {@linkcode Object.getOwnPropertyDescriptor}, but looks up the prototype chain.
 * @param o Value to get the property descriptor for
 * @param p Property key to get the descriptor for
 * @returns The property descriptor for the given object and property key.
 */
function getPropertyDescriptor(o, p) {
  do {
    var _d = getOwnPropertyDescriptor$1(o, p);
    if (!isUndefined$1(_d)) {
      return _d;
    }
    o = getPrototypeOf$1(o);
  } while (o !== null);
}

/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// These must be updated when the enum is updated.
// It's a bit annoying to do have to do this manually, but this makes the file tree-shakeable,
// passing the `verify-treeshakeable.js` test.
var allVersions = [58 /* APIVersion.V58_244_SUMMER_23 */, 59 /* APIVersion.V59_246_WINTER_24 */, 60 /* APIVersion.V60_248_SPRING_24 */, 61 /* APIVersion.V61_250_SUMMER_24 */, 62 /* APIVersion.V62_252_WINTER_25 */];
var LOWEST_API_VERSION = allVersions[0];
/**
 *
 * @param apiVersionFeature
 * @param apiVersion
 */
function isAPIFeatureEnabled(apiVersionFeature, apiVersion) {
  switch (apiVersionFeature) {
    case 0 /* APIFeature.LOWERCASE_SCOPE_TOKENS */:
    case 1 /* APIFeature.TREAT_ALL_PARSE5_ERRORS_AS_ERRORS */:
      return apiVersion >= 59 /* APIVersion.V59_246_WINTER_24 */;
    case 3 /* APIFeature.DISABLE_OBJECT_REST_SPREAD_TRANSFORMATION */:
    case 4 /* APIFeature.SKIP_UNNECESSARY_REGISTER_DECORATORS */:
    case 5 /* APIFeature.USE_COMMENTS_FOR_FRAGMENT_BOOKENDS */:
    case 2 /* APIFeature.USE_FRAGMENTS_FOR_LIGHT_DOM_SLOTS */:
      return apiVersion >= 60 /* APIVersion.V60_248_SPRING_24 */;
    case 8 /* APIFeature.ENABLE_ELEMENT_INTERNALS_AND_FACE */:
    case 7 /* APIFeature.ENABLE_NATIVE_CUSTOM_ELEMENT_LIFECYCLE */:
    case 6 /* APIFeature.USE_LIGHT_DOM_SLOT_FORWARDING */:
      return apiVersion >= 61 /* APIVersion.V61_250_SUMMER_24 */;
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * According to the following list, there are 48 aria attributes of which two (ariaDropEffect and
 * ariaGrabbed) are deprecated:
 * https://www.w3.org/TR/wai-aria-1.1/#x6-6-definitions-of-states-and-properties-all-aria-attributes
 *
 * The above list of 46 aria attributes is consistent with the following resources:
 * https://github.com/w3c/aria/pull/708/files#diff-eacf331f0ffc35d4b482f1d15a887d3bR11060
 * https://wicg.github.io/aom/spec/aria-reflection.html
 *
 * NOTE: If you update this list, please update test files that implicitly reference this list!
 * Searching the codebase for `aria-flowto` and `ariaFlowTo` should be good enough to find all usages.
 */
var AriaPropertyNames = ['ariaActiveDescendant', 'ariaAtomic', 'ariaAutoComplete', 'ariaBusy', 'ariaChecked', 'ariaColCount', 'ariaColIndex', 'ariaColIndexText', 'ariaColSpan', 'ariaControls', 'ariaCurrent', 'ariaDescribedBy', 'ariaDescription', 'ariaDetails', 'ariaDisabled', 'ariaErrorMessage', 'ariaExpanded', 'ariaFlowTo', 'ariaHasPopup', 'ariaHidden', 'ariaInvalid', 'ariaKeyShortcuts', 'ariaLabel', 'ariaLabelledBy', 'ariaLevel', 'ariaLive', 'ariaModal', 'ariaMultiLine', 'ariaMultiSelectable', 'ariaOrientation', 'ariaOwns', 'ariaPlaceholder', 'ariaPosInSet', 'ariaPressed', 'ariaReadOnly', 'ariaRelevant', 'ariaRequired', 'ariaRoleDescription', 'ariaRowCount', 'ariaRowIndex', 'ariaRowIndexText', 'ariaRowSpan', 'ariaSelected', 'ariaSetSize', 'ariaSort', 'ariaValueMax', 'ariaValueMin', 'ariaValueNow', 'ariaValueText', 'ariaBrailleLabel', 'ariaBrailleRoleDescription', 'role'];
var _ref = /*@__PURE__*/function () {
    var AriaAttrNameToPropNameMap = create(null);
    var AriaPropNameToAttrNameMap = create(null);
    // Synthetic creation of all AOM property descriptors for Custom Elements
    forEach.call(AriaPropertyNames, function (propName) {
      var attrName = StringToLowerCase.call(StringReplace.call(propName, /^aria/, function () {
        return 'aria-';
      }));
      AriaAttrNameToPropNameMap[attrName] = propName;
      AriaPropNameToAttrNameMap[propName] = attrName;
    });
    return {
      AriaAttrNameToPropNameMap: AriaAttrNameToPropNameMap,
      AriaPropNameToAttrNameMap: AriaPropNameToAttrNameMap
    };
  }(),
  AriaAttrNameToPropNameMap = _ref.AriaAttrNameToPropNameMap,
  AriaPropNameToAttrNameMap = _ref.AriaPropNameToAttrNameMap;
// These attributes take either an ID or a list of IDs as values.
// This includes aria-* attributes as well as the special non-ARIA "for" attribute
var ID_REFERENCING_ATTRIBUTES_SET = /*@__PURE__*/new Set(['aria-activedescendant', 'aria-controls', 'aria-describedby', 'aria-details', 'aria-errormessage', 'aria-flowto', 'aria-labelledby', 'aria-owns', 'for']);

/*
 * Copyright (c) 2023, Salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var KEY__SHADOW_RESOLVER = '$shadowResolver$';
var KEY__SHADOW_STATIC = '$shadowStaticNode$';
var KEY__SHADOW_TOKEN = '$shadowToken$';
var KEY__SYNTHETIC_MODE = '$$lwc-synthetic-mode';
var KEY__SCOPED_CSS = '$scoped$';
var KEY__NATIVE_GET_ELEMENT_BY_ID = '$nativeGetElementById$';
var KEY__NATIVE_QUERY_SELECTOR_ALL = '$nativeQuerySelectorAll$';
var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var XLINK_NAMESPACE = 'http://www.w3.org/1999/xlink';

/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var CAMEL_REGEX = /-([a-z])/g;
// These are HTML standard prop/attribute IDL mappings, but are not predictable based on camel/kebab-case conversion
var SPECIAL_PROPERTY_ATTRIBUTE_MAPPING = /*@__PURE__@*/new Map([['accessKey', 'accesskey'], ['readOnly', 'readonly'], ['tabIndex', 'tabindex'], ['bgColor', 'bgcolor'], ['colSpan', 'colspan'], ['rowSpan', 'rowspan'], ['contentEditable', 'contenteditable'], ['crossOrigin', 'crossorigin'], ['dateTime', 'datetime'], ['formAction', 'formaction'], ['isMap', 'ismap'], ['maxLength', 'maxlength'], ['minLength', 'minlength'], ['noValidate', 'novalidate'], ['useMap', 'usemap'], ['htmlFor', 'for']]);
/**
 * Map associating previously transformed HTML property into HTML attribute.
 */
var CACHED_PROPERTY_ATTRIBUTE_MAPPING = /*@__PURE__@*/new Map();
/**
 *
 * @param propName
 */
function htmlPropertyToAttribute(propName) {
  var ariaAttributeName = AriaPropNameToAttrNameMap[propName];
  if (!isUndefined$1(ariaAttributeName)) {
    return ariaAttributeName;
  }
  var specialAttributeName = SPECIAL_PROPERTY_ATTRIBUTE_MAPPING.get(propName);
  if (!isUndefined$1(specialAttributeName)) {
    return specialAttributeName;
  }
  var cachedAttributeName = CACHED_PROPERTY_ATTRIBUTE_MAPPING.get(propName);
  if (!isUndefined$1(cachedAttributeName)) {
    return cachedAttributeName;
  }
  var attributeName = '';
  for (var _i = 0, len = propName.length; _i < len; _i++) {
    var code = StringCharCodeAt.call(propName, _i);
    if (code >= 65 &&
    // "A"
    code <= 90 // "Z"
    ) {
      attributeName += '-' + StringFromCharCode(code + 32);
    } else {
      attributeName += StringFromCharCode(code);
    }
  }
  CACHED_PROPERTY_ATTRIBUTE_MAPPING.set(propName, attributeName);
  return attributeName;
}
/**
 * Map associating previously transformed kabab-case attributes into camel-case props.
 */
var CACHED_KEBAB_CAMEL_MAPPING = /*@__PURE__@*/new Map();
/**
 *
 * @param attrName
 */
function kebabCaseToCamelCase(attrName) {
  var result = CACHED_KEBAB_CAMEL_MAPPING.get(attrName);
  if (isUndefined$1(result)) {
    result = StringReplace.call(attrName, CAMEL_REGEX, function (g) {
      return g[1].toUpperCase();
    });
    CACHED_KEBAB_CAMEL_MAPPING.set(attrName, result);
  }
  return result;
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// Increment whenever the LWC template compiler changes
var LWC_VERSION = "6.6.3";
var LWC_VERSION_COMMENT_REGEX = /\/\*LWC compiler v([\d.]+)\*\/\s*}/;
if (!globalThis.lwcRuntimeFlags) {
  Object.defineProperty(globalThis, 'lwcRuntimeFlags', {
    value: create(null)
  });
}
/**
 * Whether reporting is enabled.
 *
 * Note that this may seem redundant, given you can just check if the currentDispatcher is undefined,
 * but it turns out that Terser only strips out unused code if we use this explicit boolean.
 */
var enabled$1 = false;
/**
 * Report to the current dispatcher, if there is one.
 * @param reportingEventId
 * @param payload data to report
 */
function report(reportingEventId, payload) {}
/**
 * Return true if reporting is enabled
 */
function isReportingEnabled() {
  return enabled$1;
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function getComponentTag(vm) {
  return "<".concat(StringToLowerCase.call(vm.tagName), ">");
}
// TODO [#1695]: Unify getComponentStack and getErrorComponentStack
function getComponentStack(vm) {
  var stack = [];
  var prefix = '';
  while (!isNull(vm.owner)) {
    ArrayPush$1.call(stack, prefix + getComponentTag(vm));
    vm = vm.owner;
    prefix += '\t';
  }
  return ArrayJoin.call(stack, '\n');
}
function getErrorComponentStack(vm) {
  var wcStack = [];
  var currentVm = vm;
  while (!isNull(currentVm)) {
    ArrayPush$1.call(wcStack, getComponentTag(currentVm));
    currentVm = currentVm.owner;
  }
  return wcStack.reverse().join('\n\t');
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function addErrorComponentStack(vm, error) {
  if (!isFrozen(error) && isUndefined$1(error.wcStack)) {
    var wcStack = getErrorComponentStack(vm);
    defineProperty(error, 'wcStack', {
      get: function get() {
        return wcStack;
      }
    });
  }
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var alreadyLoggedMessages = new Set();
// Only used in LWC's Karma tests
if (process.env.NODE_ENV === 'test-karma-lwc') {
  window.__lwcResetAlreadyLoggedMessages = function () {
    alreadyLoggedMessages.clear();
  };
}
function log(method, message, vm, once) {
  var msg = "[LWC ".concat(method, "]: ").concat(message);
  if (!isUndefined$1(vm)) {
    msg = "".concat(msg, "\n").concat(getComponentStack(vm));
  }
  if (once) {
    if (alreadyLoggedMessages.has(msg)) {
      return;
    }
    alreadyLoggedMessages.add(msg);
  }
  // In Jest tests, reduce the warning and error verbosity by not printing the callstack
  if (process.env.NODE_ENV === 'test') {
    /* eslint-disable-next-line no-console */
    console[method](msg);
    return;
  }
  try {
    throw new Error(msg);
  } catch (e) {
    /* eslint-disable-next-line no-console */
    console[method](e);
  }
}
function logError(message, vm) {
  log('error', message, vm, false);
}
function logWarn(message, vm) {
  log('warn', message, vm, false);
}
function logWarnOnce(message, vm) {
  log('warn', message, vm, true);
}

/*
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var TargetToReactiveRecordMap = new WeakMap();
function getReactiveRecord(target) {
  var reactiveRecord = TargetToReactiveRecordMap.get(target);
  if (isUndefined$1(reactiveRecord)) {
    var newRecord = create(null);
    reactiveRecord = newRecord;
    TargetToReactiveRecordMap.set(target, newRecord);
  }
  return reactiveRecord;
}
var currentReactiveObserver = null;
function valueMutated(target, key) {
  var reactiveRecord = TargetToReactiveRecordMap.get(target);
  if (!isUndefined$1(reactiveRecord)) {
    var reactiveObservers = reactiveRecord[key];
    if (!isUndefined$1(reactiveObservers)) {
      for (var _i2 = 0, len = reactiveObservers.length; _i2 < len; _i2 += 1) {
        var ro = reactiveObservers[_i2];
        ro.notify();
      }
    }
  }
}
function valueObserved(target, key) {
  // We should determine if an active Observing Record is present to track mutations.
  if (currentReactiveObserver === null) {
    return;
  }
  var ro = currentReactiveObserver;
  var reactiveRecord = getReactiveRecord(target);
  var reactiveObservers = reactiveRecord[key];
  if (isUndefined$1(reactiveObservers)) {
    reactiveObservers = [];
    reactiveRecord[key] = reactiveObservers;
  } else if (reactiveObservers[0] === ro) {
    return; // perf optimization considering that most subscriptions will come from the same record
  }
  if (ArrayIndexOf.call(reactiveObservers, ro) === -1) {
    ro.link(reactiveObservers);
  }
}
var ReactiveObserver = /*#__PURE__*/function () {
  function ReactiveObserver(callback) {
    _classCallCheck(this, ReactiveObserver);
    this.listeners = [];
    this.callback = callback;
  }
  _createClass(ReactiveObserver, [{
    key: "observe",
    value: function observe(job) {
      var inceptionReactiveRecord = currentReactiveObserver;
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      currentReactiveObserver = this;
      var error;
      try {
        job();
      } catch (e) {
        error = Object(e);
      } finally {
        currentReactiveObserver = inceptionReactiveRecord;
        if (error !== undefined) {
          throw error; // eslint-disable-line no-unsafe-finally
        }
      }
    }
    /**
     * This method is responsible for disconnecting the Reactive Observer
     * from any Reactive Record that has a reference to it, to prevent future
     * notifications about previously recorded access.
     */
  }, {
    key: "reset",
    value: function reset() {
      var listeners = this.listeners;
      var len = listeners.length;
      if (len > 0) {
        for (var _i3 = 0; _i3 < len; _i3++) {
          var set = listeners[_i3];
          var setLength = set.length;
          // The length is usually 1, so avoid doing an indexOf when we know for certain
          // that `this` is the first item in the array.
          if (setLength > 1) {
            // Swap with the last item before removal.
            // (Avoiding splice here is a perf optimization, and the order doesn't matter.)
            var index = ArrayIndexOf.call(set, this);
            set[index] = set[setLength - 1];
          }
          // Remove the last item
          ArrayPop.call(set);
        }
        listeners.length = 0;
      }
    }
    // friend methods
  }, {
    key: "notify",
    value: function notify() {
      this.callback.call(undefined, this);
    }
  }, {
    key: "link",
    value: function link(reactiveObservers) {
      ArrayPush$1.call(reactiveObservers, this);
      // we keep track of observing records where the observing record was added to so we can do some clean up later on
      ArrayPush$1.call(this.listeners, reactiveObservers);
    }
  }, {
    key: "isObserving",
    value: function isObserving() {
      return currentReactiveObserver === this;
    }
  }]);
  return ReactiveObserver;
}();
/*
 * Copyright (c) 2024, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * This map keeps track of objects to signals. There is an assumption that the signal is strongly referenced
 * on the object which allows the SignalTracker to be garbage collected along with the object.
 */
var TargetToSignalTrackerMap = new WeakMap();
function getSignalTracker(target) {
  var signalTracker = TargetToSignalTrackerMap.get(target);
  if (isUndefined$1(signalTracker)) {
    signalTracker = new SignalTracker();
    TargetToSignalTrackerMap.set(target, signalTracker);
  }
  return signalTracker;
}
function subscribeToSignal(target, signal, update) {
  var signalTracker = getSignalTracker(target);
  if (isFalse(signalTracker.seen(signal))) {
    signalTracker.subscribeToSignal(signal, update);
  }
}
function unsubscribeFromSignals(target) {
  if (TargetToSignalTrackerMap.has(target)) {
    var signalTracker = getSignalTracker(target);
    signalTracker.unsubscribeFromSignals();
    signalTracker.reset();
  }
}
/**
 * This class is used to keep track of the signals associated to a given object.
 * It is used to prevent the LWC engine from subscribing duplicate callbacks multiple times
 * to the same signal. Additionally, it keeps track of all signal unsubscribe callbacks, handles invoking
 * them when necessary and discarding them.
 */
var SignalTracker = /*#__PURE__*/function () {
  function SignalTracker() {
    _classCallCheck(this, SignalTracker);
    this.signalToUnsubscribeMap = new Map();
  }
  _createClass(SignalTracker, [{
    key: "seen",
    value: function seen(signal) {
      return this.signalToUnsubscribeMap.has(signal);
    }
  }, {
    key: "subscribeToSignal",
    value: function subscribeToSignal(signal, update) {
      try {
        var unsubscribe = signal.subscribe(update);
        if (isFunction$1(unsubscribe)) {
          // TODO [#3978]: Evaluate how we should handle the case when unsubscribe is not a function.
          // Long term we should throw an error or log a warning.
          this.signalToUnsubscribeMap.set(signal, unsubscribe);
        }
      } catch (err) {
        var _err$stack;
        logWarnOnce("Attempted to subscribe to an object that has the shape of a signal but received the following error: ".concat((_err$stack = err === null || err === void 0 ? void 0 : err.stack) !== null && _err$stack !== void 0 ? _err$stack : err));
      }
    }
  }, {
    key: "unsubscribeFromSignals",
    value: function unsubscribeFromSignals() {
      try {
        this.signalToUnsubscribeMap.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      } catch (err) {
        var _err$stack2;
        logWarnOnce("Attempted to call a signal's unsubscribe callback but received the following error: ".concat((_err$stack2 = err === null || err === void 0 ? void 0 : err.stack) !== null && _err$stack2 !== void 0 ? _err$stack2 : err));
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.signalToUnsubscribeMap.clear();
    }
  }]);
  return SignalTracker;
}();
function componentValueMutated(vm, key) {
  // On the server side, we don't need mutation tracking. Skipping it improves performance.
  {
    valueMutated(vm.component, key);
  }
}
function componentValueObserved(vm, key) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var component = vm.component,
    tro = vm.tro;
  // On the server side, we don't need mutation tracking. Skipping it improves performance.
  {
    valueObserved(component, key);
  }
  // The portion of reactivity that's exposed to signals is to subscribe a callback to re-render the VM (templates).
  // We check check the following to ensure re-render is subscribed at the correct time.
  //  1. The template is currently being rendered (there is a template reactive observer)
  //  2. There was a call to a getter to access the signal (happens during vnode generation)
  if (lwcRuntimeFlags.ENABLE_EXPERIMENTAL_SIGNALS && isObject(target) && !isNull(target) && 'value' in target && 'subscribe' in target && isFunction$1(target.subscribe) &&
  // Only subscribe if a template is being rendered by the engine
  tro.isObserving()) {
    // Subscribe the template reactive observer's notify method, which will mark the vm as dirty and schedule hydration.
    subscribeToSignal(component, target, tro.notify.bind(tro));
  }
}
function createReactiveObserver(callback) {
  // On the server side, we don't need mutation tracking. Skipping it improves performance.
  return new ReactiveObserver(callback);
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var nextTickCallbackQueue = [];
var SPACE_CHAR = 32;
var EmptyObject = seal(create(null));
var EmptyArray = seal([]);
function flushCallbackQueue() {
  if (process.env.NODE_ENV !== 'production') {
    if (nextTickCallbackQueue.length === 0) {
      throw new Error("Internal Error: If callbackQueue is scheduled, it is because there must be at least one callback on this pending queue.");
    }
  }
  var callbacks = nextTickCallbackQueue;
  nextTickCallbackQueue = []; // reset to a new queue
  for (var _i4 = 0, len = callbacks.length; _i4 < len; _i4 += 1) {
    callbacks[_i4]();
  }
}
function addCallbackToNextTick(callback) {
  if (process.env.NODE_ENV !== 'production') {
    if (!isFunction$1(callback)) {
      throw new Error("Internal Error: addCallbackToNextTick() can only accept a function callback");
    }
  }
  if (nextTickCallbackQueue.length === 0) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    Promise.resolve().then(flushCallbackQueue);
  }
  ArrayPush$1.call(nextTickCallbackQueue, callback);
}
function shouldUseNativeCustomElementLifecycle(ctor) {
  if (lwcRuntimeFlags.DISABLE_NATIVE_CUSTOM_ELEMENT_LIFECYCLE) {
    // temporary "kill switch"
    return false;
  }
  var apiVersion = getComponentAPIVersion(ctor);
  return isAPIFeatureEnabled(7 /* APIFeature.ENABLE_NATIVE_CUSTOM_ELEMENT_LIFECYCLE */, apiVersion);
}
function flattenStylesheets(stylesheets) {
  var list = [];
  var _iterator = _createForOfIteratorHelper(stylesheets),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _stylesheet = _step.value;
      if (!isArray$1(_stylesheet)) {
        list.push(_stylesheet);
      } else {
        list.push.apply(list, _toConsumableArray(flattenStylesheets(_stylesheet)));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return list;
}
// Throw an error if we're running in prod mode. Ensures code is truly removed from prod mode.
function assertNotProd() {
  /* istanbul ignore if */
  if (process.env.NODE_ENV === 'production') {
    // this method should never leak to prod
    throw new ReferenceError();
  }
}
function shouldBeFormAssociated(Ctor) {
  var ctorFormAssociated = Boolean(Ctor.formAssociated);
  var apiVersion = getComponentAPIVersion(Ctor);
  var apiFeatureEnabled = isAPIFeatureEnabled(8 /* APIFeature.ENABLE_ELEMENT_INTERNALS_AND_FACE */, apiVersion);
  if (process.env.NODE_ENV !== 'production' && ctorFormAssociated && !apiFeatureEnabled) {
    var tagName = getComponentRegisteredName(Ctor);
    logWarnOnce("Component <".concat(tagName, "> set static formAssociated to true, but form ") + "association is not enabled because the API version is ".concat(apiVersion, ". To enable form association, ") + "update the LWC component API version to 61 or above. https://lwc.dev/guide/versioning");
  }
  return ctorFormAssociated && apiFeatureEnabled;
}

/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function resolveCircularModuleDependency(fn) {
  var module = fn();
  return module !== null && module !== void 0 && module.__esModule ? module["default"] : module;
}
function isCircularModuleDependency(obj) {
  return isFunction$1(obj) && hasOwnProperty$1.call(obj, '__circular__');
}

/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var instrumentDef = (_globalThis$__lwc_ins = globalThis.__lwc_instrument_cmp_def) !== null && _globalThis$__lwc_ins !== void 0 ? _globalThis$__lwc_ins : noop;
var instrumentInstance = (_globalThis$__lwc_ins2 = globalThis.__lwc_instrument_cmp_instance) !== null && _globalThis$__lwc_ins2 !== void 0 ? _globalThis$__lwc_ins2 : noop;

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// This is a temporary workaround to get the @lwc/engine-server to evaluate in node without having
// to inject at runtime.
var HTMLElementConstructor = typeof HTMLElement !== 'undefined' ? HTMLElement : function () {};
var HTMLElementPrototype = HTMLElementConstructor.prototype;

/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// Apply ARIA string reflection behavior to a prototype.
// This is deliberately kept separate from @lwc/aria-reflection. @lwc/aria-reflection is a global polyfill that is
// needed for backwards compatibility in LEX, whereas this is designed to only apply to our own
// LightningElement/BaseBridgeElement prototypes.
// Note we only need to handle ARIA reflections that aren't already in Element.prototype
var ariaReflectionPolyfillDescriptors = create(null);
var _iterator2 = _createForOfIteratorHelper(entries(AriaPropNameToAttrNameMap)),
  _step2;
try {
  var _loop8 = function _loop8() {
    var _step2$value = _slicedToArray(_step2.value, 2),
      propName = _step2$value[0],
      attrName = _step2$value[1];
    if (isUndefined$1(getPropertyDescriptor(HTMLElementPrototype, propName))) {
      // Note that we need to call this.{get,set,has,remove}Attribute rather than dereferencing
      // from Element.prototype, because these methods are overridden in LightningElement.
      ariaReflectionPolyfillDescriptors[propName] = {
        get: function get() {
          return this.getAttribute(attrName);
        },
        set: function set(newValue) {
          // TODO [#3284]: there is disagreement between browsers and the spec on how to treat undefined
          // Our historical behavior is to only treat null as removing the attribute
          // See also https://github.com/w3c/aria/issues/1858
          if (isNull(newValue)) {
            this.removeAttribute(attrName);
          } else {
            this.setAttribute(attrName, newValue);
          }
        },
        // configurable and enumerable to allow it to be overridden – this mimics Safari's/Chrome's behavior
        configurable: true,
        enumerable: true
      };
    }
  };
  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
    _loop8();
  }

  /*
   * Copyright (c) 2018, salesforce.com, inc.
   * All rights reserved.
   * SPDX-License-Identifier: MIT
   * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
   */
  // These properties get added to LWCElement.prototype publicProps automatically
} catch (err) {
  _iterator2.e(err);
} finally {
  _iterator2.f();
}
var defaultDefHTMLPropertyNames = ['accessKey', 'dir', 'draggable', 'hidden', 'id', 'lang', 'spellcheck', 'tabIndex', 'title'];

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * This is a descriptor map that contains
 * all standard properties that a Custom Element can support (including AOM properties), which
 * determines what kind of capabilities the Base HTML Element and
 * Base Lightning Element should support.
 */
var HTMLElementOriginalDescriptors = create(null);
forEach.call(keys(AriaPropNameToAttrNameMap), function (propName) {
  // Note: intentionally using our in-house getPropertyDescriptor instead of getOwnPropertyDescriptor here because
  // in IE11, some properties are on Element.prototype instead of HTMLElement, just to be sure.
  var descriptor = getPropertyDescriptor(HTMLElementPrototype, propName);
  if (!isUndefined$1(descriptor)) {
    HTMLElementOriginalDescriptors[propName] = descriptor;
  }
});
forEach.call(defaultDefHTMLPropertyNames, function (propName) {
  // Note: intentionally using our in-house getPropertyDescriptor instead of getOwnPropertyDescriptor here because
  // in IE11, id property is on Element.prototype instead of HTMLElement, and we suspect that more will fall into
  // this category, so, better to be sure.
  var descriptor = getPropertyDescriptor(HTMLElementPrototype, propName);
  if (!isUndefined$1(descriptor)) {
    HTMLElementOriginalDescriptors[propName] = descriptor;
  }
});

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function generateDataDescriptor(options) {
  return assign({
    configurable: true,
    enumerable: true,
    writable: true
  }, options);
}
function generateAccessorDescriptor(options) {
  return assign({
    configurable: true,
    enumerable: true
  }, options);
}
var isDomMutationAllowed = false;
function unlockDomMutation() {
  assertNotProd(); // this method should never leak to prod
  isDomMutationAllowed = true;
}
function lockDomMutation() {
  assertNotProd(); // this method should never leak to prod
  isDomMutationAllowed = false;
}
function logMissingPortalWarn(name, type) {
  return logWarn("The `".concat(name, "` ").concat(type, " is available only on elements that use the `lwc:dom=\"manual\"` directive."));
}
function patchElementWithRestrictions(elm, options) {
  assertNotProd(); // this method should never leak to prod
  var originalOuterHTMLDescriptor = getPropertyDescriptor(elm, 'outerHTML');
  var descriptors = {
    outerHTML: generateAccessorDescriptor({
      get: function get() {
        return originalOuterHTMLDescriptor.get.call(this);
      },
      set: function set(value) {
        logError("Invalid attempt to set outerHTML on Element.");
        return originalOuterHTMLDescriptor.set.call(this, value);
      }
    })
  };
  // Apply extra restriction related to DOM manipulation if the element is not a portal.
  if (!options.isLight && options.isSynthetic && !options.isPortal) {
    var appendChild = elm.appendChild,
      insertBefore = elm.insertBefore,
      removeChild = elm.removeChild,
      replaceChild = elm.replaceChild;
    var originalNodeValueDescriptor = getPropertyDescriptor(elm, 'nodeValue');
    var originalInnerHTMLDescriptor = getPropertyDescriptor(elm, 'innerHTML');
    var originalTextContentDescriptor = getPropertyDescriptor(elm, 'textContent');
    assign(descriptors, {
      appendChild: generateDataDescriptor({
        value: function value(aChild) {
          logMissingPortalWarn('appendChild', 'method');
          return appendChild.call(this, aChild);
        }
      }),
      insertBefore: generateDataDescriptor({
        value: function value(newNode, referenceNode) {
          if (!isDomMutationAllowed) {
            logMissingPortalWarn('insertBefore', 'method');
          }
          return insertBefore.call(this, newNode, referenceNode);
        }
      }),
      removeChild: generateDataDescriptor({
        value: function value(aChild) {
          if (!isDomMutationAllowed) {
            logMissingPortalWarn('removeChild', 'method');
          }
          return removeChild.call(this, aChild);
        }
      }),
      replaceChild: generateDataDescriptor({
        value: function value(newChild, oldChild) {
          logMissingPortalWarn('replaceChild', 'method');
          return replaceChild.call(this, newChild, oldChild);
        }
      }),
      nodeValue: generateAccessorDescriptor({
        get: function get() {
          return originalNodeValueDescriptor.get.call(this);
        },
        set: function set(value) {
          if (!isDomMutationAllowed) {
            logMissingPortalWarn('nodeValue', 'property');
          }
          originalNodeValueDescriptor.set.call(this, value);
        }
      }),
      textContent: generateAccessorDescriptor({
        get: function get() {
          return originalTextContentDescriptor.get.call(this);
        },
        set: function set(value) {
          logMissingPortalWarn('textContent', 'property');
          originalTextContentDescriptor.set.call(this, value);
        }
      }),
      innerHTML: generateAccessorDescriptor({
        get: function get() {
          return originalInnerHTMLDescriptor.get.call(this);
        },
        set: function set(value) {
          logMissingPortalWarn('innerHTML', 'property');
          return originalInnerHTMLDescriptor.set.call(this, value);
        }
      })
    });
  }
  defineProperties(elm, descriptors);
}
function getShadowRootRestrictionsDescriptors(sr) {
  assertNotProd(); // this method should never leak to prod
  // Disallowing properties in dev mode only to avoid people doing the wrong
  // thing when using the real shadow root, because if that's the case,
  // the component will not work when running with synthetic shadow.
  var originalAddEventListener = sr.addEventListener;
  var originalInnerHTMLDescriptor = getPropertyDescriptor(sr, 'innerHTML');
  var originalTextContentDescriptor = getPropertyDescriptor(sr, 'textContent');
  return {
    innerHTML: generateAccessorDescriptor({
      get: function get() {
        return originalInnerHTMLDescriptor.get.call(this);
      },
      set: function set(value) {
        logError("Invalid attempt to set innerHTML on ShadowRoot.");
        return originalInnerHTMLDescriptor.set.call(this, value);
      }
    }),
    textContent: generateAccessorDescriptor({
      get: function get() {
        return originalTextContentDescriptor.get.call(this);
      },
      set: function set(value) {
        logError("Invalid attempt to set textContent on ShadowRoot.");
        return originalTextContentDescriptor.set.call(this, value);
      }
    }),
    addEventListener: generateDataDescriptor({
      value: function value(type, listener, options) {
        // TODO [#1824]: Potentially relax this restriction
        if (!isUndefined$1(options)) {
          logError('The `addEventListener` method on ShadowRoot does not support any options.', getAssociatedVMIfPresent(this));
        }
        // Typescript does not like it when you treat the `arguments` object as an array
        // @ts-expect-error type-mismatch
        return originalAddEventListener.apply(this, arguments);
      }
    })
  };
}
// Custom Elements Restrictions:
// -----------------------------
function getCustomElementRestrictionsDescriptors(elm) {
  assertNotProd(); // this method should never leak to prod
  var originalAddEventListener = elm.addEventListener;
  var originalInnerHTMLDescriptor = getPropertyDescriptor(elm, 'innerHTML');
  var originalOuterHTMLDescriptor = getPropertyDescriptor(elm, 'outerHTML');
  var originalTextContentDescriptor = getPropertyDescriptor(elm, 'textContent');
  return {
    innerHTML: generateAccessorDescriptor({
      get: function get() {
        return originalInnerHTMLDescriptor.get.call(this);
      },
      set: function set(value) {
        logError("Invalid attempt to set innerHTML on HTMLElement.");
        return originalInnerHTMLDescriptor.set.call(this, value);
      }
    }),
    outerHTML: generateAccessorDescriptor({
      get: function get() {
        return originalOuterHTMLDescriptor.get.call(this);
      },
      set: function set(value) {
        logError("Invalid attempt to set outerHTML on HTMLElement.");
        return originalOuterHTMLDescriptor.set.call(this, value);
      }
    }),
    textContent: generateAccessorDescriptor({
      get: function get() {
        return originalTextContentDescriptor.get.call(this);
      },
      set: function set(value) {
        logError("Invalid attempt to set textContent on HTMLElement.");
        return originalTextContentDescriptor.set.call(this, value);
      }
    }),
    addEventListener: generateDataDescriptor({
      value: function value(type, listener, options) {
        // TODO [#1824]: Potentially relax this restriction
        if (!isUndefined$1(options)) {
          logError('The `addEventListener` method in `LightningElement` does not support any options.', getAssociatedVMIfPresent(this));
        }
        // Typescript does not like it when you treat the `arguments` object as an array
        // @ts-expect-error type-mismatch
        return originalAddEventListener.apply(this, arguments);
      }
    })
  };
}
// This routine will prevent access to certain properties on a shadow root instance to guarantee
// that all components will work fine in IE11 and other browsers without shadow dom support.
function patchShadowRootWithRestrictions(sr) {
  defineProperties(sr, getShadowRootRestrictionsDescriptors(sr));
}
function patchCustomElementWithRestrictions(elm) {
  var restrictionsDescriptors = getCustomElementRestrictionsDescriptors(elm);
  var elmProto = getPrototypeOf$1(elm);
  setPrototypeOf(elm, create(elmProto, restrictionsDescriptors));
}
function updateComponentValue(vm, key, newValue) {
  var cmpFields = vm.cmpFields;
  if (newValue !== cmpFields[key]) {
    cmpFields[key] = newValue;
    componentValueMutated(vm, key);
  }
}

/**
 * Copyright (C) 2017 salesforce.com, inc.
 */
var isArray = Array.isArray;
var ObjectDotPrototype = Object.prototype,
  _getPrototypeOf = Object.getPrototypeOf,
  ObjectCreate = Object.create,
  ObjectDefineProperty = Object.defineProperty,
  _isExtensible = Object.isExtensible,
  _getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
  getOwnPropertyNames = Object.getOwnPropertyNames,
  getOwnPropertySymbols = Object.getOwnPropertySymbols,
  _preventExtensions = Object.preventExtensions,
  hasOwnProperty = Object.hasOwnProperty;
var _Array$prototype2 = Array.prototype,
  ArrayPush = _Array$prototype2.push,
  ArrayConcat = _Array$prototype2.concat;
var OtS = {}.toString;
function toString(obj) {
  if (obj && obj.toString) {
    return obj.toString();
  } else if (_typeof(obj) === 'object') {
    return OtS.call(obj);
  } else {
    return obj + '';
  }
}
function isUndefined(obj) {
  return obj === undefined;
}
function isFunction(obj) {
  return typeof obj === 'function';
}
var proxyToValueMap = new WeakMap();
function registerProxy(proxy, value) {
  proxyToValueMap.set(proxy, value);
}
var unwrap$1 = function unwrap$1(replicaOrAny) {
  return proxyToValueMap.get(replicaOrAny) || replicaOrAny;
};
var BaseProxyHandler = /*#__PURE__*/function () {
  function BaseProxyHandler(membrane, value) {
    _classCallCheck(this, BaseProxyHandler);
    this.originalTarget = value;
    this.membrane = membrane;
  }
  // Shared utility methods
  _createClass(BaseProxyHandler, [{
    key: "wrapDescriptor",
    value: function wrapDescriptor(descriptor) {
      if (hasOwnProperty.call(descriptor, 'value')) {
        descriptor.value = this.wrapValue(descriptor.value);
      } else {
        var originalSet = descriptor.set,
          originalGet = descriptor.get;
        if (!isUndefined(originalGet)) {
          descriptor.get = this.wrapGetter(originalGet);
        }
        if (!isUndefined(originalSet)) {
          descriptor.set = this.wrapSetter(originalSet);
        }
      }
      return descriptor;
    }
  }, {
    key: "copyDescriptorIntoShadowTarget",
    value: function copyDescriptorIntoShadowTarget(shadowTarget, key) {
      var originalTarget = this.originalTarget;
      // Note: a property might get defined multiple times in the shadowTarget
      //       but it will always be compatible with the previous descriptor
      //       to preserve the object invariants, which makes these lines safe.
      var originalDescriptor = _getOwnPropertyDescriptor(originalTarget, key);
      // TODO: it should be impossible for the originalDescriptor to ever be undefined, this `if` can be removed
      /* istanbul ignore else */
      if (!isUndefined(originalDescriptor)) {
        var wrappedDesc = this.wrapDescriptor(originalDescriptor);
        ObjectDefineProperty(shadowTarget, key, wrappedDesc);
      }
    }
  }, {
    key: "lockShadowTarget",
    value: function lockShadowTarget(shadowTarget) {
      var _this = this;
      var originalTarget = this.originalTarget;
      var targetKeys = ArrayConcat.call(getOwnPropertyNames(originalTarget), getOwnPropertySymbols(originalTarget));
      targetKeys.forEach(function (key) {
        _this.copyDescriptorIntoShadowTarget(shadowTarget, key);
      });
      var tagPropertyKey = this.membrane.tagPropertyKey;
      if (!isUndefined(tagPropertyKey) && !hasOwnProperty.call(shadowTarget, tagPropertyKey)) {
        ObjectDefineProperty(shadowTarget, tagPropertyKey, ObjectCreate(null));
      }
      _preventExtensions(shadowTarget);
    }
    // Shared Traps
    // TODO: apply() is never called
    /* istanbul ignore next */
  }, {
    key: "apply",
    value: function apply(shadowTarget, thisArg, argArray) {
      /* No op */
    }
    // TODO: construct() is never called
    /* istanbul ignore next */
  }, {
    key: "construct",
    value: function construct(shadowTarget, argArray, newTarget) {
      /* No op */
    }
  }, {
    key: "get",
    value: function get(shadowTarget, key) {
      var originalTarget = this.originalTarget,
        valueObserved = this.membrane.valueObserved;
      var value = originalTarget[key];
      valueObserved(originalTarget, key);
      return this.wrapValue(value);
    }
  }, {
    key: "has",
    value: function has(shadowTarget, key) {
      var originalTarget = this.originalTarget,
        _this$membrane = this.membrane,
        tagPropertyKey = _this$membrane.tagPropertyKey,
        valueObserved = _this$membrane.valueObserved;
      valueObserved(originalTarget, key);
      // since key is never going to be undefined, and tagPropertyKey might be undefined
      // we can simply compare them as the second part of the condition.
      return key in originalTarget || key === tagPropertyKey;
    }
  }, {
    key: "ownKeys",
    value: function ownKeys(shadowTarget) {
      var originalTarget = this.originalTarget,
        tagPropertyKey = this.membrane.tagPropertyKey;
      // if the membrane tag key exists and it is not in the original target, we add it to the keys.
      var keys = isUndefined(tagPropertyKey) || hasOwnProperty.call(originalTarget, tagPropertyKey) ? [] : [tagPropertyKey];
      // small perf optimization using push instead of concat to avoid creating an extra array
      ArrayPush.apply(keys, getOwnPropertyNames(originalTarget));
      ArrayPush.apply(keys, getOwnPropertySymbols(originalTarget));
      return keys;
    }
  }, {
    key: "isExtensible",
    value: function isExtensible(shadowTarget) {
      var originalTarget = this.originalTarget;
      // optimization to avoid attempting to lock down the shadowTarget multiple times
      if (!_isExtensible(shadowTarget)) {
        return false; // was already locked down
      }
      if (!_isExtensible(originalTarget)) {
        this.lockShadowTarget(shadowTarget);
        return false;
      }
      return true;
    }
  }, {
    key: "getPrototypeOf",
    value: function getPrototypeOf(shadowTarget) {
      var originalTarget = this.originalTarget;
      return _getPrototypeOf(originalTarget);
    }
  }, {
    key: "getOwnPropertyDescriptor",
    value: function getOwnPropertyDescriptor(shadowTarget, key) {
      var originalTarget = this.originalTarget,
        _this$membrane2 = this.membrane,
        valueObserved = _this$membrane2.valueObserved,
        tagPropertyKey = _this$membrane2.tagPropertyKey;
      // keys looked up via getOwnPropertyDescriptor need to be reactive
      valueObserved(originalTarget, key);
      var desc = _getOwnPropertyDescriptor(originalTarget, key);
      if (isUndefined(desc)) {
        if (key !== tagPropertyKey) {
          return undefined;
        }
        // if the key is the membrane tag key, and is not in the original target,
        // we produce a synthetic descriptor and install it on the shadow target
        desc = {
          value: undefined,
          writable: false,
          configurable: false,
          enumerable: false
        };
        ObjectDefineProperty(shadowTarget, tagPropertyKey, desc);
        return desc;
      }
      if (desc.configurable === false) {
        // updating the descriptor to non-configurable on the shadow
        this.copyDescriptorIntoShadowTarget(shadowTarget, key);
      }
      // Note: by accessing the descriptor, the key is marked as observed
      // but access to the value, setter or getter (if available) cannot observe
      // mutations, just like regular methods, in which case we just do nothing.
      return this.wrapDescriptor(desc);
    }
  }]);
  return BaseProxyHandler;
}();
var getterMap$1 = new WeakMap();
var setterMap$1 = new WeakMap();
var reverseGetterMap = new WeakMap();
var reverseSetterMap = new WeakMap();
var ReactiveProxyHandler = /*#__PURE__*/function (_BaseProxyHandler) {
  _inherits(ReactiveProxyHandler, _BaseProxyHandler);
  var _super = _createSuper(ReactiveProxyHandler);
  function ReactiveProxyHandler() {
    _classCallCheck(this, ReactiveProxyHandler);
    return _super.apply(this, arguments);
  }
  _createClass(ReactiveProxyHandler, [{
    key: "wrapValue",
    value: function wrapValue(value) {
      return this.membrane.getProxy(value);
    }
  }, {
    key: "wrapGetter",
    value: function wrapGetter(originalGet) {
      var wrappedGetter = getterMap$1.get(originalGet);
      if (!isUndefined(wrappedGetter)) {
        return wrappedGetter;
      }
      var handler = this;
      var get = function get() {
        // invoking the original getter with the original target
        return handler.wrapValue(originalGet.call(unwrap$1(this)));
      };
      getterMap$1.set(originalGet, get);
      reverseGetterMap.set(get, originalGet);
      return get;
    }
  }, {
    key: "wrapSetter",
    value: function wrapSetter(originalSet) {
      var wrappedSetter = setterMap$1.get(originalSet);
      if (!isUndefined(wrappedSetter)) {
        return wrappedSetter;
      }
      var set = function set(v) {
        // invoking the original setter with the original target
        originalSet.call(unwrap$1(this), unwrap$1(v));
      };
      setterMap$1.set(originalSet, set);
      reverseSetterMap.set(set, originalSet);
      return set;
    }
  }, {
    key: "unwrapDescriptor",
    value: function unwrapDescriptor(descriptor) {
      if (hasOwnProperty.call(descriptor, 'value')) {
        // dealing with a data descriptor
        descriptor.value = unwrap$1(descriptor.value);
      } else {
        var set = descriptor.set,
          get = descriptor.get;
        if (!isUndefined(get)) {
          descriptor.get = this.unwrapGetter(get);
        }
        if (!isUndefined(set)) {
          descriptor.set = this.unwrapSetter(set);
        }
      }
      return descriptor;
    }
  }, {
    key: "unwrapGetter",
    value: function unwrapGetter(redGet) {
      var reverseGetter = reverseGetterMap.get(redGet);
      if (!isUndefined(reverseGetter)) {
        return reverseGetter;
      }
      var handler = this;
      var get = function get() {
        // invoking the red getter with the proxy of this
        return unwrap$1(redGet.call(handler.wrapValue(this)));
      };
      getterMap$1.set(get, redGet);
      reverseGetterMap.set(redGet, get);
      return get;
    }
  }, {
    key: "unwrapSetter",
    value: function unwrapSetter(redSet) {
      var reverseSetter = reverseSetterMap.get(redSet);
      if (!isUndefined(reverseSetter)) {
        return reverseSetter;
      }
      var handler = this;
      var set = function set(v) {
        // invoking the red setter with the proxy of this
        redSet.call(handler.wrapValue(this), handler.wrapValue(v));
      };
      setterMap$1.set(set, redSet);
      reverseSetterMap.set(redSet, set);
      return set;
    }
  }, {
    key: "set",
    value: function set(shadowTarget, key, value) {
      var originalTarget = this.originalTarget,
        valueMutated = this.membrane.valueMutated;
      var oldValue = originalTarget[key];
      if (oldValue !== value) {
        originalTarget[key] = value;
        valueMutated(originalTarget, key);
      } else if (key === 'length' && isArray(originalTarget)) {
        // fix for issue #236: push will add the new index, and by the time length
        // is updated, the internal length is already equal to the new length value
        // therefore, the oldValue is equal to the value. This is the forking logic
        // to support this use case.
        valueMutated(originalTarget, key);
      }
      return true;
    }
  }, {
    key: "deleteProperty",
    value: function deleteProperty(shadowTarget, key) {
      var originalTarget = this.originalTarget,
        valueMutated = this.membrane.valueMutated;
      delete originalTarget[key];
      valueMutated(originalTarget, key);
      return true;
    }
  }, {
    key: "setPrototypeOf",
    value: function setPrototypeOf(shadowTarget, prototype) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        throw new Error("Invalid setPrototypeOf invocation for reactive proxy ".concat(toString(this.originalTarget), ". Prototype of reactive objects cannot be changed."));
      }
    }
  }, {
    key: "preventExtensions",
    value: function preventExtensions(shadowTarget) {
      if (_isExtensible(shadowTarget)) {
        var originalTarget = this.originalTarget;
        _preventExtensions(originalTarget);
        // if the originalTarget is a proxy itself, it might reject
        // the preventExtension call, in which case we should not attempt to lock down
        // the shadow target.
        // TODO: It should not actually be possible to reach this `if` statement.
        // If a proxy rejects extensions, then calling preventExtensions will throw an error:
        // https://codepen.io/nolanlawson-the-selector/pen/QWMOjbY
        /* istanbul ignore if */
        if (_isExtensible(originalTarget)) {
          return false;
        }
        this.lockShadowTarget(shadowTarget);
      }
      return true;
    }
  }, {
    key: "defineProperty",
    value: function defineProperty(shadowTarget, key, descriptor) {
      var originalTarget = this.originalTarget,
        _this$membrane3 = this.membrane,
        valueMutated = _this$membrane3.valueMutated,
        tagPropertyKey = _this$membrane3.tagPropertyKey;
      if (key === tagPropertyKey && !hasOwnProperty.call(originalTarget, key)) {
        // To avoid leaking the membrane tag property into the original target, we must
        // be sure that the original target doesn't have yet.
        // NOTE: we do not return false here because Object.freeze and equivalent operations
        // will attempt to set the descriptor to the same value, and expect no to throw. This
        // is an small compromise for the sake of not having to diff the descriptors.
        return true;
      }
      ObjectDefineProperty(originalTarget, key, this.unwrapDescriptor(descriptor));
      // intentionally testing if false since it could be undefined as well
      if (descriptor.configurable === false) {
        this.copyDescriptorIntoShadowTarget(shadowTarget, key);
      }
      valueMutated(originalTarget, key);
      return true;
    }
    /*LWC compiler v6.6.3*/
  }]);
  return ReactiveProxyHandler;
}(BaseProxyHandler);
var getterMap = new WeakMap();
var setterMap = new WeakMap();
var ReadOnlyHandler = /*#__PURE__*/function (_BaseProxyHandler2) {
  _inherits(ReadOnlyHandler, _BaseProxyHandler2);
  var _super2 = _createSuper(ReadOnlyHandler);
  function ReadOnlyHandler() {
    _classCallCheck(this, ReadOnlyHandler);
    return _super2.apply(this, arguments);
  }
  _createClass(ReadOnlyHandler, [{
    key: "wrapValue",
    value: function wrapValue(value) {
      return this.membrane.getReadOnlyProxy(value);
    }
  }, {
    key: "wrapGetter",
    value: function wrapGetter(originalGet) {
      var wrappedGetter = getterMap.get(originalGet);
      if (!isUndefined(wrappedGetter)) {
        return wrappedGetter;
      }
      var handler = this;
      var get = function get() {
        // invoking the original getter with the original target
        return handler.wrapValue(originalGet.call(unwrap$1(this)));
      };
      getterMap.set(originalGet, get);
      return get;
    }
  }, {
    key: "wrapSetter",
    value: function wrapSetter(originalSet) {
      var wrappedSetter = setterMap.get(originalSet);
      if (!isUndefined(wrappedSetter)) {
        return wrappedSetter;
      }
      var handler = this;
      var set = function set(v) {
        /* istanbul ignore else */
        if (process.env.NODE_ENV !== 'production') {
          var originalTarget = handler.originalTarget;
          throw new Error("Invalid mutation: Cannot invoke a setter on \"".concat(originalTarget, "\". \"").concat(originalTarget, "\" is read-only."));
        }
      };
      setterMap.set(originalSet, set);
      return set;
    }
  }, {
    key: "set",
    value: function set(shadowTarget, key, value) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        var originalTarget = this.originalTarget;
        var msg = isArray(originalTarget) ? "Invalid mutation: Cannot mutate array at index ".concat(key.toString(), ". Array is read-only.") : "Invalid mutation: Cannot set \"".concat(key.toString(), "\" on \"").concat(originalTarget, "\". \"").concat(originalTarget, "\" is read-only.");
        throw new Error(msg);
      }
      /* istanbul ignore next */
      return false;
    }
  }, {
    key: "deleteProperty",
    value: function deleteProperty(shadowTarget, key) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        var originalTarget = this.originalTarget;
        throw new Error("Invalid mutation: Cannot delete \"".concat(key.toString(), "\" on \"").concat(originalTarget, "\". \"").concat(originalTarget, "\" is read-only."));
      }
      /* istanbul ignore next */
      return false;
    }
  }, {
    key: "setPrototypeOf",
    value: function setPrototypeOf(shadowTarget, prototype) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        var originalTarget = this.originalTarget;
        throw new Error("Invalid prototype mutation: Cannot set prototype on \"".concat(originalTarget, "\". \"").concat(originalTarget, "\" prototype is read-only."));
      }
    }
  }, {
    key: "preventExtensions",
    value: function preventExtensions(shadowTarget) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        var originalTarget = this.originalTarget;
        throw new Error("Invalid mutation: Cannot preventExtensions on ".concat(originalTarget, "\". \"").concat(originalTarget, " is read-only."));
      }
      /* istanbul ignore next */
      return false;
    }
  }, {
    key: "defineProperty",
    value: function defineProperty(shadowTarget, key, descriptor) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        var originalTarget = this.originalTarget;
        throw new Error("Invalid mutation: Cannot defineProperty \"".concat(key.toString(), "\" on \"").concat(originalTarget, "\". \"").concat(originalTarget, "\" is read-only."));
      }
      /* istanbul ignore next */
      return false;
    }
    /*LWC compiler v6.6.3*/
  }]);
  return ReadOnlyHandler;
}(BaseProxyHandler);
function extract(objectOrArray) {
  if (isArray(objectOrArray)) {
    return objectOrArray.map(function (item) {
      var original = unwrap$1(item);
      if (original !== item) {
        return extract(original);
      }
      return item;
    });
  }
  var obj = ObjectCreate(_getPrototypeOf(objectOrArray));
  var names = getOwnPropertyNames(objectOrArray);
  return ArrayConcat.call(names, getOwnPropertySymbols(objectOrArray)).reduce(function (seed, key) {
    var item = objectOrArray[key];
    var original = unwrap$1(item);
    if (original !== item) {
      seed[key] = extract(original);
    } else {
      seed[key] = item;
    }
    return seed;
  }, obj);
}
var formatter = {
  header: function header(plainOrProxy) {
    var originalTarget = unwrap$1(plainOrProxy);
    // if originalTarget is falsy or not unwrappable, exit
    if (!originalTarget || originalTarget === plainOrProxy) {
      return null;
    }
    var obj = extract(plainOrProxy);
    return ['object', {
      object: obj
    }];
  },
  hasBody: function hasBody() {
    return false;
  },
  body: function body() {
    return null;
  }
};
// Inspired from paulmillr/es6-shim
// https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L176-L185
/* istanbul ignore next */
function getGlobal() {
  // the only reliable means to get the global object is `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  // Gracefully degrade if not able to locate the global object
  return {};
}
function init$1() {
  /* istanbul ignore if */
  if (process.env.NODE_ENV === 'production') {
    // this method should never leak to prod
    throw new ReferenceError();
  }
  var global = getGlobal();
  // Custom Formatter for Dev Tools. To enable this, open Chrome Dev Tools
  //  - Go to Settings,
  //  - Under console, select "Enable custom formatters"
  // For more information, https://docs.google.com/document/d/1FTascZXT9cxfetuPRT2eXPQKXui4nWFivUnS_335T3U/preview
  var devtoolsFormatters = global.devtoolsFormatters || [];
  ArrayPush.call(devtoolsFormatters, formatter);
  global.devtoolsFormatters = devtoolsFormatters;
}

/* istanbul ignore else */
if (process.env.NODE_ENV !== 'production') {
  init$1();
}
function defaultValueIsObservable(value) {
  // intentionally checking for null
  if (value === null) {
    return false;
  }
  // treat all non-object types, including undefined, as non-observable values
  if (_typeof(value) !== 'object') {
    return false;
  }
  if (isArray(value)) {
    return true;
  }
  var proto = _getPrototypeOf(value);
  return proto === ObjectDotPrototype || proto === null || _getPrototypeOf(proto) === null;
}
var defaultValueObserved = function defaultValueObserved(obj, key) {
  /* do nothing */
};
var defaultValueMutated = function defaultValueMutated(obj, key) {
  /* do nothing */
};
function createShadowTarget(value) {
  return isArray(value) ? [] : {};
}
var ObservableMembrane = /*#__PURE__*/function () {
  function ObservableMembrane() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ObservableMembrane);
    this.readOnlyObjectGraph = new WeakMap();
    this.reactiveObjectGraph = new WeakMap();
    var valueMutated = options.valueMutated,
      valueObserved = options.valueObserved,
      valueIsObservable = options.valueIsObservable,
      tagPropertyKey = options.tagPropertyKey;
    this.valueMutated = isFunction(valueMutated) ? valueMutated : defaultValueMutated;
    this.valueObserved = isFunction(valueObserved) ? valueObserved : defaultValueObserved;
    this.valueIsObservable = isFunction(valueIsObservable) ? valueIsObservable : defaultValueIsObservable;
    this.tagPropertyKey = tagPropertyKey;
  }
  _createClass(ObservableMembrane, [{
    key: "getProxy",
    value: function getProxy(value) {
      var unwrappedValue = unwrap$1(value);
      if (this.valueIsObservable(unwrappedValue)) {
        // When trying to extract the writable version of a readonly we return the readonly.
        if (this.readOnlyObjectGraph.get(unwrappedValue) === value) {
          return value;
        }
        return this.getReactiveHandler(unwrappedValue);
      }
      return unwrappedValue;
    }
  }, {
    key: "getReadOnlyProxy",
    value: function getReadOnlyProxy(value) {
      value = unwrap$1(value);
      if (this.valueIsObservable(value)) {
        return this.getReadOnlyHandler(value);
      }
      return value;
    }
  }, {
    key: "unwrapProxy",
    value: function unwrapProxy(p) {
      return unwrap$1(p);
    }
  }, {
    key: "getReactiveHandler",
    value: function getReactiveHandler(value) {
      var proxy = this.reactiveObjectGraph.get(value);
      if (isUndefined(proxy)) {
        // caching the proxy after the first time it is accessed
        var handler = new ReactiveProxyHandler(this, value);
        proxy = new Proxy(createShadowTarget(value), handler);
        registerProxy(proxy, value);
        this.reactiveObjectGraph.set(value, proxy);
      }
      return proxy;
    }
  }, {
    key: "getReadOnlyHandler",
    value: function getReadOnlyHandler(value) {
      var proxy = this.readOnlyObjectGraph.get(value);
      if (isUndefined(proxy)) {
        // caching the proxy after the first time it is accessed
        var handler = new ReadOnlyHandler(this, value);
        proxy = new Proxy(createShadowTarget(value), handler);
        registerProxy(proxy, value);
        this.readOnlyObjectGraph.set(value, proxy);
      }
      return proxy;
    }
  }]);
  return ObservableMembrane;
}();
/** version: 2.0.0 */
/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var lockerLivePropertyKey = Symbol["for"]('@@lockerLiveValue');
var reactiveMembrane = new ObservableMembrane({
  valueObserved: valueObserved,
  valueMutated: valueMutated,
  tagPropertyKey: lockerLivePropertyKey
});
function getReadOnlyProxy(value) {
  // We must return a frozen wrapper around the value, so that child components cannot mutate properties passed to
  // them from their parents. This applies to both the client and server.
  return reactiveMembrane.getReadOnlyProxy(value);
}
function getReactiveProxy(value) {
  // On the server side, we don't need mutation tracking. Skipping it improves performance.
  return reactiveMembrane.getProxy(value);
}
// Making the component instance a live value when using Locker to support expandos.
function markLockerLiveObject(obj) {
  // On the server side, we don't need mutation tracking. Skipping it improves performance.
  {
    obj[lockerLivePropertyKey] = undefined;
  }
}

/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var globalStylesheet;
function isStyleElement(elm) {
  return elm.tagName === 'STYLE';
}
function fetchStylesheet(_x) {
  return _fetchStylesheet.apply(this, arguments);
}
function _fetchStylesheet() {
  _fetchStylesheet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(elm) {
    var href;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!isStyleElement(elm)) {
            _context5.next = 4;
            break;
          }
          return _context5.abrupt("return", elm.textContent);
        case 4:
          // <link>
          href = elm.href;
          _context5.prev = 5;
          _context5.next = 8;
          return fetch(href);
        case 8:
          _context5.next = 10;
          return _context5.sent.text();
        case 10:
          return _context5.abrupt("return", _context5.sent);
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](5);
          logWarnOnce("Ignoring cross-origin stylesheet in migrate mode: ".concat(href));
          // ignore errors with cross-origin stylesheets - nothing we can do for those
          return _context5.abrupt("return", '');
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[5, 13]]);
  }));
  return _fetchStylesheet.apply(this, arguments);
}
function initGlobalStylesheet() {
  var stylesheet = new CSSStyleSheet();
  var elmsToPromises = new Map();
  var lastSeenLength = 0;
  var copyToGlobalStylesheet = function copyToGlobalStylesheet() {
    var elms = document.head.querySelectorAll('style:not([data-rendered-by-lwc]),link[rel="stylesheet"]');
    if (elms.length === lastSeenLength) {
      return; // nothing to update
    }
    lastSeenLength = elms.length;
    var promises = _toConsumableArray(elms).map(function (elm) {
      var promise = elmsToPromises.get(elm);
      if (!promise) {
        // Cache the promise
        promise = fetchStylesheet(elm);
        elmsToPromises.set(elm, promise);
      }
      return promise;
    });
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    Promise.all(promises).then(function (stylesheetTexts) {
      // When replaceSync() is called, the entire contents of the constructable stylesheet are replaced
      // with the copied+concatenated styles. This means that any shadow root's adoptedStyleSheets that
      // contains this constructable stylesheet will immediately get the new styles.
      stylesheet.replaceSync(stylesheetTexts.join('\n'));
    });
  };
  var headObserver = new MutationObserver(copyToGlobalStylesheet);
  // By observing only the childList, note that we are not covering the case where someone changes an `href`
  // on an existing <link>`, or the textContent on an existing `<style>`. This is assumed to be an uncommon
  // case and not worth covering.
  headObserver.observe(document.head, {
    childList: true
  });
  copyToGlobalStylesheet();
  return stylesheet;
}
function applyShadowMigrateMode(shadowRoot) {
  if (!globalStylesheet) {
    globalStylesheet = initGlobalStylesheet();
  }
  shadowRoot.synthetic = true; // pretend to be synthetic mode
  shadowRoot.adoptedStyleSheets.push(globalStylesheet);
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * This module is responsible for producing the ComponentDef object that is always
 * accessible via `vm.def`. This is lazily created during the creation of the first
 * instance of a component class, and shared across all instances.
 *
 * This structure can be used to synthetically create proxies, and understand the
 * shape of a component. It is also used internally to apply extra optimizations.
 */
/**
 * This operation is called with a descriptor of an standard html property
 * that a Custom Element can support (including AOM properties), which
 * determines what kind of capabilities the Base Lightning Element should support. When producing the new descriptors
 * for the Base Lightning Element, it also include the reactivity bit, so the standard property is reactive.
 * @param propName
 * @param descriptor
 */
function createBridgeToElementDescriptor(propName, descriptor) {
  var _get = descriptor.get,
    _set = descriptor.set,
    enumerable = descriptor.enumerable,
    configurable = descriptor.configurable;
  if (!isFunction$1(_get)) {
    throw new TypeError("Detected invalid public property descriptor for HTMLElement.prototype.".concat(propName, " definition. Missing the standard getter."));
  }
  if (!isFunction$1(_set)) {
    throw new TypeError("Detected invalid public property descriptor for HTMLElement.prototype.".concat(propName, " definition. Missing the standard setter."));
  }
  return {
    enumerable: enumerable,
    configurable: configurable,
    get: function get() {
      var vm = getAssociatedVM(this);
      if (isBeingConstructed(vm)) {
        if (process.env.NODE_ENV !== 'production') {
          logError("The value of property `".concat(propName, "` can't be read from the constructor because the owner component hasn't set the value yet. Instead, use the constructor to set a default value for the property."), vm);
        }
        return;
      }
      componentValueObserved(vm, propName);
      return _get.call(vm.elm);
    },
    set: function set(newValue) {
      var vm = getAssociatedVM(this);
      if (process.env.NODE_ENV !== 'production') {
        var _vmBeingRendered = getVMBeingRendered();
        if (isInvokingRender) {
          logError("".concat(_vmBeingRendered, ".render() method has side effects on the state of ").concat(vm, ".").concat(propName));
        }
        if (isUpdatingTemplate) {
          logError("When updating the template of ".concat(_vmBeingRendered, ", one of the accessors used by the template has side effects on the state of ").concat(vm, ".").concat(propName));
        }
        if (isBeingConstructed(vm)) {
          logError("Failed to construct '".concat(getComponentTag(vm), "': The result must not have attributes."));
        }
        if (isObject(newValue) && !isNull(newValue)) {
          logError("Invalid value \"".concat(newValue, "\" for \"").concat(propName, "\" of ").concat(vm, ". Value cannot be an object, must be a primitive value."));
        }
      }
      updateComponentValue(vm, propName, newValue);
      return _set.call(vm.elm, newValue);
    }
  };
}
var refsCache = new WeakMap();
/**
 * This class is the base class for any LWC element.
 * Some elements directly extends this class, others implement it via inheritance.
 */
// @ts-expect-error When exported, it will conform, but we need to build it first!
var LightningElement = function LightningElement() {
  // This should be as performant as possible, while any initialization should be done lazily
  if (isNull(vmBeingConstructed)) {
    // Thrown when doing something like `new LightningElement()` or
    // `class Foo extends LightningElement {}; new Foo()`
    throw new TypeError('Illegal constructor');
  }
  // This is a no-op unless Lightning DevTools are enabled.
  instrumentInstance(this, vmBeingConstructed);
  var vm = vmBeingConstructed;
  var def = vm.def,
    elm = vm.elm;
  var bridge = def.bridge;
  if (process.env.NODE_ENV !== 'production') {
    var assertInstanceOfHTMLElement = vm.renderer.assertInstanceOfHTMLElement;
    assertInstanceOfHTMLElement(vm.elm, "Component creation requires a DOM element to be associated to ".concat(vm, "."));
  }
  setPrototypeOf(elm, bridge.prototype);
  vm.component = this;
  // Locker hooks assignment. When the LWC engine run with Locker, Locker intercepts all the new
  // component creation and passes hooks to instrument all the component interactions with the
  // engine. We are intentionally hiding this argument from the formal API of LightningElement
  // because we don't want folks to know about it just yet.
  if (arguments.length === 1) {
    var _arguments$ = arguments[0],
      _callHook = _arguments$.callHook,
      _setHook = _arguments$.setHook,
      _getHook = _arguments$.getHook;
    vm.callHook = _callHook;
    vm.setHook = _setHook;
    vm.getHook = _getHook;
  }
  markLockerLiveObject(this);
  // Linking elm, shadow root and component with the VM.
  associateVM(this, vm);
  associateVM(elm, vm);
  if (vm.renderMode === 1 /* RenderMode.Shadow */) {
    vm.renderRoot = doAttachShadow(vm);
  } else {
    vm.renderRoot = elm;
  }
  // Adding extra guard rails in DEV mode.
  if (process.env.NODE_ENV !== 'production') {
    patchCustomElementWithRestrictions(elm);
  }
  return this;
};
function doAttachShadow(vm) {
  var _attachShadow;
  var elm = vm.elm,
    mode = vm.mode,
    shadowMode = vm.shadowMode,
    ctor = vm.def.ctor,
    attachShadow = vm.renderer.attachShadow;
  var shadowRoot = attachShadow(elm, (_attachShadow = {}, _defineProperty(_attachShadow, KEY__SYNTHETIC_MODE, shadowMode === 1), _defineProperty(_attachShadow, "delegatesFocus", Boolean(ctor.delegatesFocus)), _defineProperty(_attachShadow, "mode", mode), _attachShadow));
  vm.shadowRoot = shadowRoot;
  associateVM(shadowRoot, vm);
  if (process.env.NODE_ENV !== 'production') {
    patchShadowRootWithRestrictions(shadowRoot);
  }
  if (lwcRuntimeFlags.ENABLE_FORCE_SHADOW_MIGRATE_MODE && vm.shadowMigrateMode) {
    applyShadowMigrateMode(shadowRoot);
  }
  return shadowRoot;
}
function warnIfInvokedDuringConstruction(vm, methodOrPropName) {
  if (isBeingConstructed(vm)) {
    logError("this.".concat(methodOrPropName, " should not be called during the construction of the custom element for ").concat(getComponentTag(vm), " because the element is not yet in the DOM or has no children yet."));
  }
}
// Type assertion because we need to build the prototype before it satisfies the interface.
LightningElement.prototype = {
  constructor: LightningElement,
  dispatchEvent: function dispatchEvent(event) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      dispatchEvent = vm.renderer.dispatchEvent;
    return dispatchEvent(elm, event);
  },
  addEventListener: function addEventListener(type, listener, options) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      addEventListener = vm.renderer.addEventListener;
    if (process.env.NODE_ENV !== 'production') {
      var _vmBeingRendered2 = getVMBeingRendered();
      if (isInvokingRender) {
        logError("".concat(_vmBeingRendered2, ".render() method has side effects on the state of ").concat(vm, " by adding an event listener for \"").concat(type, "\"."));
      }
      if (isUpdatingTemplate) {
        logError("Updating the template of ".concat(_vmBeingRendered2, " has side effects on the state of ").concat(vm, " by adding an event listener for \"").concat(type, "\"."));
      }
      if (!isFunction$1(listener)) {
        logError("Invalid second argument for this.addEventListener() in ".concat(vm, " for event \"").concat(type, "\". Expected an EventListener but received ").concat(listener, "."));
      }
    }
    var wrappedListener = getWrappedComponentsListener(vm, listener);
    addEventListener(elm, type, wrappedListener, options);
  },
  removeEventListener: function removeEventListener(type, listener, options) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      removeEventListener = vm.renderer.removeEventListener;
    var wrappedListener = getWrappedComponentsListener(vm, listener);
    removeEventListener(elm, type, wrappedListener, options);
  },
  hasAttribute: function hasAttribute(name) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      getAttribute = vm.renderer.getAttribute;
    return !isNull(getAttribute(elm, name));
  },
  hasAttributeNS: function hasAttributeNS(namespace, name) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      getAttribute = vm.renderer.getAttribute;
    return !isNull(getAttribute(elm, name, namespace));
  },
  removeAttribute: function removeAttribute(name) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      removeAttribute = vm.renderer.removeAttribute;
    removeAttribute(elm, name);
  },
  removeAttributeNS: function removeAttributeNS(namespace, name) {
    var _getAssociatedVM = getAssociatedVM(this),
      elm = _getAssociatedVM.elm,
      removeAttribute = _getAssociatedVM.renderer.removeAttribute;
    removeAttribute(elm, name, namespace);
  },
  getAttribute: function getAttribute(name) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm;
    var getAttribute = vm.renderer.getAttribute;
    return getAttribute(elm, name);
  },
  getAttributeNS: function getAttributeNS(namespace, name) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm;
    var getAttribute = vm.renderer.getAttribute;
    return getAttribute(elm, name, namespace);
  },
  setAttribute: function setAttribute(name, value) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      setAttribute = vm.renderer.setAttribute;
    if (process.env.NODE_ENV !== 'production') {
      if (isBeingConstructed(vm)) {
        logError("Failed to construct '".concat(getComponentTag(vm), "': The result must not have attributes."));
      }
    }
    setAttribute(elm, name, value);
  },
  setAttributeNS: function setAttributeNS(namespace, name, value) {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      setAttribute = vm.renderer.setAttribute;
    if (process.env.NODE_ENV !== 'production') {
      if (isBeingConstructed(vm)) {
        logError("Failed to construct '".concat(getComponentTag(vm), "': The result must not have attributes."));
      }
    }
    setAttribute(elm, name, value, namespace);
  },
  getBoundingClientRect: function getBoundingClientRect() {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      getBoundingClientRect = vm.renderer.getBoundingClientRect;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'getBoundingClientRect()');
    }
    return getBoundingClientRect(elm);
  },
  attachInternals: function attachInternals() {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      apiVersion = vm.apiVersion,
      attachInternals = vm.renderer.attachInternals;
    if (!isAPIFeatureEnabled(8 /* APIFeature.ENABLE_ELEMENT_INTERNALS_AND_FACE */, apiVersion)) {
      throw new Error("The attachInternals API is only supported in API version 61 and above. " + "The current version is ".concat(apiVersion, ". ") + "To use this API, update the LWC component API version. https://lwc.dev/guide/versioning");
    }
    if (vm.shadowMode === 1 /* ShadowMode.Synthetic */) {
      throw new Error('attachInternals API is not supported in synthetic shadow.');
    }
    return attachInternals(elm);
  },
  get isConnected() {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      isConnected = vm.renderer.isConnected;
    return isConnected(elm);
  },
  get classList() {
    var vm = getAssociatedVM(this);
    var elm = vm.elm,
      getClassList = vm.renderer.getClassList;
    if (process.env.NODE_ENV !== 'production') {
      if (isBeingConstructed(vm)) {
        logError("Failed to construct ".concat(vm, ": The result must not have attributes. Adding or tampering with classname in constructor is not allowed in a web component, use connectedCallback() instead."));
      }
    }
    return getClassList(elm);
  },
  get template() {
    var vm = getAssociatedVM(this);
    if (process.env.NODE_ENV !== 'production') {
      if (vm.renderMode === 0 /* RenderMode.Light */) {
        logError('`this.template` returns null for light DOM components. Since there is no shadow, the rendered content can be accessed via `this` itself. e.g. instead of `this.template.querySelector`, use `this.querySelector`.');
      }
    }
    return vm.shadowRoot;
  },
  get refs() {
    var vm = getAssociatedVM(this);
    if (isUpdatingTemplate) {
      if (process.env.NODE_ENV !== 'production') {
        logError("this.refs should not be called while ".concat(getComponentTag(vm), " is rendering. Use this.refs only when the DOM is stable, e.g. in renderedCallback()."));
      }
      // If the template is in the process of being updated, then we don't want to go through the normal
      // process of returning the refs and caching them, because the state of the refs is unstable.
      // This can happen if e.g. a template contains `<div class={foo}></div>` and `foo` is computed
      // based on `this.refs.bar`.
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'refs');
    }
    var refVNodes = vm.refVNodes,
      cmpTemplate = vm.cmpTemplate;
    // If the `cmpTemplate` is null, that means that the template has not been rendered yet. Most likely this occurs
    // if `this.refs` is called during the `connectedCallback` phase. The DOM elements have not been rendered yet,
    // so log a warning. Note we also check `isBeingConstructed()` to avoid a double warning (due to
    // `warnIfInvokedDuringConstruction` above).
    if (process.env.NODE_ENV !== 'production' && isNull(cmpTemplate) && !isBeingConstructed(vm)) {
      logError("this.refs is undefined for ".concat(getComponentTag(vm), ". This is either because the attached template has no \"lwc:ref\" directive, or this.refs was ") + "invoked before renderedCallback(). Use this.refs only when the referenced HTML elements have " + "been rendered to the DOM, such as within renderedCallback() or disconnectedCallback().");
    }
    // For backwards compatibility with component written before template refs
    // were introduced, we return undefined if the template has no refs defined
    // anywhere. This fixes components that may want to add an expando called `refs`
    // and are checking if it exists with `if (this.refs)`  before adding it.
    // Note we use a null refVNodes to indicate that the template has no refs defined.
    if (isNull(refVNodes)) {
      return;
    }
    // The refNodes can be cached based on the refVNodes, since the refVNodes
    // are recreated from scratch every time the template is rendered.
    // This happens with `vm.refVNodes = null` in `template.ts` in `@lwc/engine-core`.
    var refs = refsCache.get(refVNodes);
    if (isUndefined$1(refs)) {
      refs = create(null);
      var _iterator3 = _createForOfIteratorHelper(keys(refVNodes)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var key = _step3.value;
          refs[key] = refVNodes[key].elm;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      freeze(refs);
      refsCache.set(refVNodes, refs);
    }
    return refs;
  },
  // For backwards compat, we allow component authors to set `refs` as an expando
  set refs(value) {
    defineProperty(this, 'refs', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: value
    });
  },
  get shadowRoot() {
    // From within the component instance, the shadowRoot is always reported as "closed".
    // Authors should rely on this.template instead.
    return null;
  },
  get children() {
    var vm = getAssociatedVM(this);
    var renderer = vm.renderer;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'children');
    }
    return renderer.getChildren(vm.elm);
  },
  get childNodes() {
    var vm = getAssociatedVM(this);
    var renderer = vm.renderer;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'childNodes');
    }
    // getChildNodes returns a NodeList, which has `item(index: number): Node | null`.
    // NodeListOf<T> extends NodeList, but claims to not return null. That seems inaccurate,
    // but these are built-in types, so ultimately not our problem.
    return renderer.getChildNodes(vm.elm);
  },
  get firstChild() {
    var vm = getAssociatedVM(this);
    var renderer = vm.renderer;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'firstChild');
    }
    return renderer.getFirstChild(vm.elm);
  },
  get firstElementChild() {
    var vm = getAssociatedVM(this);
    var renderer = vm.renderer;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'firstElementChild');
    }
    return renderer.getFirstElementChild(vm.elm);
  },
  get lastChild() {
    var vm = getAssociatedVM(this);
    var renderer = vm.renderer;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'lastChild');
    }
    return renderer.getLastChild(vm.elm);
  },
  get lastElementChild() {
    var vm = getAssociatedVM(this);
    var renderer = vm.renderer;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'lastElementChild');
    }
    return renderer.getLastElementChild(vm.elm);
  },
  get ownerDocument() {
    var vm = getAssociatedVM(this);
    var renderer = vm.renderer;
    if (process.env.NODE_ENV !== 'production') {
      warnIfInvokedDuringConstruction(vm, 'ownerDocument');
    }
    return renderer.ownerDocument(vm.elm);
  },
  get tagName() {
    var _getAssociatedVM2 = getAssociatedVM(this),
      elm = _getAssociatedVM2.elm,
      renderer = _getAssociatedVM2.renderer;
    return renderer.getTagName(elm);
  },
  render: function render() {
    var vm = getAssociatedVM(this);
    return vm.def.template;
  },
  toString: function toString() {
    var vm = getAssociatedVM(this);
    return "[object ".concat(vm.def.name, "]");
  }
};
var queryAndChildGetterDescriptors = create(null);
var queryMethods = ['getElementsByClassName', 'getElementsByTagName', 'querySelector', 'querySelectorAll'];
// Generic passthrough for query APIs on HTMLElement to the relevant Renderer APIs
var _loop = function _loop() {
  var queryMethod = _queryMethods[_i5];
  queryAndChildGetterDescriptors[queryMethod] = {
    value: function value(arg) {
      var vm = getAssociatedVM(this);
      var elm = vm.elm,
        renderer = vm.renderer;
      if (process.env.NODE_ENV !== 'production') {
        warnIfInvokedDuringConstruction(vm, "".concat(queryMethod, "()"));
      }
      return renderer[queryMethod](elm, arg);
    },
    configurable: true,
    enumerable: true,
    writable: true
  };
};
for (var _i5 = 0, _queryMethods = queryMethods; _i5 < _queryMethods.length; _i5++) {
  _loop();
}
defineProperties(LightningElement.prototype, queryAndChildGetterDescriptors);
var lightningBasedDescriptors = create(null);
for (var propName in HTMLElementOriginalDescriptors) {
  lightningBasedDescriptors[propName] = createBridgeToElementDescriptor(propName, HTMLElementOriginalDescriptors[propName]);
}
// Apply ARIA reflection to LightningElement.prototype, on both the browser and server.
// This allows `this.aria*` property accessors to work from inside a component, and to reflect `aria-*` attrs.
// Note this works regardless of whether the global ARIA reflection polyfill is applied or not.
{
  // In the browser, we use createBridgeToElementDescriptor, so we can get the normal reactivity lifecycle for
  // aria* properties
  var _iterator4 = _createForOfIteratorHelper(entries(ariaReflectionPolyfillDescriptors)),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _slicedToArray(_step4.value, 2),
        _propName = _step4$value[0],
        descriptor = _step4$value[1];
      lightningBasedDescriptors[_propName] = createBridgeToElementDescriptor(_propName, descriptor);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
defineProperties(LightningElement.prototype, lightningBasedDescriptors);
defineProperty(LightningElement, 'CustomElementConstructor', {
  get: function get() {
    // If required, a runtime-specific implementation must be defined.
    throw new ReferenceError('The current runtime does not support CustomElementConstructor.');
  },
  configurable: true
});
function createObservedFieldPropertyDescriptor(key) {
  return {
    get: function get() {
      var vm = getAssociatedVM(this);
      var val = vm.cmpFields[key];
      componentValueObserved(vm, key, val);
      return val;
    },
    set: function set(newValue) {
      var vm = getAssociatedVM(this);
      updateComponentValue(vm, key, newValue);
    },
    enumerable: true,
    configurable: true
  };
}

/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var AdapterToTokenMap = new Map();
function createContextWatcher(vm, wireDef, callbackWhenContextIsReady) {
  var adapter = wireDef.adapter;
  var adapterContextToken = AdapterToTokenMap.get(adapter);
  if (isUndefined$1(adapterContextToken)) {
    return; // no provider found, nothing to be done
  }
  var elm = vm.elm,
    _vm$context = vm.context,
    wiredConnecting = _vm$context.wiredConnecting,
    wiredDisconnecting = _vm$context.wiredDisconnecting,
    registerContextConsumer = vm.renderer.registerContextConsumer;
  // waiting for the component to be connected to formally request the context via the token
  ArrayPush$1.call(wiredConnecting, function () {
    // This will attempt to connect the current element with one of its anscestors
    // that can provide context for the given wire adapter. This relationship is
    // keyed on the secret & internal value of `adapterContextToken`, which is unique
    // to a given wire adapter.
    //
    // Depending on the runtime environment, this connection is made using either DOM
    // events (in the browser) or a custom traversal (on the server).
    registerContextConsumer(elm, adapterContextToken, {
      setNewContext: function setNewContext(newContext) {
        // eslint-disable-next-line @lwc/lwc-internal/no-invalid-todo
        // TODO: dev-mode validation of config based on the adapter.contextSchema
        callbackWhenContextIsReady(newContext);
      },
      setDisconnectedCallback: function setDisconnectedCallback(disconnectCallback) {
        // adds this callback into the disconnect bucket so it gets disconnected from parent
        // the the element hosting the wire is disconnected
        ArrayPush$1.call(wiredDisconnecting, disconnectCallback);
      }
    });
  });
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var DeprecatedWiredElementHost = '$$DeprecatedWiredElementHostKey$$';
var DeprecatedWiredParamsMeta = '$$DeprecatedWiredParamsMetaKey$$';
var WIRE_DEBUG_ENTRY = '@wire';
var WireMetaMap = new Map();
function createFieldDataCallback(vm, name) {
  return function (value) {
    updateComponentValue(vm, name, value);
  };
}
function createMethodDataCallback(vm, method) {
  return function (value) {
    // dispatching new value into the wired method
    runWithBoundaryProtection(vm, vm.owner, noop, function () {
      // job
      method.call(vm.component, value);
    }, noop);
  };
}
function createConfigWatcher(component, configCallback, callbackWhenConfigIsReady) {
  var hasPendingConfig = false;
  // creating the reactive observer for reactive params when needed
  var ro = createReactiveObserver(function () {
    if (hasPendingConfig === false) {
      hasPendingConfig = true;
      // collect new config in the micro-task
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      Promise.resolve().then(function () {
        hasPendingConfig = false;
        // resetting current reactive params
        ro.reset();
        // dispatching a new config due to a change in the configuration
        computeConfigAndUpdate();
      });
    }
  });
  var computeConfigAndUpdate = function computeConfigAndUpdate() {
    var config;
    ro.observe(function () {
      return config = configCallback(component);
    });
    // eslint-disable-next-line @lwc/lwc-internal/no-invalid-todo
    // TODO: dev-mode validation of config based on the adapter.configSchema
    // @ts-expect-error it is assigned in the observe() callback
    callbackWhenConfigIsReady(config);
  };
  return {
    computeConfigAndUpdate: computeConfigAndUpdate,
    ro: ro
  };
}
function createConnector(vm, name, wireDef) {
  var method = wireDef.method,
    adapter = wireDef.adapter,
    configCallback = wireDef.configCallback,
    dynamic = wireDef.dynamic;
  var debugInfo;
  if (process.env.NODE_ENV !== 'production') {
    var wiredPropOrMethod = isUndefined$1(method) ? name : method.name;
    debugInfo = create(null);
    debugInfo.wasDataProvisionedForConfig = false;
    vm.debugInfo[WIRE_DEBUG_ENTRY][wiredPropOrMethod] = debugInfo;
  }
  var fieldOrMethodCallback = isUndefined$1(method) ? createFieldDataCallback(vm, name) : createMethodDataCallback(vm, method);
  var dataCallback = function dataCallback(value) {
    if (process.env.NODE_ENV !== 'production') {
      debugInfo.data = value;
      // Note: most of the time, the data provided is for the current config, but there may be
      // some conditions in which it does not, ex:
      // race conditions in a poor network while the adapter does not cancel a previous request.
      debugInfo.wasDataProvisionedForConfig = true;
    }
    fieldOrMethodCallback(value);
  };
  var context;
  var connector;
  // Workaround to pass the component element associated to this wire adapter instance.
  defineProperty(dataCallback, DeprecatedWiredElementHost, {
    value: vm.elm
  });
  defineProperty(dataCallback, DeprecatedWiredParamsMeta, {
    value: dynamic
  });
  runWithBoundaryProtection(vm, vm, noop, function () {
    // job
    connector = new adapter(dataCallback, {
      tagName: vm.tagName
    });
  }, noop);
  var updateConnectorConfig = function updateConnectorConfig(config) {
    // every time the config is recomputed due to tracking,
    // this callback will be invoked with the new computed config
    runWithBoundaryProtection(vm, vm, noop, function () {
      // job
      if (process.env.NODE_ENV !== 'production') {
        debugInfo.config = config;
        debugInfo.context = context;
        debugInfo.wasDataProvisionedForConfig = false;
      }
      connector.update(config, context);
    }, noop);
  };
  // Computes the current wire config and calls the update method on the wire adapter.
  // If it has params, we will need to observe changes in the next tick.
  var _createConfigWatcher = createConfigWatcher(vm.component, configCallback, updateConnectorConfig),
    computeConfigAndUpdate = _createConfigWatcher.computeConfigAndUpdate,
    ro = _createConfigWatcher.ro;
  // if the adapter needs contextualization, we need to watch for new context and push it alongside the config
  if (!isUndefined$1(adapter.contextSchema)) {
    createContextWatcher(vm, wireDef, function (newContext) {
      // every time the context is pushed into this component,
      // this callback will be invoked with the new computed context
      if (context !== newContext) {
        context = newContext;
        // Note: when new context arrives, the config will be recomputed and pushed along side the new
        // context, this is to preserve the identity characteristics, config should not have identity
        // (ever), while context can have identity
        if (vm.state === 1 /* VMState.connected */) {
          computeConfigAndUpdate();
        }
      }
    });
  }
  return {
    // @ts-expect-error the boundary protection executes sync, connector is always defined
    connector: connector,
    computeConfigAndUpdate: computeConfigAndUpdate,
    resetConfigWatcher: function resetConfigWatcher() {
      return ro.reset();
    }
  };
}
function storeWiredMethodMeta(descriptor, adapter, configCallback, dynamic) {
  // support for callable adapters
  if (adapter.adapter) {
    adapter = adapter.adapter;
  }
  var method = descriptor.value;
  var def = {
    adapter: adapter,
    method: method,
    configCallback: configCallback,
    dynamic: dynamic
  };
  WireMetaMap.set(descriptor, def);
}
function storeWiredFieldMeta(descriptor, adapter, configCallback, dynamic) {
  // support for callable adapters
  if (adapter.adapter) {
    adapter = adapter.adapter;
  }
  var def = {
    adapter: adapter,
    configCallback: configCallback,
    dynamic: dynamic
  };
  WireMetaMap.set(descriptor, def);
}
function installWireAdapters(vm) {
  var context = vm.context,
    wire = vm.def.wire;
  if (process.env.NODE_ENV !== 'production') {
    vm.debugInfo[WIRE_DEBUG_ENTRY] = create(null);
  }
  var wiredConnecting = context.wiredConnecting = [];
  var wiredDisconnecting = context.wiredDisconnecting = [];
  var _loop2 = function _loop2() {
    var descriptor = wire[fieldNameOrMethod];
    var wireDef = WireMetaMap.get(descriptor);
    if (process.env.NODE_ENV !== 'production') {
      assert.invariant(wireDef, "Internal Error: invalid wire definition found.");
    }
    if (!isUndefined$1(wireDef)) {
      var _createConnector = createConnector(vm, fieldNameOrMethod, wireDef),
        connector = _createConnector.connector,
        computeConfigAndUpdate = _createConnector.computeConfigAndUpdate,
        resetConfigWatcher = _createConnector.resetConfigWatcher;
      var hasDynamicParams = wireDef.dynamic.length > 0;
      ArrayPush$1.call(wiredConnecting, function () {
        connector.connect();
        if (!lwcRuntimeFlags.ENABLE_WIRE_SYNC_EMIT) {
          if (hasDynamicParams) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            Promise.resolve().then(computeConfigAndUpdate);
            return;
          }
        }
        computeConfigAndUpdate();
      });
      ArrayPush$1.call(wiredDisconnecting, function () {
        connector.disconnect();
        resetConfigWatcher();
      });
    }
  };
  for (var fieldNameOrMethod in wire) {
    _loop2();
  }
}
function connectWireAdapters(vm) {
  var wiredConnecting = vm.context.wiredConnecting;
  for (var _i6 = 0, len = wiredConnecting.length; _i6 < len; _i6 += 1) {
    wiredConnecting[_i6]();
  }
}
function disconnectWireAdapters(vm) {
  var wiredDisconnecting = vm.context.wiredDisconnecting;
  runWithBoundaryProtection(vm, vm, noop, function () {
    // job
    for (var _i7 = 0, len = wiredDisconnecting.length; _i7 < len; _i7 += 1) {
      wiredDisconnecting[_i7]();
    }
  }, noop);
}
function createPublicPropertyDescriptor(key) {
  return {
    get: function get() {
      var vm = getAssociatedVM(this);
      if (isBeingConstructed(vm)) {
        if (process.env.NODE_ENV !== 'production') {
          logError("Can\u2019t read the value of property `".concat(toString$1(key), "` from the constructor because the owner component hasn\u2019t set the value yet. Instead, use the constructor to set a default value for the property."), vm);
        }
        return;
      }
      var val = vm.cmpProps[key];
      componentValueObserved(vm, key, val);
      return val;
    },
    set: function set(newValue) {
      var vm = getAssociatedVM(this);
      if (process.env.NODE_ENV !== 'production') {
        var _vmBeingRendered3 = getVMBeingRendered();
        if (isInvokingRender) {
          logError("render() method has side effects on the state of property \"".concat(toString$1(key), "\""), isNull(_vmBeingRendered3) ? vm : _vmBeingRendered3);
        }
        if (isUpdatingTemplate) {
          logError("Updating the template has side effects on the state of property \"".concat(toString$1(key), "\""), isNull(_vmBeingRendered3) ? vm : _vmBeingRendered3);
        }
      }
      vm.cmpProps[key] = newValue;
      componentValueMutated(vm, key);
    },
    enumerable: true,
    configurable: true
  };
}
function createPublicAccessorDescriptor(key, descriptor) {
  var _get2 = descriptor.get,
    _set2 = descriptor.set,
    enumerable = descriptor.enumerable,
    configurable = descriptor.configurable;
  assert.invariant(isFunction$1(_get2), "Invalid public accessor ".concat(toString$1(key), " decorated with @api. The property is missing a getter."));
  return {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        // Assert that the this value is an actual Component with an associated VM.
        getAssociatedVM(this);
      }
      return _get2.call(this);
    },
    set: function set(newValue) {
      var vm = getAssociatedVM(this);
      if (process.env.NODE_ENV !== 'production') {
        var _vmBeingRendered4 = getVMBeingRendered();
        if (isInvokingRender) {
          logError("render() method has side effects on the state of property \"".concat(toString$1(key), "\""), isNull(_vmBeingRendered4) ? vm : _vmBeingRendered4);
        }
        if (isUpdatingTemplate) {
          logError("Updating the template has side effects on the state of property \"".concat(toString$1(key), "\""), isNull(_vmBeingRendered4) ? vm : _vmBeingRendered4);
        }
      }
      if (_set2) {
        _set2.call(this, newValue);
      } else if (process.env.NODE_ENV !== 'production') {
        logError("Invalid attempt to set a new value for property \"".concat(toString$1(key), "\" that does not has a setter decorated with @api."), vm);
      }
    },
    enumerable: enumerable,
    configurable: configurable
  };
}
function internalTrackDecorator(key) {
  return {
    get: function get() {
      var vm = getAssociatedVM(this);
      var val = vm.cmpFields[key];
      componentValueObserved(vm, key, val);
      return val;
    },
    set: function set(newValue) {
      var vm = getAssociatedVM(this);
      if (process.env.NODE_ENV !== 'production') {
        var _vmBeingRendered5 = getVMBeingRendered();
        if (isInvokingRender) {
          logError("".concat(_vmBeingRendered5, ".render() method has side effects on the state of ").concat(vm, ".").concat(toString$1(key)));
        }
        if (isUpdatingTemplate) {
          logError("Updating the template of ".concat(_vmBeingRendered5, " has side effects on the state of ").concat(vm, ".").concat(toString$1(key)));
        }
      }
      var reactiveOrAnyValue = getReactiveProxy(newValue);
      updateComponentValue(vm, key, reactiveOrAnyValue);
    },
    enumerable: true,
    configurable: true
  };
}
function internalWireFieldDecorator(key) {
  return {
    get: function get() {
      var vm = getAssociatedVM(this);
      componentValueObserved(vm, key);
      return vm.cmpFields[key];
    },
    set: function set(value) {
      var vm = getAssociatedVM(this);
      /**
       * Reactivity for wired fields is provided in wiring.
       * We intentionally add reactivity here since this is just
       * letting the author to do the wrong thing, but it will keep our
       * system to be backward compatible.
       */
      updateComponentValue(vm, key, value);
    },
    enumerable: true,
    configurable: true
  };
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function getClassDescriptorType(descriptor) {
  if (isFunction$1(descriptor.value)) {
    return "method" /* DescriptorType.Method */;
  } else if (isFunction$1(descriptor.set) || isFunction$1(descriptor.get)) {
    return "accessor" /* DescriptorType.Accessor */;
  } else {
    return "field" /* DescriptorType.Field */;
  }
}
function validateObservedField(Ctor, fieldName, descriptor) {
  assertNotProd(); // this method should never leak to prod
  if (!isUndefined$1(descriptor)) {
    var type = getClassDescriptorType(descriptor);
    var message = "Invalid observed ".concat(fieldName, " field. Found a duplicate ").concat(type, " with the same name.");
    // TODO [#3408]: this should throw, not log
    logError(message);
  }
}
function validateFieldDecoratedWithTrack(Ctor, fieldName, descriptor) {
  assertNotProd(); // this method should never leak to prod
  if (!isUndefined$1(descriptor)) {
    var type = getClassDescriptorType(descriptor);
    // TODO [#3408]: this should throw, not log
    logError("Invalid @track ".concat(fieldName, " field. Found a duplicate ").concat(type, " with the same name."));
  }
}
function validateFieldDecoratedWithWire(Ctor, fieldName, descriptor) {
  assertNotProd(); // this method should never leak to prod
  if (!isUndefined$1(descriptor)) {
    var type = getClassDescriptorType(descriptor);
    // TODO [#3408]: this should throw, not log
    logError("Invalid @wire ".concat(fieldName, " field. Found a duplicate ").concat(type, " with the same name."));
  }
}
function validateMethodDecoratedWithWire(Ctor, methodName, descriptor) {
  assertNotProd(); // this method should never leak to prod
  if (isUndefined$1(descriptor) || !isFunction$1(descriptor.value) || isFalse(descriptor.writable)) {
    // TODO [#3441]: This line of code does not seem possible to reach.
    logError("Invalid @wire ".concat(methodName, " field. The field should have a valid writable descriptor."));
  }
}
function validateFieldDecoratedWithApi(Ctor, fieldName, descriptor) {
  assertNotProd(); // this method should never leak to prod
  if (!isUndefined$1(descriptor)) {
    var type = getClassDescriptorType(descriptor);
    var message = "Invalid @api ".concat(fieldName, " field. Found a duplicate ").concat(type, " with the same name.");
    // TODO [#3408]: this should throw, not log
    logError(message);
  }
}
function validateAccessorDecoratedWithApi(Ctor, fieldName, descriptor) {
  assertNotProd(); // this method should never leak to prod
  if (isFunction$1(descriptor.set)) {
    if (!isFunction$1(descriptor.get)) {
      // TODO [#3441]: This line of code does not seem possible to reach.
      logError("Missing getter for property ".concat(fieldName, " decorated with @api in ").concat(Ctor, ". You cannot have a setter without the corresponding getter."));
    }
  } else if (!isFunction$1(descriptor.get)) {
    // TODO [#3441]: This line of code does not seem possible to reach.
    logError("Missing @api get ".concat(fieldName, " accessor."));
  }
}
function validateMethodDecoratedWithApi(Ctor, methodName, descriptor) {
  assertNotProd(); // this method should never leak to prod
  if (isUndefined$1(descriptor) || !isFunction$1(descriptor.value) || isFalse(descriptor.writable)) {
    // TODO [#3441]: This line of code does not seem possible to reach.
    logError("Invalid @api ".concat(methodName, " method."));
  }
}
/**
 * INTERNAL: This function can only be invoked by compiled code. The compiler
 * will prevent this function from being imported by user-land code.
 * @param Ctor
 * @param meta
 */
function registerDecorators(Ctor, meta) {
  var proto = Ctor.prototype;
  var publicProps = meta.publicProps,
    publicMethods = meta.publicMethods,
    wire = meta.wire,
    track = meta.track,
    fields = meta.fields;
  var apiMethods = create(null);
  var apiFields = create(null);
  var wiredMethods = create(null);
  var wiredFields = create(null);
  var observedFields = create(null);
  var apiFieldsConfig = create(null);
  var descriptor;
  if (!isUndefined$1(publicProps)) {
    for (var fieldName in publicProps) {
      var propConfig = publicProps[fieldName];
      apiFieldsConfig[fieldName] = propConfig.config;
      descriptor = getOwnPropertyDescriptor$1(proto, fieldName);
      if (propConfig.config > 0) {
        if (isUndefined$1(descriptor)) {
          // TODO [#3441]: This line of code does not seem possible to reach.
          throw new Error();
        }
        // accessor declaration
        if (process.env.NODE_ENV !== 'production') {
          validateAccessorDecoratedWithApi(Ctor, fieldName, descriptor);
        }
        descriptor = createPublicAccessorDescriptor(fieldName, descriptor);
      } else {
        // field declaration
        if (process.env.NODE_ENV !== 'production') {
          validateFieldDecoratedWithApi(Ctor, fieldName, descriptor);
        }
        // [W-9927596] If a component has both a public property and a private setter/getter
        // with the same name, the property is defined as a public accessor. This branch is
        // only here for backward compatibility reasons.
        if (!isUndefined$1(descriptor) && !isUndefined$1(descriptor.get)) {
          descriptor = createPublicAccessorDescriptor(fieldName, descriptor);
        } else {
          descriptor = createPublicPropertyDescriptor(fieldName);
        }
      }
      apiFields[fieldName] = descriptor;
      defineProperty(proto, fieldName, descriptor);
    }
  }
  if (!isUndefined$1(publicMethods)) {
    forEach.call(publicMethods, function (methodName) {
      descriptor = getOwnPropertyDescriptor$1(proto, methodName);
      if (process.env.NODE_ENV !== 'production') {
        validateMethodDecoratedWithApi(Ctor, methodName, descriptor);
      }
      if (isUndefined$1(descriptor)) {
        throw new Error();
      }
      apiMethods[methodName] = descriptor;
    });
  }
  if (!isUndefined$1(wire)) {
    for (var fieldOrMethodName in wire) {
      var _wire$fieldOrMethodNa = wire[fieldOrMethodName],
        adapter = _wire$fieldOrMethodNa.adapter,
        method = _wire$fieldOrMethodNa.method,
        configCallback = _wire$fieldOrMethodNa.config,
        _wire$fieldOrMethodNa2 = _wire$fieldOrMethodNa.dynamic,
        dynamic = _wire$fieldOrMethodNa2 === void 0 ? [] : _wire$fieldOrMethodNa2;
      descriptor = getOwnPropertyDescriptor$1(proto, fieldOrMethodName);
      if (method === 1) {
        if (process.env.NODE_ENV !== 'production') {
          if (!adapter) {
            // TODO [#3408]: this should throw, not log
            logError("@wire on method \"".concat(fieldOrMethodName, "\": adapter id must be truthy."));
          }
          validateMethodDecoratedWithWire(Ctor, fieldOrMethodName, descriptor);
        }
        if (isUndefined$1(descriptor)) {
          throw new Error();
        }
        wiredMethods[fieldOrMethodName] = descriptor;
        storeWiredMethodMeta(descriptor, adapter, configCallback, dynamic);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (!adapter) {
            // TODO [#3408]: this should throw, not log
            logError("@wire on field \"".concat(fieldOrMethodName, "\": adapter id must be truthy."));
          }
          validateFieldDecoratedWithWire(Ctor, fieldOrMethodName, descriptor);
        }
        descriptor = internalWireFieldDecorator(fieldOrMethodName);
        wiredFields[fieldOrMethodName] = descriptor;
        storeWiredFieldMeta(descriptor, adapter, configCallback, dynamic);
        defineProperty(proto, fieldOrMethodName, descriptor);
      }
    }
  }
  if (!isUndefined$1(track)) {
    for (var _fieldName in track) {
      descriptor = getOwnPropertyDescriptor$1(proto, _fieldName);
      if (process.env.NODE_ENV !== 'production') {
        validateFieldDecoratedWithTrack(Ctor, _fieldName, descriptor);
      }
      descriptor = internalTrackDecorator(_fieldName);
      defineProperty(proto, _fieldName, descriptor);
    }
  }
  if (!isUndefined$1(fields)) {
    for (var _i8 = 0, n = fields.length; _i8 < n; _i8++) {
      var _fieldName2 = fields[_i8];
      descriptor = getOwnPropertyDescriptor$1(proto, _fieldName2);
      if (process.env.NODE_ENV !== 'production') {
        validateObservedField(Ctor, _fieldName2, descriptor);
      }
      // [W-9927596] Only mark a field as observed whenever it isn't a duplicated public nor
      // tracked property. This is only here for backward compatibility purposes.
      var isDuplicatePublicProp = !isUndefined$1(publicProps) && _fieldName2 in publicProps;
      var isDuplicateTrackedProp = !isUndefined$1(track) && _fieldName2 in track;
      if (!isDuplicatePublicProp && !isDuplicateTrackedProp) {
        observedFields[_fieldName2] = createObservedFieldPropertyDescriptor(_fieldName2);
      }
    }
  }
  setDecoratorsMeta(Ctor, {
    apiMethods: apiMethods,
    apiFields: apiFields,
    apiFieldsConfig: apiFieldsConfig,
    wiredMethods: wiredMethods,
    wiredFields: wiredFields,
    observedFields: observedFields
  });
  return Ctor;
}
var signedDecoratorToMetaMap = new Map();
function setDecoratorsMeta(Ctor, meta) {
  signedDecoratorToMetaMap.set(Ctor, meta);
}
var defaultMeta = {
  apiMethods: EmptyObject,
  apiFields: EmptyObject,
  apiFieldsConfig: EmptyObject,
  wiredMethods: EmptyObject,
  wiredFields: EmptyObject,
  observedFields: EmptyObject
};
function getDecoratorsMeta(Ctor) {
  var meta = signedDecoratorToMetaMap.get(Ctor);
  return isUndefined$1(meta) ? defaultMeta : meta;
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var warned = false;
// Only used in LWC's Karma tests
if (process.env.NODE_ENV === 'test-karma-lwc') {
  window.__lwcResetWarnedOnVersionMismatch = function () {
    warned = false;
  };
}
function checkVersionMismatch(func, type) {
  var versionMatcher = func.toString().match(LWC_VERSION_COMMENT_REGEX);
  if (!isNull(versionMatcher) && !warned) {
    var version = versionMatcher[1];
    var _version$split = version.split('.'),
      _version$split2 = _slicedToArray(_version$split, 2),
      major = _version$split2[0],
      minor = _version$split2[1];
    var _LWC_VERSION$split = LWC_VERSION.split('.'),
      _LWC_VERSION$split2 = _slicedToArray(_LWC_VERSION$split, 2),
      expectedMajor = _LWC_VERSION$split2[0],
      expectedMinor = _LWC_VERSION$split2[1];
    if (major !== expectedMajor || minor !== expectedMinor) {
      warned = true; // only warn once to avoid flooding the console
      // stylesheets and templates do not have user-meaningful names, but components do
      var friendlyName = type === 'component' ? "".concat(type, " ").concat(func.name) : type;
      logError("LWC WARNING: current engine is v".concat(LWC_VERSION, ", but ").concat(friendlyName, " was compiled with v").concat(version, ".\nPlease update your compiled code or LWC engine so that the versions match.\nNo further warnings will appear."));
    }
  }
}
var signedTemplateSet = new Set();
function defaultEmptyTemplate() {
  return [];
}
signedTemplateSet.add(defaultEmptyTemplate);
function isTemplateRegistered(tpl) {
  return signedTemplateSet.has(tpl);
}
/**
 * INTERNAL: This function can only be invoked by compiled code. The compiler
 * will prevent this function from being imported by userland code.
 * @param tpl
 */
function registerTemplate(tpl) {
  if (process.env.NODE_ENV !== 'production') {
    checkVersionMismatch(tpl, 'template');
  }
  signedTemplateSet.add(tpl);
  // chaining this method as a way to wrap existing
  // assignment of templates easily, without too much transformation
  return tpl;
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * This module is responsible for creating the base bridge class BaseBridgeElement
 * that represents the HTMLElement extension used for any LWC inserted in the DOM.
 */
// A bridge descriptor is a descriptor whose job is just to get the component instance
// from the element instance, and get the value or set a new value on the component.
// This means that across different elements, similar names can get the exact same
// descriptor, so we can cache them:
var cachedGetterByKey = create(null);
var cachedSetterByKey = create(null);
function createGetter(key) {
  var fn = cachedGetterByKey[key];
  if (isUndefined$1(fn)) {
    fn = cachedGetterByKey[key] = function () {
      var vm = getAssociatedVM(this);
      var getHook = vm.getHook;
      return getHook(vm.component, key);
    };
  }
  return fn;
}
function createSetter(key) {
  var fn = cachedSetterByKey[key];
  if (isUndefined$1(fn)) {
    fn = cachedSetterByKey[key] = function (newValue) {
      var vm = getAssociatedVM(this);
      var setHook = vm.setHook;
      newValue = getReadOnlyProxy(newValue);
      setHook(vm.component, key, newValue);
    };
  }
  return fn;
}
function createMethodCaller(methodName) {
  return function () {
    var vm = getAssociatedVM(this);
    var callHook = vm.callHook,
      component = vm.component;
    var fn = component[methodName];
    return callHook(vm.component, fn, ArraySlice.call(arguments));
  };
}
function createAttributeChangedCallback(attributeToPropMap, superAttributeChangedCallback) {
  return function attributeChangedCallback(attrName, oldValue, newValue) {
    if (oldValue === newValue) {
      // Ignore same values.
      return;
    }
    var propName = attributeToPropMap[attrName];
    if (isUndefined$1(propName)) {
      if (!isUndefined$1(superAttributeChangedCallback)) {
        // delegate unknown attributes to the super.
        // Typescript does not like it when you treat the `arguments` object as an array
        // @ts-expect-error type-mismatch
        superAttributeChangedCallback.apply(this, arguments);
      }
      return;
    }
    // Reflect attribute change to the corresponding property when changed from outside.
    this[propName] = newValue;
  };
}
function createAccessorThatWarns(propName) {
  var prop;
  return {
    get: function get() {
      logWarn("The property \"".concat(propName, "\" is not publicly accessible. Add the @api annotation to the property declaration or getter/setter in the component to make it accessible."));
      return prop;
    },
    set: function set(value) {
      logWarn("The property \"".concat(propName, "\" is not publicly accessible. Add the @api annotation to the property declaration or getter/setter in the component to make it accessible."));
      prop = value;
    },
    enumerable: true,
    configurable: true
  };
}
function HTMLBridgeElementFactory(SuperClass, publicProperties, methods, observedFields, proto, hasCustomSuperClass) {
  var HTMLBridgeElement = /*#__PURE__*/function (_SuperClass) {
    _inherits(HTMLBridgeElement, _SuperClass);
    var _super3 = _createSuper(HTMLBridgeElement);
    function HTMLBridgeElement() {
      _classCallCheck(this, HTMLBridgeElement);
      return _super3.apply(this, arguments);
    }
    return _createClass(HTMLBridgeElement);
  }(SuperClass);
  // generating the hash table for attributes to avoid duplicate fields and facilitate validation
  // and false positives in case of inheritance.
  var attributeToPropMap = create(null);
  var superAttributeChangedCallback = SuperClass.prototype.attributeChangedCallback;
  var _SuperClass$observedA = SuperClass.observedAttributes,
    superObservedAttributes = _SuperClass$observedA === void 0 ? [] : _SuperClass$observedA;
  var descriptors = create(null);
  // present a hint message so that developers are aware that they have not decorated property with @api
  if (process.env.NODE_ENV !== 'production') {
    // TODO [#3761]: enable for components that don't extend from LightningElement
    if (!isUndefined$1(proto) && !isNull(proto) && !hasCustomSuperClass) {
      var nonPublicPropertiesToWarnOn = new Set([].concat(_toConsumableArray(keys(getOwnPropertyDescriptors(proto))), _toConsumableArray(observedFields)) // we don't want to override HTMLElement props because these are meaningful in other ways,
      // and can break tooling that expects it to be iterable or defined, e.g. Jest:
      // https://github.com/jestjs/jest/blob/b4c9587/packages/pretty-format/src/plugins/DOMElement.ts#L95
      // It also doesn't make sense to override e.g. "constructor".
      .filter(function (propName) {
        return !(propName in HTMLElementPrototype) && !(propName in ariaReflectionPolyfillDescriptors);
      }));
      var _iterator5 = _createForOfIteratorHelper(nonPublicPropertiesToWarnOn),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _propName2 = _step5.value;
          if (ArrayIndexOf.call(publicProperties, _propName2) === -1) {
            descriptors[_propName2] = createAccessorThatWarns(_propName2);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }
  // expose getters and setters for each public props on the new Element Bridge
  for (var _i9 = 0, len = publicProperties.length; _i9 < len; _i9 += 1) {
    var _propName3 = publicProperties[_i9];
    attributeToPropMap[htmlPropertyToAttribute(_propName3)] = _propName3;
    descriptors[_propName3] = {
      get: createGetter(_propName3),
      set: createSetter(_propName3),
      enumerable: true,
      configurable: true
    };
  }
  // expose public methods as props on the new Element Bridge
  for (var _i10 = 0, _len = methods.length; _i10 < _len; _i10 += 1) {
    var methodName = methods[_i10];
    descriptors[methodName] = {
      value: createMethodCaller(methodName),
      writable: true,
      configurable: true
    };
  }
  // creating a new attributeChangedCallback per bridge because they are bound to the corresponding
  // map of attributes to props. We do this after all other props and methods to avoid the possibility
  // of getting overrule by a class declaration in user-land, and we make it non-writable, non-configurable
  // to preserve this definition.
  descriptors.attributeChangedCallback = {
    value: createAttributeChangedCallback(attributeToPropMap, superAttributeChangedCallback)
  };
  // To avoid leaking private component details, accessing internals from outside a component is not allowed.
  descriptors.attachInternals = {
    set: function set() {
      if (process.env.NODE_ENV !== 'production') {
        logWarn('attachInternals cannot be accessed outside of a component. Use this.attachInternals instead.');
      }
    },
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        logWarn('attachInternals cannot be accessed outside of a component. Use this.attachInternals instead.');
      }
    }
  };
  descriptors.formAssociated = {
    set: function set() {
      if (process.env.NODE_ENV !== 'production') {
        logWarn('formAssociated cannot be accessed outside of a component. Set the value within the component class.');
      }
    },
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        logWarn('formAssociated cannot be accessed outside of a component. Set the value within the component class.');
      }
    }
  };
  // Specify attributes for which we want to reflect changes back to their corresponding
  // properties via attributeChangedCallback.
  defineProperty(HTMLBridgeElement, 'observedAttributes', {
    get: function get() {
      return [].concat(_toConsumableArray(superObservedAttributes), _toConsumableArray(keys(attributeToPropMap)));
    }
  });
  defineProperties(HTMLBridgeElement.prototype, descriptors);
  return HTMLBridgeElement;
}
// We do some special handling of non-standard ARIA props like ariaLabelledBy as well as props without (as of this
// writing) broad cross-browser support like ariaBrailleLabel. This is so the reflection works correctly and preserves
// backwards compatibility with the previous global polyfill approach.
//
// The goal here is to expose `elm.aria*` property accessors to work from outside a component, and to reflect `aria-*`
// attrs. This is especially important because the template compiler compiles aria-* attrs on components to aria* props.
// Note this works regardless of whether the global ARIA reflection polyfill is applied or not.
//
// Also note this ARIA reflection only really makes sense in the browser. On the server, there is no
// `renderedCallback()`, so you cannot do e.g. `this.template.querySelector('x-child').ariaBusy = 'true'`. So we don't
// need to expose ARIA props outside the LightningElement
var basePublicProperties = [].concat(_toConsumableArray(getOwnPropertyNames$1(HTMLElementOriginalDescriptors)), _toConsumableArray(getOwnPropertyNames$1(ariaReflectionPolyfillDescriptors)));
var BaseBridgeElement = HTMLBridgeElementFactory(HTMLElementConstructor, basePublicProperties, [], [], null, false);
freeze(BaseBridgeElement);
seal(BaseBridgeElement.prototype);

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// These are only used for HMR in dev mode
// The "pure" annotations are so that Rollup knows for sure it can remove these from prod mode
var stylesheetsToCssContent = /*@__PURE__@*/new WeakMap();
var cssContentToAbortControllers = /*@__PURE__@*/new Map();
// Only used in LWC's Karma tests
if (process.env.NODE_ENV === 'test-karma-lwc') {
  // Used to reset the global state between test runs
  window.__lwcResetStylesheetCache = function () {
    stylesheetsToCssContent = new WeakMap();
    cssContentToAbortControllers = new Map();
  };
}
function linkStylesheetToCssContentInDevMode(stylesheet, cssContent) {
  // Should never leak to prod; only used for HMR
  assertNotProd();
  var cssContents = stylesheetsToCssContent.get(stylesheet);
  if (isUndefined$1(cssContents)) {
    cssContents = new Set();
    stylesheetsToCssContent.set(stylesheet, cssContents);
  }
  cssContents.add(cssContent);
}
function getOrCreateAbortControllerInDevMode(cssContent) {
  // Should never leak to prod; only used for HMR
  assertNotProd();
  var abortController = cssContentToAbortControllers.get(cssContent);
  if (isUndefined$1(abortController)) {
    abortController = new AbortController();
    cssContentToAbortControllers.set(cssContent, abortController);
  }
  return abortController;
}
function getOrCreateAbortSignal(cssContent) {
  // abort controller/signal is only used for HMR in development
  if (process.env.NODE_ENV !== 'production') {
    return getOrCreateAbortControllerInDevMode(cssContent).signal;
  }
  return undefined;
}
function makeHostToken(token) {
  // Note: if this ever changes, update the `cssScopeTokens` returned by `@lwc/compiler`
  return "".concat(token, "-host");
}
function createInlineStyleVNode(content) {
  return api.h('style', {
    key: 'style',
    // special key
    attrs: {
      type: 'text/css'
    }
  }, [api.t(content)]);
}
// TODO [#3733]: remove support for legacy scope tokens
function updateStylesheetToken(vm, template, legacy) {
  var elm = vm.elm,
    context = vm.context,
    renderMode = vm.renderMode,
    shadowMode = vm.shadowMode,
    _vm$renderer = vm.renderer,
    getClassList = _vm$renderer.getClassList,
    removeAttribute = _vm$renderer.removeAttribute,
    setAttribute = _vm$renderer.setAttribute;
  var newStylesheets = template.stylesheets;
  var newStylesheetToken = legacy ? template.legacyStylesheetToken : template.stylesheetToken;
  var newVmStylesheets = vm.stylesheets;
  var isSyntheticShadow = renderMode === 1 /* RenderMode.Shadow */ && shadowMode === 1 /* ShadowMode.Synthetic */;
  var hasScopedStyles = context.hasScopedStyles;
  var newToken;
  var newHasTokenInClass;
  var newHasTokenInAttribute;
  // Reset the styling token applied to the host element.
  var oldToken;
  var oldHasTokenInClass;
  var oldHasTokenInAttribute;
  if (legacy) {
    oldToken = context.legacyStylesheetToken;
    oldHasTokenInClass = context.hasLegacyTokenInClass;
    oldHasTokenInAttribute = context.hasLegacyTokenInAttribute;
  } else {
    oldToken = context.stylesheetToken;
    oldHasTokenInClass = context.hasTokenInClass;
    oldHasTokenInAttribute = context.hasTokenInAttribute;
  }
  if (!isUndefined$1(oldToken)) {
    if (oldHasTokenInClass) {
      getClassList(elm).remove(makeHostToken(oldToken));
    }
    if (oldHasTokenInAttribute) {
      removeAttribute(elm, makeHostToken(oldToken));
    }
  }
  // Apply the new template styling token to the host element, if the new template has any
  // associated stylesheets. In the case of light DOM, also ensure there is at least one scoped stylesheet.
  var hasNewStylesheets = hasStyles(newStylesheets);
  var hasNewVmStylesheets = hasStyles(newVmStylesheets);
  if (hasNewStylesheets || hasNewVmStylesheets) {
    newToken = newStylesheetToken;
  }
  // Set the new styling token on the host element
  if (!isUndefined$1(newToken)) {
    if (hasScopedStyles) {
      getClassList(elm).add(makeHostToken(newToken));
      newHasTokenInClass = true;
    }
    if (isSyntheticShadow) {
      setAttribute(elm, makeHostToken(newToken), '');
      newHasTokenInAttribute = true;
    }
  }
  // Update the styling tokens present on the context object.
  if (legacy) {
    context.legacyStylesheetToken = newToken;
    context.hasLegacyTokenInClass = newHasTokenInClass;
    context.hasLegacyTokenInAttribute = newHasTokenInAttribute;
  } else {
    context.stylesheetToken = newToken;
    context.hasTokenInClass = newHasTokenInClass;
    context.hasTokenInAttribute = newHasTokenInAttribute;
  }
}
function evaluateStylesheetsContent(stylesheets, stylesheetToken, vm) {
  var content = [];
  var root;
  for (var _i11 = 0; _i11 < stylesheets.length; _i11++) {
    var _stylesheet2 = stylesheets[_i11];
    if (isArray$1(_stylesheet2)) {
      ArrayPush$1.apply(content, evaluateStylesheetsContent(_stylesheet2, stylesheetToken, vm));
    } else {
      if (process.env.NODE_ENV !== 'production') {
        // Check for compiler version mismatch in dev mode only
        checkVersionMismatch(_stylesheet2, 'stylesheet');
        // in dev-mode, we support hot swapping of stylesheet, which means that
        // the component instance might be attempting to use an old version of
        // the stylesheet, while internally, we have a replacement for it.
        _stylesheet2 = getStyleOrSwappedStyle(_stylesheet2);
      }
      var isScopedCss = _stylesheet2[KEY__SCOPED_CSS];
      if (lwcRuntimeFlags.DISABLE_LIGHT_DOM_UNSCOPED_CSS && !isScopedCss && vm.renderMode === 0 /* RenderMode.Light */) {
        logError('Unscoped CSS is not supported in Light DOM in this environment. Please use scoped CSS ' + '(*.scoped.css) instead of unscoped CSS (*.css). See also: https://sfdc.co/scoped-styles-light-dom');
        continue;
      }
      // Apply the scope token only if the stylesheet itself is scoped, or if we're rendering synthetic shadow.
      var scopeToken = isScopedCss || vm.shadowMode === 1 /* ShadowMode.Synthetic */ && vm.renderMode === 1 /* RenderMode.Shadow */ ? stylesheetToken : undefined;
      // Use the actual `:host` selector if we're rendering global CSS for light DOM, or if we're rendering
      // native shadow DOM. Synthetic shadow DOM never uses `:host`.
      var useActualHostSelector = vm.renderMode === 0 /* RenderMode.Light */ ? !isScopedCss : vm.shadowMode === 0 /* ShadowMode.Native */;
      // Use the native :dir() pseudoclass only in native shadow DOM. Otherwise, in synthetic shadow,
      // we use an attribute selector on the host to simulate :dir().
      var useNativeDirPseudoclass = void 0;
      if (vm.renderMode === 1 /* RenderMode.Shadow */) {
        useNativeDirPseudoclass = vm.shadowMode === 0 /* ShadowMode.Native */;
      } else {
        // Light DOM components should only render `[dir]` if they're inside of a synthetic shadow root.
        // At the top level (root is null) or inside of a native shadow root, they should use `:dir()`.
        if (isUndefined$1(root)) {
          // Only calculate the root once as necessary
          root = getNearestShadowComponent(vm);
        }
        useNativeDirPseudoclass = isNull(root) || root.shadowMode === 0 /* ShadowMode.Native */;
      }
      var cssContent = _stylesheet2(scopeToken, useActualHostSelector, useNativeDirPseudoclass);
      if (process.env.NODE_ENV !== 'production') {
        linkStylesheetToCssContentInDevMode(_stylesheet2, cssContent);
      }
      ArrayPush$1.call(content, cssContent);
    }
  }
  return content;
}
function getStylesheetsContent(vm, template) {
  var stylesheets = template.stylesheets,
    stylesheetToken = template.stylesheetToken;
  var vmStylesheets = vm.stylesheets;
  var content = [];
  if (hasStyles(stylesheets)) {
    content = evaluateStylesheetsContent(stylesheets, stylesheetToken, vm);
  }
  // VM (component) stylesheets apply after template stylesheets
  if (hasStyles(vmStylesheets)) {
    ArrayPush$1.apply(content, evaluateStylesheetsContent(vmStylesheets, stylesheetToken, vm));
  }
  return content;
}
// It might be worth caching this to avoid doing the lookup repeatedly, but
// perf testing has not shown it to be a huge improvement yet:
// https://github.com/salesforce/lwc/pull/2460#discussion_r691208892
function getNearestShadowComponent(vm) {
  var owner = vm;
  while (!isNull(owner)) {
    if (owner.renderMode === 1 /* RenderMode.Shadow */) {
      return owner;
    }
    owner = owner.owner;
  }
  return owner;
}
/**
 * If the component that is currently being rendered uses scoped styles,
 * this returns the unique token for that scoped stylesheet. Otherwise
 * it returns null.
 * @param owner
 * @param legacy
 */
// TODO [#3733]: remove support for legacy scope tokens
function getScopeTokenClass(owner, legacy) {
  var cmpTemplate = owner.cmpTemplate,
    context = owner.context;
  return context.hasScopedStyles && (legacy ? cmpTemplate === null || cmpTemplate === void 0 ? void 0 : cmpTemplate.legacyStylesheetToken : cmpTemplate === null || cmpTemplate === void 0 ? void 0 : cmpTemplate.stylesheetToken) || null;
}
function getNearestNativeShadowComponent(vm) {
  var owner = getNearestShadowComponent(vm);
  if (!isNull(owner) && owner.shadowMode === 1 /* ShadowMode.Synthetic */) {
    // Synthetic-within-native is impossible. So if the nearest shadow component is
    // synthetic, we know we won't find a native component if we go any further.
    return null;
  }
  return owner;
}
function createStylesheet(vm, stylesheets) {
  var renderMode = vm.renderMode,
    shadowMode = vm.shadowMode,
    insertStylesheet = vm.renderer.insertStylesheet;
  if (renderMode === 1 /* RenderMode.Shadow */ && shadowMode === 1 /* ShadowMode.Synthetic */) {
    for (var _i12 = 0; _i12 < stylesheets.length; _i12++) {
      var _stylesheet3 = stylesheets[_i12];
      insertStylesheet(_stylesheet3, undefined, getOrCreateAbortSignal(_stylesheet3));
    }
  } else if (vm.hydrated) {
    // Note: We need to ensure that during hydration, the stylesheets method is the same as those in ssr.
    //       This works in the client, because the stylesheets are created, and cached in the VM
    //       the first time the VM renders.
    // native shadow or light DOM, SSR
    return ArrayMap.call(stylesheets, createInlineStyleVNode);
  } else {
    // native shadow or light DOM, DOM renderer
    var root = getNearestNativeShadowComponent(vm);
    // null root means a global style
    var target = isNull(root) ? undefined : root.shadowRoot;
    for (var _i13 = 0; _i13 < stylesheets.length; _i13++) {
      var _stylesheet4 = stylesheets[_i13];
      insertStylesheet(_stylesheet4, target, getOrCreateAbortSignal(_stylesheet4));
    }
  }
  return null;
}

/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var supportsWeakRefs = typeof WeakRef === 'function' && typeof FinalizationRegistry === 'function';
// In browsers that doesn't support WeakRefs, the values will still leak, but at least the keys won't
var LegacyWeakMultiMap = /*#__PURE__*/function () {
  function LegacyWeakMultiMap() {
    _classCallCheck(this, LegacyWeakMultiMap);
    this._map = new WeakMap();
  }
  _createClass(LegacyWeakMultiMap, [{
    key: "_getValues",
    value: function _getValues(key) {
      var values = this._map.get(key);
      if (isUndefined$1(values)) {
        values = new Set();
        this._map.set(key, values);
      }
      return values;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._getValues(key);
    }
  }, {
    key: "add",
    value: function add(key, vm) {
      var set = this._getValues(key);
      set.add(vm);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this._map["delete"](key);
    }
  }]);
  return LegacyWeakMultiMap;
}(); // This implementation relies on the WeakRef/FinalizationRegistry proposal.
// For some background, see: https://github.com/tc39/proposal-weakrefs
var ModernWeakMultiMap = /*#__PURE__*/function () {
  function ModernWeakMultiMap() {
    _classCallCheck(this, ModernWeakMultiMap);
    this._map = new WeakMap();
    this._registry = new FinalizationRegistry(function (weakRefs) {
      // This should be considered an optional cleanup method to remove GC'ed values from their respective arrays.
      // JS VMs are not obligated to call FinalizationRegistry callbacks.
      // Work backwards, removing stale VMs
      for (var _i14 = weakRefs.length - 1; _i14 >= 0; _i14--) {
        var vm = weakRefs[_i14].deref();
        if (isUndefined$1(vm)) {
          ArraySplice.call(weakRefs, _i14, 1); // remove
        }
      }
    });
  }
  _createClass(ModernWeakMultiMap, [{
    key: "_getWeakRefs",
    value: function _getWeakRefs(key) {
      var weakRefs = this._map.get(key);
      if (isUndefined$1(weakRefs)) {
        weakRefs = [];
        this._map.set(key, weakRefs);
      }
      return weakRefs;
    }
  }, {
    key: "get",
    value: function get(key) {
      var weakRefs = this._getWeakRefs(key);
      var result = new Set();
      var _iterator6 = _createForOfIteratorHelper(weakRefs),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var weakRef = _step6.value;
          var vm = weakRef.deref();
          if (!isUndefined$1(vm)) {
            result.add(vm);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return result;
    }
  }, {
    key: "add",
    value: function add(key, value) {
      var weakRefs = this._getWeakRefs(key);
      // We could check for duplicate values here, but it doesn't seem worth it.
      // We transform the output into a Set anyway
      ArrayPush$1.call(weakRefs, new WeakRef(value));
      // It's important here not to leak the second argument, which is the "held value." The FinalizationRegistry
      // effectively creates a strong reference between the first argument (the "target") and the held value. When
      // the target is GC'ed, the callback is called, and then the held value is GC'ed.
      // Putting the key here would mean the key is not GC'ed until the value is GC'ed, which defeats the purpose
      // of the WeakMap. Whereas putting the weakRefs array here is fine, because it doesn't have a strong reference
      // to anything. See also this example:
      // https://gist.github.com/nolanlawson/79a3d36e8e6cc25c5048bb17c1795aea
      this._registry.register(value, weakRefs);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this._map["delete"](key);
    }
  }]);
  return ModernWeakMultiMap;
}();
var WeakMultiMap = supportsWeakRefs ? ModernWeakMultiMap : LegacyWeakMultiMap;

/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var swappedTemplateMap = /*@__PURE__@*/new WeakMap();
var swappedComponentMap = /*@__PURE__@*/new WeakMap();
var swappedStyleMap = /*@__PURE__@*/new WeakMap();
// The important thing here is the weak values – VMs are transient (one per component instance) and should be GC'ed,
// so we don't want to create strong references to them.
// The weak keys are kind of useless, because Templates, LightningElementConstructors, and StylesheetFactories are
// never GC'ed. But maybe they will be someday, so we may as well use weak keys too.
// The "pure" annotations are so that Rollup knows for sure it can remove these from prod mode
var activeTemplates = /*@__PURE__@*/new WeakMultiMap();
var activeComponents = /*@__PURE__@*/new WeakMultiMap();
var activeStyles = /*@__PURE__@*/new WeakMultiMap();
// Only used in LWC's Karma tests
if (process.env.NODE_ENV === 'test-karma-lwc') {
  // Used to reset the global state between test runs
  window.__lwcResetHotSwaps = function () {
    swappedTemplateMap = new WeakMap();
    swappedComponentMap = new WeakMap();
    swappedStyleMap = new WeakMap();
    activeTemplates = new WeakMultiMap();
    activeComponents = new WeakMultiMap();
    activeStyles = new WeakMultiMap();
  };
}
function getTemplateOrSwappedTemplate(tpl) {
  assertNotProd(); // this method should never leak to prod
  // TODO [#4154]: shows stale content when swapping content back and forth multiple times
  var visited = new Set();
  while (swappedTemplateMap.has(tpl) && !visited.has(tpl)) {
    visited.add(tpl);
    tpl = swappedTemplateMap.get(tpl);
  }
  return tpl;
}
function getComponentOrSwappedComponent(Ctor) {
  assertNotProd(); // this method should never leak to prod
  // TODO [#4154]: shows stale content when swapping content back and forth multiple times
  var visited = new Set();
  while (swappedComponentMap.has(Ctor) && !visited.has(Ctor)) {
    visited.add(Ctor);
    Ctor = swappedComponentMap.get(Ctor);
  }
  return Ctor;
}
function getStyleOrSwappedStyle(style) {
  assertNotProd(); // this method should never leak to prod
  // TODO [#4154]: shows stale content when swapping content back and forth multiple times
  var visited = new Set();
  while (swappedStyleMap.has(style) && !visited.has(style)) {
    visited.add(style);
    style = swappedStyleMap.get(style);
  }
  return style;
}
function addActiveStylesheets(stylesheets, vm) {
  if (isUndefined$1(stylesheets) || isNull(stylesheets)) {
    // Ignore non-existent stylesheets
    return;
  }
  var _iterator7 = _createForOfIteratorHelper(flattenStylesheets(stylesheets)),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _stylesheet5 = _step7.value;
      // this is necessary because we don't hold the list of styles
      // in the vm, we only hold the selected (already swapped template)
      // but the styles attached to the template might not be the actual
      // active ones, but the swapped versions of those.
      var swappedStylesheet = getStyleOrSwappedStyle(_stylesheet5);
      // this will allow us to keep track of the stylesheet that are
      // being used by a hot component
      activeStyles.add(swappedStylesheet, vm);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
}
function setActiveVM(vm) {
  assertNotProd(); // this method should never leak to prod
  // tracking active component
  var Ctor = vm.def.ctor;
  // this will allow us to keep track of the hot components
  activeComponents.add(Ctor, vm);
  // tracking active template
  var template = vm.cmpTemplate;
  if (!isNull(template)) {
    // this will allow us to keep track of the templates that are
    // being used by a hot component
    activeTemplates.add(template, vm);
    // Tracking active styles from the template or the VM. `template.stylesheets` are implicitly associated
    // (e.g. `foo.css` associated with `foo.html`), whereas `vm.stylesheets` are from `static stylesheets`.
    addActiveStylesheets(template.stylesheets, vm);
    addActiveStylesheets(vm.stylesheets, vm);
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * This module is responsible for producing the ComponentDef object that is always
 * accessible via `vm.def`. This is lazily created during the creation of the first
 * instance of a component class, and shared across all instances.
 *
 * This structure can be used to synthetically create proxies, and understand the
 * shape of a component. It is also used internally to apply extra optimizations.
 */
var CtorToDefMap = new WeakMap();
function getCtorProto(Ctor) {
  var proto = getPrototypeOf$1(Ctor);
  if (isNull(proto)) {
    throw new ReferenceError("Invalid prototype chain for ".concat(Ctor.name, ", you must extend LightningElement."));
  }
  // covering the cases where the ref is circular in AMD
  if (isCircularModuleDependency(proto)) {
    var p = resolveCircularModuleDependency(proto);
    if (process.env.NODE_ENV !== 'production') {
      if (isNull(p)) {
        throw new ReferenceError("Circular module dependency for ".concat(Ctor.name, ", must resolve to a constructor that extends LightningElement."));
      }
    }
    // escape hatch for Locker and other abstractions to provide their own base class instead
    // of our Base class without having to leak it to user-land. If the circular function returns
    // itself, that's the signal that we have hit the end of the proto chain, which must always
    // be base.
    proto = p === proto ? LightningElement : p;
  }
  return proto;
}
function createComponentDef(Ctor) {
  var ctorShadowSupportMode = Ctor.shadowSupportMode,
    ctorRenderMode = Ctor.renderMode,
    ctorFormAssociated = Ctor.formAssociated;
  if (process.env.NODE_ENV !== 'production') {
    var ctorName = Ctor.name;
    // Removing the following assert until https://bugs.webkit.org/show_bug.cgi?id=190140 is fixed.
    // assert.isTrue(ctorName && isString(ctorName), `${toString(Ctor)} should have a "name" property with string value, but found ${ctorName}.`);
    if (!Ctor.constructor) {
      // This error seems impossible to hit, due to an earlier check in `isComponentConstructor()`.
      // But we keep it here just in case.
      logError("Missing ".concat(ctorName, ".constructor, ").concat(ctorName, " should have a \"constructor\" property."));
    }
    if (!isUndefined$1(ctorShadowSupportMode) && ctorShadowSupportMode !== "any" /* ShadowSupportMode.Any */ && ctorShadowSupportMode !== "reset" /* ShadowSupportMode.Default */ && ctorShadowSupportMode !== "native" /* ShadowSupportMode.Native */) {
      logError("Invalid value for static property shadowSupportMode: '".concat(ctorShadowSupportMode, "'"));
    }
    // TODO [#3971]: Completely remove shadowSupportMode "any"
    if (ctorShadowSupportMode === "any" /* ShadowSupportMode.Any */) {
      logWarn("Invalid value 'any' for static property shadowSupportMode. 'any' is deprecated and will be removed in a future release--use 'native' instead.");
    }
    if (!isUndefined$1(ctorRenderMode) && ctorRenderMode !== 'light' && ctorRenderMode !== 'shadow') {
      logError("Invalid value for static property renderMode: '".concat(ctorRenderMode, "'. renderMode must be either 'light' or 'shadow'."));
    }
  }
  var decoratorsMeta = getDecoratorsMeta(Ctor);
  var apiFields = decoratorsMeta.apiFields,
    apiFieldsConfig = decoratorsMeta.apiFieldsConfig,
    apiMethods = decoratorsMeta.apiMethods,
    wiredFields = decoratorsMeta.wiredFields,
    wiredMethods = decoratorsMeta.wiredMethods,
    observedFields = decoratorsMeta.observedFields;
  var proto = Ctor.prototype;
  var connectedCallback = proto.connectedCallback,
    disconnectedCallback = proto.disconnectedCallback,
    renderedCallback = proto.renderedCallback,
    errorCallback = proto.errorCallback,
    formAssociatedCallback = proto.formAssociatedCallback,
    formResetCallback = proto.formResetCallback,
    formDisabledCallback = proto.formDisabledCallback,
    formStateRestoreCallback = proto.formStateRestoreCallback,
    render = proto.render;
  var superProto = getCtorProto(Ctor);
  var hasCustomSuperClass = superProto !== LightningElement;
  var superDef = hasCustomSuperClass ? getComponentInternalDef(superProto) : lightingElementDef;
  var bridge = HTMLBridgeElementFactory(superDef.bridge, keys(apiFields), keys(apiMethods), keys(observedFields), proto, hasCustomSuperClass);
  var props = assign(create(null), superDef.props, apiFields);
  var propsConfig = assign(create(null), superDef.propsConfig, apiFieldsConfig);
  var methods = assign(create(null), superDef.methods, apiMethods);
  var wire = assign(create(null), superDef.wire, wiredFields, wiredMethods);
  connectedCallback = connectedCallback || superDef.connectedCallback;
  disconnectedCallback = disconnectedCallback || superDef.disconnectedCallback;
  renderedCallback = renderedCallback || superDef.renderedCallback;
  errorCallback = errorCallback || superDef.errorCallback;
  formAssociatedCallback = formAssociatedCallback || superDef.formAssociatedCallback;
  formResetCallback = formResetCallback || superDef.formResetCallback;
  formDisabledCallback = formDisabledCallback || superDef.formDisabledCallback;
  formStateRestoreCallback = formStateRestoreCallback || superDef.formStateRestoreCallback;
  render = render || superDef.render;
  var shadowSupportMode = superDef.shadowSupportMode;
  if (!isUndefined$1(ctorShadowSupportMode)) {
    shadowSupportMode = ctorShadowSupportMode;
  }
  var renderMode = superDef.renderMode;
  if (!isUndefined$1(ctorRenderMode)) {
    renderMode = ctorRenderMode === 'light' ? 0 /* RenderMode.Light */ : 1 /* RenderMode.Shadow */;
  }
  var formAssociated = superDef.formAssociated;
  if (!isUndefined$1(ctorFormAssociated)) {
    formAssociated = ctorFormAssociated;
  }
  var template = getComponentRegisteredTemplate(Ctor) || superDef.template;
  var name = Ctor.name || superDef.name;
  // installing observed fields into the prototype.
  defineProperties(proto, observedFields);
  var def = {
    ctor: Ctor,
    name: name,
    wire: wire,
    props: props,
    propsConfig: propsConfig,
    methods: methods,
    bridge: bridge,
    template: template,
    renderMode: renderMode,
    shadowSupportMode: shadowSupportMode,
    formAssociated: formAssociated,
    connectedCallback: connectedCallback,
    disconnectedCallback: disconnectedCallback,
    errorCallback: errorCallback,
    formAssociatedCallback: formAssociatedCallback,
    formDisabledCallback: formDisabledCallback,
    formResetCallback: formResetCallback,
    formStateRestoreCallback: formStateRestoreCallback,
    renderedCallback: renderedCallback,
    render: render
  };
  // This is a no-op unless Lightning DevTools are enabled.
  instrumentDef(def);
  if (process.env.NODE_ENV !== 'production') {
    freeze(Ctor.prototype);
  }
  return def;
}
/**
 * EXPERIMENTAL: This function allows for the identification of LWC constructors. This API is
 * subject to change or being removed.
 * @param ctor
 */
function isComponentConstructor(ctor) {
  if (!isFunction$1(ctor)) {
    return false;
  }
  // Fast path: LightningElement is part of the prototype chain of the constructor.
  if (ctor.prototype instanceof LightningElement) {
    return true;
  }
  // Slow path: LightningElement is not part of the prototype chain of the constructor, we need
  // climb up the constructor prototype chain to check in case there are circular dependencies
  // to resolve.
  var current = ctor;
  do {
    if (isCircularModuleDependency(current)) {
      var circularResolved = resolveCircularModuleDependency(current);
      // If the circular function returns itself, that's the signal that we have hit the end
      // of the proto chain, which must always be a valid base constructor.
      if (circularResolved === current) {
        return true;
      }
      current = circularResolved;
    }
    if (current === LightningElement) {
      return true;
    }
  } while (!isNull(current) && (current = getPrototypeOf$1(current)));
  // Finally return false if the LightningElement is not part of the prototype chain.
  return false;
}
function getComponentInternalDef(Ctor) {
  if (process.env.NODE_ENV !== 'production') {
    Ctor = getComponentOrSwappedComponent(Ctor);
  }
  var def = CtorToDefMap.get(Ctor);
  if (isUndefined$1(def)) {
    if (isCircularModuleDependency(Ctor)) {
      var resolvedCtor = resolveCircularModuleDependency(Ctor);
      def = getComponentInternalDef(resolvedCtor);
      // Cache the unresolved component ctor too. The next time if the same unresolved ctor is used,
      // look up the definition in cache instead of re-resolving and recreating the def.
      CtorToDefMap.set(Ctor, def);
      return def;
    }
    if (!isComponentConstructor(Ctor)) {
      throw new TypeError("".concat(Ctor, " is not a valid component, or does not extends LightningElement from \"lwc\". You probably forgot to add the extend clause on the class declaration."));
    }
    def = createComponentDef(Ctor);
    CtorToDefMap.set(Ctor, def);
  }
  return def;
}
function getComponentHtmlPrototype(Ctor) {
  var def = getComponentInternalDef(Ctor);
  return def.bridge;
}
var lightingElementDef = {
  ctor: LightningElement,
  name: LightningElement.name,
  props: lightningBasedDescriptors,
  propsConfig: EmptyObject,
  methods: EmptyObject,
  renderMode: 1 /* RenderMode.Shadow */,
  shadowSupportMode: "reset" /* ShadowSupportMode.Default */,
  formAssociated: undefined,
  wire: EmptyObject,
  bridge: BaseBridgeElement,
  template: defaultEmptyTemplate,
  render: LightningElement.prototype.render
};

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function isVBaseElement(vnode) {
  var type = vnode.type;
  return type === 2 /* VNodeType.Element */ || type === 3 /* VNodeType.CustomElement */;
}
function isSameVnode(vnode1, vnode2) {
  return vnode1.key === vnode2.key && vnode1.sel === vnode2.sel;
}
function isVCustomElement(vnode) {
  return vnode.type === 3 /* VNodeType.CustomElement */;
}
function isVFragment(vnode) {
  return vnode.type === 5 /* VNodeType.Fragment */;
}
function isVScopedSlotFragment(vnode) {
  return vnode.type === 6 /* VNodeType.ScopedSlotFragment */;
}
function isVStatic(vnode) {
  return vnode.type === 4 /* VNodeType.Static */;
}
function isVStaticPartElement(vnode) {
  return vnode.type === 1 /* VStaticPartType.Element */;
}
function isVStaticPartText(vnode) {
  return vnode.type === 0 /* VStaticPartType.Text */;
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var ColonCharCode = 58;
function patchAttributes(oldVnode, vnode, renderer) {
  var data = vnode.data,
    elm = vnode.elm;
  var attrs = data.attrs;
  if (isUndefined$1(attrs)) {
    return;
  }
  var oldAttrs = isNull(oldVnode) ? EmptyObject : oldVnode.data.attrs;
  // Attrs may be the same due to the static content optimization, so we can skip diffing
  if (oldAttrs === attrs) {
    return;
  }
  // Note VStaticPartData does not contain the external property so it will always default to false.
  var external = 'external' in data ? data.external : false;
  var setAttribute = renderer.setAttribute,
    removeAttribute = renderer.removeAttribute,
    setProperty = renderer.setProperty;
  for (var key in attrs) {
    var cur = attrs[key];
    var old = oldAttrs[key];
    if (old !== cur) {
      var _propName4 = void 0;
      // For external custom elements, sniff to see if the attr should be considered a prop.
      // Use kebabCaseToCamelCase directly because we don't want to set props like `ariaLabel` or `tabIndex`
      // on a custom element versus just using the more reliable attribute format.
      if (external && (_propName4 = kebabCaseToCamelCase(key)) in elm) {
        setProperty(elm, _propName4, cur);
      } else if (StringCharCodeAt.call(key, 3) === ColonCharCode) {
        // Assume xml namespace
        setAttribute(elm, key, cur, XML_NAMESPACE);
      } else if (StringCharCodeAt.call(key, 5) === ColonCharCode) {
        // Assume xlink namespace
        setAttribute(elm, key, cur, XLINK_NAMESPACE);
      } else if (isNull(cur) || isUndefined$1(cur)) {
        removeAttribute(elm, key);
      } else {
        setAttribute(elm, key, cur);
      }
    }
  }
}
function patchSlotAssignment(oldVnode, vnode, renderer) {
  var slotAssignment = vnode.slotAssignment;
  if ((oldVnode === null || oldVnode === void 0 ? void 0 : oldVnode.slotAssignment) === slotAssignment) {
    return;
  }
  var elm = vnode.elm;
  var setAttribute = renderer.setAttribute,
    removeAttribute = renderer.removeAttribute;
  if (isUndefined$1(slotAssignment) || isNull(slotAssignment)) {
    removeAttribute(elm, 'slot');
  } else {
    setAttribute(elm, 'slot', slotAssignment);
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function isLiveBindingProp(sel, key) {
  // For properties with live bindings, we read values from the DOM element
  // instead of relying on internally tracked values.
  return sel === 'input' && (key === 'value' || key === 'checked');
}
function patchProps(oldVnode, vnode, renderer) {
  var props = vnode.data.props;
  if (isUndefined$1(props)) {
    return;
  }
  var oldProps;
  if (!isNull(oldVnode)) {
    oldProps = oldVnode.data.props;
    // Props may be the same due to the static content optimization, so we can skip diffing
    if (oldProps === props) {
      return;
    }
    if (isUndefined$1(oldProps)) {
      oldProps = EmptyObject;
    }
  }
  var isFirstPatch = isNull(oldVnode);
  var elm = vnode.elm,
    sel = vnode.sel;
  var getProperty = renderer.getProperty,
    setProperty = renderer.setProperty;
  for (var key in props) {
    var cur = props[key];
    // Set the property if it's the first time is is patched or if the previous property is
    // different than the one previously set.
    if (isFirstPatch || cur !== (isLiveBindingProp(sel, key) ? getProperty(elm, key) : oldProps[key]) || !(key in oldProps) // this is required because the above case will pass when `cur` is `undefined` and key is missing in `oldProps`
    ) {
      // Additional verification if properties are supported by the element
      // Validation relies on html properties and public properties being defined on the element,
      // SSR has its own custom validation.
      if (process.env.NODE_ENV !== 'production') {
        if (!(key in elm)) {
          logWarn("Unknown public property \"".concat(key, "\" of element <").concat(elm.tagName.toLowerCase(), ">. This is either a typo on the corresponding attribute \"").concat(htmlPropertyToAttribute(key), "\", or the attribute does not exist in this browser or DOM implementation."));
        }
      }
      setProperty(elm, key, cur);
    }
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var classNameToClassMap = create(null);
function getMapFromClassName(className) {
  if (isUndefined$1(className) || isNull(className) || className === '') {
    return EmptyObject;
  }
  // computed class names must be string
  // This will throw if className is a symbol or null-prototype object
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  className = isString(className) ? className : className + '';
  var map = classNameToClassMap[className];
  if (map) {
    return map;
  }
  map = create(null);
  var start = 0;
  var o;
  var len = className.length;
  for (o = 0; o < len; o++) {
    if (StringCharCodeAt.call(className, o) === SPACE_CHAR) {
      if (o > start) {
        map[StringSlice.call(className, start, o)] = true;
      }
      start = o + 1;
    }
  }
  if (o > start) {
    map[StringSlice.call(className, start, o)] = true;
  }
  classNameToClassMap[className] = map;
  if (process.env.NODE_ENV !== 'production') {
    // just to make sure that this object never changes as part of the diffing algo
    freeze(map);
  }
  return map;
}
function patchClassAttribute(oldVnode, vnode, renderer) {
  var elm = vnode.elm,
    newClass = vnode.data.className;
  var oldClass = isNull(oldVnode) ? undefined : oldVnode.data.className;
  if (oldClass === newClass) {
    return;
  }
  var newClassMap = getMapFromClassName(newClass);
  var oldClassMap = getMapFromClassName(oldClass);
  if (oldClassMap === newClassMap) {
    // These objects are cached by className string (`classNameToClassMap`), so we can only get here if there is
    // a key collision due to types, e.g. oldClass is `undefined` and newClass is `""` (empty string), or oldClass
    // is `1` (number) and newClass is `"1"` (string).
    return;
  }
  var getClassList = renderer.getClassList;
  var classList = getClassList(elm);
  var name;
  for (name in oldClassMap) {
    // remove only if it is not in the new class collection and it is not set from within the instance
    if (isUndefined$1(newClassMap[name])) {
      classList.remove(name);
    }
  }
  for (name in newClassMap) {
    if (isUndefined$1(oldClassMap[name])) {
      classList.add(name);
    }
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// The style property is a string when defined via an expression in the template.
function patchStyleAttribute(oldVnode, vnode, renderer, owner) {
  var elm = vnode.elm,
    newStyle = vnode.data.style;
  if (process.env.NODE_ENV !== 'production') {
    if (!isNull(newStyle) && !isUndefined$1(newStyle) && !isString(newStyle)) {
      logError("Invalid 'style' attribute passed to <".concat(elm.tagName.toLowerCase(), "> is ignored. This attribute must be a string value."), owner);
    }
  }
  var oldStyle = isNull(oldVnode) ? undefined : oldVnode.data.style;
  if (oldStyle === newStyle) {
    return;
  }
  var setAttribute = renderer.setAttribute,
    removeAttribute = renderer.removeAttribute;
  if (!isString(newStyle) || newStyle === '') {
    removeAttribute(elm, 'style');
  } else {
    setAttribute(elm, 'style', newStyle);
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function applyEventListeners(vnode, renderer) {
  var elm = vnode.elm,
    data = vnode.data;
  var on = data.on;
  if (isUndefined$1(on)) {
    return;
  }
  var addEventListener = renderer.addEventListener;
  for (var name in on) {
    var handler = on[name];
    addEventListener(elm, name, handler);
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// The HTML class property becomes the vnode.data.classMap object when defined as a string in the template.
// The compiler takes care of transforming the inline classnames into an object. It's faster to set the
// different classnames properties individually instead of via a string.
function applyStaticClassAttribute(vnode, renderer) {
  var elm = vnode.elm,
    classMap = vnode.data.classMap;
  if (isUndefined$1(classMap)) {
    return;
  }
  var getClassList = renderer.getClassList;
  var classList = getClassList(elm);
  for (var name in classMap) {
    classList.add(name);
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// The HTML style property becomes the vnode.data.styleDecls object when defined as a string in the template.
// The compiler takes care of transforming the inline style into an object. It's faster to set the
// different style properties individually instead of via a string.
function applyStaticStyleAttribute(vnode, renderer) {
  var elm = vnode.elm,
    styleDecls = vnode.data.styleDecls;
  if (isUndefined$1(styleDecls)) {
    return;
  }
  var setCSSStyleProperty = renderer.setCSSStyleProperty;
  for (var _i15 = 0; _i15 < styleDecls.length; _i15++) {
    var _styleDecls$_i = _slicedToArray(styleDecls[_i15], 3),
      prop = _styleDecls$_i[0],
      value = _styleDecls$_i[1],
      important = _styleDecls$_i[2];
    setCSSStyleProperty(elm, prop, value, important);
  }
}

/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// Set a ref (lwc:ref) on a VM, from a template API
function applyRefs(vnode, owner) {
  var data = vnode.data;
  var ref = data.ref;
  if (isUndefined$1(ref)) {
    return;
  }
  if (process.env.NODE_ENV !== 'production' && isUndefined$1(owner.refVNodes)) {
    throw new Error('refVNodes must be defined when setting a ref');
  }
  // If this method is called, then vm.refVNodes is set as the template has refs.
  // If not, then something went wrong and we threw an error above.
  var refVNodes = owner.refVNodes;
  // In cases of conflict (two elements with the same ref), prefer the last one,
  // in depth-first traversal order. This happens automatically due to how we render
  refVNodes[ref] = vnode;
}

/*
 * Copyright (c) 2024, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function patchTextVNode(n1, n2, renderer) {
  n2.elm = n1.elm;
  if (n2.text !== n1.text) {
    updateTextContent$1(n2, renderer);
  }
}
function patchTextVStaticPart(n1, n2, renderer) {
  if (isNull(n1) || n2.text !== n1.text) {
    updateTextContent$1(n2, renderer);
  }
}
function updateTextContent$1(vnode, renderer) {
  var elm = vnode.elm,
    text = vnode.text;
  var setText = renderer.setText;
  if (process.env.NODE_ENV !== 'production') {
    unlockDomMutation();
  }
  setText(elm, text);
  if (process.env.NODE_ENV !== 'production') {
    lockDomMutation();
  }
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * Given an array of static parts, mounts the DOM element to the part based on the staticPartId
 * @param root the root element
 * @param parts an array of VStaticParts
 * @param renderer the renderer to use
 */
function traverseAndSetElements(root, parts, renderer) {
  var numParts = parts.length;
  // Optimization given that, in most cases, there will be one part, and it's just the root
  if (numParts === 1) {
    var firstPart = parts[0];
    if (firstPart.partId === 0) {
      // 0 means the root node
      firstPart.elm = root;
      return;
    }
  }
  var partIdsToParts = new Map();
  var _iterator8 = _createForOfIteratorHelper(parts),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var staticPart = _step8.value;
      partIdsToParts.set(staticPart.partId, staticPart);
    }
    // Note that we traverse using `*Child`/`*Sibling` rather than `children` because the browser uses a linked
    // list under the hood to represent the DOM tree, so it's faster to do this than to create an underlying array
    // by calling `children`.
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  var nextSibling = renderer.nextSibling,
    getFirstChild = renderer.getFirstChild,
    getParentNode = renderer.getParentNode;
  var numFoundParts = 0;
  var partId = -1;
  // We should never traverse up to the root. We should exit early due to numFoundParts === numParts.
  // This is just a sanity check, in case the static parts generated by @lwc/template-compiler are wrong.
  function assertNotRoot(node) {
    if (process.env.NODE_ENV !== 'production') {
      assert.isFalse(node === root, "Reached the root without finding all parts. Found ".concat(numFoundParts, ", needed ").concat(numParts, "."));
    }
  }
  // Depth-first traversal. We assign a partId to each element, which is an integer based on traversal order.
  // This function is very hot, which is why it's micro-optimized. Note we don't use a stack at all; we traverse
  // using an algorithm that relies on the parentNode getter: https://stackoverflow.com/a/5285417
  // This is very slightly faster than a TreeWalker (~0.5% on js-framework-benchmark create-10k), but basically
  // the same idea.
  var node = root;
  while (!isNull(node)) {
    // visit node
    partId++;
    var part = partIdsToParts.get(partId);
    if (!isUndefined$1(part)) {
      part.elm = node;
      numFoundParts++;
      if (numFoundParts === numParts) {
        return; // perf optimization - stop traversing once we've found everything we need
      }
    }
    var child = getFirstChild(node);
    if (!isNull(child)) {
      // walk down
      node = child;
    } else {
      var sibling = void 0;
      while (isNull(sibling = nextSibling(node))) {
        // we never want to walk up from the root
        assertNotRoot(node);
        // walk up
        node = getParentNode(node);
      }
      // we never want to walk right from the root
      assertNotRoot(node);
      // walk right
      node = sibling;
    }
  }
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(numFoundParts === numParts, "Should have found all parts by now. Found ".concat(numFoundParts, ", needed ").concat(numParts, "."));
  }
}
/**
 * Given an array of static parts, do all the mounting required for these parts.
 * @param root the root element
 * @param vnode the parent VStatic
 * @param renderer the renderer to use
 */
function mountStaticParts(root, vnode, renderer) {
  var parts = vnode.parts,
    owner = vnode.owner;
  if (isUndefined$1(parts)) {
    return;
  }
  // This adds `part.elm` to each `part`. We have to do this on every mount because the `parts`
  // array is recreated from scratch every time, so each `part.elm` is now undefined.
  traverseAndSetElements(root, parts, renderer);
  // Currently only event listeners and refs are supported for static vnodes
  var _iterator9 = _createForOfIteratorHelper(parts),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var part = _step9.value;
      if (isVStaticPartElement(part)) {
        // Event listeners only need to be applied once when mounting
        applyEventListeners(part, renderer);
        // Refs must be updated after every render due to refVNodes getting reset before every render
        applyRefs(part, owner);
        patchAttributes(null, part, renderer);
        patchClassAttribute(null, part, renderer);
        patchStyleAttribute(null, part, renderer, owner);
      } else {
        if (process.env.NODE_ENV !== 'production' && !isVStaticPartText(part)) {
          throw new Error("LWC internal error, encountered unknown static part type: ".concat(part.type));
        }
        patchTextVStaticPart(null, part, renderer);
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
}
/**
 * Updates the static elements based on the content of the VStaticParts
 * @param n1 the previous VStatic vnode
 * @param n2 the current VStatic vnode
 * @param renderer the renderer to use
 */
function patchStaticParts(n1, n2, renderer) {
  var currParts = n2.parts,
    currPartsOwner = n2.owner;
  if (isUndefined$1(currParts)) {
    return;
  }
  var prevParts = n1.parts;
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(currParts.length === (prevParts === null || prevParts === void 0 ? void 0 : prevParts.length), 'Expected static parts to be the same for the same element. This is an error with the LWC framework itself.');
  }
  for (var _i16 = 0; _i16 < currParts.length; _i16++) {
    var prevPart = prevParts[_i16];
    var part = currParts[_i16];
    // Patch only occurs if the vnode is newly generated, which means the part.elm is always undefined
    // Since the vnode and elements are the same we can safely assume that prevParts[i].elm is defined.
    part.elm = prevPart.elm;
    if (process.env.NODE_ENV !== 'production' && prevPart.type !== part.type) {
      throw new Error("LWC internal error, static part types do not match. Previous type was ".concat(prevPart.type, " and current type is ").concat(part.type));
    }
    if (isVStaticPartElement(part)) {
      // Refs must be updated after every render due to refVNodes getting reset before every render
      applyRefs(part, currPartsOwner);
      patchAttributes(prevPart, part, renderer);
      patchClassAttribute(prevPart, part, renderer);
      patchStyleAttribute(prevPart, part, renderer, currPartsOwner);
    } else {
      patchTextVStaticPart(null, part, renderer);
    }
  }
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function patchChildren(c1, c2, parent, renderer) {
  if (hasDynamicChildren(c2)) {
    updateDynamicChildren(c1, c2, parent, renderer);
  } else {
    updateStaticChildren(c1, c2, parent, renderer);
  }
}
function patch(n1, n2, parent, renderer) {
  var _n2$data$renderer, _n2$data$renderer2;
  if (n1 === n2) {
    return;
  }
  if (process.env.NODE_ENV !== 'production') {
    if (!isSameVnode(n1, n2) &&
    // Currently the only scenario when patch does not receive the same vnodes are for
    // dynamic components. When a dynamic component's constructor changes, the value of its
    // tag name (sel) will be different. The engine will unmount the previous element
    // and mount the new one using the new constructor in patchCustomElement.
    !(isVCustomElement(n1) && isVCustomElement(n2))) {
      throw new Error('Expected these VNodes to be the same: ' + JSON.stringify({
        sel: n1.sel,
        key: n1.key
      }) + ', ' + JSON.stringify({
        sel: n2.sel,
        key: n2.key
      }));
    }
  }
  switch (n2.type) {
    case 0 /* VNodeType.Text */:
      // VText has no special capability, fallback to the owner's renderer
      patchTextVNode(n1, n2, renderer);
      break;
    case 1 /* VNodeType.Comment */:
      // VComment has no special capability, fallback to the owner's renderer
      patchComment(n1, n2, renderer);
      break;
    case 4 /* VNodeType.Static */:
      patchStatic(n1, n2, renderer);
      break;
    case 5 /* VNodeType.Fragment */:
      patchFragment(n1, n2, parent, renderer);
      break;
    case 2 /* VNodeType.Element */:
      patchElement(n1, n2, (_n2$data$renderer = n2.data.renderer) !== null && _n2$data$renderer !== void 0 ? _n2$data$renderer : renderer);
      break;
    case 3 /* VNodeType.CustomElement */:
      patchCustomElement(n1, n2, parent, (_n2$data$renderer2 = n2.data.renderer) !== null && _n2$data$renderer2 !== void 0 ? _n2$data$renderer2 : renderer);
      break;
  }
}
function mount(node, parent, renderer, anchor) {
  var _node$data$renderer, _node$data$renderer2;
  switch (node.type) {
    case 0 /* VNodeType.Text */:
      // VText has no special capability, fallback to the owner's renderer
      mountText(node, parent, anchor, renderer);
      break;
    case 1 /* VNodeType.Comment */:
      // VComment has no special capability, fallback to the owner's renderer
      mountComment(node, parent, anchor, renderer);
      break;
    case 4 /* VNodeType.Static */:
      // VStatic cannot have a custom renderer associated to them, using owner's renderer
      mountStatic(node, parent, anchor, renderer);
      break;
    case 5 /* VNodeType.Fragment */:
      mountFragment(node, parent, anchor, renderer);
      break;
    case 2 /* VNodeType.Element */:
      // If the vnode data has a renderer override use it, else fallback to owner's renderer
      mountElement(node, parent, anchor, (_node$data$renderer = node.data.renderer) !== null && _node$data$renderer !== void 0 ? _node$data$renderer : renderer);
      break;
    case 3 /* VNodeType.CustomElement */:
      // If the vnode data has a renderer override use it, else fallback to owner's renderer
      mountCustomElement(node, parent, anchor, (_node$data$renderer2 = node.data.renderer) !== null && _node$data$renderer2 !== void 0 ? _node$data$renderer2 : renderer);
      break;
  }
}
function mountText(vnode, parent, anchor, renderer) {
  var owner = vnode.owner;
  var createText = renderer.createText;
  var textNode = vnode.elm = createText(vnode.text);
  linkNodeToShadow(textNode, owner, renderer);
  insertNode(textNode, parent, anchor, renderer);
}
function patchComment(n1, n2, renderer) {
  n2.elm = n1.elm;
  // FIXME: Comment nodes should be static, we shouldn't need to diff them together. However
  // it is the case today.
  if (n2.text !== n1.text) {
    updateTextContent$1(n2, renderer);
  }
}
function mountComment(vnode, parent, anchor, renderer) {
  var owner = vnode.owner;
  var createComment = renderer.createComment;
  var commentNode = vnode.elm = createComment(vnode.text);
  linkNodeToShadow(commentNode, owner, renderer);
  insertNode(commentNode, parent, anchor, renderer);
}
function mountFragment(vnode, parent, anchor, renderer) {
  var children = vnode.children;
  mountVNodes(children, parent, renderer, anchor);
  vnode.elm = vnode.leading.elm;
}
function patchFragment(n1, n2, parent, renderer) {
  var children = n2.children,
    stable = n2.stable;
  if (stable) {
    updateStaticChildren(n1.children, children, parent, renderer);
  } else {
    updateDynamicChildren(n1.children, children, parent, renderer);
  }
  // Note: not reusing n1.elm, because during patching, it may be patched with another text node.
  n2.elm = n2.leading.elm;
}
function mountElement(vnode, parent, anchor, renderer) {
  var sel = vnode.sel,
    owner = vnode.owner,
    svg = vnode.data.svg;
  var createElement = renderer.createElement;
  var namespace = isTrue(svg) ? SVG_NAMESPACE : undefined;
  var elm = vnode.elm = createElement(sel, namespace);
  linkNodeToShadow(elm, owner, renderer);
  applyStyleScoping(elm, owner, renderer);
  applyDomManual(elm, vnode);
  applyElementRestrictions(elm, vnode);
  patchElementPropsAndAttrsAndRefs$1(null, vnode, renderer);
  insertNode(elm, parent, anchor, renderer);
  mountVNodes(vnode.children, elm, renderer, null);
}
function patchStatic(n1, n2, renderer) {
  n2.elm = n1.elm;
  // slotAssignments can only apply to the top level element, never to a static part.
  patchSlotAssignment(n1, n2, renderer);
  // The `refs` object is blown away in every re-render, so we always need to re-apply them
  patchStaticParts(n1, n2, renderer);
}
function patchElement(n1, n2, renderer) {
  var elm = n2.elm = n1.elm;
  patchElementPropsAndAttrsAndRefs$1(n1, n2, renderer);
  patchChildren(n1.children, n2.children, elm, renderer);
}
function mountStatic(vnode, parent, anchor, renderer) {
  var owner = vnode.owner;
  var cloneNode = renderer.cloneNode,
    isSyntheticShadowDefined = renderer.isSyntheticShadowDefined;
  var elm = vnode.elm = cloneNode(vnode.fragment, true);
  // Define the root node shadow resolver
  linkNodeToShadow(elm, owner, renderer);
  applyElementRestrictions(elm, vnode);
  var renderMode = owner.renderMode,
    shadowMode = owner.shadowMode;
  if (isSyntheticShadowDefined) {
    // Marks this node as Static to propagate the shadow resolver. must happen after elm is assigned to the proper shadow
    if (shadowMode === 1 /* ShadowMode.Synthetic */ || renderMode === 0 /* RenderMode.Light */) {
      elm[KEY__SHADOW_STATIC] = true;
    }
  }
  // slotAssignments can only apply to the top level element, never to a static part.
  patchSlotAssignment(null, vnode, renderer);
  mountStaticParts(elm, vnode, renderer);
  insertNode(elm, parent, anchor, renderer);
}
function mountCustomElement(vnode, parent, anchor, renderer) {
  var sel = vnode.sel,
    owner = vnode.owner,
    ctor = vnode.ctor;
  var createCustomElement = renderer.createCustomElement;
  /**
   * Note: if the upgradable constructor does not expect, or throw when we new it
   * with a callback as the first argument, we could implement a more advanced
   * mechanism that only passes that argument if the constructor is known to be
   * an upgradable custom element.
   */
  var vm;
  var upgradeCallback = function upgradeCallback(elm) {
    // the custom element from the registry is expecting an upgrade callback
    vm = createViewModelHook(elm, vnode, renderer);
  };
  // Should never get a tag with upper case letter at this point; the compiler
  // should produce only tags with lowercase letters. However, the Java
  // compiler may generate tagnames with uppercase letters so - for backwards
  // compatibility, we lower case the tagname here.
  var normalizedTagname = sel.toLowerCase();
  var useNativeLifecycle = shouldUseNativeCustomElementLifecycle(ctor);
  var isFormAssociated = shouldBeFormAssociated(ctor);
  var elm = createCustomElement(normalizedTagname, upgradeCallback, useNativeLifecycle, isFormAssociated);
  vnode.elm = elm;
  vnode.vm = vm;
  linkNodeToShadow(elm, owner, renderer);
  applyStyleScoping(elm, owner, renderer);
  if (vm) {
    allocateChildren(vnode, vm);
  }
  patchElementPropsAndAttrsAndRefs$1(null, vnode, renderer);
  insertNode(elm, parent, anchor, renderer);
  if (vm) {
    {
      if (!useNativeLifecycle) {
        if (process.env.NODE_ENV !== 'production') {
          // With synthetic lifecycle callbacks, it's possible for elements to be removed without the engine
          // noticing it (e.g. `appendChild` the same host element twice). This test ensures we don't regress.
          assert.isTrue(vm.state === 0 /* VMState.created */, "".concat(vm, " cannot be recycled."));
        }
        runConnectedCallback(vm);
      }
    }
  }
  mountVNodes(vnode.children, elm, renderer, null);
  if (vm) {
    appendVM(vm);
  }
}
function patchCustomElement(n1, n2, parent, renderer) {
  // TODO [#3331]: This if branch should be removed in 246 with lwc:dynamic
  if (n1.ctor !== n2.ctor) {
    // If the constructor differs, unmount the current component and mount a new one using the new
    // constructor.
    var anchor = renderer.nextSibling(n1.elm);
    unmount(n1, parent, renderer, true);
    mountCustomElement(n2, parent, anchor, renderer);
  } else {
    // Otherwise patch the existing component with new props/attrs/etc.
    var elm = n2.elm = n1.elm;
    var vm = n2.vm = n1.vm;
    patchElementPropsAndAttrsAndRefs$1(n1, n2, renderer);
    if (!isUndefined$1(vm)) {
      // in fallback mode, the allocation will always set children to
      // empty and delegate the real allocation to the slot elements
      allocateChildren(n2, vm);
      // Solves an edge case with slotted VFragments in native shadow mode.
      //
      // During allocation, in native shadow, slotted VFragment nodes are flattened and their text delimiters are removed
      // to avoid interfering with native slot behavior. When this happens, if any of the fragments
      // were not stable, the children must go through the dynamic diffing algo.
      //
      // If the new children (n2.children) contain no VFragments, but the previous children (n1.children) were dynamic,
      // the new nodes must be marked dynamic so that all nodes are properly updated. The only indicator that the new
      // nodes need to be dynamic comes from the previous children, so we check that to determine whether we need to
      // mark the new children dynamic.
      //
      // Example:
      // n1.children: [div, VFragment('', div, null, ''), div] => [div, div, null, div]; // marked dynamic
      // n2.children: [div, null, div] => [div, null, div] // marked ???
      var shadowMode = vm.shadowMode,
        renderMode = vm.renderMode;
      if (shadowMode == 0 /* ShadowMode.Native */ && renderMode !== 0 /* RenderMode.Light */ && hasDynamicChildren(n1.children)) {
        // No-op if children has already been marked dynamic by 'allocateChildren()'.
        markAsDynamicChildren(n2.children);
      }
    }
    // in fallback mode, the children will be always empty, so, nothing
    // will happen, but in native, it does allocate the light dom
    patchChildren(n1.children, n2.children, elm, renderer);
    if (!isUndefined$1(vm)) {
      // this will probably update the shadowRoot, but only if the vm is in a dirty state
      // this is important to preserve the top to bottom synchronous rendering phase.
      rerenderVM(vm);
    }
  }
}
function mountVNodes(vnodes, parent, renderer, anchor) {
  var start = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : vnodes.length;
  for (; start < end; ++start) {
    var vnode = vnodes[start];
    if (isVNode(vnode)) {
      mount(vnode, parent, renderer, anchor);
    }
  }
}
function unmount(vnode, parent, renderer) {
  var doRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var type = vnode.type,
    elm = vnode.elm,
    sel = vnode.sel;
  // When unmounting a VNode subtree not all the elements have to removed from the DOM. The
  // subtree root, is the only element worth unmounting from the subtree.
  if (doRemove && type !== 5 /* VNodeType.Fragment */) {
    // The vnode might or might not have a data.renderer associated to it
    // but the removal used here is from the owner instead.
    removeNode(elm, parent, renderer);
  }
  switch (type) {
    case 5 /* VNodeType.Fragment */:
      {
        unmountVNodes(vnode.children, parent, renderer, doRemove);
        break;
      }
    case 2 /* VNodeType.Element */:
      {
        // Slot content is removed to trigger slotchange event when removing slot.
        // Only required for synthetic shadow.
        var shouldRemoveChildren = sel === 'slot' && vnode.owner.shadowMode === 1 /* ShadowMode.Synthetic */;
        unmountVNodes(vnode.children, elm, renderer, shouldRemoveChildren);
        break;
      }
    case 3 /* VNodeType.CustomElement */:
      {
        var vm = vnode.vm;
        // No need to unmount the children here, `removeVM` will take care of removing the
        // children.
        if (!isUndefined$1(vm)) {
          removeVM(vm);
        }
      }
  }
}
function unmountVNodes(vnodes, parent, renderer) {
  var doRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var start = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : vnodes.length;
  for (; start < end; ++start) {
    var ch = vnodes[start];
    if (isVNode(ch)) {
      unmount(ch, parent, renderer, doRemove);
    }
  }
}
function isVNode(vnode) {
  return vnode != null;
}
function linkNodeToShadow(elm, owner, renderer) {
  var renderRoot = owner.renderRoot,
    renderMode = owner.renderMode,
    shadowMode = owner.shadowMode;
  var isSyntheticShadowDefined = renderer.isSyntheticShadowDefined;
  // TODO [#1164]: this should eventually be done by the polyfill directly
  if (isSyntheticShadowDefined) {
    if (shadowMode === 1 /* ShadowMode.Synthetic */ || renderMode === 0 /* RenderMode.Light */) {
      elm[KEY__SHADOW_RESOLVER] = renderRoot[KEY__SHADOW_RESOLVER];
    }
  }
}
function insertFragmentOrNode(vnode, parent, anchor, renderer) {
  if (process.env.NODE_ENV !== 'production') {
    unlockDomMutation();
  }
  if (isVFragment(vnode)) {
    var children = vnode.children;
    for (var _i17 = 0; _i17 < children.length; _i17 += 1) {
      var child = children[_i17];
      if (!isNull(child)) {
        renderer.insert(child.elm, parent, anchor);
      }
    }
  } else {
    renderer.insert(vnode.elm, parent, anchor);
  }
  if (process.env.NODE_ENV !== 'production') {
    lockDomMutation();
  }
}
function insertNode(node, parent, anchor, renderer) {
  if (process.env.NODE_ENV !== 'production') {
    unlockDomMutation();
  }
  renderer.insert(node, parent, anchor);
  if (process.env.NODE_ENV !== 'production') {
    lockDomMutation();
  }
}
function removeNode(node, parent, renderer) {
  if (process.env.NODE_ENV !== 'production') {
    unlockDomMutation();
  }
  renderer.remove(node, parent);
  if (process.env.NODE_ENV !== 'production') {
    lockDomMutation();
  }
}
function patchElementPropsAndAttrsAndRefs$1(oldVnode, vnode, renderer) {
  if (isNull(oldVnode)) {
    applyEventListeners(vnode, renderer);
    applyStaticClassAttribute(vnode, renderer);
    applyStaticStyleAttribute(vnode, renderer);
  }
  var owner = vnode.owner;
  // Attrs need to be applied to element before props IE11 will wipe out value on radio inputs if
  // value is set before type=radio.
  patchClassAttribute(oldVnode, vnode, renderer);
  patchStyleAttribute(oldVnode, vnode, renderer, owner);
  patchAttributes(oldVnode, vnode, renderer);
  patchProps(oldVnode, vnode, renderer);
  patchSlotAssignment(oldVnode, vnode, renderer);
  // The `refs` object is blown away in every re-render, so we always need to re-apply them
  applyRefs(vnode, owner);
}
function applyStyleScoping(elm, owner, renderer) {
  var getClassList = renderer.getClassList;
  // Set the class name for `*.scoped.css` style scoping.
  var scopeToken = getScopeTokenClass(owner, /* legacy */false);
  if (!isNull(scopeToken)) {
    // TODO [#2762]: this dot notation with add is probably problematic
    // probably we should have a renderer api for just the add operation
    getClassList(elm).add(scopeToken);
  }
  // TODO [#3733]: remove support for legacy scope tokens
  if (lwcRuntimeFlags.ENABLE_LEGACY_SCOPE_TOKENS) {
    var legacyScopeToken = getScopeTokenClass(owner, /* legacy */true);
    if (!isNull(legacyScopeToken)) {
      // TODO [#2762]: this dot notation with add is probably problematic
      // probably we should have a renderer api for just the add operation
      getClassList(elm).add(legacyScopeToken);
    }
  }
  // Set property element for synthetic shadow DOM style scoping.
  var syntheticToken = owner.context.stylesheetToken;
  if (owner.shadowMode === 1 /* ShadowMode.Synthetic */) {
    if (!isUndefined$1(syntheticToken)) {
      elm.$shadowToken$ = syntheticToken;
    }
    if (lwcRuntimeFlags.ENABLE_LEGACY_SCOPE_TOKENS) {
      var legacyToken = owner.context.legacyStylesheetToken;
      if (!isUndefined$1(legacyToken)) {
        elm.$legacyShadowToken$ = legacyToken;
      }
    }
  }
}
function applyDomManual(elm, vnode) {
  var _context$lwc;
  var owner = vnode.owner,
    context = vnode.data.context;
  if (owner.shadowMode === 1 /* ShadowMode.Synthetic */ && (context === null || context === void 0 || (_context$lwc = context.lwc) === null || _context$lwc === void 0 ? void 0 : _context$lwc.dom) === "manual" /* LwcDomMode.Manual */) {
    elm.$domManual$ = true;
  }
}
function applyElementRestrictions(elm, vnode) {
  if (process.env.NODE_ENV !== 'production') {
    var _vnode$data$context;
    var isSynthetic = vnode.owner.shadowMode === 1 /* ShadowMode.Synthetic */;
    var isPortal = vnode.type === 2 /* VNodeType.Element */ && ((_vnode$data$context = vnode.data.context) === null || _vnode$data$context === void 0 || (_vnode$data$context = _vnode$data$context.lwc) === null || _vnode$data$context === void 0 ? void 0 : _vnode$data$context.dom) === "manual" /* LwcDomMode.Manual */;
    var isLight = vnode.owner.renderMode === 0 /* RenderMode.Light */;
    patchElementWithRestrictions(elm, {
      isPortal: isPortal,
      isLight: isLight,
      isSynthetic: isSynthetic
    });
  }
}
function allocateChildren(vnode, vm) {
  // A component with slots will re-render because:
  // 1- There is a change of the internal state.
  // 2- There is a change on the external api (ex: slots)
  //
  // In case #1, the vnodes in the cmpSlots will be reused since they didn't changed. This routine emptied the
  // slotted children when those VCustomElement were rendered and therefore in subsequent calls to allocate children
  // in a reused VCustomElement, there won't be any slotted children.
  // For those cases, we will use the reference for allocated children stored when rendering the fresh VCustomElement.
  //
  // In case #2, we will always get a fresh VCustomElement.
  var children = vnode.aChildren || vnode.children;
  var renderMode = vm.renderMode,
    shadowMode = vm.shadowMode;
  if (process.env.NODE_ENV !== 'production') {
    // If any of the children being allocated is a scoped slot fragment, make sure the receiving
    // component is a light DOM component. This is mainly to validate light dom parent running
    // in native shadow mode.
    if (renderMode !== 0 /* RenderMode.Light */ && ArraySome.call(children, function (child) {
      return !isNull(child) && isVScopedSlotFragment(child);
    })) {
      logError("Invalid usage of 'lwc:slot-data' on ".concat(getComponentTag(vm), " tag. Scoped slot content can only be passed to a light dom child."));
    }
  }
  // If any of the children being allocated are VFragments, we remove the text delimiters and flatten all immediate
  // children VFragments to avoid them interfering with default slot behavior.
  var allocatedChildren = flattenFragmentsInChildren(children);
  vnode.children = allocatedChildren;
  vm.aChildren = allocatedChildren;
  if (shadowMode === 1 /* ShadowMode.Synthetic */ || renderMode === 0 /* RenderMode.Light */) {
    // slow path
    allocateInSlot(vm, allocatedChildren, vnode.owner);
    // save the allocated children in case this vnode is reused.
    vnode.aChildren = allocatedChildren;
    // every child vnode is now allocated, and the host should receive none directly, it receives them via the shadow!
    vnode.children = EmptyArray;
  }
}
/**
 * Flattens the contents of all VFragments in an array of VNodes, removes the text delimiters on those VFragments, and
 * marks the resulting children array as dynamic. Uses a stack (array) to iteratively traverse the nested VFragments
 * and avoid the perf overhead of creating/destroying throwaway arrays/objects in a recursive approach.
 *
 * With the delimiters removed, the contents are marked dynamic so they are diffed correctly.
 *
 * This function is used for slotted VFragments to avoid the text delimiters interfering with slotting functionality.
 * @param children
 */
function flattenFragmentsInChildren(children) {
  var flattenedChildren = [];
  // Initialize our stack with the direct children of the custom component and check whether we have a VFragment.
  // If no VFragment is found in children, we don't need to traverse anything or mark the children dynamic and can return early.
  var nodeStack = [];
  var fragmentFound = false;
  for (var _i18 = children.length - 1; _i18 > -1; _i18 -= 1) {
    var child = children[_i18];
    ArrayPush$1.call(nodeStack, child);
    fragmentFound = fragmentFound || !!(child && isVFragment(child));
  }
  if (!fragmentFound) {
    return children;
  }
  var currentNode;
  while (!isUndefined$1(currentNode = ArrayPop.call(nodeStack))) {
    if (!isNull(currentNode) && isVFragment(currentNode)) {
      var fChildren = currentNode.children;
      // Ignore the start and end text node delimiters
      for (var _i19 = fChildren.length - 2; _i19 > 0; _i19 -= 1) {
        ArrayPush$1.call(nodeStack, fChildren[_i19]);
      }
    } else {
      ArrayPush$1.call(flattenedChildren, currentNode);
    }
  }
  // We always mark the children as dynamic because nothing generates stable VFragments yet.
  // If/when stable VFragments are generated by the compiler, this code should be updated to
  // not mark dynamic if all flattened VFragments were stable.
  markAsDynamicChildren(flattenedChildren);
  return flattenedChildren;
}
function createViewModelHook(elm, vnode, renderer) {
  var vm = getAssociatedVMIfPresent(elm);
  // There is a possibility that a custom element is registered under tagName, in which case, the
  // initialization is already carry on, and there is nothing else to do here since this hook is
  // called right after invoking `document.createElement`.
  if (!isUndefined$1(vm)) {
    return vm;
  }
  var sel = vnode.sel,
    mode = vnode.mode,
    ctor = vnode.ctor,
    owner = vnode.owner;
  vm = createVM(elm, ctor, renderer, {
    mode: mode,
    owner: owner,
    tagName: sel
  });
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isArray$1(vnode.children), "Invalid vnode for a custom element, it must have children defined.");
  }
  return vm;
}
function allocateInSlot(vm, children, owner) {
  var oldSlotsMapping = vm.cmpSlots.slotAssignments;
  var cmpSlotsMapping = create(null);
  // Collect all slots into cmpSlotsMapping
  for (var _i20 = 0, len = children.length; _i20 < len; _i20 += 1) {
    var vnode = children[_i20];
    if (isNull(vnode)) {
      continue;
    }
    var slotName = '';
    if (isVBaseElement(vnode) || isVStatic(vnode)) {
      var _vnode$slotAssignment;
      slotName = (_vnode$slotAssignment = vnode.slotAssignment) !== null && _vnode$slotAssignment !== void 0 ? _vnode$slotAssignment : '';
    } else if (isVScopedSlotFragment(vnode)) {
      slotName = vnode.slotName;
    }
    // Can't use toString here because Symbol(1).toString() is 'Symbol(1)'
    // but elm.setAttribute('slot', Symbol(1)) is an error.
    // the following line also throws same error for symbols
    // Similar for Object.create(null)
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    var normalizedSlotName = '' + slotName;
    var vnodes = cmpSlotsMapping[normalizedSlotName] = cmpSlotsMapping[normalizedSlotName] || [];
    ArrayPush$1.call(vnodes, vnode);
  }
  vm.cmpSlots = {
    owner: owner,
    slotAssignments: cmpSlotsMapping
  };
  if (isFalse(vm.isDirty)) {
    // We need to determine if the old allocation is really different from the new one
    // and mark the vm as dirty
    var oldKeys = keys(oldSlotsMapping);
    if (oldKeys.length !== keys(cmpSlotsMapping).length) {
      markComponentAsDirty(vm);
      return;
    }
    for (var _i21 = 0, _len2 = oldKeys.length; _i21 < _len2; _i21 += 1) {
      var key = oldKeys[_i21];
      if (isUndefined$1(cmpSlotsMapping[key]) || oldSlotsMapping[key].length !== cmpSlotsMapping[key].length) {
        markComponentAsDirty(vm);
        return;
      }
      var oldVNodes = oldSlotsMapping[key];
      var _vnodes = cmpSlotsMapping[key];
      for (var j = 0, a = cmpSlotsMapping[key].length; j < a; j += 1) {
        if (oldVNodes[j] !== _vnodes[j]) {
          markComponentAsDirty(vm);
          return;
        }
      }
    }
  }
}
var DynamicChildren = new WeakSet();
// dynamic children means it was either generated by an iteration in a template
// or part of an unstable fragment, and will require a more complex diffing algo.
function markAsDynamicChildren(children) {
  DynamicChildren.add(children);
}
function hasDynamicChildren(children) {
  return DynamicChildren.has(children);
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
  var map = {};
  // TODO [#1637]: simplify this by assuming that all vnodes has keys
  for (var j = beginIdx; j <= endIdx; ++j) {
    var ch = children[j];
    if (isVNode(ch)) {
      var key = ch.key;
      if (key !== undefined) {
        map[key] = j;
      }
    }
  }
  return map;
}
function updateDynamicChildren(oldCh, newCh, parent, renderer) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVnode = oldCh[0];
  var oldEndVnode = oldCh[oldEndIdx];
  var newChEnd = newCh.length - 1;
  var newEndIdx = newChEnd;
  var newStartVnode = newCh[0];
  var newEndVnode = newCh[newEndIdx];
  var oldKeyToIdx;
  var idxInOld;
  var elmToMove;
  var before;
  var clonedOldCh = false;
  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (!isVNode(oldStartVnode)) {
      oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
    } else if (!isVNode(oldEndVnode)) {
      oldEndVnode = oldCh[--oldEndIdx];
    } else if (!isVNode(newStartVnode)) {
      newStartVnode = newCh[++newStartIdx];
    } else if (!isVNode(newEndVnode)) {
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldStartVnode, newStartVnode)) {
      patch(oldStartVnode, newStartVnode, parent, renderer);
      oldStartVnode = oldCh[++oldStartIdx];
      newStartVnode = newCh[++newStartIdx];
    } else if (isSameVnode(oldEndVnode, newEndVnode)) {
      patch(oldEndVnode, newEndVnode, parent, renderer);
      oldEndVnode = oldCh[--oldEndIdx];
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldStartVnode, newEndVnode)) {
      // Vnode moved right
      patch(oldStartVnode, newEndVnode, parent, renderer);
      // In the case of fragments, the `elm` property of a vfragment points to the leading
      // anchor. To determine the next sibling of the whole fragment, we need to use the
      // trailing anchor as the argument to nextSibling():
      // [..., [leading, ...content, trailing], nextSibling, ...]
      var anchor = void 0;
      if (isVFragment(oldEndVnode)) {
        anchor = renderer.nextSibling(oldEndVnode.trailing.elm);
      } else {
        anchor = renderer.nextSibling(oldEndVnode.elm);
      }
      insertFragmentOrNode(oldStartVnode, parent, anchor, renderer);
      oldStartVnode = oldCh[++oldStartIdx];
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldEndVnode, newStartVnode)) {
      // Vnode moved left
      patch(oldEndVnode, newStartVnode, parent, renderer);
      insertFragmentOrNode(newStartVnode, parent, oldStartVnode.elm, renderer);
      oldEndVnode = oldCh[--oldEndIdx];
      newStartVnode = newCh[++newStartIdx];
    } else {
      if (oldKeyToIdx === undefined) {
        oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      }
      idxInOld = oldKeyToIdx[newStartVnode.key];
      if (isUndefined$1(idxInOld)) {
        // New element
        mount(newStartVnode, parent, renderer, oldStartVnode.elm);
        newStartVnode = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];
        if (isVNode(elmToMove)) {
          if (elmToMove.sel !== newStartVnode.sel) {
            // New element
            mount(newStartVnode, parent, renderer, oldStartVnode.elm);
          } else {
            patch(elmToMove, newStartVnode, parent, renderer);
            // Delete the old child, but copy the array since it is read-only.
            // The `oldCh` will be GC'ed after `updateDynamicChildren` is complete,
            // so we only care about the `oldCh` object inside this function.
            // To avoid cloning over and over again, we check `clonedOldCh`
            // and only clone once.
            if (!clonedOldCh) {
              clonedOldCh = true;
              oldCh = _toConsumableArray(oldCh);
            }
            // We've already cloned at least once, so it's no longer read-only
            oldCh[idxInOld] = undefined;
            insertFragmentOrNode(elmToMove, parent, oldStartVnode.elm, renderer);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
  }
  if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
    if (oldStartIdx > oldEndIdx) {
      // There's some cases in which the sub array of vnodes to be inserted is followed by null(s) and an
      // already processed vnode, in such cases the vnodes to be inserted should be before that processed vnode.
      var _i22 = newEndIdx;
      var n;
      do {
        n = newCh[++_i22];
      } while (!isVNode(n) && _i22 < newChEnd);
      before = isVNode(n) ? n.elm : null;
      mountVNodes(newCh, parent, renderer, before, newStartIdx, newEndIdx + 1);
    } else {
      unmountVNodes(oldCh, parent, renderer, true, oldStartIdx, oldEndIdx + 1);
    }
  }
}
function updateStaticChildren(c1, c2, parent, renderer) {
  var c1Length = c1.length;
  var c2Length = c2.length;
  if (c1Length === 0) {
    // the old list is empty, we can directly insert anything new
    mountVNodes(c2, parent, renderer, null);
    return;
  }
  if (c2Length === 0) {
    // the old list is nonempty and the new list is empty so we can directly remove all old nodes
    // this is the case in which the dynamic children of an if-directive should be removed
    unmountVNodes(c1, parent, renderer, true);
    return;
  }
  // if the old list is not empty, the new list MUST have the same
  // amount of nodes, that's why we call this static children
  var anchor = null;
  for (var _i23 = c2Length - 1; _i23 >= 0; _i23 -= 1) {
    var n1 = c1[_i23];
    var n2 = c2[_i23];
    if (n2 !== n1) {
      if (isVNode(n1)) {
        if (isVNode(n2)) {
          if (isSameVnode(n1, n2)) {
            // both vnodes are equivalent, and we just need to patch them
            patch(n1, n2, parent, renderer);
            anchor = n2.elm;
          } else {
            // removing the old vnode since the new one is different
            unmount(n1, parent, renderer, true);
            mount(n2, parent, renderer, anchor);
            anchor = n2.elm;
          }
        } else {
          // removing the old vnode since the new one is null
          unmount(n1, parent, renderer, true);
        }
      } else if (isVNode(n2)) {
        mount(n2, parent, renderer, anchor);
        anchor = n2.elm;
      }
    }
  }
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var SymbolIterator = Symbol.iterator;
function addVNodeToChildLWC(vnode) {
  ArrayPush$1.call(getVMBeingRendered().velements, vnode);
}
// [s]tatic [p]art
function sp(partId, data, text) {
  // Static part will always have either text or data, it's guaranteed by the compiler.
  var type = isNull(text) ? 1 /* VStaticPartType.Element */ : 0 /* VStaticPartType.Text */;
  return {
    type: type,
    partId: partId,
    data: data,
    text: text,
    elm: undefined // elm is defined later
  };
}
// [s]coped [s]lot [f]actory
function ssf(slotName, factory) {
  return {
    type: 6 /* VNodeType.ScopedSlotFragment */,
    factory: factory,
    owner: getVMBeingRendered(),
    elm: undefined,
    sel: undefined,
    key: undefined,
    slotName: slotName
  };
}
// [st]atic node
function st(fragmentFactory, key, parts) {
  var owner = getVMBeingRendered();
  var fragment = fragmentFactory(parts);
  var vnode = {
    type: 4 /* VNodeType.Static */,
    sel: undefined,
    key: key,
    elm: undefined,
    fragment: fragment,
    owner: owner,
    parts: parts,
    slotAssignment: undefined
  };
  return vnode;
}
// [fr]agment node
function fr(key, children, stable) {
  var owner = getVMBeingRendered();
  var useCommentNodes = isAPIFeatureEnabled(5 /* APIFeature.USE_COMMENTS_FOR_FRAGMENT_BOOKENDS */, owner.apiVersion);
  var leading = useCommentNodes ? co('') : t('');
  var trailing = useCommentNodes ? co('') : t('');
  return {
    type: 5 /* VNodeType.Fragment */,
    sel: undefined,
    key: key,
    elm: undefined,
    children: [leading].concat(_toConsumableArray(children), [trailing]),
    stable: stable,
    owner: owner,
    leading: leading,
    trailing: trailing
  };
}
// [h]tml node
function h(sel, data) {
  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EmptyArray;
  var vmBeingRendered = getVMBeingRendered();
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isString(sel), "h() 1st argument sel must be a string.");
    assert.isTrue(isObject(data), "h() 2nd argument data must be an object.");
    assert.isTrue(isArray$1(children), "h() 3rd argument children must be an array.");
    assert.isTrue('key' in data, " <".concat(sel, "> \"key\" attribute is invalid or missing for ").concat(vmBeingRendered, ". Key inside iterator is either undefined or null."));
    // checking reserved internal data properties
    assert.isFalse(data.className && data.classMap, "vnode.data.className and vnode.data.classMap ambiguous declaration.");
    assert.isFalse(data.styleDecls && data.style, "vnode.data.styleDecls and vnode.data.style ambiguous declaration.");
    forEach.call(children, function (childVnode) {
      if (childVnode != null) {
        assert.isTrue('type' in childVnode && 'sel' in childVnode && 'elm' in childVnode && 'key' in childVnode, "".concat(childVnode, " is not a vnode."));
      }
    });
  }
  var key = data.key,
    slotAssignment = data.slotAssignment;
  var vnode = {
    type: 2 /* VNodeType.Element */,
    sel: sel,
    data: data,
    children: children,
    elm: undefined,
    key: key,
    owner: vmBeingRendered,
    slotAssignment: slotAssignment
  };
  return vnode;
}
// [t]ab[i]ndex function
function ti(value) {
  // if value is greater than 0, we normalize to 0
  // If value is an invalid tabIndex value (null, undefined, string, etc), we let that value pass through
  // If value is less than -1, we don't care
  var shouldNormalize = value > 0 && !(isTrue(value) || isFalse(value));
  if (process.env.NODE_ENV !== 'production') {
    var _vmBeingRendered6 = getVMBeingRendered();
    if (shouldNormalize) {
      logError("Invalid tabindex value `".concat(toString$1(value), "` in template for ").concat(_vmBeingRendered6, ". This attribute must be set to 0 or -1."), _vmBeingRendered6);
    }
  }
  return shouldNormalize ? 0 : value;
}
// [s]lot element node
function s(slotName, data, children, slotset) {
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isString(slotName), "s() 1st argument slotName must be a string.");
    assert.isTrue(isObject(data), "s() 2nd argument data must be an object.");
    assert.isTrue(isArray$1(children), "h() 3rd argument children must be an array.");
  }
  var vmBeingRendered = getVMBeingRendered();
  var renderMode = vmBeingRendered.renderMode,
    apiVersion = vmBeingRendered.apiVersion;
  if (!isUndefined$1(slotset) && !isUndefined$1(slotset.slotAssignments) && !isUndefined$1(slotset.slotAssignments[slotName]) && slotset.slotAssignments[slotName].length !== 0) {
    var newChildren = [];
    var slotAssignments = slotset.slotAssignments[slotName];
    var _loop3 = function _loop3() {
      var vnode = slotAssignments[_i24];
      if (!isNull(vnode)) {
        var assignedNodeIsScopedSlot = isVScopedSlotFragment(vnode);
        // The only sniff test for a scoped <slot> element is the presence of `slotData`
        var isScopedSlotElement = !isUndefined$1(data.slotData);
        // Check if slot types of parent and child are matching
        if (assignedNodeIsScopedSlot !== isScopedSlotElement) {
          if (process.env.NODE_ENV !== 'production') {
            logError("Mismatched slot types for ".concat(slotName === '' ? '(default)' : slotName, " slot. Both parent and child component must use standard type or scoped type for a given slot."), slotset.owner);
          }
          // Ignore slot content from parent
          return 1; // continue
        }
        // If the passed slot content is factory, evaluate it and add the produced vnodes
        if (assignedNodeIsScopedSlot) {
          // Evaluate in the scope of the slot content's owner
          // if a slotset is provided, there will always be an owner. The only case where owner is
          // undefined is for root components, but root components cannot accept slotted content
          setVMBeingRendered(slotset.owner);
          try {
            // The factory function is a template snippet from the slot set owner's template,
            // hence switch over to the slot set owner's template reactive observer
            var tro = slotset.owner.tro;
            tro.observe(function () {
              ArrayPush$1.call(newChildren, vnode.factory(data.slotData, data.key));
            });
          } finally {
            setVMBeingRendered(vmBeingRendered);
          }
        } else {
          var _clonedVNode;
          // This block is for standard slots (non-scoped slots)
          var clonedVNode;
          if (renderMode === 0 /* RenderMode.Light */ && isAPIFeatureEnabled(6 /* APIFeature.USE_LIGHT_DOM_SLOT_FORWARDING */, apiVersion) && (isVBaseElement(vnode) || isVStatic(vnode)) &&
          // We only need to copy the vnodes when the slot assignment changes, copying every time causes issues with
          // disconnected/connected callback firing.
          vnode.slotAssignment !== data.slotAssignment) {
            // When the light DOM slot assignment (slot attribute) changes we can't use the same reference
            // to the vnode because the current way the diffing algo works, it will replace the original reference
            // to the host element with a new one. This means the new element will be mounted and immediately unmounted.
            // Creating a copy of the vnode to preserve a reference to the previous host element.
            clonedVNode = _objectSpread(_objectSpread({}, vnode), {}, {
              slotAssignment: data.slotAssignment
            });
          }
          // If the slot content is standard type, the content is static, no additional
          // processing needed on the vnode
          ArrayPush$1.call(newChildren, (_clonedVNode = clonedVNode) !== null && _clonedVNode !== void 0 ? _clonedVNode : vnode);
        }
      }
    };
    for (var _i24 = 0; _i24 < slotAssignments.length; _i24++) {
      if (_loop3()) continue;
    }
    children = newChildren;
  }
  var shadowMode = vmBeingRendered.shadowMode;
  if (renderMode === 0 /* RenderMode.Light */) {
    // light DOM slots - backwards-compatible behavior uses flattening, new behavior uses fragments
    if (isAPIFeatureEnabled(2 /* APIFeature.USE_FRAGMENTS_FOR_LIGHT_DOM_SLOTS */, apiVersion)) {
      return fr(data.key, children, 0);
    } else {
      sc(children);
      return children;
    }
  }
  if (shadowMode === 1 /* ShadowMode.Synthetic */) {
    // TODO [#1276]: compiler should give us some sort of indicator when a vnodes collection is dynamic
    sc(children);
  }
  return h('slot', data, children);
}
// [c]ustom element node
function c(sel, Ctor, data) {
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EmptyArray;
  var vmBeingRendered = getVMBeingRendered();
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isString(sel), "c() 1st argument sel must be a string.");
    assert.isTrue(isFunction$1(Ctor), "c() 2nd argument Ctor must be a function.");
    assert.isTrue(isObject(data), "c() 3nd argument data must be an object.");
    assert.isTrue(arguments.length === 3 || isArray$1(children), "c() 4nd argument data must be an array.");
    // checking reserved internal data properties
    assert.isFalse(data.className && data.classMap, "vnode.data.className and vnode.data.classMap ambiguous declaration.");
    assert.isFalse(data.styleDecls && data.style, "vnode.data.styleDecls and vnode.data.style ambiguous declaration.");
    if (data.style && !isString(data.style)) {
      logError("Invalid 'style' attribute passed to <".concat(sel, "> is ignored. This attribute must be a string value."), vmBeingRendered);
    }
    if (arguments.length === 4) {
      forEach.call(children, function (childVnode) {
        if (childVnode != null) {
          assert.isTrue('type' in childVnode && 'sel' in childVnode && 'elm' in childVnode && 'key' in childVnode, "".concat(childVnode, " is not a vnode."));
        }
      });
    }
  }
  var key = data.key,
    slotAssignment = data.slotAssignment;
  var elm, aChildren, vm;
  var vnode = {
    type: 3 /* VNodeType.CustomElement */,
    sel: sel,
    data: data,
    children: children,
    elm: elm,
    key: key,
    slotAssignment: slotAssignment,
    ctor: Ctor,
    owner: vmBeingRendered,
    mode: 'open',
    // TODO [#1294]: this should be defined in Ctor
    aChildren: aChildren,
    vm: vm
  };
  addVNodeToChildLWC(vnode);
  return vnode;
}
// [i]terable node
function i(iterable, factory) {
  var list = [];
  // TODO [#1276]: compiler should give us some sort of indicator when a vnodes collection is dynamic
  sc(list);
  var vmBeingRendered = getVMBeingRendered();
  if (isUndefined$1(iterable) || iterable === null) {
    if (process.env.NODE_ENV !== 'production') {
      logError("Invalid template iteration for value \"".concat(toString$1(iterable), "\" in ").concat(vmBeingRendered, ". It must be an Array or an iterable Object."), vmBeingRendered);
    }
    return list;
  }
  if (process.env.NODE_ENV !== 'production') {
    assert.isFalse(isUndefined$1(iterable[SymbolIterator]), "Invalid template iteration for value `".concat(toString$1(iterable), "` in ").concat(vmBeingRendered, ". It must be an array-like object and not `null` nor `undefined`."));
  }
  var iterator = iterable[SymbolIterator]();
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(iterator && isFunction$1(iterator.next), "Invalid iterator function for \"".concat(toString$1(iterable), "\" in ").concat(vmBeingRendered, "."));
  }
  var next = iterator.next();
  var j = 0;
  var _next2 = next,
    value = _next2.value,
    last = _next2.done;
  var keyMap;
  var iterationError;
  if (process.env.NODE_ENV !== 'production') {
    keyMap = create(null);
  }
  while (last === false) {
    // implementing a look-back-approach because we need to know if the element is the last
    next = iterator.next();
    last = next.done;
    // template factory logic based on the previous collected value
    var vnode = factory(value, j, j === 0, last === true);
    if (isArray$1(vnode)) {
      ArrayPush$1.apply(list, vnode);
    } else {
      // `isArray` doesn't narrow this block properly...
      ArrayPush$1.call(list, vnode);
    }
    if (process.env.NODE_ENV !== 'production') {
      var vnodes = isArray$1(vnode) ? vnode : [vnode];
      forEach.call(vnodes, function (childVnode) {
        // Check that the child vnode is either an element or VStatic
        if (!isNull(childVnode) && (isVBaseElement(childVnode) || isVStatic(childVnode))) {
          var key = childVnode.key;
          // In @lwc/engine-server the fragment doesn't have a tagName, default to the VM's tagName.
          var tagName = vmBeingRendered.tagName;
          if (isString(key) || isNumber(key)) {
            if (keyMap[key] === 1 && isUndefined$1(iterationError)) {
              iterationError = "Duplicated \"key\" attribute value in \"<".concat(tagName, ">\" for item number ").concat(j, ". A key with value \"").concat(key, "\" appears more than once in the iteration. Key values must be unique numbers or strings.");
            }
            keyMap[key] = 1;
          } else if (isUndefined$1(iterationError)) {
            iterationError = "Invalid \"key\" attribute value in \"<".concat(tagName, ">\" for item number ").concat(j, ". Set a unique \"key\" value on all iterated child elements.");
          }
        }
      });
    }
    // preparing next value
    j += 1;
    value = next.value;
  }
  if (process.env.NODE_ENV !== 'production') {
    if (!isUndefined$1(iterationError)) {
      logError(iterationError, vmBeingRendered);
    }
  }
  return list;
}
/**
 * [f]lattening
 * @param items
 */
function f(items) {
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isArray$1(items), 'flattening api can only work with arrays.');
  }
  var len = items.length;
  var flattened = [];
  // TODO [#1276]: compiler should give us some sort of indicator when a vnodes collection is dynamic
  sc(flattened);
  for (var j = 0; j < len; j += 1) {
    var item = items[j];
    if (isArray$1(item)) {
      ArrayPush$1.apply(flattened, item);
    } else {
      // `isArray` doesn't narrow this block properly...
      ArrayPush$1.call(flattened, item);
    }
  }
  return flattened;
}
// [t]ext node
function t(text) {
  var sel, key, elm;
  return {
    type: 0 /* VNodeType.Text */,
    sel: sel,
    text: text,
    elm: elm,
    key: key,
    owner: getVMBeingRendered()
  };
}
// [co]mment node
function co(text) {
  var sel, elm;
  return {
    type: 1 /* VNodeType.Comment */,
    sel: sel,
    text: text,
    elm: elm,
    key: 'c',
    owner: getVMBeingRendered()
  };
}
// [d]ynamic text
function d(value) {
  return value == null ? '' : String(value);
}
// [b]ind function
function b(fn) {
  var vmBeingRendered = getVMBeingRendered();
  if (isNull(vmBeingRendered)) {
    throw new Error();
  }
  var vm = vmBeingRendered;
  return function (event) {
    invokeEventListener(vm, fn, vm.component, event);
  };
}
// [k]ey function
function k(compilerKey, obj) {
  switch (_typeof(obj)) {
    case 'number':
    case 'string':
      return compilerKey + ':' + obj;
    case 'object':
      if (process.env.NODE_ENV !== 'production') {
        logError("Invalid key value \"".concat(obj, "\" in ").concat(getVMBeingRendered(), ". Key must be a string or number."));
      }
  }
}
// [g]lobal [id] function
function gid(id) {
  var vmBeingRendered = getVMBeingRendered();
  if (isUndefined$1(id) || id === '') {
    if (process.env.NODE_ENV !== 'production') {
      logError("Invalid id value \"".concat(id, "\". The id attribute must contain a non-empty string."), vmBeingRendered);
    }
    return id;
  }
  // We remove attributes when they are assigned a value of null
  if (isNull(id)) {
    return null;
  }
  var idx = vmBeingRendered.idx,
    shadowMode = vmBeingRendered.shadowMode;
  if (shadowMode === 1 /* ShadowMode.Synthetic */) {
    return StringReplace.call(id, /\S+/g, function (id) {
      return "".concat(id, "-").concat(idx);
    });
  }
  return id;
}
// [f]ragment [id] function
function fid(url) {
  var vmBeingRendered = getVMBeingRendered();
  if (isUndefined$1(url) || url === '') {
    if (process.env.NODE_ENV !== 'production') {
      if (isUndefined$1(url)) {
        logError("Undefined url value for \"href\" or \"xlink:href\" attribute. Expected a non-empty string.", vmBeingRendered);
      }
    }
    return url;
  }
  // We remove attributes when they are assigned a value of null
  if (isNull(url)) {
    return null;
  }
  var idx = vmBeingRendered.idx,
    shadowMode = vmBeingRendered.shadowMode;
  // Apply transformation only for fragment-only-urls, and only in shadow DOM
  if (shadowMode === 1 /* ShadowMode.Synthetic */ && /^#/.test(url)) {
    return "".concat(url, "-").concat(idx);
  }
  return url;
}
/**
 * [ddc] - create a (deprecated) dynamic component via `<x-foo lwc:dynamic={Ctor}>`
 *
 * TODO [#3331]: remove usage of lwc:dynamic in 246
 * @param sel
 * @param Ctor
 * @param data
 * @param children
 */
function ddc(sel, Ctor, data) {
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EmptyArray;
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isString(sel), "dc() 1st argument sel must be a string.");
    assert.isTrue(isObject(data), "dc() 3nd argument data must be an object.");
    assert.isTrue(arguments.length === 3 || isArray$1(children), "dc() 4nd argument data must be an array.");
  }
  // null or undefined values should produce a null value in the VNodes
  if (isNull(Ctor) || isUndefined$1(Ctor)) {
    return null;
  }
  if (!isComponentConstructor(Ctor)) {
    throw new Error("Invalid LWC Constructor ".concat(toString$1(Ctor), " for custom element <").concat(sel, ">."));
  }
  return c(sel, Ctor, data, children);
}
/**
 * [dc] - create a dynamic component via `<lwc:component lwc:is={Ctor}>`
 * @param Ctor
 * @param data
 * @param children
 */
function dc(Ctor, data) {
  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EmptyArray;
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isObject(data), "dc() 2nd argument data must be an object.");
    assert.isTrue(arguments.length === 3 || isArray$1(children), "dc() 3rd argument data must be an array.");
  }
  // Null or undefined values should produce a null value in the VNodes.
  // This is the only value at compile time as the constructor will not be known.
  if (isNull(Ctor) || isUndefined$1(Ctor)) {
    return null;
  }
  if (!isComponentConstructor(Ctor)) {
    throw new Error("Invalid constructor ".concat(toString$1(Ctor), " is not a LightningElement constructor."));
  }
  // Look up the dynamic component's name at runtime once the constructor is available.
  // This information is only known at runtime and is stored as part of registerComponent.
  var sel = getComponentRegisteredName(Ctor);
  if (isUndefined$1(sel) || sel === '') {
    throw new Error("Invalid LWC constructor ".concat(toString$1(Ctor), " does not have a registered name"));
  }
  return c(sel, Ctor, data, children);
}
/**
 * slow children collection marking mechanism. this API allows the compiler to signal
 * to the engine that a particular collection of children must be diffed using the slow
 * algo based on keys due to the nature of the list. E.g.:
 *
 * - slot element's children: the content of the slot has to be dynamic when in synthetic
 * shadow mode because the `vnode.children` might be the slotted
 * content vs default content, in which case the size and the
 * keys are not matching.
 * - children that contain dynamic components
 * - children that are produced by iteration
 * @param vnodes
 */
function sc(vnodes) {
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(isArray$1(vnodes), 'sc() api can only work with arrays.');
  }
  // We have to mark the vnodes collection as dynamic so we can later on
  // choose to use the snabbdom virtual dom diffing algo instead of our
  // static dummy algo.
  markAsDynamicChildren(vnodes);
  return vnodes;
}
/**
 * EXPERIMENTAL: This function acts like a hook for Lightning Locker Service and other similar
 * libraries to sanitize HTML content. This hook process the content passed via the template to
 * lwc:inner-html directive.
 * It is meant to be overridden with setSanitizeHtmlContentHook, it throws an error by default.
 */
var sanitizeHtmlContentHook = function sanitizeHtmlContentHook() {
  // locker-service patches this function during runtime to sanitize HTML content.
  throw new Error('sanitizeHtmlContent hook must be implemented.');
};
// [s]anitize [h]tml [c]ontent
function shc(content) {
  return sanitizeHtmlContentHook();
}
var api = freeze({
  s: s,
  h: h,
  c: c,
  i: i,
  f: f,
  t: t,
  d: d,
  b: b,
  k: k,
  co: co,
  dc: dc,
  fr: fr,
  ti: ti,
  st: st,
  gid: gid,
  fid: fid,
  shc: shc,
  ssf: ssf,
  ddc: ddc,
  sp: sp
});

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var operationIdNameMapping = ['constructor', 'render', 'patch', 'connectedCallback', 'renderedCallback', 'disconnectedCallback', 'errorCallback', 'lwc-hydrate', 'lwc-rehydrate'];
// Even if all the browser the engine supports implements the UserTiming API, we need to guard the measure APIs.
// JSDom (used in Jest) for example doesn't implement the UserTiming APIs.
var isUserTimingSupported = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';
var start = !isUserTimingSupported ? noop : function (markName) {
  performance.mark(markName);
};
var end = !isUserTimingSupported ? noop : function (measureName, markName) {
  performance.measure(measureName, markName);
  // Clear the created marks and measure to avoid filling the performance entries buffer.
  // Note: Even if the entries get deleted, existing PerformanceObservers preserve a copy of those entries.
  performance.clearMarks(markName);
  performance.clearMeasures(measureName);
};
function getOperationName(opId) {
  return operationIdNameMapping[opId];
}
function getMeasureName(opId, vm) {
  return "".concat(getComponentTag(vm), " - ").concat(getOperationName(opId));
}
function getMarkName(opId, vm) {
  // Adding the VM idx to the mark name creates a unique mark name component instance. This is necessary to produce
  // the right measures for components that are recursive.
  return "".concat(getMeasureName(opId, vm), " - ").concat(vm.idx);
}
/** Indicates if operations should be logged via the User Timing API. */
var isMeasureEnabled = process.env.NODE_ENV !== 'production';
function logOperationStart(opId, vm) {
  if (isMeasureEnabled) {
    var markName = getMarkName(opId, vm);
    start(markName);
  }
}
function logOperationEnd(opId, vm) {
  if (isMeasureEnabled) {
    var markName = getMarkName(opId, vm);
    var measureName = getMeasureName(opId, vm);
    end(measureName, markName);
  }
}
function logGlobalOperationStart(opId, vm) {
  if (isMeasureEnabled) {
    var opName = getOperationName(opId);
    var markName = isUndefined$1(vm) ? opName : getMarkName(opId, vm);
    start(markName);
  }
}
function logGlobalOperationEnd(opId, vm) {
  if (isMeasureEnabled) {
    var opName = getOperationName(opId);
    var markName = isUndefined$1(vm) ? opName : getMarkName(opId, vm);
    end(opName, markName);
  }
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var isUpdatingTemplate = false;
var vmBeingRendered = null;
function getVMBeingRendered() {
  return vmBeingRendered;
}
function setVMBeingRendered(vm) {
  vmBeingRendered = vm;
}
function validateSlots(vm) {
  assertNotProd(); // this method should never leak to prod
  var cmpSlots = vm.cmpSlots;
  for (var slotName in cmpSlots.slotAssignments) {
    assert.isTrue(isArray$1(cmpSlots.slotAssignments[slotName]), "Slots can only be set to an array, instead received ".concat(toString$1(cmpSlots.slotAssignments[slotName]), " for slot \"").concat(slotName, "\" in ").concat(vm, "."));
  }
}
function validateLightDomTemplate(template, vm) {
  assertNotProd(); // should never leak to prod mode
  if (template === defaultEmptyTemplate) {
    return;
  }
  if (vm.renderMode === 0 /* RenderMode.Light */) {
    if (template.renderMode !== 'light') {
      logError("Light DOM components can't render shadow DOM templates. Add an 'lwc:render-mode=\"light\"' directive to the root template tag of ".concat(getComponentTag(vm), "."));
    }
  } else {
    if (!isUndefined$1(template.renderMode)) {
      logError("Shadow DOM components template can't render light DOM templates. Either remove the 'lwc:render-mode' directive from ".concat(getComponentTag(vm), " or set it to 'lwc:render-mode=\"shadow\""));
    }
  }
}
var browserExpressionSerializer = function browserExpressionSerializer(partToken, classAttrToken) {
  // This will insert the scoped style token as a static class attribute in the fragment
  // bypassing the need to call applyStyleScoping when mounting static parts.
  var type = StringCharAt.call(partToken, 0);
  switch (type) {
    case "c" /* STATIC_PART_TOKEN_ID.CLASS */:
      return classAttrToken;
    case "t" /* STATIC_PART_TOKEN_ID.TEXT */:
      // Using a single space here gives us a single empty text node
      return ' ';
    default:
      return '';
  }
};
// This function serializes the expressions generated by static content optimization.
// Currently this is only needed for SSR.
// TODO [#4078]: Split the implementation between @lwc/engine-dom and @lwc/engine-server
function buildSerializeExpressionFn(parts) {
  {
    return browserExpressionSerializer;
  }
}
// This should be a no-op outside of LWC's Karma tests, where it's not needed
var registerFragmentCache = noop;
// Only used in LWC's Karma tests
if (process.env.NODE_ENV === 'test-karma-lwc') {
  // Keep track of fragmentCaches, so we can clear them in LWC's Karma tests
  var fragmentCaches = [];
  registerFragmentCache = function registerFragmentCache(fragmentCache) {
    fragmentCaches.push(fragmentCache);
  };
  window.__lwcResetFragmentCaches = function () {
    for (var _i25 = 0, _fragmentCaches = fragmentCaches; _i25 < _fragmentCaches.length; _i25++) {
      var fragmentCache = _fragmentCaches[_i25];
      var _iterator10 = _createForOfIteratorHelper(keys(fragmentCache)),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var key = _step10.value;
          delete fragmentCache[key];
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  };
}
function buildParseFragmentFn(createFragmentFn) {
  return function (strings) {
    for (var _len3 = arguments.length, keys = new Array(_len3 > 1 ? _len3 - 1 : 0), _key = 1; _key < _len3; _key++) {
      keys[_key - 1] = arguments[_key];
    }
    var cache = create(null);
    registerFragmentCache(cache);
    return function (parts) {
      var _getVMBeingRendered = getVMBeingRendered(),
        _getVMBeingRendered$c = _getVMBeingRendered.context,
        hasScopedStyles = _getVMBeingRendered$c.hasScopedStyles,
        stylesheetToken = _getVMBeingRendered$c.stylesheetToken,
        legacyStylesheetToken = _getVMBeingRendered$c.legacyStylesheetToken,
        shadowMode = _getVMBeingRendered.shadowMode,
        renderer = _getVMBeingRendered.renderer;
      var hasStyleToken = !isUndefined$1(stylesheetToken);
      var isSyntheticShadow = shadowMode === 1 /* ShadowMode.Synthetic */;
      var hasLegacyToken = lwcRuntimeFlags.ENABLE_LEGACY_SCOPE_TOKENS && !isUndefined$1(legacyStylesheetToken);
      var cacheKey = 0;
      if (hasStyleToken && hasScopedStyles) {
        cacheKey |= 1 /* FragmentCache.HAS_SCOPED_STYLE */;
      }
      if (hasStyleToken && isSyntheticShadow) {
        cacheKey |= 2 /* FragmentCache.SHADOW_MODE_SYNTHETIC */;
      }
      // Cache is only here to prevent calling innerHTML multiple times which doesn't happen on the server.
      {
        // Disable this on the server to prevent cache poisoning when expressions are used.
        var cached = cache[cacheKey];
        if (!isUndefined$1(cached)) {
          return cached;
        }
      }
      // If legacy stylesheet tokens are required, then add them to the rendered string
      var stylesheetTokenToRender = stylesheetToken + (hasLegacyToken ? " ".concat(legacyStylesheetToken) : '');
      var classToken = hasScopedStyles && hasStyleToken ? ' ' + stylesheetTokenToRender : '';
      var classAttrToken = hasScopedStyles && hasStyleToken ? " class=\"".concat(stylesheetTokenToRender, "\"") : '';
      var attrToken = hasStyleToken && isSyntheticShadow ? ' ' + stylesheetTokenToRender : '';
      // In the browser, we provide the entire class attribute as a perf optimization to avoid applying it on mount.
      // The remaining class expression will be applied when the static parts are mounted.
      // In SSR, the entire class attribute (expression included) is assembled along with the fragment.
      // This is why in the browser we provide the entire class attribute and in SSR we only provide the class token.
      var exprClassToken = classAttrToken;
      // TODO [#3624]: The implementation of this function should be specific to @lwc/engine-dom and @lwc/engine-server.
      // Find a way to split this in a future refactor.
      var serializeExpression = buildSerializeExpressionFn();
      var htmlFragment = '';
      for (var _i26 = 0, n = keys.length; _i26 < n; _i26++) {
        switch (keys[_i26]) {
          case 0:
            // styleToken in existing class attr
            htmlFragment += strings[_i26] + classToken;
            break;
          case 1:
            // styleToken for added class attr
            htmlFragment += strings[_i26] + classAttrToken;
            break;
          case 2:
            // styleToken as attr
            htmlFragment += strings[_i26] + attrToken;
            break;
          case 3:
            // ${1}${2}
            htmlFragment += strings[_i26] + classAttrToken + attrToken;
            break;
          default:
            // expressions ${partId:attributeName/textId}
            htmlFragment += strings[_i26] + serializeExpression(keys[_i26], exprClassToken);
            break;
        }
      }
      htmlFragment += strings[strings.length - 1];
      cache[cacheKey] = createFragmentFn(htmlFragment, renderer);
      return cache[cacheKey];
    };
  };
}
// Note: at the moment this code executes, we don't have a renderer yet.
var parseFragment = buildParseFragmentFn(function (html, renderer) {
  var createFragment = renderer.createFragment;
  return createFragment(html);
});
function evaluateTemplate(vm, html) {
  if (process.env.NODE_ENV !== 'production') {
    // in dev-mode, we support hot swapping of templates, which means that
    // the component instance might be attempting to use an old version of
    // the template, while internally, we have a replacement for it.
    html = getTemplateOrSwappedTemplate(html);
  }
  var isUpdatingTemplateInception = isUpdatingTemplate;
  var vmOfTemplateBeingUpdatedInception = vmBeingRendered;
  var vnodes = [];
  runWithBoundaryProtection(vm, vm.owner, function () {
    // pre
    vmBeingRendered = vm;
    logOperationStart(1 /* OperationId.Render */, vm);
  }, function () {
    // job
    var component = vm.component,
      context = vm.context,
      cmpSlots = vm.cmpSlots,
      cmpTemplate = vm.cmpTemplate,
      tro = vm.tro;
    tro.observe(function () {
      // Reset the cache memoizer for template when needed.
      if (html !== cmpTemplate) {
        // Check that the template was built by the compiler.
        if (!isTemplateRegistered(html)) {
          throw new TypeError("Invalid template returned by the render() method on ".concat(vm.tagName, ". It must return an imported template (e.g.: `import html from \"./").concat(vm.def.name, ".html\"`), instead, it has returned: ").concat(toString$1(html), "."));
        }
        if (process.env.NODE_ENV !== 'production') {
          validateLightDomTemplate(html, vm);
        }
        // Perf opt: do not reset the shadow root during the first rendering (there is
        // nothing to reset).
        if (!isNull(cmpTemplate)) {
          // It is important to reset the content to avoid reusing similar elements
          // generated from a different template, because they could have similar IDs,
          // and snabbdom just rely on the IDs.
          resetComponentRoot(vm);
        }
        vm.cmpTemplate = html;
        // Create a brand new template cache for the swapped templated.
        context.tplCache = create(null);
        // Set the computeHasScopedStyles property in the context, to avoid recomputing it repeatedly.
        context.hasScopedStyles = computeHasScopedStyles(html, vm);
        // Update the scoping token on the host element.
        updateStylesheetToken(vm, html, /* legacy */false);
        if (lwcRuntimeFlags.ENABLE_LEGACY_SCOPE_TOKENS) {
          updateStylesheetToken(vm, html, /* legacy */true);
        }
        // Evaluate, create stylesheet and cache the produced VNode for future
        // re-rendering.
        var stylesheetsContent = getStylesheetsContent(vm, html);
        context.styleVNodes = stylesheetsContent.length === 0 ? null : createStylesheet(vm, stylesheetsContent);
      }
      if (process.env.NODE_ENV !== 'production') {
        // validating slots in every rendering since the allocated content might change over time
        validateSlots(vm);
        // add the VM to the list of host VMs that can be re-rendered if html is swapped
        setActiveVM(vm);
      }
      // right before producing the vnodes, we clear up all internal references
      // to custom elements from the template.
      vm.velements = [];
      // Set the global flag that template is being updated
      isUpdatingTemplate = true;
      vnodes = html.call(undefined, api, component, cmpSlots, context.tplCache);
      var styleVNodes = context.styleVNodes;
      if (!isNull(styleVNodes)) {
        ArrayUnshift.apply(vnodes, styleVNodes);
      }
    });
  }, function () {
    // post
    isUpdatingTemplate = isUpdatingTemplateInception;
    vmBeingRendered = vmOfTemplateBeingUpdatedInception;
    logOperationEnd(1 /* OperationId.Render */, vm);
  });
  if (process.env.NODE_ENV !== 'production') {
    if (!isArray$1(vnodes)) {
      logError("Compiler should produce html functions that always return an array.");
    }
  }
  return vnodes;
}
function computeHasScopedStylesInStylesheets(stylesheets) {
  if (hasStyles(stylesheets)) {
    for (var _i27 = 0; _i27 < stylesheets.length; _i27++) {
      if (isTrue(stylesheets[_i27][KEY__SCOPED_CSS])) {
        return true;
      }
    }
  }
  return false;
}
function computeHasScopedStyles(template, vm) {
  var stylesheets = template.stylesheets;
  var vmStylesheets = !isUndefined$1(vm) ? vm.stylesheets : null;
  return computeHasScopedStylesInStylesheets(stylesheets) || computeHasScopedStylesInStylesheets(vmStylesheets);
}
function hasStyles(stylesheets) {
  return !isUndefined$1(stylesheets) && !isNull(stylesheets) && stylesheets.length > 0;
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var isInvokingRender = false;
var vmBeingConstructed = null;
function isBeingConstructed(vm) {
  return vmBeingConstructed === vm;
}
function invokeComponentCallback(vm, fn, args) {
  var component = vm.component,
    callHook = vm.callHook,
    owner = vm.owner;
  runWithBoundaryProtection(vm, owner, noop, function () {
    callHook(component, fn, args);
  }, noop);
}
function invokeComponentConstructor(vm, Ctor) {
  var vmBeingConstructedInception = vmBeingConstructed;
  var error;
  logOperationStart(0 /* OperationId.Constructor */, vm);
  vmBeingConstructed = vm;
  /**
   * Constructors don't need to be wrapped with a boundary because for root elements
   * it should throw, while elements from template are already wrapped by a boundary
   * associated to the diffing algo.
   */
  try {
    // job
    var result = new Ctor();
    // Check indirectly if the constructor result is an instance of LightningElement. Using
    // the "instanceof" operator would not work here since Locker Service provides its own
    // implementation of LightningElement, so we indirectly check if the base constructor is
    // invoked by accessing the component on the vm.
    if (vmBeingConstructed.component !== result) {
      throw new TypeError('Invalid component constructor, the class should extend LightningElement.');
    }
  } catch (e) {
    error = Object(e);
  } finally {
    logOperationEnd(0 /* OperationId.Constructor */, vm);
    vmBeingConstructed = vmBeingConstructedInception;
    if (!isUndefined$1(error)) {
      addErrorComponentStack(vm, error);
      // re-throwing the original error annotated after restoring the context
      throw error; // eslint-disable-line no-unsafe-finally
    }
  }
}
function invokeComponentRenderMethod(vm) {
  var render = vm.def.render,
    callHook = vm.callHook,
    component = vm.component,
    owner = vm.owner;
  var isRenderBeingInvokedInception = isInvokingRender;
  var vmBeingRenderedInception = getVMBeingRendered();
  var html;
  var renderInvocationSuccessful = false;
  runWithBoundaryProtection(vm, owner, function () {
    // pre
    isInvokingRender = true;
    setVMBeingRendered(vm);
  }, function () {
    // job
    vm.tro.observe(function () {
      html = callHook(component, render);
      renderInvocationSuccessful = true;
    });
  }, function () {
    // post
    isInvokingRender = isRenderBeingInvokedInception;
    setVMBeingRendered(vmBeingRenderedInception);
  });
  // If render() invocation failed, process errorCallback in boundary and return an empty template
  return renderInvocationSuccessful ? evaluateTemplate(vm, html) : [];
}
function invokeEventListener(vm, fn, thisValue, event) {
  var callHook = vm.callHook,
    owner = vm.owner;
  runWithBoundaryProtection(vm, owner, noop, function () {
    // job
    if (process.env.NODE_ENV !== 'production') {
      assert.isTrue(isFunction$1(fn), "Invalid event handler for event '".concat(event.type, "' on ").concat(vm, "."));
    }
    callHook(thisValue, fn, [event]);
  }, noop);
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var registeredComponentMap = new Map();
/**
 * INTERNAL: This function can only be invoked by compiled code. The compiler
 * will prevent this function from being imported by userland code.
 * @param Ctor
 * @param metadata
 */
function registerComponent(
// We typically expect a LightningElementConstructor, but technically you can call this with anything
Ctor, metadata) {
  if (isFunction$1(Ctor)) {
    if (process.env.NODE_ENV !== 'production') {
      // There is no point in running this in production, because the version mismatch check relies
      // on code comments which are stripped out in production by minifiers
      checkVersionMismatch(Ctor, 'component');
    }
    // TODO [#3331]: add validation to check the value of metadata.sel is not an empty string.
    registeredComponentMap.set(Ctor, metadata);
  }
  // chaining this method as a way to wrap existing assignment of component constructor easily,
  // without too much transformation
  return Ctor;
}
function getComponentRegisteredTemplate(Ctor) {
  var _registeredComponentM;
  return (_registeredComponentM = registeredComponentMap.get(Ctor)) === null || _registeredComponentM === void 0 ? void 0 : _registeredComponentM.tmpl;
}
function getComponentRegisteredName(Ctor) {
  var _registeredComponentM2;
  return (_registeredComponentM2 = registeredComponentMap.get(Ctor)) === null || _registeredComponentM2 === void 0 ? void 0 : _registeredComponentM2.sel;
}
function getComponentAPIVersion(Ctor) {
  var metadata = registeredComponentMap.get(Ctor);
  var apiVersion = metadata === null || metadata === void 0 ? void 0 : metadata.apiVersion;
  if (isUndefined$1(apiVersion)) {
    // This should only occur in our Karma tests; in practice every component
    // is registered, and so this code path should not get hit. But to be safe,
    // return the lowest possible version.
    return LOWEST_API_VERSION;
  }
  return apiVersion;
}
function getTemplateReactiveObserver(vm) {
  return createReactiveObserver(function () {
    var isDirty = vm.isDirty;
    if (isFalse(isDirty)) {
      markComponentAsDirty(vm);
      scheduleRehydration(vm);
    }
  });
}
function resetTemplateObserverAndUnsubscribe(vm) {
  var tro = vm.tro,
    component = vm.component;
  tro.reset();
  // Unsubscribe every time the template reactive observer is reset.
  if (lwcRuntimeFlags.ENABLE_EXPERIMENTAL_SIGNALS) {
    unsubscribeFromSignals(component);
  }
}
function renderComponent(vm) {
  if (process.env.NODE_ENV !== 'production') {
    assert.invariant(vm.isDirty, "".concat(vm, " is not dirty."));
  }
  // The engine should only hold a subscription to a signal if it is rendered in the template.
  // Because of the potential presence of conditional rendering logic, we unsubscribe on each render
  // in the scenario where it is present in one condition but not the other.
  // For example:
  // 1. There is an lwc:if=true conditional where the signal is present on the template.
  // 2. The lwc:if changes to false and the signal is no longer present on the template.
  // If the signal is still subscribed to, the template will re-render when it receives a notification
  // from the signal, even though we won't be using the new value.
  resetTemplateObserverAndUnsubscribe(vm);
  var vnodes = invokeComponentRenderMethod(vm);
  vm.isDirty = false;
  vm.isScheduled = false;
  return vnodes;
}
function markComponentAsDirty(vm) {
  if (process.env.NODE_ENV !== 'production') {
    var _vmBeingRendered7 = getVMBeingRendered();
    assert.isFalse(vm.isDirty, "markComponentAsDirty() for ".concat(vm, " should not be called when the component is already dirty."));
    assert.isFalse(isInvokingRender, "markComponentAsDirty() for ".concat(vm, " cannot be called during rendering of ").concat(_vmBeingRendered7, "."));
    assert.isFalse(isUpdatingTemplate, "markComponentAsDirty() for ".concat(vm, " cannot be called while updating template of ").concat(_vmBeingRendered7, "."));
  }
  vm.isDirty = true;
}
var cmpEventListenerMap = new WeakMap();
function getWrappedComponentsListener(vm, listener) {
  if (!isFunction$1(listener)) {
    throw new TypeError('Expected an EventListener but received ' + _typeof(listener)); // avoiding problems with non-valid listeners
  }
  var wrappedListener = cmpEventListenerMap.get(listener);
  if (isUndefined$1(wrappedListener)) {
    wrappedListener = function wrappedListener(event) {
      invokeEventListener(vm, listener, undefined, event);
    };
    cmpEventListenerMap.set(listener, wrappedListener);
  }
  return wrappedListener;
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var idx = 0;
/** The internal slot used to associate different objects the engine manipulates with the VM */
var ViewModelReflection = new WeakMap();
function callHook(cmp, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return fn.apply(cmp, args);
}
function setHook(cmp, prop, newValue) {
  cmp[prop] = newValue;
}
function getHook(cmp, prop) {
  return cmp[prop];
}
function rerenderVM(vm) {
  rehydrate(vm);
}
function connectRootElement(elm) {
  var vm = getAssociatedVM(elm);
  logGlobalOperationStart(7 /* OperationId.GlobalHydrate */, vm);
  // Usually means moving the element from one place to another, which is observable via
  // life-cycle hooks.
  if (vm.state === 1 /* VMState.connected */) {
    disconnectRootElement(elm);
  }
  runConnectedCallback(vm);
  rehydrate(vm);
  logGlobalOperationEnd(7 /* OperationId.GlobalHydrate */, vm);
}
function disconnectRootElement(elm) {
  var vm = getAssociatedVM(elm);
  resetComponentStateWhenRemoved(vm);
}
function appendVM(vm) {
  rehydrate(vm);
}
// just in case the component comes back, with this we guarantee re-rendering it
// while preventing any attempt to rehydration until after reinsertion.
function resetComponentStateWhenRemoved(vm) {
  var state = vm.state;
  if (state !== 2 /* VMState.disconnected */) {
    // Making sure that any observing record will not trigger the rehydrated on this vm
    resetTemplateObserverAndUnsubscribe(vm);
    runDisconnectedCallback(vm);
    // Spec: https://dom.spec.whatwg.org/#concept-node-remove (step 14-15)
    runChildNodesDisconnectedCallback(vm);
    runLightChildNodesDisconnectedCallback(vm);
  }
}
// this method is triggered by the diffing algo only when a vnode from the
// old vnode.children is removed from the DOM.
function removeVM(vm) {
  if (process.env.NODE_ENV !== 'production') {
    if (!shouldUseNativeCustomElementLifecycle(vm.component.constructor)) {
      // With native lifecycle, we cannot be certain that connectedCallback was called before a component
      // was removed from the VDOM. If the component is disconnected, then connectedCallback will not fire
      // in native mode, although it will fire in synthetic mode due to appendChild triggering it.
      // See: W-14037619 for details
      assert.isTrue(vm.state === 1 /* VMState.connected */ || vm.state === 2 /* VMState.disconnected */, "".concat(vm, " must have been connected."));
    }
  }
  resetComponentStateWhenRemoved(vm);
}
function getNearestShadowAncestor(owner) {
  var ancestor = owner;
  while (!isNull(ancestor) && ancestor.renderMode === 0 /* RenderMode.Light */) {
    ancestor = ancestor.owner;
  }
  return ancestor;
}
function createVM(elm, ctor, renderer, options) {
  var mode = options.mode,
    owner = options.owner,
    tagName = options.tagName,
    hydrated = options.hydrated;
  var def = getComponentInternalDef(ctor);
  var apiVersion = getComponentAPIVersion(ctor);
  var vm = {
    elm: elm,
    def: def,
    idx: idx++,
    state: 0 /* VMState.created */,
    isScheduled: false,
    isDirty: true,
    tagName: tagName,
    mode: mode,
    owner: owner,
    refVNodes: null,
    children: EmptyArray,
    aChildren: EmptyArray,
    velements: EmptyArray,
    cmpProps: create(null),
    cmpFields: create(null),
    cmpSlots: {
      slotAssignments: create(null)
    },
    cmpTemplate: null,
    hydrated: Boolean(hydrated),
    renderMode: def.renderMode,
    context: {
      stylesheetToken: undefined,
      hasTokenInClass: undefined,
      hasTokenInAttribute: undefined,
      legacyStylesheetToken: undefined,
      hasLegacyTokenInClass: undefined,
      hasLegacyTokenInAttribute: undefined,
      hasScopedStyles: undefined,
      styleVNodes: null,
      tplCache: EmptyObject,
      wiredConnecting: EmptyArray,
      wiredDisconnecting: EmptyArray
    },
    // Properties set right after VM creation.
    tro: null,
    shadowMode: null,
    shadowMigrateMode: false,
    stylesheets: null,
    // Properties set by the LightningElement constructor.
    component: null,
    shadowRoot: null,
    renderRoot: null,
    callHook: callHook,
    setHook: setHook,
    getHook: getHook,
    renderer: renderer,
    apiVersion: apiVersion
  };
  if (process.env.NODE_ENV !== 'production') {
    vm.debugInfo = create(null);
  }
  vm.stylesheets = computeStylesheets(vm, def.ctor);
  var computedShadowMode = computeShadowMode(def, vm.owner, renderer, hydrated);
  if (lwcRuntimeFlags.ENABLE_FORCE_SHADOW_MIGRATE_MODE) {
    vm.shadowMode = 0 /* ShadowMode.Native */;
    vm.shadowMigrateMode = computedShadowMode === 1 /* ShadowMode.Synthetic */;
  } else {
    vm.shadowMode = computedShadowMode;
  }
  vm.tro = getTemplateReactiveObserver(vm);
  if (process.env.NODE_ENV !== 'production') {
    vm.toString = function () {
      return "[object:vm ".concat(def.name, " (").concat(vm.idx, ")]");
    };
  }
  // Create component instance associated to the vm and the element.
  invokeComponentConstructor(vm, def.ctor);
  // Initializing the wire decorator per instance only when really needed
  if (hasWireAdapters(vm)) {
    installWireAdapters(vm);
  }
  return vm;
}
function validateComponentStylesheets(vm, stylesheets) {
  var valid = true;
  var validate = function validate(arrayOrStylesheet) {
    if (isArray$1(arrayOrStylesheet)) {
      for (var _i28 = 0; _i28 < arrayOrStylesheet.length; _i28++) {
        validate(arrayOrStylesheet[_i28]);
      }
    } else if (!isFunction$1(arrayOrStylesheet)) {
      // function assumed to be a stylesheet factory
      valid = false;
    }
  };
  if (!isArray$1(stylesheets)) {
    valid = false;
  } else {
    validate(stylesheets);
  }
  return valid;
}
// Validate and flatten any stylesheets defined as `static stylesheets`
function computeStylesheets(vm, ctor) {
  warnOnStylesheetsMutation(ctor);
  var stylesheets = ctor.stylesheets;
  if (!isUndefined$1(stylesheets)) {
    var valid = validateComponentStylesheets(vm, stylesheets);
    if (valid) {
      return flattenStylesheets(stylesheets);
    } else if (process.env.NODE_ENV !== 'production') {
      logError("static stylesheets must be an array of CSS stylesheets. Found invalid stylesheets on <".concat(vm.tagName, ">"), vm);
    }
  }
  return null;
}
function warnOnStylesheetsMutation(ctor) {
  if (process.env.NODE_ENV !== 'production') {
    var stylesheets = ctor.stylesheets;
    defineProperty(ctor, 'stylesheets', {
      enumerable: true,
      configurable: true,
      get: function get() {
        return stylesheets;
      },
      set: function set(newValue) {
        logWarnOnce("Dynamically setting the \"stylesheets\" static property on ".concat(ctor.name, " ") + 'will not affect the stylesheets injected.');
        stylesheets = newValue;
      }
    });
  }
}
// Compute the shadowMode/renderMode without creating a VM. This is used in some scenarios like hydration.
function computeShadowAndRenderMode(Ctor, renderer) {
  var def = getComponentInternalDef(Ctor);
  var renderMode = def.renderMode;
  // Assume null `owner` - this is what happens in hydration cases anyway
  // Also assume we are not in hydration mode for this exported API
  var shadowMode = computeShadowMode(def, /* owner */null, renderer, false);
  return {
    renderMode: renderMode,
    shadowMode: shadowMode
  };
}
function computeShadowMode(def, owner, renderer, hydrated) {
  if (
  // Force the shadow mode to always be native. Used for running tests with synthetic shadow patches
  // on, but components running in actual native shadow mode
  process.env.NODE_ENV === 'test-karma-lwc' && process.env.FORCE_NATIVE_SHADOW_MODE_FOR_TEST ||
  // hydration only supports native shadow
  isTrue(hydrated)) {
    return 0 /* ShadowMode.Native */;
  }
  var isSyntheticShadowDefined = renderer.isSyntheticShadowDefined;
  var shadowMode;
  if (isSyntheticShadowDefined || lwcRuntimeFlags.ENABLE_FORCE_SHADOW_MIGRATE_MODE) {
    if (def.renderMode === 0 /* RenderMode.Light */) {
      // ShadowMode.Native implies "not synthetic shadow" which is consistent with how
      // everything defaults to native when the synthetic shadow polyfill is unavailable.
      shadowMode = 0 /* ShadowMode.Native */;
    } else if (def.shadowSupportMode === "native" /* ShadowSupportMode.Native */) {
      shadowMode = 0 /* ShadowMode.Native */;
    } else {
      var shadowAncestor = getNearestShadowAncestor(owner);
      if (!isNull(shadowAncestor) && shadowAncestor.shadowMode === 0 /* ShadowMode.Native */) {
        // Transitive support for native Shadow DOM. A component in native mode
        // transitively opts all of its descendants into native.
        shadowMode = 0 /* ShadowMode.Native */;
      } else {
        // Synthetic if neither this component nor any of its ancestors are configured
        // to be native.
        shadowMode = 1 /* ShadowMode.Synthetic */;
      }
    }
  } else {
    // Native if the synthetic shadow polyfill is unavailable.
    shadowMode = 0 /* ShadowMode.Native */;
  }
  return shadowMode;
}
function assertIsVM(obj) {
  if (!isObject(obj) || isNull(obj) || !('renderRoot' in obj)) {
    throw new TypeError("".concat(obj, " is not a VM."));
  }
}
function associateVM(obj, vm) {
  ViewModelReflection.set(obj, vm);
}
function getAssociatedVM(obj) {
  var vm = ViewModelReflection.get(obj);
  if (process.env.NODE_ENV !== 'production') {
    assertIsVM(vm);
  }
  return vm;
}
function getAssociatedVMIfPresent(obj) {
  var maybeVm = ViewModelReflection.get(obj);
  if (process.env.NODE_ENV !== 'production') {
    if (!isUndefined$1(maybeVm)) {
      assertIsVM(maybeVm);
    }
  }
  return maybeVm;
}
function rehydrate(vm) {
  if (isTrue(vm.isDirty)) {
    var children = renderComponent(vm);
    patchShadowRoot(vm, children);
  }
}
function patchShadowRoot(vm, newCh) {
  var renderRoot = vm.renderRoot,
    oldCh = vm.children,
    renderer = vm.renderer;
  // reset the refs; they will be set during `patchChildren`
  resetRefVNodes(vm);
  // caching the new children collection
  vm.children = newCh;
  if (newCh.length > 0 || oldCh.length > 0) {
    // patch function mutates vnodes by adding the element reference,
    // however, if patching fails it contains partial changes.
    if (oldCh !== newCh) {
      runWithBoundaryProtection(vm, vm, function () {
        // pre
        logOperationStart(2 /* OperationId.Patch */, vm);
      }, function () {
        // job
        patchChildren(oldCh, newCh, renderRoot, renderer);
      }, function () {
        // post
        logOperationEnd(2 /* OperationId.Patch */, vm);
      });
    }
  }
  if (vm.state === 1 /* VMState.connected */) {
    // If the element is connected, that means connectedCallback was already issued, and
    // any successive rendering should finish with the call to renderedCallback, otherwise
    // the connectedCallback will take care of calling it in the right order at the end of
    // the current rehydration process.
    runRenderedCallback(vm);
  }
}
function runRenderedCallback(vm) {
  var renderedCallback = vm.def.renderedCallback;
  if (!isUndefined$1(renderedCallback)) {
    logOperationStart(4 /* OperationId.RenderedCallback */, vm);
    invokeComponentCallback(vm, renderedCallback);
    logOperationEnd(4 /* OperationId.RenderedCallback */, vm);
  }
}
var rehydrateQueue = [];
function flushRehydrationQueue() {
  logGlobalOperationStart(8 /* OperationId.GlobalRehydrate */);
  if (process.env.NODE_ENV !== 'production') {
    assert.invariant(rehydrateQueue.length, "If rehydrateQueue was scheduled, it is because there must be at least one VM on this pending queue instead of ".concat(rehydrateQueue, "."));
  }
  var vms = rehydrateQueue.sort(function (a, b) {
    return a.idx - b.idx;
  });
  rehydrateQueue = []; // reset to a new queue
  for (var _i29 = 0, len = vms.length; _i29 < len; _i29 += 1) {
    var vm = vms[_i29];
    try {
      rehydrate(vm);
    } catch (error) {
      if (_i29 + 1 < len) {
        // pieces of the queue are still pending to be rehydrated, those should have priority
        if (rehydrateQueue.length === 0) {
          addCallbackToNextTick(flushRehydrationQueue);
        }
        ArrayUnshift.apply(rehydrateQueue, ArraySlice.call(vms, _i29 + 1));
      }
      // we need to end the measure before throwing.
      logGlobalOperationEnd(8 /* OperationId.GlobalRehydrate */);
      // re-throwing the original error will break the current tick, but since the next tick is
      // already scheduled, it should continue patching the rest.
      throw error;
    }
  }
  logGlobalOperationEnd(8 /* OperationId.GlobalRehydrate */);
}
function runConnectedCallback(vm) {
  var state = vm.state;
  if (state === 1 /* VMState.connected */) {
    return; // nothing to do since it was already connected
  }
  vm.state = 1 /* VMState.connected */;
  if (hasWireAdapters(vm)) {
    connectWireAdapters(vm);
  }
  var connectedCallback = vm.def.connectedCallback;
  if (!isUndefined$1(connectedCallback)) {
    logOperationStart(3 /* OperationId.ConnectedCallback */, vm);
    invokeComponentCallback(vm, connectedCallback);
    logOperationEnd(3 /* OperationId.ConnectedCallback */, vm);
  }
  // This test only makes sense in the browser, with synthetic lifecycle, and when reporting is enabled or
  // we're in dev mode. This is to detect a particular issue with synthetic lifecycle.
  if (!shouldUseNativeCustomElementLifecycle(vm.component.constructor) && (process.env.NODE_ENV !== 'production' || isReportingEnabled())) {
    if (!vm.renderer.isConnected(vm.elm)) {
      if (process.env.NODE_ENV !== 'production') {
        logWarnOnce("Element <".concat(vm.tagName, "> ") + "fired a `connectedCallback` and rendered, but was not connected to the DOM. " + "Please ensure all components are actually connected to the DOM, e.g. using " + "`document.body.appendChild(element)`. This will not be supported in future versions of " + "LWC and could cause component errors. For details, see: https://sfdc.co/synthetic-lifecycle");
      }
      report("ConnectedCallbackWhileDisconnected" /* ReportingEventId.ConnectedCallbackWhileDisconnected */, {
        tagName: vm.tagName
      });
    }
  }
}
function hasWireAdapters(vm) {
  return getOwnPropertyNames$1(vm.def.wire).length > 0;
}
function runDisconnectedCallback(vm) {
  if (process.env.NODE_ENV !== 'production') {
    assert.isTrue(vm.state !== 2 /* VMState.disconnected */, "".concat(vm, " must be inserted."));
  }
  if (isFalse(vm.isDirty)) {
    // this guarantees that if the component is reused/reinserted,
    // it will be re-rendered because we are disconnecting the reactivity
    // linking, so mutations are not automatically reflected on the state
    // of disconnected components.
    vm.isDirty = true;
  }
  vm.state = 2 /* VMState.disconnected */;
  if (hasWireAdapters(vm)) {
    disconnectWireAdapters(vm);
  }
  var disconnectedCallback = vm.def.disconnectedCallback;
  if (!isUndefined$1(disconnectedCallback)) {
    logOperationStart(5 /* OperationId.DisconnectedCallback */, vm);
    invokeComponentCallback(vm, disconnectedCallback);
    logOperationEnd(5 /* OperationId.DisconnectedCallback */, vm);
  }
}
function runChildNodesDisconnectedCallback(vm) {
  var vCustomElementCollection = vm.velements;
  // Reporting disconnection for every child in inverse order since they are
  // inserted in reserved order.
  for (var _i30 = vCustomElementCollection.length - 1; _i30 >= 0; _i30 -= 1) {
    var elm = vCustomElementCollection[_i30].elm;
    // There are two cases where the element could be undefined:
    // * when there is an error during the construction phase, and an error
    //   boundary picks it, there is a possibility that the VCustomElement
    //   is not properly initialized, and therefore is should be ignored.
    // * when slotted custom element is not used by the element where it is
    //   slotted into it, as  a result, the custom element was never
    //   initialized.
    if (!isUndefined$1(elm)) {
      var childVM = getAssociatedVMIfPresent(elm);
      // The VM associated with the element might be associated undefined
      // in the case where the VM failed in the middle of its creation,
      // eg: constructor throwing before invoking super().
      if (!isUndefined$1(childVM)) {
        resetComponentStateWhenRemoved(childVM);
      }
    }
  }
}
function runLightChildNodesDisconnectedCallback(vm) {
  var adoptedChildren = vm.aChildren;
  recursivelyDisconnectChildren(adoptedChildren);
}
/**
 * The recursion doesn't need to be a complete traversal of the vnode graph,
 * instead it can be partial, when a custom element vnode is found, we don't
 * need to continue into its children because by attempting to disconnect the
 * custom element itself will trigger the removal of anything slotted or anything
 * defined on its shadow.
 * @param vnodes
 */
function recursivelyDisconnectChildren(vnodes) {
  for (var _i31 = 0, len = vnodes.length; _i31 < len; _i31 += 1) {
    var vnode = vnodes[_i31];
    if (!isNull(vnode) && !isUndefined$1(vnode.elm)) {
      switch (vnode.type) {
        case 2 /* VNodeType.Element */:
          recursivelyDisconnectChildren(vnode.children);
          break;
        case 3 /* VNodeType.CustomElement */:
          {
            var vm = getAssociatedVM(vnode.elm);
            resetComponentStateWhenRemoved(vm);
            break;
          }
      }
    }
  }
}
// This is a super optimized mechanism to remove the content of the root node (shadow root
// for shadow DOM components and the root element itself for light DOM) without having to go
// into snabbdom. Especially useful when the reset is a consequence of an error, in which case the
// children VNodes might not be representing the current state of the DOM.
function resetComponentRoot(vm) {
  recursivelyRemoveChildren(vm.children, vm);
  vm.children = EmptyArray;
  runChildNodesDisconnectedCallback(vm);
  vm.velements = EmptyArray;
}
// Helper function to remove all children of the root node.
// If the set of children includes VFragment nodes, we need to remove the children of those nodes too.
// Since VFragments can contain other VFragments, we need to traverse the entire of tree of VFragments.
// If the set contains no VFragment nodes, no traversal is needed.
function recursivelyRemoveChildren(vnodes, vm) {
  var renderRoot = vm.renderRoot,
    remove = vm.renderer.remove;
  for (var _i32 = 0, len = vnodes.length; _i32 < len; _i32 += 1) {
    var vnode = vnodes[_i32];
    if (!isNull(vnode)) {
      // VFragments are special; their .elm property does not point to the root element since they have no single root.
      if (isVFragment(vnode)) {
        recursivelyRemoveChildren(vnode.children, vm);
      } else if (!isUndefined$1(vnode.elm)) {
        remove(vnode.elm, renderRoot);
      }
    }
  }
}
function scheduleRehydration(vm) {
  if (isTrue(vm.isScheduled)) {
    return;
  }
  vm.isScheduled = true;
  if (rehydrateQueue.length === 0) {
    addCallbackToNextTick(flushRehydrationQueue);
  }
  ArrayPush$1.call(rehydrateQueue, vm);
}
function getErrorBoundaryVM(vm) {
  var currentVm = vm;
  while (!isNull(currentVm)) {
    if (!isUndefined$1(currentVm.def.errorCallback)) {
      return currentVm;
    }
    currentVm = currentVm.owner;
  }
}
function runWithBoundaryProtection(vm, owner, pre, job, post) {
  var error;
  pre();
  try {
    job();
  } catch (e) {
    error = Object(e);
  } finally {
    post();
    if (!isUndefined$1(error)) {
      addErrorComponentStack(vm, error);
      var errorBoundaryVm = isNull(owner) ? undefined : getErrorBoundaryVM(owner);
      // Error boundaries are not in effect when server-side rendering. `errorCallback`
      // is intended to allow recovery from errors - changing the state of a component
      // and instigating a re-render. That is at odds with the single-pass, synchronous
      // nature of SSR. For that reason, all errors bubble up to the `renderComponent`
      // call site.
      if (isUndefined$1(errorBoundaryVm)) {
        throw error; // eslint-disable-line no-unsafe-finally
      }
      resetComponentRoot(vm); // remove offenders
      logOperationStart(6 /* OperationId.ErrorCallback */, vm);
      // error boundaries must have an ErrorCallback
      var errorCallback = errorBoundaryVm.def.errorCallback;
      invokeComponentCallback(errorBoundaryVm, errorCallback, [error, error.wcStack]);
      logOperationEnd(6 /* OperationId.ErrorCallback */, vm);
    }
  }
}
function runFormAssociatedCustomElementCallback(vm, faceCb, args) {
  var renderMode = vm.renderMode,
    shadowMode = vm.shadowMode;
  if (shadowMode === 1 /* ShadowMode.Synthetic */ && renderMode !== 0 /* RenderMode.Light */) {
    throw new Error('Form associated lifecycle methods are not available in synthetic shadow. Please use native shadow or light DOM.');
  }
  invokeComponentCallback(vm, faceCb, args);
}
function runFormAssociatedCallback(elm, form) {
  var vm = getAssociatedVM(elm);
  var formAssociatedCallback = vm.def.formAssociatedCallback;
  if (!isUndefined$1(formAssociatedCallback)) {
    runFormAssociatedCustomElementCallback(vm, formAssociatedCallback, [form]);
  }
}
function runFormDisabledCallback(elm, disabled) {
  var vm = getAssociatedVM(elm);
  var formDisabledCallback = vm.def.formDisabledCallback;
  if (!isUndefined$1(formDisabledCallback)) {
    runFormAssociatedCustomElementCallback(vm, formDisabledCallback, [disabled]);
  }
}
function runFormResetCallback(elm) {
  var vm = getAssociatedVM(elm);
  var formResetCallback = vm.def.formResetCallback;
  if (!isUndefined$1(formResetCallback)) {
    runFormAssociatedCustomElementCallback(vm, formResetCallback);
  }
}
function runFormStateRestoreCallback(elm, state, reason) {
  var vm = getAssociatedVM(elm);
  var formStateRestoreCallback = vm.def.formStateRestoreCallback;
  if (!isUndefined$1(formStateRestoreCallback)) {
    runFormAssociatedCustomElementCallback(vm, formStateRestoreCallback, [state, reason]);
  }
}
function resetRefVNodes(vm) {
  var cmpTemplate = vm.cmpTemplate;
  vm.refVNodes = !isNull(cmpTemplate) && cmpTemplate.hasRefs ? create(null) : null;
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
//
// The goal of this code is to detect invalid cross-root ARIA references in synthetic shadow DOM.
// These invalid references should be fixed before the offending components can be migrated to native shadow DOM.
// When invalid usage is detected, we warn in dev mode and call the reporting API if enabled.
// See: https://sfdc.co/synthetic-aria
//
// Use the unpatched native getElementById/querySelectorAll rather than the synthetic one
var getElementById = globalThis[KEY__NATIVE_GET_ELEMENT_BY_ID];
var querySelectorAll = globalThis[KEY__NATIVE_QUERY_SELECTOR_ALL];
// This is a "handoff" from synthetic-shadow to engine-core – we want to clean up after ourselves
// so nobody else can misuse these global APIs.
delete globalThis[KEY__NATIVE_GET_ELEMENT_BY_ID];
delete globalThis[KEY__NATIVE_QUERY_SELECTOR_ALL];
function isSyntheticShadowRootInstance(rootNode) {
  return rootNode !== document && isTrue(rootNode.synthetic);
}
function reportViolation$1(source, target, attrName) {
  // The vm is either for the source, the target, or both. Either one or both must be using synthetic
  // shadow for a violation to be detected.
  var vm = getAssociatedVMIfPresent(source.getRootNode().host);
  if (isUndefined$1(vm)) {
    vm = getAssociatedVMIfPresent(target.getRootNode().host);
  }
  if (isUndefined$1(vm)) {
    // vm should never be undefined here, but just to be safe, bail out and don't report
    return;
  }
  report("CrossRootAriaInSyntheticShadow" /* ReportingEventId.CrossRootAriaInSyntheticShadow */, {
    tagName: vm.tagName,
    attributeName: attrName
  });
  if (process.env.NODE_ENV !== 'production') {
    // Avoid excessively logging to the console in the case of duplicates.
    logWarnOnce("Element <".concat(source.tagName.toLowerCase(), "> uses attribute \"").concat(attrName, "\" to reference element ") + "<".concat(target.tagName.toLowerCase(), ">, which is not in the same shadow root. This will break in native shadow DOM. ") + "For details, see: https://sfdc.co/synthetic-aria", vm);
  }
}
function parseIdRefAttributeValue(attrValue) {
  // split on whitespace and skip empty strings after splitting
  return isString(attrValue) ? ArrayFilter.call(StringSplit.call(attrValue, /\s+/), Boolean) : [];
}
function detectSyntheticCrossRootAria(elm, attrName, attrValue) {
  var root = elm.getRootNode();
  if (!isSyntheticShadowRootInstance(root)) {
    return;
  }
  if (attrName === 'id') {
    // elm is the target, find the source
    if (!isString(attrValue) || attrValue.length === 0) {
      // if our id is null or empty, nobody can reference us
      return;
    }
    var _iterator11 = _createForOfIteratorHelper(ID_REFERENCING_ATTRIBUTES_SET),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var idRefAttrName = _step11.value;
        // Query all global elements with this attribute. The attribute selector syntax `~=` is for values
        // that reference multiple IDs, separated by whitespace.
        var query = "[".concat(idRefAttrName, "~=\"").concat(CSS.escape(attrValue), "\"]");
        var sourceElements = querySelectorAll.call(document, query);
        for (var _i33 = 0; _i33 < sourceElements.length; _i33++) {
          var sourceElement = sourceElements[_i33];
          var sourceRoot = sourceElement.getRootNode();
          if (sourceRoot !== root) {
            reportViolation$1(sourceElement, elm, idRefAttrName);
            break;
          }
        }
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  } else {
    // elm is the source, find the target
    var ids = parseIdRefAttributeValue(attrValue);
    var _iterator12 = _createForOfIteratorHelper(ids),
      _step12;
    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var _id = _step12.value;
        var target = getElementById.call(document, _id);
        if (!isNull(target)) {
          var targetRoot = target.getRootNode();
          if (targetRoot !== root) {
            // target element's shadow root is not the same as ours
            reportViolation$1(elm, target, attrName);
          }
        }
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }
}
var enabled = false;
// We want to avoid patching globals whenever possible, so this should be tree-shaken out in prod-mode and if
// reporting is not enabled. It should also only run once
function enableDetection$1() {
  if (enabled) {
    return; // don't double-apply the patches
  }
  enabled = true;
  var _setAttribute = Element.prototype.setAttribute;
  // Detect calling `setAttribute` to set an idref or an id
  assign(Element.prototype, {
    setAttribute: function setAttribute(attrName, attrValue) {
      _setAttribute.call(this, attrName, attrValue);
      if (attrName === 'id' || ID_REFERENCING_ATTRIBUTES_SET.has(attrName)) {
        detectSyntheticCrossRootAria(this, attrName, attrValue);
      }
    }
  });
  // Detect `elm.id = 'foo'`
  var idDescriptor = getOwnPropertyDescriptor$1(Element.prototype, 'id');
  if (!isUndefined$1(idDescriptor)) {
    var _get3 = idDescriptor.get,
      _set3 = idDescriptor.set;
    // These should always be a getter and a setter, but if someone is monkeying with the global descriptor, ignore it
    if (isFunction$1(_get3) && isFunction$1(_set3)) {
      defineProperty(Element.prototype, 'id', {
        get: function get() {
          return _get3.call(this);
        },
        set: function set(value) {
          _set3.call(this, value);
          detectSyntheticCrossRootAria(this, 'id', value);
        },
        // On the default descriptor for 'id', enumerable and configurable are true
        enumerable: true,
        configurable: true
      });
    }
  }
}
// Our detection logic relies on some modern browser features. We can just skip reporting the data
// for unsupported browsers
function supportsCssEscape() {
  return typeof CSS !== 'undefined' && isFunction$1(CSS.escape);
}
// If this page is not using synthetic shadow, then we don't need to install detection. Note
// that we are assuming synthetic shadow is loaded before LWC.
function isSyntheticShadowLoaded() {
  // We should probably be calling `renderer.isSyntheticShadowDefined`, but 1) we don't have access to the renderer,
  // and 2) this code needs to run in @lwc/engine-core, so it can access `logWarn()` and `report()`.
  return hasOwnProperty$1.call(Element.prototype, KEY__SHADOW_TOKEN);
}
// Detecting cross-root ARIA in synthetic shadow only makes sense for the browser
if (supportsCssEscape() && isSyntheticShadowLoaded()) {
  // Always run detection in dev mode, so we can at least print to the console
  if (process.env.NODE_ENV !== 'production') {
    enableDetection$1();
  }
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
//
// The goal of this code is to detect usages of non-standard reflected ARIA properties. These are caused by
// legacy non-standard Element.prototype extensions added by the @lwc/aria-reflection package.
//
// See the README for @lwc/aria-reflection
var NON_STANDARD_ARIA_PROPS = ['ariaActiveDescendant', 'ariaControls', 'ariaDescribedBy', 'ariaDetails', 'ariaErrorMessage', 'ariaFlowTo', 'ariaLabelledBy', 'ariaOwns'];
function isGlobalAriaPolyfillLoaded() {
  // Sniff for the legacy polyfill being loaded. The reason this works is because ariaActiveDescendant is a
  // non-standard ARIA property reflection that is only supported in our legacy polyfill. See
  // @lwc/aria-reflection/README.md for details.
  return !isUndefined$1(getOwnPropertyDescriptor$1(Element.prototype, 'ariaActiveDescendant'));
}
function findVM(elm) {
  // If it's a shadow DOM component, then it has a host
  var _elm$getRootNode = elm.getRootNode(),
    host = _elm$getRootNode.host;
  var vm = isUndefined$1(host) ? undefined : getAssociatedVMIfPresent(host);
  if (!isUndefined$1(vm)) {
    return vm;
  }
  // Else it might be a light DOM component. Walk up the tree trying to find the owner
  var parentElement = elm;
  while (!isNull(parentElement = parentElement.parentElement)) {
    if (parentElement instanceof BaseBridgeElement) {
      // parentElement is an LWC component
      var _vm = getAssociatedVMIfPresent(parentElement);
      if (!isUndefined$1(_vm)) {
        return _vm;
      }
    }
  }
  // If we return undefined, it's because the element was rendered wholly outside a LightningElement
}
function checkAndReportViolation(elm, prop, isSetter, setValue) {
  var vm = findVM(elm);
  if (process.env.NODE_ENV !== 'production') {
    logWarnOnce("Element <".concat(elm.tagName.toLowerCase(), "> ") + (isUndefined$1(vm) ? '' : "owned by <".concat(vm.elm.tagName.toLowerCase(), "> ")) + "uses non-standard property \"".concat(prop, "\". This will be removed in a future version of LWC. ") + "See https://sfdc.co/deprecated-aria");
  }
  var setValueType;
  if (isSetter) {
    // `typeof null` is "object" which is not very useful for detecting null.
    // We mostly want to know null vs undefined vs other types here, due to
    // https://github.com/salesforce/lwc/issues/3284
    setValueType = isNull(setValue) ? 'null' : _typeof(setValue);
  }
  report("NonStandardAriaReflection" /* ReportingEventId.NonStandardAriaReflection */, {
    tagName: vm === null || vm === void 0 ? void 0 : vm.tagName,
    propertyName: prop,
    isSetter: isSetter,
    setValueType: setValueType
  });
}
function enableDetection() {
  var _Element = Element,
    prototype = _Element.prototype;
  var _iterator13 = _createForOfIteratorHelper(NON_STANDARD_ARIA_PROPS),
    _step13;
  try {
    var _loop4 = function _loop4() {
      var prop = _step13.value;
      var descriptor = getOwnPropertyDescriptor$1(prototype, prop);
      // The descriptor should exist because the @lwc/aria-reflection polyfill has run by now.
      // This happens automatically because of the ordering of imports.
      if (process.env.NODE_ENV !== 'production') {
        /* istanbul ignore if */
        if (isUndefined$1(descriptor) || isUndefined$1(descriptor.get) || isUndefined$1(descriptor.set)) {
          // should never happen
          throw new Error('detect-non-standard-aria.ts loaded before @lwc/aria-reflection');
        }
      }
      var _get4 = descriptor.get,
        _set4 = descriptor.set;
      // It's important for this defineProperty call to happen _after_ ARIA accessors are applied to the
      // BaseBridgeElement and LightningElement prototypes. Otherwise, we will log/report for access of non-standard
      // props on these prototypes, which we actually don't want. We only care about access on generic HTMLElements.
      defineProperty(prototype, prop, {
        get: function get() {
          checkAndReportViolation(this, prop, false, undefined);
          return _get4.call(this);
        },
        set: function set(val) {
          checkAndReportViolation(this, prop, true, val);
          return _set4.call(this, val);
        },
        configurable: true,
        enumerable: true
      });
    };
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      _loop4();
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }
}
// No point in running this code if we're not in a browser, or if the global polyfill is not loaded
if (isGlobalAriaPolyfillLoaded()) {
  // Always run detection in dev mode, so we can at least print to the console
  if (process.env.NODE_ENV !== 'production') {
    enableDetection();
  }
}

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
// See @lwc/engine-core/src/framework/template.ts
var TEMPLATE_PROPS = ['slots', 'stylesheetToken', 'stylesheets', 'renderMode'];
// Expandos that may be placed on a stylesheet factory function, and which are meaningful to LWC at runtime
var STYLESHEET_PROPS = [
// SEE `KEY__SCOPED_CSS` in @lwc/style-compiler
'$scoped$'];
// Via https://www.npmjs.com/package/object-observer
var ARRAY_MUTATION_METHODS = ['pop', 'push', 'shift', 'unshift', 'reverse', 'sort', 'fill', 'splice', 'copyWithin'];
var mutationTrackingDisabled = false;
function getOriginalArrayMethod(prop) {
  switch (prop) {
    case 'pop':
      return ArrayPop;
    case 'push':
      return ArrayPush$1;
    case 'shift':
      return ArrayShift;
    case 'unshift':
      return ArrayUnshift;
    case 'reverse':
      return ArrayReverse;
    case 'sort':
      return ArraySort;
    case 'fill':
      return ArrayFill;
    case 'splice':
      return ArraySplice;
    case 'copyWithin':
      return ArrayCopyWithin;
  }
}
function reportViolation(type, eventId, prop) {
  if (process.env.NODE_ENV !== 'production') {
    logWarnOnce("Mutating the \"".concat(prop, "\" property on a ").concat(type, " ") + "is deprecated and will be removed in a future version of LWC. " + "See: https://sfdc.co/template-mutation");
  }
}
function reportTemplateViolation(prop) {
  reportViolation('template', "TemplateMutation" /* ReportingEventId.TemplateMutation */, prop);
}
function reportStylesheetViolation(prop) {
  reportViolation('stylesheet', "StylesheetMutation" /* ReportingEventId.StylesheetMutation */, prop);
}
// Warn if the user tries to mutate a stylesheets array, e.g.:
// `tmpl.stylesheets.push(someStylesheetFunction)`
function warnOnArrayMutation(stylesheets) {
  var _loop5 = function _loop5() {
    var prop = _ARRAY_MUTATION_METHO[_i34];
    var originalArrayMethod = getOriginalArrayMethod(prop);
    // Assertions used here because TypeScript can't handle mapping over our types
    stylesheets[prop] = function arrayMutationWarningWrapper() {
      reportTemplateViolation('stylesheets');
      return originalArrayMethod.apply(this, arguments);
    };
  };
  // We can't handle users calling Array.prototype.slice.call(tmpl.stylesheets), but
  // we can at least warn when they use the most common mutation methods.
  for (var _i34 = 0, _ARRAY_MUTATION_METHO = ARRAY_MUTATION_METHODS; _i34 < _ARRAY_MUTATION_METHO.length; _i34++) {
    _loop5();
  }
}
// Warn if the user tries to mutate a stylesheet factory function, e.g.:
// `stylesheet.$scoped$ = true`
function warnOnStylesheetFunctionMutation(stylesheet) {
  var _loop6 = function _loop6() {
    var prop = _STYLESHEET_PROPS[_i35];
    var value = stylesheet[prop];
    defineProperty(stylesheet, prop, {
      enumerable: true,
      configurable: true,
      get: function get() {
        return value;
      },
      set: function set(newValue) {
        reportStylesheetViolation(prop);
        value = newValue;
      }
    });
  };
  for (var _i35 = 0, _STYLESHEET_PROPS = STYLESHEET_PROPS; _i35 < _STYLESHEET_PROPS.length; _i35++) {
    _loop6();
  }
}
// Warn on either array or stylesheet (function) mutation, in a deeply-nested array
function trackStylesheetsMutation(stylesheets) {
  traverseStylesheets(stylesheets, function (subStylesheets) {
    if (isArray$1(subStylesheets)) {
      warnOnArrayMutation(subStylesheets);
    } else {
      warnOnStylesheetFunctionMutation(subStylesheets);
    }
  });
}
// Deeply freeze the entire array (of arrays) of stylesheet factory functions
function deepFreeze(stylesheets) {
  traverseStylesheets(stylesheets, function (subStylesheets) {
    freeze(subStylesheets);
  });
}
// Deep-traverse an array (of arrays) of stylesheet factory functions, and call the callback for every array/function
function traverseStylesheets(stylesheets, callback) {
  callback(stylesheets);
  for (var _i36 = 0; _i36 < stylesheets.length; _i36++) {
    var _stylesheet6 = stylesheets[_i36];
    if (isArray$1(_stylesheet6)) {
      traverseStylesheets(_stylesheet6, callback);
    } else {
      callback(_stylesheet6);
    }
  }
}
function trackMutations(tmpl) {
  if (!isUndefined$1(tmpl.stylesheets)) {
    trackStylesheetsMutation(tmpl.stylesheets);
  }
  var _loop7 = function _loop7() {
    var prop = _TEMPLATE_PROPS[_i37];
    var value = tmpl[prop];
    defineProperty(tmpl, prop, {
      enumerable: true,
      configurable: true,
      get: function get() {
        return value;
      },
      set: function set(newValue) {
        if (!mutationTrackingDisabled) {
          reportTemplateViolation(prop);
        }
        value = newValue;
      }
    });
  };
  for (var _i37 = 0, _TEMPLATE_PROPS = TEMPLATE_PROPS; _i37 < _TEMPLATE_PROPS.length; _i37++) {
    _loop7();
  }
  var originalDescriptor = getOwnPropertyDescriptor$1(tmpl, 'stylesheetTokens');
  defineProperty(tmpl, 'stylesheetTokens', {
    enumerable: true,
    configurable: true,
    get: originalDescriptor.get,
    set: function set(value) {
      reportTemplateViolation('stylesheetTokens');
      // Avoid logging/reporting twice (for both stylesheetToken and stylesheetTokens)
      mutationTrackingDisabled = true;
      originalDescriptor.set.call(this, value);
      mutationTrackingDisabled = false;
    }
  });
}
function addLegacyStylesheetTokensShim(tmpl) {
  // When ENABLE_FROZEN_TEMPLATE is false, then we shim stylesheetTokens on top of stylesheetToken for anyone who
  // is accessing the old internal API (backwards compat). Details: W-14210169
  defineProperty(tmpl, 'stylesheetTokens', {
    enumerable: true,
    configurable: true,
    get: function get() {
      var stylesheetToken = this.stylesheetToken;
      if (isUndefined$1(stylesheetToken)) {
        return stylesheetToken;
      }
      // Shim for the old `stylesheetTokens` property
      // See https://github.com/salesforce/lwc/pull/2332/files#diff-7901555acef29969adaa6583185b3e9bce475cdc6f23e799a54e0018cb18abaa
      return {
        hostAttribute: "".concat(stylesheetToken, "-host"),
        shadowAttribute: stylesheetToken
      };
    },
    set: function set(value) {
      // If the value is null or some other exotic object, you would be broken anyway in the past
      // because the engine would try to access hostAttribute/shadowAttribute, which would throw an error.
      // However it may be undefined in newer versions of LWC, so we need to guard against that case.
      this.stylesheetToken = isUndefined$1(value) ? undefined : value.shadowAttribute;
    }
  });
}
function freezeTemplate(tmpl) {
  // TODO [#2782]: remove this flag and delete the legacy behavior
  if (lwcRuntimeFlags.ENABLE_FROZEN_TEMPLATE) {
    // Deep freeze the template
    freeze(tmpl);
    if (!isUndefined$1(tmpl.stylesheets)) {
      deepFreeze(tmpl.stylesheets);
    }
  } else {
    // template is not frozen - shim, report, and warn
    // this shim should be applied in both dev and prod
    addLegacyStylesheetTokensShim(tmpl);
    // When ENABLE_FROZEN_TEMPLATE is false, we want to warn in dev mode whenever someone is mutating the template
    if (process.env.NODE_ENV !== 'production') {
      trackMutations(tmpl);
    }
  }
}
/** version: 6.6.3 */

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * Displays the header for a custom element.
 * @param ce The custom element to get the header for.
 * @param componentInstance component instance associated with the custom element.
 */
function getHeaderForCustomElement(ce, componentInstance) {
  // [element]
  // LWC component instance: [vm.component]
  return ['div', {}, ['object', {
    object: ce,
    config: {
      skip: true
    }
  }], ['div', {}, ['span', {
    style: 'margin: 0 5px; color: red'
  }, 'LWC:'], ['object', {
    object: componentInstance
  }]]];
}
function getHeaderForComponentInstance(componentInstance, debugInfo) {
  if (keys(debugInfo).length === 0) {
    // there is no debug information, no need to customize this component instance
    return null;
  }
  // [component]
  // Debug information: [vm.debugInfo]
  return ['div', {}, ['object', {
    object: componentInstance,
    config: {
      skip: true
    }
  }], ['div', {}, ['span', {
    style: 'margin: 0 5px; color: red'
  }, 'Debug:'], ['object', {
    object: debugInfo
  }]]];
}
var LightningElementFormatter = {
  name: 'LightningElementFormatter',
  header: function header(obj, config) {
    var vm = getAssociatedVMIfPresent(obj);
    if (!isUndefined$1(vm) && (isUndefined$1(config) || !config.skip)) {
      if (obj instanceof HTMLElement) {
        return getHeaderForCustomElement(obj, vm.component);
      } else {
        return getHeaderForComponentInstance(obj, vm.debugInfo);
      }
    }
    return null;
  },
  hasBody: function hasBody() {
    return false;
  }
};

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
function init() {
  var devtoolsFormatters = globalThis.devtoolsFormatters || [];
  ArrayPush$1.call(devtoolsFormatters, LightningElementFormatter);
  globalThis.devtoolsFormatters = devtoolsFormatters;
}
if (process.env.NODE_ENV !== 'production') {
  init();
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
//
// Feature detection
//
// This check for constructable style sheets is similar to Fast's:
// https://github.com/microsoft/fast/blob/d49d1ec/packages/web-components/fast-element/src/dom.ts#L51-L53
// See also: https://github.com/whatwg/webidl/issues/1027#issuecomment-934510070
var supportsConstructableStylesheets = isFunction$1(CSSStyleSheet.prototype.replaceSync) && isArray$1(document.adoptedStyleSheets);
var stylesheetCache = new Map();
//
// Test utilities
//
// Only used in LWC's Karma tests
if (process.env.NODE_ENV === 'test-karma-lwc') {
  window.__lwcResetGlobalStylesheets = function () {
    stylesheetCache.clear();
  };
}
function createFreshStyleElement(content) {
  var elm = document.createElement('style');
  elm.type = 'text/css';
  elm.textContent = content;
  // Add an attribute to distinguish global styles added by LWC as opposed to other frameworks/libraries on the page
  elm.setAttribute('data-rendered-by-lwc', '');
  return elm;
}
function createStyleElement(content, cacheData) {
  var element = cacheData.element,
    usedElement = cacheData.usedElement;
  // If the <style> was already used, then we should clone it. We cannot insert
  // the same <style> in two places in the DOM.
  if (usedElement) {
    // This `<style>` may be repeated multiple times in the DOM, so cache it. It's a bit
    // faster to call `cloneNode()` on an existing node than to recreate it every time.
    return element.cloneNode(true);
  }
  // We don't clone every time, because that would be a perf tax on the first time
  cacheData.usedElement = true;
  return element;
}
function createConstructableStylesheet(content) {
  var stylesheet = new CSSStyleSheet();
  stylesheet.replaceSync(content);
  return stylesheet;
}
function insertConstructableStylesheet(content, target, cacheData, signal) {
  var adoptedStyleSheets = target.adoptedStyleSheets;
  var stylesheet = cacheData.stylesheet;
  // The reason we prefer .push() rather than reassignment is for perf: https://github.com/salesforce/lwc/pull/2683
  adoptedStyleSheets.push(stylesheet);
  if (process.env.NODE_ENV !== 'production') {
    /* istanbul ignore if */
    if (isUndefined$1(signal)) {
      throw new Error('Expected AbortSignal to be defined in dev mode');
    }
    // TODO [#4155]: unrendering should account for stylesheet content collisions
    signal.addEventListener('abort', function () {
      adoptedStyleSheets.splice(adoptedStyleSheets.indexOf(stylesheet), 1);
      stylesheetCache["delete"](content);
    });
  }
}
function insertStyleElement(content, target, cacheData, signal) {
  var elm = createStyleElement(content, cacheData);
  target.appendChild(elm);
  if (process.env.NODE_ENV !== 'production') {
    /* istanbul ignore if */
    if (isUndefined$1(signal)) {
      throw new Error('Expected AbortSignal to be defined in dev mode');
    }
    // TODO [#4155]: unrendering should account for stylesheet content collisions
    signal.addEventListener('abort', function () {
      target.removeChild(elm);
      stylesheetCache["delete"](content);
    });
  }
}
function getCacheData(content, useConstructableStylesheet) {
  var cacheData = stylesheetCache.get(content);
  if (isUndefined$1(cacheData)) {
    cacheData = {
      stylesheet: undefined,
      element: undefined,
      roots: undefined,
      global: false,
      usedElement: false
    };
    stylesheetCache.set(content, cacheData);
  }
  // Create <style> elements or CSSStyleSheets on-demand, as needed
  if (useConstructableStylesheet && isUndefined$1(cacheData.stylesheet)) {
    cacheData.stylesheet = createConstructableStylesheet(content);
  } else if (!useConstructableStylesheet && isUndefined$1(cacheData.element)) {
    cacheData.element = createFreshStyleElement(content);
  }
  return cacheData;
}
function insertGlobalStylesheet(content, signal) {
  // Force a <style> element for global stylesheets. See comment below.
  var cacheData = getCacheData(content, false);
  if (cacheData.global) {
    // already inserted
    return;
  }
  cacheData.global = true; // mark inserted
  // TODO [#2922]: use document.adoptedStyleSheets in supported browsers. Currently we can't, due to backwards compat.
  insertStyleElement(content, document.head, cacheData, signal);
}
function insertLocalStylesheet(content, target, signal) {
  var cacheData = getCacheData(content, supportsConstructableStylesheets);
  var roots = cacheData.roots;
  if (isUndefined$1(roots)) {
    roots = cacheData.roots = new WeakSet(); // lazily initialize (not needed for global styles)
  } else if (roots.has(target)) {
    // already inserted
    return;
  }
  roots.add(target); // mark inserted
  // Constructable stylesheets are only supported in certain browsers:
  // https://caniuse.com/mdn-api_document_adoptedstylesheets
  // The reason we use it is for perf: https://github.com/salesforce/lwc/pull/2460
  if (supportsConstructableStylesheets) {
    insertConstructableStylesheet(content, target, cacheData, signal);
  } else {
    // Fall back to <style> element
    insertStyleElement(content, target, cacheData, signal);
  }
}
/**
 * Injects a stylesheet into the global (document) level or inside a shadow root.
 * @param content CSS content to insert
 * @param target ShadowRoot to insert into, or undefined if global (document) level
 * @param signal AbortSignal for aborting the stylesheet render. Used in dev mode for HMR to unrender stylesheets.
 */
function insertStylesheet(content, target, signal) {
  if (isUndefined$1(target)) {
    // global
    insertGlobalStylesheet(content, signal);
  } else {
    // local
    insertLocalStylesheet(content, target, signal);
  }
}

/*
 * Copyright (c) 2023, Salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var cachedConstructors = new Map();
var nativeLifecycleElementsToUpgradedByLWC = new WeakMap();
var elementBeingUpgradedByLWC = false;
var BaseUpgradableConstructor;
var BaseHTMLElement;
function createBaseUpgradableConstructor() {
  // Creates a constructor that is intended to be used directly as a custom element, except that the upgradeCallback is
  // passed in to the constructor so LWC can reuse the same custom element constructor for multiple components.
  // Another benefit is that only LWC can create components that actually do anything – if you do
  // `customElements.define('x-foo')`, then you don't have access to the upgradeCallback, so it's a dummy custom element.
  // This class should be created once per tag name.
  // TODO [#2972]: this class should expose observedAttributes as necessary
  BaseUpgradableConstructor = /*#__PURE__*/function (_HTMLElement) {
    _inherits(TheBaseUpgradableConstructor, _HTMLElement);
    var _super4 = _createSuper(TheBaseUpgradableConstructor);
    function TheBaseUpgradableConstructor(upgradeCallback, useNativeLifecycle) {
      var _this2;
      _classCallCheck(this, TheBaseUpgradableConstructor);
      _this2 = _super4.call(this);
      if (useNativeLifecycle) {
        // When in native lifecycle mode, we need to keep track of instances that were created outside LWC
        // (i.e. not created by `lwc.createElement()`). If the element uses synthetic lifecycle, then we don't
        // need to track this.
        nativeLifecycleElementsToUpgradedByLWC.set(_assertThisInitialized(_this2), elementBeingUpgradedByLWC);
      }
      // If the element is not created using lwc.createElement(), e.g. `document.createElement('x-foo')`,
      // then elementBeingUpgradedByLWC will be false
      if (elementBeingUpgradedByLWC) {
        upgradeCallback(_assertThisInitialized(_this2));
      }
      // TODO [#2970]: LWC elements cannot be upgraded via new Ctor()
      // Do we want to support this? Throw an error? Currently for backwards compat it's a no-op.
      return _this2;
    }
    _createClass(TheBaseUpgradableConstructor, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        if (isTrue(nativeLifecycleElementsToUpgradedByLWC.get(this))) {
          connectRootElement(this);
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        if (isTrue(nativeLifecycleElementsToUpgradedByLWC.get(this))) {
          disconnectRootElement(this);
        }
      }
    }, {
      key: "formAssociatedCallback",
      value: function formAssociatedCallback(form) {
        if (isTrue(nativeLifecycleElementsToUpgradedByLWC.get(this))) {
          runFormAssociatedCallback(this, form);
        }
      }
    }, {
      key: "formDisabledCallback",
      value: function formDisabledCallback(disabled) {
        if (isTrue(nativeLifecycleElementsToUpgradedByLWC.get(this))) {
          runFormDisabledCallback(this, disabled);
        }
      }
    }, {
      key: "formResetCallback",
      value: function formResetCallback() {
        if (isTrue(nativeLifecycleElementsToUpgradedByLWC.get(this))) {
          runFormResetCallback(this);
        }
      }
    }, {
      key: "formStateRestoreCallback",
      value: function formStateRestoreCallback(state, reason) {
        if (isTrue(nativeLifecycleElementsToUpgradedByLWC.get(this))) {
          runFormStateRestoreCallback(this, state, reason);
        }
      }
      /*LWC compiler v6.6.3*/
    }]);
    return TheBaseUpgradableConstructor;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  BaseHTMLElement = HTMLElement; // cache to track if it changes
}
var createUpgradableConstructor = function createUpgradableConstructor(isFormAssociated) {
  if (HTMLElement !== BaseHTMLElement) {
    // If the global HTMLElement changes out from under our feet, then we need to create a new
    // BaseUpgradableConstructor from scratch (since it extends from HTMLElement). This can occur if
    // polyfills are in play, e.g. a polyfill for scoped custom element registries.
    // This workaround can potentially be removed when W-15361244 is resolved.
    createBaseUpgradableConstructor();
  }
  // Using a BaseUpgradableConstructor superclass here is a perf optimization to avoid
  // re-defining the same logic (connectedCallback, disconnectedCallback, etc.) over and over.
  var UpgradableConstructor = /*#__PURE__*/function (_BaseUpgradableConstr) {
    _inherits(UpgradableConstructor, _BaseUpgradableConstr);
    var _super5 = _createSuper(UpgradableConstructor);
    function UpgradableConstructor() {
      _classCallCheck(this, UpgradableConstructor);
      return _super5.apply(this, arguments);
    }
    return _createClass(UpgradableConstructor);
  }(BaseUpgradableConstructor);
  if (isFormAssociated) {
    // Perf optimization - the vast majority of components have formAssociated=false,
    // so we can skip the setter in those cases, since undefined works the same as false.
    UpgradableConstructor.formAssociated = isFormAssociated;
  }
  return UpgradableConstructor;
};
function getUpgradableConstructor(tagName, isFormAssociated) {
  var UpgradableConstructor = cachedConstructors.get(tagName);
  if (isUndefined$1(UpgradableConstructor)) {
    if (!isUndefined$1(customElements.get(tagName))) {
      throw new Error("Unexpected tag name \"".concat(tagName, "\". This name is a registered custom element, preventing LWC to upgrade the element."));
    }
    UpgradableConstructor = createUpgradableConstructor(isFormAssociated);
    customElements.define(tagName, UpgradableConstructor);
    cachedConstructors.set(tagName, UpgradableConstructor);
  }
  return UpgradableConstructor;
}
var createCustomElement = function createCustomElement(tagName, upgradeCallback, useNativeLifecycle, isFormAssociated) {
  var UpgradableConstructor = getUpgradableConstructor(tagName, isFormAssociated);
  if (Boolean(UpgradableConstructor.formAssociated) !== isFormAssociated) {
    throw new Error("<".concat(tagName, "> was already registered with formAssociated=").concat(UpgradableConstructor.formAssociated, ". It cannot be re-registered with formAssociated=").concat(isFormAssociated, ". Please rename your component to have a different name than <").concat(tagName, ">"));
  }
  elementBeingUpgradedByLWC = true;
  try {
    return new UpgradableConstructor(upgradeCallback, useNativeLifecycle);
  } finally {
    elementBeingUpgradedByLWC = false;
  }
};

/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * A factory function that produces a renderer.
 * Renderer encapsulates operations that are required to render an LWC component into the underlying
 * runtime environment. In the case of @lwc/enigne-dom, it is meant to be used in a DOM environment.
 * @param baseRenderer Either null or the base renderer imported from 'lwc'.
 * @returns The created renderer
 * @example
 * import { renderer, rendererFactory } from 'lwc';
 * const customRenderer = rendererFactory(renderer);
 */
function rendererFactory(baseRenderer) {
  // Type assertion because this is replaced by rollup with an object, not a string.
  // See `injectInlineRenderer` in /scripts/rollup/rollup.config.js
  var renderer = function (exports) {
    /**
     * Copyright (c) 2024 Salesforce, Inc.
     */
    /*
     * Copyright (c) 2018, salesforce.com, inc.
     * All rights reserved.
     * SPDX-License-Identifier: MIT
     * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
     */
    /**
     *
     * @param value
     * @param msg
     */
    function invariant(value, msg) {
      if (!value) {
        throw new Error("Invariant Violation: ".concat(msg));
      }
    }
    /**
     *
     * @param value
     * @param msg
     */
    function isTrue$1(value, msg) {
      if (!value) {
        throw new Error("Assert Violation: ".concat(msg));
      }
    }
    /**
     *
     * @param value
     * @param msg
     */
    function isFalse$1(value, msg) {
      if (value) {
        throw new Error("Assert Violation: ".concat(msg));
      }
    }
    /**
     *
     * @param msg
     */
    function fail(msg) {
      throw new Error(msg);
    }
    var assert = /*#__PURE__*/Object.freeze({
      __proto__: null,
      fail: fail,
      invariant: invariant,
      isFalse: isFalse$1,
      isTrue: isTrue$1
    });
    /**
     * Determines whether the argument is `undefined`.
     * @param obj Value to test
     * @returns `true` if the value is `undefined`.
     */
    function isUndefined(obj) {
      return obj === undefined;
    }
    /**
     * Determines whether the argument is `null`.
     * @param obj Value to test
     * @returns `true` if the value is `null`.
     */
    function isNull(obj) {
      return obj === null;
    }
    /** version: 6.6.3 */

    /*
     * Copyright (c) 2023, salesforce.com, inc.
     * All rights reserved.
     * SPDX-License-Identifier: MIT
     * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
     */
    var WireContextSubscriptionEvent = /*#__PURE__*/function (_CustomEvent) {
      _inherits(WireContextSubscriptionEvent, _CustomEvent);
      var _super6 = _createSuper(WireContextSubscriptionEvent);
      function WireContextSubscriptionEvent(adapterToken, _ref2) {
        var _this3;
        var setNewContext = _ref2.setNewContext,
          setDisconnectedCallback = _ref2.setDisconnectedCallback;
        _classCallCheck(this, WireContextSubscriptionEvent);
        _this3 = _super6.call(this, adapterToken, {
          bubbles: true,
          composed: true
        });
        _this3.setNewContext = setNewContext;
        _this3.setDisconnectedCallback = setDisconnectedCallback;
        return _this3;
      }
      /*LWC compiler v6.6.3*/
      return _createClass(WireContextSubscriptionEvent);
    }( /*#__PURE__*/_wrapNativeSuper(CustomEvent));
    function registerContextConsumer(elm, adapterContextToken, subscriptionPayload) {
      dispatchEvent(elm, new WireContextSubscriptionEvent(adapterContextToken, subscriptionPayload));
    }
    function registerContextProvider(elm, adapterContextToken, onContextSubscription) {
      addEventListener(elm, adapterContextToken, function (evt) {
        evt.stopImmediatePropagation();
        var setNewContext = evt.setNewContext,
          setDisconnectedCallback = evt.setDisconnectedCallback;
        onContextSubscription({
          setNewContext: setNewContext,
          setDisconnectedCallback: setDisconnectedCallback
        });
      });
    }

    /*
     * Copyright (c) 2018, salesforce.com, inc.
     * All rights reserved.
     * SPDX-License-Identifier: MIT
     * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
     */
    function cloneNode(node, deep) {
      return node.cloneNode(deep);
    }
    function createElement(tagName, namespace) {
      return isUndefined(namespace) ? document.createElement(tagName) : document.createElementNS(namespace, tagName);
    }
    function createText(content) {
      return document.createTextNode(content);
    }
    function createComment(content) {
      return document.createComment(content);
    }
    // Parse the fragment HTML string into DOM
    function createFragment(html) {
      var template = document.createElement('template');
      template.innerHTML = html;
      return template.content.firstChild;
    }
    function insert(node, parent, anchor) {
      parent.insertBefore(node, anchor);
    }
    function remove(node, parent) {
      parent.removeChild(node);
    }
    function nextSibling(node) {
      return node.nextSibling;
    }
    function previousSibling(node) {
      return node.previousSibling;
    }
    function getParentNode(node) {
      return node.parentNode;
    }
    function attachShadow(element, options) {
      // `shadowRoot` will be non-null in two cases:
      //   1. upon initial load with an SSR-generated DOM, while in Shadow render mode
      //   2. when a webapp author places <c-app> in their static HTML and mounts their
      //      root component with customElement.define('c-app', Ctor)
      if (!isNull(element.shadowRoot)) {
        return element.shadowRoot;
      }
      return element.attachShadow(options);
    }
    function setText(node, content) {
      node.nodeValue = content;
    }
    function getProperty(node, key) {
      return node[key];
    }
    function setProperty(node, key, value) {
      node[key] = value;
    }
    function getAttribute(element, name, namespace) {
      return isUndefined(namespace) ? element.getAttribute(name) : element.getAttributeNS(namespace, name);
    }
    function setAttribute(element, name, value, namespace) {
      return isUndefined(namespace) ? element.setAttribute(name, value) : element.setAttributeNS(namespace, name, value);
    }
    function removeAttribute(element, name, namespace) {
      if (isUndefined(namespace)) {
        element.removeAttribute(name);
      } else {
        element.removeAttributeNS(namespace, name);
      }
    }
    function addEventListener(target, type, callback, options) {
      target.addEventListener(type, callback, options);
    }
    function removeEventListener(target, type, callback, options) {
      target.removeEventListener(type, callback, options);
    }
    function dispatchEvent(target, event) {
      return target.dispatchEvent(event);
    }
    function getClassList(element) {
      return element.classList;
    }
    function setCSSStyleProperty(element, name, value, important) {
      // TODO [#0]: How to avoid this type casting? Shall we use a different type interface to
      // represent elements in the engine?
      element.style.setProperty(name, value, important ? 'important' : '');
    }
    function getBoundingClientRect(element) {
      return element.getBoundingClientRect();
    }
    function querySelector(element, selectors) {
      return element.querySelector(selectors);
    }
    function querySelectorAll(element, selectors) {
      return element.querySelectorAll(selectors);
    }
    function getElementsByTagName(element, tagNameOrWildCard) {
      return element.getElementsByTagName(tagNameOrWildCard);
    }
    function getElementsByClassName(element, names) {
      return element.getElementsByClassName(names);
    }
    function getChildren(element) {
      return element.children;
    }
    function getChildNodes(element) {
      return element.childNodes;
    }
    function getFirstChild(element) {
      return element.firstChild;
    }
    function getFirstElementChild(element) {
      return element.firstElementChild;
    }
    function getLastChild(element) {
      return element.lastChild;
    }
    function getLastElementChild(element) {
      return element.lastElementChild;
    }
    function isConnected(node) {
      return node.isConnected;
    }
    function assertInstanceOfHTMLElement(elm, msg) {
      assert.invariant(elm instanceof HTMLElement, msg);
    }
    function ownerDocument(element) {
      return element.ownerDocument;
    }
    function getTagName(elm) {
      return elm.tagName;
    }
    function attachInternals(elm) {
      return attachInternalsFunc.call(elm);
    }
    // Use the attachInternals method from HTMLElement.prototype because access to it is removed
    // in HTMLBridgeElement, ie: elm.attachInternals is undefined.
    // Additionally, cache the attachInternals method to protect against 3rd party monkey-patching.
    var attachInternalsFunc = typeof ElementInternals !== 'undefined' ? HTMLElement.prototype.attachInternals : function () {
      throw new Error('attachInternals API is not supported in this browser environment.');
    };
    exports.addEventListener = addEventListener;
    exports.assertInstanceOfHTMLElement = assertInstanceOfHTMLElement;
    exports.attachInternals = attachInternals;
    exports.attachShadow = attachShadow;
    exports.cloneNode = cloneNode;
    exports.createComment = createComment;
    exports.createElement = createElement;
    exports.createFragment = createFragment;
    exports.createText = createText;
    exports.dispatchEvent = dispatchEvent;
    exports.getAttribute = getAttribute;
    exports.getBoundingClientRect = getBoundingClientRect;
    exports.getChildNodes = getChildNodes;
    exports.getChildren = getChildren;
    exports.getClassList = getClassList;
    exports.getElementsByClassName = getElementsByClassName;
    exports.getElementsByTagName = getElementsByTagName;
    exports.getFirstChild = getFirstChild;
    exports.getFirstElementChild = getFirstElementChild;
    exports.getLastChild = getLastChild;
    exports.getLastElementChild = getLastElementChild;
    exports.getParentNode = getParentNode;
    exports.getProperty = getProperty;
    exports.getTagName = getTagName;
    exports.insert = insert;
    exports.isConnected = isConnected;
    exports.nextSibling = nextSibling;
    exports.ownerDocument = ownerDocument;
    exports.previousSibling = previousSibling;
    exports.querySelector = querySelector;
    exports.querySelectorAll = querySelectorAll;
    exports.registerContextConsumer = registerContextConsumer;
    exports.registerContextProvider = registerContextProvider;
    exports.remove = remove;
    exports.removeAttribute = removeAttribute;
    exports.removeEventListener = removeEventListener;
    exports.setAttribute = setAttribute;
    exports.setCSSStyleProperty = setCSSStyleProperty;
    exports.setProperty = setProperty;
    exports.setText = setText;
    return exports;
  }({});
  // Meant to inherit any properties passed via the base renderer as the argument to the factory.
  Object.setPrototypeOf(renderer, baseRenderer);
  return renderer;
}

/*
 * Copyright (c) 2023, Salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
/**
 * The base renderer that will be used by engine-core.
 * This will be used for DOM operations when lwc is running in a browser environment.
 */
var renderer = assign(
// The base renderer will invoke the factory with null and assign additional properties that are
// shared across renderers
rendererFactory(null),
// Properties that are either not required to be sandboxed or rely on a globally shared information
{
  // insertStyleSheet implementation shares a global cache of stylesheet data
  insertStylesheet: insertStylesheet,
  // relies on a shared global cache
  createCustomElement: createCustomElement,
  defineCustomElement: getUpgradableConstructor,
  isSyntheticShadowDefined: hasOwnProperty$1.call(Element.prototype, KEY__SHADOW_TOKEN)
});
function clearNode(node) {
  var childNodes = renderer.getChildNodes(node);
  for (var _i38 = childNodes.length - 1; _i38 >= 0; _i38--) {
    renderer.remove(childNodes[_i38], node);
  }
}
/**
 * The real `buildCustomElementConstructor`. Should not be accessible to external users!
 * @internal
 * @param Ctor LWC constructor to build
 * @returns A Web Component class
 * @see {@linkcode deprecatedBuildCustomElementConstructor}
 */
function buildCustomElementConstructor(Ctor) {
  var _a;
  var HtmlPrototype = getComponentHtmlPrototype(Ctor);
  var observedAttributes = HtmlPrototype.observedAttributes;
  var _attributeChangedCallback = HtmlPrototype.prototype.attributeChangedCallback;
  return _a = /*#__PURE__*/function (_HTMLElement2) {
    _inherits(_a, _HTMLElement2);
    var _super7 = _createSuper(_a);
    function _a() {
      var _this4;
      _classCallCheck(this, _a);
      _this4 = _super7.call(this);
      if (!isNull(_this4.shadowRoot)) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("Found an existing shadow root for the custom element \"".concat(Ctor.name, "\". Call `hydrateComponent` instead."));
        }
        clearNode(_this4.shadowRoot);
      }
      // Compute renderMode/shadowMode in advance. This must be done before `createVM` because `createVM` may
      // mutate the element.
      var _computeShadowAndRend = computeShadowAndRenderMode(Ctor, renderer),
        shadowMode = _computeShadowAndRend.shadowMode,
        renderMode = _computeShadowAndRend.renderMode;
      // Native shadow components are allowed to have pre-existing `childNodes` before upgrade. This supports
      // use cases where a custom element has declaratively-defined slotted content, e.g.:
      // https://github.com/salesforce/lwc/issues/3639
      var isNativeShadow = renderMode === 1 /* RenderMode.Shadow */ && shadowMode === 0 /* ShadowMode.Native */;
      if (!isNativeShadow && _this4.childNodes.length > 0) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("Light DOM and synthetic shadow custom elements cannot have child nodes. " + "Ensure the element is empty, including whitespace.");
        }
        clearNode(_assertThisInitialized(_this4));
      }
      createVM(_assertThisInitialized(_this4), Ctor, renderer, {
        mode: 'open',
        owner: null,
        tagName: _this4.tagName
      });
      return _this4;
    }
    _createClass(_a, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        connectRootElement(this);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        disconnectRootElement(this);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        _attributeChangedCallback.call(this, name, oldValue, newValue);
      }
    }, {
      key: "formAssociatedCallback",
      value: function formAssociatedCallback(form) {
        runFormAssociatedCallback(this, form);
      }
    }, {
      key: "formDisabledCallback",
      value: function formDisabledCallback(disabled) {
        runFormDisabledCallback(this, disabled);
      }
    }, {
      key: "formResetCallback",
      value: function formResetCallback() {
        runFormResetCallback(this);
      }
    }, {
      key: "formStateRestoreCallback",
      value: function formStateRestoreCallback(state, reason) {
        runFormStateRestoreCallback(this, state, reason);
      }
      /*LWC compiler v6.6.3*/
    }]);
    return _a;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)), _a.observedAttributes = observedAttributes,
  // Note CustomElementConstructor is not upgraded by LWC and inherits directly from HTMLElement which means it calls the native
  // attachInternals API.
  _a.formAssociated = Boolean(Ctor.formAssociated), _a;
}

/*
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
var ComponentConstructorToCustomElementConstructorMap = new Map();
function getCustomElementConstructor(Ctor) {
  if (Ctor === LightningElement) {
    throw new TypeError("Invalid Constructor. LightningElement base class can't be claimed as a custom element.");
  }
  var ce = ComponentConstructorToCustomElementConstructorMap.get(Ctor);
  if (isUndefined$1(ce)) {
    ce = buildCustomElementConstructor(Ctor);
    ComponentConstructorToCustomElementConstructorMap.set(Ctor, ce);
  }
  return ce;
}
/**
 * This static getter builds a Web Component class from a LWC constructor so it can be registered
 * as a new element via customElements.define() at any given time.
 * @example
 * import Foo from 'ns/foo';
 * customElements.define('x-foo', Foo.CustomElementConstructor);
 * const elm = document.createElement('x-foo');
 */
defineProperty(LightningElement, 'CustomElementConstructor', {
  get: function get() {
    return getCustomElementConstructor(this);
  }
});
freeze(LightningElement);
seal(LightningElement.prototype);
/** version: 6.6.3 */

function stylesheet$g(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return "[part=\"container\"]" + shadowSelector + " {border-radius: 100%;background: linear-gradient(\n 145deg,\n var(--lume-g-color-indigo-30) 14.1%,\n var(--lume-g-color-indigo-50) 85.9%\n );}[part=\"initials\"]" + shadowSelector + " {font-weight: var(--lume-g-font-weight-semibold);color: var(--lume-g-color-text-inverse);}[part=\"icon\"]" + shadowSelector + " {--lume-c-icon-color-foreground: var(--lume-g-color-icon-inverse);}" + (useActualHostSelector ? ":host([size=\"xx-small\"]) [part=\"container\"]" : hostSelector + "[size=\"xx-small\"] [part=\"container\"]") + shadowSelector + " {width: 0.75rem;height: 0.75rem;}" + (useActualHostSelector ? ":host([size=\"x-small\"]) [part=\"container\"]" : hostSelector + "[size=\"x-small\"] [part=\"container\"]") + shadowSelector + " {width: 1rem;height: 1rem;}" + (useActualHostSelector ? ":host([size=\"small\"]) [part=\"container\"]" : hostSelector + "[size=\"small\"] [part=\"container\"]") + shadowSelector + " {width: 1.25rem;height: 1.25rem;}" + (useActualHostSelector ? ":host([size=\"medium\"]) [part=\"container\"]" : hostSelector + "[size=\"medium\"] [part=\"container\"]") + shadowSelector + " {width: 1.5rem;height: 1.5rem;}" + (useActualHostSelector ? ":host([size=\"medium\"]) [part=\"initials\"]" : hostSelector + "[size=\"medium\"] [part=\"initials\"]") + shadowSelector + " {font-size: var(--lume-g-font-scale-neg-2);}" + (useActualHostSelector ? ":host([size=\"large\"]) [part=\"container\"]" : hostSelector + "[size=\"large\"] [part=\"container\"]") + shadowSelector + " {width: 2rem;height: 2rem;}" + (useActualHostSelector ? ":host([size=\"large\"]) [part=\"initials\"]" : hostSelector + "[size=\"large\"] [part=\"initials\"]") + shadowSelector + " {font-size: var(--lume-g-font-scale-neg-2);}" + (useActualHostSelector ? ":host([size=\"x-large\"]) [part=\"container\"]" : hostSelector + "[size=\"x-large\"] [part=\"container\"]") + shadowSelector + " {width: 3rem;height: 3rem;}" + (useActualHostSelector ? ":host([size=\"x-large\"]) [part=\"initials\"]" : hostSelector + "[size=\"x-large\"] [part=\"initials\"]") + shadowSelector + " {font-size: var(--lume-g-font-size-base);}" + (useActualHostSelector ? ":host([size=\"xx-large\"]) [part=\"container\"]" : hostSelector + "[size=\"xx-large\"] [part=\"container\"]") + shadowSelector + " {width: 7.5rem;height: 7.5rem;}" + (useActualHostSelector ? ":host([size=\"xx-large\"]) [part=\"initials\"]" : hostSelector + "[size=\"xx-large\"] [part=\"initials\"]") + shadowSelector + " {font-size: var(--lume-g-font-scale-6);}" + (useActualHostSelector ? ":host([variant=\"brand\"]) [part=\"spinner\"]" : hostSelector + "[variant=\"brand\"] [part=\"spinner\"]") + shadowSelector + " {border-color: var(--lume-g-color-indigo-80);border-top-color: var(--lume-g-color-indigo-50);}" + (useActualHostSelector ? ":host([variant=\"neutral\"]) [part=\"spinner\"]" : hostSelector + "[variant=\"neutral\"] [part=\"spinner\"]") + shadowSelector + " {border-color: var(--lume-g-color-neutral-80);border-top-color: var(--lume-g-color-neutral-20);}" + (useActualHostSelector ? ":host([variant=\"inverse\"]) [part=\"spinner\"]" : hostSelector + "[variant=\"inverse\"] [part=\"spinner\"]") + shadowSelector + " {border-color: var(--lume-g-color-indigo-60);border-top-color: var(--lume-g-color-neutral-100);}" + (useActualHostSelector ? ":host([variant=\"inverse\"]) [part=\"label\"]" : hostSelector + "[variant=\"inverse\"] [part=\"label\"]") + shadowSelector + " {color: var(--lume-g-color-text-inverse);}[part=\"container\"]" + shadowSelector + " {display: flex;align-items: center;justify-content: center;}" + (useActualHostSelector ? ":host([label-position=\"inline-end\"]) [part=\"container\"]" : hostSelector + "[label-position=\"inline-end\"] [part=\"container\"]") + shadowSelector + " {flex-direction: row;}" + (useActualHostSelector ? ":host([label-position=\"inline-end\"]) [part=\"label\"]" : hostSelector + "[label-position=\"inline-end\"] [part=\"label\"]") + shadowSelector + " {margin-inline-start: var(--lume-g-spacing-4);}" + (useActualHostSelector ? ":host([label-position=\"inline-start\"]) [part=\"container\"]" : hostSelector + "[label-position=\"inline-start\"] [part=\"container\"]") + shadowSelector + " {flex-direction: row-reverse;}" + (useActualHostSelector ? ":host([label-position=\"inline-start\"]) [part=\"label\"]" : hostSelector + "[label-position=\"inline-start\"] [part=\"label\"]") + shadowSelector + " {margin-inline-end: var(--lume-g-spacing-4);}" + (useActualHostSelector ? ":host([label-position=\"block-end\"]) [part=\"container\"]" : hostSelector + "[label-position=\"block-end\"] [part=\"container\"]") + shadowSelector + " {flex-direction: column;}" + (useActualHostSelector ? ":host([label-position=\"block-end\"]) [part=\"label\"]" : hostSelector + "[label-position=\"block-end\"] [part=\"label\"]") + shadowSelector + " {margin-block-start: var(--lume-g-spacing-4);}" + (useActualHostSelector ? ":host([label-position=\"block-start\"]) [part=\"container\"]" : hostSelector + "[label-position=\"block-start\"] [part=\"container\"]") + shadowSelector + " {flex-direction: column-reverse;}" + (useActualHostSelector ? ":host([label-position=\"block-start\"]) [part=\"label\"]" : hostSelector + "[label-position=\"block-start\"] [part=\"label\"]") + shadowSelector + " {margin-block-end: var(--lume-g-spacing-4);}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$c = [stylesheet$g];
var $fragment1$3 = parseFragment(_templateObject || (_templateObject = _taggedTemplateLiteral(["<span part=\"initials\"", ">", "</span>"])), 3, "t1");
var stc0$a = {
  attrs: {
    "part": "container"
  },
  key: 0
};
function tmpl$c($api, $cmp, $slotset, $ctx) {
  var api_dynamic_text = $api.d,
    api_static_part = $api.sp,
    api_static_fragment = $api.st,
    api_fragment = $api.fr,
    api_element = $api.h;
  return [api_element("div", stc0$a, [$cmp.showInitials ? api_fragment(1, [api_static_fragment($fragment1$3, 3, [api_static_part(1, null, api_dynamic_text($cmp.initials))])], 0) : api_fragment(1, [api_element("lume-icon", {
    attrs: {
      "part": "icon",
      "symbol": "user",
      "set": "utility",
      "size": $cmp.iconSize
    },
    key: 4,
    external: true
  })], 0)])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$c = registerTemplate(tmpl$c);
tmpl$c.stylesheets = [];
if (_implicitStylesheets$c) {
  tmpl$c.stylesheets.push.apply(tmpl$c.stylesheets, _implicitStylesheets$c);
}
tmpl$c.stylesheetToken = "lwc-3smd4ecsuig";
tmpl$c.legacyStylesheetToken = "lume-avatar_avatar";
freezeTemplate(tmpl$c);
var reflectAttribute = function reflectAttribute(element, attrName, value) {
  if (!element) {
    return;
  }
  if (typeof value === 'string') {
    element.setAttribute(attrName, value);
  } else if (value === true) {
    element.setAttribute(attrName, '');
  } else if (!value) {
    element.removeAttribute(attrName);
  } else {
    console.warn("Invalid attribute value for \"".concat(attrName, "\": ").concat(value));
  }
};
var normalizeBoolean = function normalizeBoolean(value) {
  return typeof value === 'string' || !!value;
};
function normalizeInput(value) {
  if (typeof value === 'number' || typeof value === 'string') {
    return String(value);
  }
  return '';
}

/**
 * A string normalization utility for attributes.
 *
 * @param {string} value - The value to normalize.
 * @param {object} config - The optional configuration object.
 * @param {string} [config.fallbackValue] - The optional fallback value to use if the given value is not provided or invalid. Defaults to an empty string.
 * @param {array} [config.validValues] - An optional array of valid values. Assumes all input is valid if not provided.
 * @return {string} - The normalized value.
 */
function normalizeString(value) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _config$fallbackValue = config.fallbackValue,
    fallbackValue = _config$fallbackValue === void 0 ? '' : _config$fallbackValue,
    validValues = config.validValues,
    _config$toLowerCase = config.toLowerCase,
    toLowerCase = _config$toLowerCase === void 0 ? true : _config$toLowerCase;
  var normalized = typeof value === 'string' && value.trim() || '';
  normalized = toLowerCase ? normalized.toLowerCase() : normalized;
  if (validValues && validValues.indexOf(normalized) === -1) {
    normalized = fallbackValue;
  }
  return normalized;
}
function stylesheet$f(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return (useActualHostSelector ? ":host {" : hostSelector + " {") + "display: inline-flex;}[part~='boundary']" + shadowSelector + " {padding-block-start: var(\n --sds-c-icon-spacing-blockstart,\n var(--sds-c-icon-spacing-block, var(--sds-c-icon-spacing, var(--sds-s-icon-spacing)))\n );padding-block-end: var(\n --sds-c-icon-spacing-blockend,\n var(--sds-c-icon-spacing-block, var(--sds-c-icon-spacing, var(--sds-s-icon-spacing)))\n );padding-inline-start: var(\n --sds-c-icon-spacing-inlinestart,\n var(--sds-c-icon-spacing-inline, var(--sds-c-icon-spacing, var(--sds-s-icon-spacing)))\n );padding-inline-end: var(\n --sds-c-icon-spacing-inlineend,\n var(--sds-c-icon-spacing-inline, var(--sds-c-icon-spacing, var(--sds-s-icon-spacing)))\n );border-radius: var(--sds-c-icon-radius-border, var(--sds-s-icon-radius-border));border-width: var(--sds-c-icon-sizing-border, var(--sds-s-icon-sizing-border));border-style: solid;border-color: var(--sds-c-icon-color-border, var(--sds-s-icon-color-border, transparent));background-color: var(--sds-c-icon-color-background, var(--sds-s-icon-color-background));}[part~='icon']" + shadowSelector + " {display: flex;height: var(--sds-c-icon-sizing-height, var(--sds-c-icon-sizing, var(--sds-s-icon-sizing)));width: var(--sds-c-icon-sizing-width, var(--sds-c-icon-sizing, var(--sds-s-icon-sizing)));color: var(--sds-c-icon-color-foreground, var(--sds-s-icon-color-foreground));}svg" + shadowSelector + " {width: 100%;height: 100%;}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$b = [stylesheet$f];
var stc0$9 = [];
function tmpl$b($api, $cmp, $slotset, $ctx) {
  var api_bind = $api.b,
    api_slot = $api.s,
    api_element = $api.h;
  var _m0 = $ctx._m0;
  return [api_element("div", {
    attrs: {
      "part": "boundary",
      "symbol": $cmp.symbol,
      "set": $cmp.set
    },
    key: 0
  }, [api_element("div", {
    attrs: {
      "part": "icon",
      "aria-label": $cmp.ariaLabel,
      "role": $cmp.role
    },
    key: 1
  }, [api_slot("", {
    key: 2,
    on: {
      "slotchange": _m0 || ($ctx._m0 = api_bind($cmp.handleSlotChange))
    }
  }, stc0$9, $slotset)])])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$b = registerTemplate(tmpl$b);
tmpl$b.slots = [""];
tmpl$b.stylesheets = [];
if (_implicitStylesheets$b) {
  tmpl$b.stylesheets.push.apply(tmpl$b.stylesheets, _implicitStylesheets$b);
}
tmpl$b.stylesheetToken = "lwc-7c8sas3um45";
tmpl$b.legacyStylesheetToken = "sds-icon_icon";
freezeTemplate(tmpl$b);
function stylesheet$e(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return (useActualHostSelector ? ":host {" : hostSelector + " {") + "--lume-c-icon-sizing-border: 0px;}" + (useActualHostSelector ? ":host([variant~=\"grayscale\"]) {" : hostSelector + "[variant~=\"grayscale\"] {") + "--lume-c-icon-color-foreground-1: var(--lume-g-color-neutral-20);--lume-c-icon-color-foreground-2: var(--lume-g-color-neutral-40);--lume-c-icon-color-foreground-3: var(--lume-g-color-neutral-60);}" + (useActualHostSelector ? ":host([variant~=\"color\"]) {" : hostSelector + "[variant~=\"color\"] {") + "--lume-c-icon-color-foreground-1: var(--lume-g-color-blue-20);--lume-c-icon-color-foreground-2: var(--lume-g-color-blue-40);--lume-c-icon-color-foreground-3: var(--lume-g-color-blue-60);}[part~=\"icon\"]" + shadowSelector + " {fill: currentColor;}" + (useActualHostSelector ? ":host([size~=\"x-small\"]) {" : hostSelector + "[size~=\"x-small\"] {") + "--lume-c-icon-sizing: 0.75rem;}" + (useActualHostSelector ? ":host([size~=\"small\"]) {" : hostSelector + "[size~=\"small\"] {") + "--lume-c-icon-sizing: 1rem;}" + (useActualHostSelector ? ":host([size~=\"medium\"]) {" : hostSelector + "[size~=\"medium\"] {") + "--lume-c-icon-sizing: 1.25rem;}" + (useActualHostSelector ? ":host([size~=\"large\"]) {" : hostSelector + "[size~=\"large\"] {") + "--lume-c-icon-sizing: 1.5rem;}" + (useActualHostSelector ? ":host([size~=\"x-large\"]) {" : hostSelector + "[size~=\"x-large\"] {") + "--lume-c-icon-sizing: 2rem;}" + (useActualHostSelector ? ":host([size~=\"xx-large\"]) {" : hostSelector + "[size~=\"xx-large\"] {") + "--lume-c-icon-sizing: 3rem;}";
  /*LWC compiler v6.6.3*/
}
var styles$1 = [stylesheet$e];
function stylesheet$d(token, useActualHostSelector, useNativeDirPseudoclass) {
  var hostSelector = token ? "[" + token + "-host]" : "";
  return (useActualHostSelector ? ":host {" : hostSelector + " {") + "--sds-c-icon-color-background: var(--lume-c-icon-color-background);--sds-c-icon-color-border: var(--lume-c-icon-color-border);--sds-c-icon-color-foreground: var(--lume-c-icon-color-foreground);--sds-c-icon-radius-border: var(--lume-c-icon-radius-border);--sds-c-icon-sizing: var(--lume-c-icon-sizing);--sds-c-icon-sizing-border: var(--lume-c-icon-sizing-border);--sds-c-icon-sizing-height: var(--lume-c-icon-sizing-height);--sds-c-icon-sizing-width: var(--lume-c-icon-sizing-width);--sds-c-icon-spacing: var(--lume-c-icon-spacing);--sds-c-icon-spacing-block: var(--lume-c-icon-spacing-block);--sds-c-icon-spacing-blockend: var(--lume-c-icon-spacing-block-end);--sds-c-icon-spacing-blockstart: var(--lume-c-icon-spacing-block-start);--sds-c-icon-spacing-inline: var(--lume-c-icon-spacing-inline);--sds-c-icon-spacing-inlineend: var(--lume-c-icon-spacing-inline-end);--sds-c-icon-spacing-inlinestart: var(--lume-c-icon-spacing-inline-start);}";
  /*LWC compiler v6.6.3*/
}
var mappings$1 = [stylesheet$d];
var sdsIconParser = new DOMParser();
var sdsIconRequests = new Map();
var Icon$1 = /*#__PURE__*/function (_LightningElement) {
  _inherits(Icon, _LightningElement);
  var _super8 = _createSuper(Icon);
  function Icon() {
    var _this5;
    _classCallCheck(this, Icon);
    for (var _len4 = arguments.length, args = new Array(_len4), _key2 = 0; _key2 < _len4; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this5 = _super8.call.apply(_super8, [this].concat(args));
    _this5._symbol = void 0;
    _this5._set = void 0;
    _this5._ariaLabel = void 0;
    _this5._prefetch = void 0;
    _this5._generatedIcon = false;
    _this5._iconSets = void 0;
    return _this5;
  }
  /**
   * An array of icon sets to use when resolving the icon.
   *
   * @type {Array}
   */
  _createClass(Icon, [{
    key: "iconSets",
    get: function get() {
      return this._iconSets;
    },
    set: function set(value) {
      this._iconSets = value;
    }

    /**
     * The name of the icon to resolve.
     *
     * @type {string}
     */
  }, {
    key: "symbol",
    get: function get() {
      return this._symbol;
    },
    set: function set(value) {
      this._symbol = value;
      reflectAttribute(this, 'symbol', this._symbol);
    }

    /**
     * The name of the icon set to use when resolving the icon.
     *
     * @type {string}
     */
  }, {
    key: "set",
    get: function get() {
      return this._set;
    },
    set: function set(value) {
      this._set = value;
      reflectAttribute(this, 'set', this._set);
    }

    /**
     * Which icons to prefetch from the set.
     *
     * @type {string}
     */
  }, {
    key: "prefetch",
    get: function get() {
      return this._prefetch;
    },
    set: function set(value) {
      this._prefetch = value;
    }

    /**
     * Defines a string value that labels an interactive element.
     *
     * @type {string}
     */
  }, {
    key: "ariaLabel",
    get: function get() {
      return this._ariaLabel;
    },
    set: function set(value) {
      this._ariaLabel = value;
      this.role = 'img';
    }

    /**
     * Provides semantic meaning to content, allowing screen readers and other
     * tools to present and support interaction with object in a way that is
     * consistent with user expectations of that type of object.
     *
     * @type {string}
     */
  }, {
    key: "role",
    get: function get() {
      return this._role;
    },
    set: function set(value) {
      this._role = value;
      reflectAttribute(this, 'role', this._role);
    }

    /**
     * Register new icon sets programmatically
     *
     * @param {array} set
     */
  }, {
    key: "registerIconSet",
    value: function registerIconSet(set) {
      var _this6 = this;
      set.forEach(function (set) {
        _this6._iconSets.push({
          name: set.name,
          resolver: set.resolver,
          mutator: set.mutator
        });
      });
    }

    /**
     * Unregister a custom icon set
     *
     * @param {string} name
     */
  }, {
    key: "unregisterIconSet",
    value: function unregisterIconSet(name) {
      this._iconSets = this._iconSets.filter(function (lib) {
        return lib.name !== name;
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // Dispatch custom event for parent
      // Used to imperatively set an iconSet
      this.dispatchEvent(new CustomEvent('iconregister', {
        bubbles: true,
        cancelable: true,
        detail: {
          name: 'sds-icon'
        }
      }));
    }

    /**
     * Retrieve an icon set
     *
     * @param {string} name
     */
  }, {
    key: "getIconSet",
    value: function getIconSet(name) {
      return this._iconSets && this._iconSets.filter(function (set) {
        return set.name === name;
      })[0];
    }

    /**
     * Return the resolver (url) for an icon set
     *
     * @param {string} set
     * @param {string} symbol
     */
  }, {
    key: "getIconUrl",
    value: function getIconUrl(set, symbol) {
      if (set && symbol) {
        return set.resolver(symbol);
      }
    }

    /**
     * Return the parameters of a symbol in an object for easier reference
     *
     * @param {string} symbol
     */
  }, {
    key: "getSymbolParams",
    value: function getSymbolParams(symbol) {
      var set = this.getIconSet(this._set);
      var url = this.getIconUrl(set, symbol);
      return {
        set: set,
        url: url
      };
    }

    /**
     * Check if the icon set and symbol are set.
     *
     * @returns {boolean}
     */
  }, {
    key: "hasIconsConfigured",
    value: function hasIconsConfigured() {
      return Boolean(this._set && this._symbol);
    }

    /**
     * Validates if the provided URL is an SVG file.
     *
     * @param {string} url
     * @returns {boolean}
     */
  }, {
    key: "isValidSvgUrl",
    value: function isValidSvgUrl(url) {
      var svgUrlPattern = /\.svg$/i;
      return svgUrlPattern.test(url);
    }

    /**
     * Validates if the provided content type is an SVG.
     *
     * @param {string} contentType
     * @returns {boolean}
     */
  }, {
    key: "isValidContentType",
    value: function isValidContentType(contentType) {
      return contentType && contentType.includes('image/svg+xml');
    }

    /**
     * Fetch SVG asset from url, run optional mutations, and return it.
     *
     * @param {string} url
     */
  }, {
    key: "fetchIcon",
    value: (function () {
      var _fetchIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url) {
        var _this7 = this;
        var result, requestPromise, request;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.isValidSvgUrl(url)) {
                _context2.next = 3;
                break;
              }
              console.error("Invalid URL: ".concat(url, ". Only SVG files are allowed."));
              return _context2.abrupt("return");
            case 3:
              if (!sdsIconRequests.has(url)) {
                _context2.next = 8;
                break;
              }
              _context2.next = 6;
              return sdsIconRequests.get(url);
            case 6:
              result = _context2.sent;
              return _context2.abrupt("return", result);
            case 8:
              // If there's no ongoing request, create a new Promise for the fetch request
              requestPromise = fetch(url).then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
                  var div, svg, _result;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!response.ok) {
                          _context.next = 15;
                          break;
                        }
                        if (_this7.isValidContentType(response.headers.get('content-type'))) {
                          _context.next = 5;
                          break;
                        }
                        console.error("Invalid content type: ".concat(contentType, ". Only SVG files are allowed."));
                        sdsIconRequests["delete"](url);
                        return _context.abrupt("return");
                      case 5:
                        div = document.createElement('div');
                        _context.next = 8;
                        return response.text();
                      case 8:
                        div.innerHTML = _context.sent;
                        svg = div.firstElementChild;
                        _result = {
                          url: url,
                          svg: svg && svg.tagName.toLowerCase() === 'svg' ? svg.outerHTML : ''
                        };
                        sdsIconRequests["delete"](url);
                        return _context.abrupt("return", _result);
                      case 15:
                        sdsIconRequests["delete"](url);
                        throw Error();
                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()); // Store the Promise in the sdsIconRequests cache
              sdsIconRequests.set(url, requestPromise);

              // Wait for the Promise to resolve and return the icon
              _context2.next = 12;
              return requestPromise;
            case 12:
              request = _context2.sent;
              return _context2.abrupt("return", request);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchIcon(_x2) {
        return _fetchIcon.apply(this, arguments);
      }
      return fetchIcon;
    }()
    /**
     * Prefetch icons before they are drawn
     *
     * @param {string} icons
     */
    )
  }, {
    key: "prefetchIcons",
    value: (function () {
      var _prefetchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(icons) {
        var _this8 = this;
        var iconsToFetch, fetchedIcons;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              iconsToFetch = icons.split(',').map(function (icon) {
                return icon.trim();
              });
              _context3.next = 3;
              return Promise.all(iconsToFetch.map(function (symbol) {
                var _this8$getSymbolParam = _this8.getSymbolParams(symbol),
                  url = _this8$getSymbolParam.url;
                return _this8.fetchIcon(url)["catch"](function () {
                  console.error("Unable to prefetch the symbol \"".concat(symbol, "\". Double check your symbol exists and use comma separated values."));
                });
              }));
            case 3:
              fetchedIcons = _context3.sent;
              return _context3.abrupt("return", fetchedIcons);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function prefetchIcons(_x4) {
        return _prefetchIcons.apply(this, arguments);
      }
      return prefetchIcons;
    }()
    /**
     * Create the icon (entry point)
     */
    )
  }, {
    key: "createIcon",
    value: (function () {
      var _createIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$getSymbolParams, set, url, slotContainer, svg, doc, svgEl;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this$getSymbolParams = this.getSymbolParams(this._symbol), set = _this$getSymbolParams.set, url = _this$getSymbolParams.url;
              if (!(url && set)) {
                _context4.next = 20;
                break;
              }
              slotContainer = !this._generatedIcon ? this.template.querySelector("[part~='icon']") : this.template.querySelector('svg');
              _context4.prev = 3;
              _context4.next = 6;
              return this.fetchIcon(url);
            case 6:
              svg = _context4.sent;
              doc = sdsIconParser.parseFromString(svg.svg, 'text/html');
              svgEl = doc.body.querySelector('svg'); // Run any optional mutations
              if (set && set.mutator) {
                svgEl = set.mutator(svgEl);
              }
              svgEl.setAttribute('aria-hidden', 'true');

              // Add the SVG as the fallback content of the slot
              !this._generatedIcon ? slotContainer.appendChild(svgEl) : slotContainer.replaceWith(svgEl);
              this._generatedIcon = true;
              _context4.next = 18;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](3);
              console.error("Error creating icon using ".concat(url));
            case 18:
              _context4.next = 21;
              break;
            case 20:
              console.error("Unable to create an icon using set ".concat(this._set, " and URL ").concat(url, ". Double check your registered set names and paths."));
            case 21:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 15]]);
      }));
      function createIcon() {
        return _createIcon.apply(this, arguments);
      }
      return createIcon;
    }()
    /**
     * Check if the slot has slotted content
     *
     * @returns {boolean}
     */
    )
  }, {
    key: "hasSlottedChildren",
    value: function hasSlottedChildren() {
      var slot = this.template.querySelector('slot');
      return slot.assignedNodes({
        flatten: true
      }).length !== 0;
    }

    /**
     * Handle slotchange event
     */
  }, {
    key: "handleSlotChange",
    value: function handleSlotChange() {
      // Remove icon generated by API to make room for slotted content
      if (this._generatedIcon) {
        this.template.querySelector('svg').remove();
        this._generatedIcon = false;
      }

      // Recreate icon if slot is emptied and icons are configured
      if (!this.hasSlottedChildren() && !this._generatedIcon && this.hasIconsConfigured) {
        this.createIcon();
      }
    }

    /**
     * RenderedCallback LWC lifecycle
     */
  }, {
    key: "renderedCallback",
    value: function renderedCallback() {
      // Create icon if slot is empty and icons have been configured
      if (!this.hasSlottedChildren() && this.hasIconsConfigured()) {
        this.createIcon();
      }

      // Check if we need to prefetch icons
      this._prefetch && this.prefetchIcons(this._prefetch);
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Icon;
}(LightningElement);
Icon$1.shadowSupportMode = 'native';
registerDecorators(Icon$1, {
  publicProps: {
    iconSets: {
      config: 3
    },
    symbol: {
      config: 3
    },
    set: {
      config: 3
    },
    prefetch: {
      config: 3
    },
    ariaLabel: {
      config: 3
    },
    role: {
      config: 3
    }
  },
  publicMethods: ["registerIconSet", "unregisterIconSet"],
  fields: ["_symbol", "_set", "_ariaLabel", "_prefetch", "_generatedIcon", "_iconSets"]
});
var SdsIcon = registerComponent(Icon$1, {
  tmpl: _tmpl$b,
  sel: "sds-icon",
  apiVersion: 62
});
var Icon = /*#__PURE__*/function (_SdsIcon) {
  _inherits(Icon, _SdsIcon);
  var _super9 = _createSuper(Icon);
  function Icon() {
    var _this9;
    _classCallCheck(this, Icon);
    _this9 = _super9.call(this);
    /**
     * Available Icon sizes.
     */
    _this9.sizes = ["x-small", "small", "medium", "large", "x-large", "xx-large"];
    /**
     * Available Icon variants.
     * Currently only apply to icons in the product set.
     */
    _this9.variants = ["color", "grayscale"];
    /**
     * Default button properties.
     */
    _this9.defaultProps = {
      size: "medium",
      variant: "color"
    };
    _this9._iconSets = [{
      name: "classic",
      resolver: function resolver(symbol) {
        return "/lume/lume-icons/latest/classic/".concat(symbol, ".svg");
      }
    }, {
      name: "product",
      resolver: function resolver(symbol) {
        return "/lume/lume-icons/latest/product/".concat(symbol, ".svg");
      }
    }, {
      name: "utility",
      resolver: function resolver(symbol) {
        return "/lume/lume-icons/latest/utility/".concat(symbol, ".svg");
      }
    }];
    return _this9;
  }

  /**
   * Defines the size of the Icon.
   *
   * @default "medium"
   */
  _createClass(Icon, [{
    key: "size",
    get: function get() {
      return this._size;
    },
    set: function set(size) {
      this._size = normalizeString(size, {
        fallbackValue: this.defaultProps.size,
        validValues: this.sizes
      });
      reflectAttribute(this, "size", this._size);
    }

    /**
     * Defines the variant for the Icon.
     * Currently only apply to icons in the product set.
     */
  }, {
    key: "variant",
    get: function get() {
      return this._variant;
    },
    set: function set(variant) {
      this._variant = normalizeString(variant, {
        fallbackValue: this.defaultProps.variant,
        validValues: this.variants
      });
      reflectAttribute(this, "variant", this._variant);
    }

    /**
     * Validates if the provided URL is an SVG file.
     * Temporary fix until this PR is merged:
     * https://github.com/salesforce-experience-platform-emu/salesforce-design-system/pull/117
     *
     * @param {string} url
     * @returns {boolean}
     */
  }, {
    key: "isValidSvgUrl",
    value: function isValidSvgUrl(url) {
      var svgUrlPattern = /\.svg$/i;
      return svgUrlPattern.test(url);
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Icon;
}(SdsIcon); // Inject Styles
Icon.stylesheets = [mappings$1, styles$1];
registerDecorators(Icon, {
  publicProps: {
    size: {
      config: 3
    },
    variant: {
      config: 3
    }
  },
  fields: ["sizes", "variants", "defaultProps"]
});
var LumeIcon = registerComponent(Icon, {
  tmpl: _tmpl$b,
  sel: "lume-icon",
  apiVersion: 62
});
var Avatar = /*#__PURE__*/function (_LightningElement2) {
  _inherits(Avatar, _LightningElement2);
  var _super10 = _createSuper(Avatar);
  function Avatar() {
    var _this10;
    _classCallCheck(this, Avatar);
    for (var _len5 = arguments.length, args = new Array(_len5), _key3 = 0; _key3 < _len5; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this10 = _super10.call.apply(_super10, [this].concat(args));
    /**
     * Available Avatar sizes.
     */
    _this10.sizes = ["xx-small", "x-small", "small", "medium", "large", "x-large", "xx-large"];
    /**
     * Default Avatar properties.
     */
    _this10.defaultProps = {
      size: "medium"
    };
    _this10.state = {
      icon: true
    };
    return _this10;
  }
  /**
   * LWC lifecycle callback called when the element is inserted into the DOM.
   * This hook flows from parent to child.
   * Can’t access child elements because they don’t exist yet.
   */
  _createClass(Avatar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.state.size) {
        this.size = this.defaultProps.size;
      }

      // Register LumeIcon if it's not on the document already.
      if (!customElements.get("lume-icon")) {
        customElements.define("lume-icon", LumeIcon.CustomElementConstructor);
      }
    }

    /**
     * Defines the size of the Avatar.
     *
     * @default "medium"
     */
  }, {
    key: "size",
    get: function get() {
      return this.state.size;
    },
    set: function set(size) {
      this.state.size = normalizeString(size, {
        fallbackValue: this.defaultProps.size,
        validValues: this.sizes
      });
      reflectAttribute(this, "size", this.state.size);
    }

    /**
     * Defines the Avatar's initials.
     *
     * @default null
     */
  }, {
    key: "initials",
    get: function get() {
      return this.state.initials;
    },
    set: function set(initials) {
      this.state.initials = normalizeString(initials, {
        fallbackValue: null
      });
      if (this.state.initials) {
        this.state.initials = this.state.initials.toUpperCase();
      }
      reflectAttribute(this, "initials", this.state.initials);
    }

    /**
     * Avatar icon size based on the component size.
     */
  }, {
    key: "iconSize",
    get: function get() {
      if (this.state.size === "xx-small" || this.state.size === "x-small") {
        return "x-small";
      }
      return this.state.size;
    }

    /**
     * Whether to display the initials or not.
     * The initials are not displayed for small sizes.
     */
  }, {
    key: "showInitials",
    get: function get() {
      if (!this.state.initials || this.state.size === "xx-small" || this.state.size === "x-small" || this.state.size === "small") {
        return false;
      }
      return true;
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Avatar;
}(LightningElement);
registerDecorators(Avatar, {
  publicProps: {
    size: {
      config: 3
    },
    initials: {
      config: 3
    }
  },
  track: {
    state: 1
  },
  fields: ["sizes", "defaultProps"]
});
var avatar = registerComponent(Avatar, {
  tmpl: _tmpl$c,
  sel: "lume-avatar",
  apiVersion: 62
});
function stylesheet$c(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  return "*" + shadowSelector + ",*" + shadowSelector + "::before,*" + shadowSelector + "::after {box-sizing: border-box;}[part~='button']" + shadowSelector + " {display: inline-flex;gap: var(--sds-c-button-spacing-gap, var(--sds-s-button-spacing-gap));background: var(--sds-c-button-color-background, var(--sds-s-button-color-background));color: var(--sds-c-button-text-color, var(--sds-s-button-color));font-weight: var(--sds-c-button-font-weight, var(--sds-s-button-font-weight));font-size: var(--sds-c-button-font-size, var(--sds-s-button-font-size, inherit));line-height: var(--sds-c-button-font-lineheight);height: var(--sds-c-button-sizing-height);width: var(--sds-c-button-sizing-width);padding-inline-start: var(\n --sds-c-button-spacing-inlinestart,\n var(\n --sds-c-button-spacing-inline,\n var(--sds-c-button-spacing, var(--sds-s-button-spacing-inline, var(--sds-s-button-spacing)))\n )\n );padding-inline-end: var(\n --sds-c-button-spacing-inlineend,\n var(\n --sds-c-button-spacing-inline,\n var(--sds-c-button-spacing, var(--sds-s-button-spacing-inline, var(--sds-s-button-spacing)))\n )\n );padding-block-start: var(\n --sds-c-button-spacing-blockstart,\n var(\n --sds-c-button-spacing-block,\n var(--sds-c-button-spacing, var(--sds-s-button-spacing-block, var(--sds-s-button-spacing)))\n )\n );padding-block-end: var(\n --sds-c-button-spacing-blockend,\n var(\n --sds-c-button-spacing-block,\n var(--sds-c-button-spacing, var(--sds-s-button-spacing-block, var(--sds-s-button-spacing)))\n )\n );border-width: var(--sds-c-button-sizing-border, var(--sds-s-button-sizing-border, 1px));border-style: solid;border-color: var(--sds-c-button-color-border, var(--sds-s-button-color-border, currentColor));border-start-start-radius: var(\n --sds-c-button-radius-border-startstart,\n var(\n --sds-c-button-radius-border,\n var(--sds-s-button-radius-border-startstart, var(--sds-s-button-radius-border))\n )\n );border-start-end-radius: var(\n --sds-c-button-radius-border-startend,\n var(\n --sds-c-button-radius-border,\n var(--sds-s-button-radius-border-startend, var(--sds-s-button-radius-border))\n )\n );border-end-start-radius: var(\n --sds-c-button-radius-border-endstart,\n var(\n --sds-c-button-radius-border,\n var(--sds-s-button-radius-border-endstart, var(--sds-s-button-radius-border))\n )\n );border-end-end-radius: var(\n --sds-c-button-radius-border-endend,\n var(\n --sds-c-button-radius-border,\n var(--sds-s-button-radius-border-endend, var(--sds-s-button-radius-border))\n )\n );box-shadow: var(--sds-c-button-shadow, var(--sds-s-button-shadow));text-decoration: var(--sds-c-button-font-decoration);white-space: normal;user-select: none;align-items: center;justify-content: center;appearance: none;}[part~='button']:hover" + shadowSelector + " {--sds-c-button-text-color: var(--sds-c-button-text-color-hover, var(--sds-s-button-color-hover, revert));--sds-c-button-color-background: var(\n --sds-c-button-color-background-hover,\n var(--sds-s-button-color-background-hover, revert)\n );--sds-c-button-color-border: var(\n --sds-c-button-color-border-hover,\n var(--sds-s-button-color-border-hover, revert)\n );--sds-c-button-shadow: var(--sds-c-button-shadow-hover, var(--sds-s-button-shadow-hover, revert));cursor: pointer;}[part~='button']:focus" + shadowSelector + " {--sds-c-button-color-background: var(\n --sds-c-button-color-background-focus,\n var(--sds-s-button-color-background-focus, revert)\n );--sds-c-button-color-border: var(\n --sds-c-button-color-border-focus,\n var(--sds-s-button-color-border-focus, revert)\n );--sds-c-button-text-color: var(--sds-c-button-text-color-focus, var(--sds-s-button-color-focus, revert));--sds-c-button-shadow: var(--sds-c-button-shadow-focus, var(--sds-s-button-shadow-focus, revert));outline: 0;}[part~='button']:active" + shadowSelector + " {--sds-c-button-text-color: var(--sds-c-button-text-color-active, var(--sds-s-button-color-active, revert));--sds-c-button-color-background: var(\n --sds-c-button-color-background-active,\n var(--sds-s-button-color-background-active, revert)\n );--sds-c-button-color-border: var(\n --sds-c-button-color-border-active,\n var(--sds-s-button-color-border-active, revert)\n );--sds-c-button-shadow: var(--sds-c-button-shadow-active, var(--sds-s-button-shadow-active, revert));}[part~='button']:disabled" + shadowSelector + " {--sds-c-button-text-color: var(--sds-c-button-text-color-disabled);--sds-c-button-color-background: var(--sds-c-button-color-background-disabled);--sds-c-button-color-border: var(--sds-c-button-color-border-disabled);--sds-c-button-shadow: var(--sds-c-button-shadow-disabled);pointer-events: none;}[part~='button']:disabled" + shadowSelector + " *" + shadowSelector + " {pointer-events: none;}[part='button'][aria-pressed='true']" + shadowSelector + " {--sds-c-button-color-background: var(--sds-c-button-color-background-pressed, revert);--sds-c-button-color-border: var(--sds-c-button-color-border-pressed, revert);--sds-c-button-text-color: var(--sds-c-button-text-color-pressed, revert);--sds-c-button-shadow: var(--sds-c-button-shadow-pressed, revert);}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$a = [stylesheet$c];
var stc0$8 = {
  attrs: {
    "name": "start"
  },
  key: 1
};
var stc1$8 = [];
var stc2$8 = {
  key: 2
};
var stc3$7 = {
  attrs: {
    "name": "end"
  },
  key: 3
};
function tmpl$a($api, $cmp, $slotset, $ctx) {
  var api_tab_index = $api.ti,
    api_bind = $api.b,
    api_slot = $api.s,
    api_element = $api.h;
  var _m0 = $ctx._m0,
    _m1 = $ctx._m1,
    _m2 = $ctx._m2;
  return [api_element("button", {
    attrs: {
      "part": "button",
      "disabled": $cmp.disabled ? "" : null,
      "name": $cmp.name,
      "role": $cmp.role,
      "tabindex": api_tab_index($cmp.tabIndex),
      "title": $cmp.title,
      "type": $cmp.type,
      "value": $cmp.value,
      "aria-haspopup": $cmp.ariaHasPopup,
      "aria-expanded": $cmp.ariaExpanded,
      "aria-pressed": $cmp.ariaPressed,
      "aria-current": $cmp.ariaCurrent,
      "aria-description": $cmp.ariaDescription,
      "aria-keyshortcuts": $cmp.ariaKeyShortcuts,
      "aria-roledescription": $cmp.ariaRoleDescription
    },
    key: 0,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClick)),
      "focus": _m1 || ($ctx._m1 = api_bind($cmp.handleFocus)),
      "blur": _m2 || ($ctx._m2 = api_bind($cmp.handleBlur))
    }
  }, [api_slot("start", stc0$8, stc1$8, $slotset), api_slot("", stc2$8, stc1$8, $slotset), api_slot("end", stc3$7, stc1$8, $slotset)])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$a = registerTemplate(tmpl$a);
tmpl$a.slots = ["", "end", "start"];
tmpl$a.stylesheets = [];
if (_implicitStylesheets$a) {
  tmpl$a.stylesheets.push.apply(tmpl$a.stylesheets, _implicitStylesheets$a);
}
tmpl$a.stylesheetToken = "lwc-1d93kuocg5i";
tmpl$a.legacyStylesheetToken = "sds-button_button";
freezeTemplate(tmpl$a);
function stylesheet$b(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return "@media (prefers-reduced-motion) {transition: none;}" + (useActualHostSelector ? ":host {" : hostSelector + " {") + "display: inline-block;--lume-c-button-color-background: transparent;--lume-c-button-sizing-border: var(--lume-g-sizing-border-1);--lume-c-button-color-border: transparent;--lume-c-button-radius-border: var(--lume-g-radius-border-pill);--lume-c-button-text-color: inherit;--lume-c-button-font-weight: var(--lume-g-font-weight-semibold);--lume-c-button-font-decoration: none;--lume-c-button-shadow-focus: var(--lume-g-shadow-focus-ring);--lume-c-button-color-background-disabled: var(--lume-g-color-neutral-90);--lume-c-button-color-border-disabled: var(--lume-g-color-neutral-90);--lume-c-button-text-color-disabled: var(--lume-g-color-neutral-65);}" + (useActualHostSelector ? ":host(:focus) {" : hostSelector + ":focus {") + "outline: 0;}" + (useActualHostSelector ? ":host([disabled]) {" : hostSelector + "[disabled] {") + "cursor: not-allowed;}[part~=\"button\"]" + shadowSelector + " > *" + shadowSelector + " {pointer-events: none;}[part~=\"button\"]" + shadowSelector + " {font-size: var(--lume-c-button-text-size, var(--lume-g-font-size-base));font-family: var(--lume-g-font-family);min-width: var(--lume-c-button-sizing-min-width);min-height: var(--lume-c-button-sizing-min-height);position: relative;user-select: none;white-space: nowrap;transition-duration: var(--lume-g-kinetics-transition-duration);transition-timing-function: var(--lume-g-kinetics-transition-timing-function);transition-property: box-shadow, background-color, border-color;}[part~=\"button\"]:focus" + shadowSelector + " {outline: var(--lume-g-outline-focus-ring);outline-offset: var(--lume-g-outline-offset-focus-ring);}[part~=\"button\"]:focus:active" + shadowSelector + " {box-shadow: var(--lume-c-button-shadow-pressed, none);}" + (useActualHostSelector ? ":host " : hostSelector + " ") + shadowSelector + "::slotted([slot~=\"start\"]) {padding-inline-end: 0.375rem;}" + (useActualHostSelector ? ":host " : hostSelector + " ") + shadowSelector + "::slotted([slot~=\"end\"]) {padding-inline-start: 0.375rem;}" + (useActualHostSelector ? ":host([size~=\"small\"]) {" : hostSelector + "[size~=\"small\"] {") + "--lume-c-button-sizing-min-width: 3.125rem;--lume-c-button-text-size: var(--lume-g-font-scale-neg-1);--lume-c-button-font-line-height: 1.625rem;--lume-c-button-spacing-inline: var(--lume-g-spacing-5);--lume-c-icon-sizing: 1rem;}" + (useActualHostSelector ? ":host([size~=\"medium\"]) {" : hostSelector + "[size~=\"medium\"] {") + "--lume-c-button-sizing-min-width: 3.75rem;--lume-c-button-text-size: var(--lume-g-font-size-base);--lume-c-button-font-line-height: 2.125rem;--lume-c-button-spacing-inline: var(--lume-g-spacing-6);--lume-c-icon-sizing: 1.25rem;}" + (useActualHostSelector ? ":host([size~=\"large\"]) {" : hostSelector + "[size~=\"large\"] {") + "--lume-c-button-sizing-min-width: 4.375rem;--lume-c-button-text-size: var(--lume-g-font-size-base);--lume-c-button-font-line-height: 2.625rem;--lume-c-button-spacing-inline: var(--lume-g-spacing-7);--lume-c-icon-sizing: 1.25rem;}" + (useActualHostSelector ? ":host([variant~=\"primary\"]) {" : hostSelector + "[variant~=\"primary\"] {") + "--lume-c-button-color-background: var(--lume-g-color-indigo-50);--lume-c-button-color-background-active: var(--lume-g-color-indigo-30);--lume-c-button-color-background-focus: var(--lume-g-color-indigo-50);--lume-c-button-color-background-hover: var(--lume-g-color-indigo-40);--lume-c-button-color-border: var(--lume-g-color-indigo-50);--lume-c-button-color-border-active: var(--lume-g-color-indigo-30);--lume-c-button-color-border-focus: var(--lume-g-color-indigo-50);--lume-c-button-color-border-hover: var(--lume-g-color-indigo-40);--lume-c-button-text-color: var(--lume-g-color-neutral-100);--lume-c-button-text-color-active: var(--lume-g-color-neutral-100);--lume-c-button-text-color-focus: var(--lume-g-color-neutral-100);--lume-c-button-text-color-hover: var(--lume-g-color-neutral-100);}" + (useActualHostSelector ? ":host([variant~=\"primary\"][destructive]) {" : hostSelector + "[destructive][variant~=\"primary\"] {") + "--lume-c-button-color-background: var(--lume-g-color-red-40);--lume-c-button-color-background-active: var(--lume-g-color-red-20);--lume-c-button-color-background-focus: var(--lume-g-color-red-40);--lume-c-button-color-background-hover: var(--lume-g-color-red-30);--lume-c-button-color-border: var(--lume-g-color-red-40);--lume-c-button-color-border-active: var(--lume-g-color-red-20);--lume-c-button-color-border-focus: var(--lume-g-color-red-40);--lume-c-button-color-border-hover: var(--lume-g-color-red-30);}" + (useActualHostSelector ? ":host([variant~=\"secondary\"]) {" : hostSelector + "[variant~=\"secondary\"] {") + "--lume-c-button-color-background: var(--lume-g-color-neutral-100);--lume-c-button-color-background-active: var(--lume-g-color-neutral-90);--lume-c-button-color-background-focus: var(--lume-g-color-neutral-100);--lume-c-button-color-background-hover: var(--lume-g-color-neutral-95);--lume-c-button-color-border: var(--lume-g-color-neutral-80);--lume-c-button-color-border-active: var(--lume-g-color-neutral-80);--lume-c-button-color-border-focus: var(--lume-g-color-neutral-80);--lume-c-button-color-border-hover: var(--lume-g-color-neutral-80);--lume-c-button-text-color: var(--lume-g-color-neutral-20);--lume-c-button-text-color-active: var(--lume-g-color-neutral-20);--lume-c-button-text-color-focus: var(--lume-g-color-neutral-20);--lume-c-button-text-color-hover: var(--lume-g-color-neutral-20);}" + (useActualHostSelector ? ":host([variant~=\"secondary\"][destructive]) {" : hostSelector + "[destructive][variant~=\"secondary\"] {") + "--lume-c-button-color-background: var(--lume-g-color-neutral-100);--lume-c-button-color-background-active: var(--lume-g-color-red-90);--lume-c-button-color-background-focus: var(--lume-g-color-neutral-100);--lume-c-button-color-background-hover: var(--lume-g-color-red-95);--lume-c-button-color-border: var(--lume-g-color-red-60);--lume-c-button-color-border-active: var(--lume-g-color-red-30);--lume-c-button-color-border-focus: var(--lume-g-color-red-60);--lume-c-button-color-border-hover: var(--lume-g-color-red-60);--lume-c-button-text-color: var(--lume-g-color-red-40);--lume-c-button-text-color-active: var(--lume-g-color-red-30);--lume-c-button-text-color-focus: var(--lume-g-color-red-40);--lume-c-button-text-color-hover: var(--lume-g-color-red-40);}" + (useActualHostSelector ? ":host([variant~=\"tertiary\"]) {" : hostSelector + "[variant~=\"tertiary\"] {") + "--lume-c-button-color-background: var(--lume-g-color-indigo-95);--lume-c-button-color-background-active: var(--lume-g-color-indigo-80);--lume-c-button-color-background-focus: var(--lume-g-color-indigo-95);--lume-c-button-color-background-hover: var(--lume-g-color-indigo-90);--lume-c-button-color-border: var(--lume-g-color-indigo-95);--lume-c-button-color-border-active: var(--lume-g-color-indigo-80);--lume-c-button-color-border-focus: var(--lume-g-color-indigo-95);--lume-c-button-color-border-hover: var(--lume-g-color-indigo-90);--lume-c-button-text-color: var(--lume-g-color-indigo-40);--lume-c-button-text-color-active: var(--lume-g-color-indigo-30);--lume-c-button-text-color-focus: var(--lume-g-color-indigo-40);--lume-c-button-text-color-hover: var(--lume-g-color-indigo-40);}" + (useActualHostSelector ? ":host([variant~=\"tertiary\"][destructive]) {" : hostSelector + "[destructive][variant~=\"tertiary\"] {") + "--lume-c-button-color-background: var(--lume-g-color-red-95);--lume-c-button-color-background-active: var(--lume-g-color-red-80);--lume-c-button-color-background-focus: var(--lume-g-color-red-95);--lume-c-button-color-background-hover: var(--lume-g-color-red-90);--lume-c-button-color-border: var(--lume-g-color-red-95);--lume-c-button-color-border-active: var(--lume-g-color-red-80);--lume-c-button-color-border-focus: var(--lume-g-color-red-95);--lume-c-button-color-border-hover: var(--lume-g-color-red-90);--lume-c-button-text-color: var(--lume-g-color-red-40);--lume-c-button-text-color-active: var(--lume-g-color-red-30);--lume-c-button-text-color-focus: var(--lume-g-color-red-40);--lume-c-button-text-color-hover: var(--lume-g-color-red-40);}" + (useActualHostSelector ? ":host([variant~=\"minimal\"]) {" : hostSelector + "[variant~=\"minimal\"] {") + "--lume-c-button-color-background: transparent;--lume-c-button-color-background-active: var(--lume-g-color-neutral-90);--lume-c-button-color-background-disabled: transparent;--lume-c-button-color-background-focus: transparent;--lume-c-button-color-background-hover: var(--lume-g-color-neutral-95);--lume-c-button-color-border: transparent;--lume-c-button-color-border-active: var(--lume-g-color-neutral-90);--lume-c-button-color-border-disabled: transparent;--lume-c-button-color-border-focus: transparent;--lume-c-button-color-border-hover: var(--lume-g-color-neutral-95);--lume-c-button-text-color: var(--lume-g-color-neutral-20);--lume-c-button-text-color-active: var(--lume-g-color-neutral-20);--lume-c-button-text-color-disabled: var(--lume-g-color-neutral-65);--lume-c-button-text-color-focus: var(--lume-g-color-neutral-20);--lume-c-button-text-color-hover: var(--lume-g-color-neutral-20);--lume-c-button-text-decoration: underline;}" + (useActualHostSelector ? ":host([variant~=\"minimal\"][destructive]) {" : hostSelector + "[destructive][variant~=\"minimal\"] {") + "--lume-c-button-color-background: transparent;--lume-c-button-color-background-active: var(--lume-g-color-red-90);--lume-c-button-color-background-focus: transparent;--lume-c-button-color-background-hover: var(--lume-g-color-red-95);--lume-c-button-color-border: transparent;--lume-c-button-color-border-active: var(--lume-g-color-red-90);--lume-c-button-color-border-focus: transparent;--lume-c-button-color-border-hover: var(--lume-g-color-red-95);--lume-c-button-text-color: var(--lume-g-color-red-40);--lume-c-button-text-color-active: var(--lume-g-color-red-30);--lume-c-button-text-color-focus: var(--lume-g-color-red-40);--lume-c-button-text-color-hover: var(--lume-g-color-red-40);}";
  /*LWC compiler v6.6.3*/
}
var styles = [stylesheet$b];
function stylesheet$a(token, useActualHostSelector, useNativeDirPseudoclass) {
  var hostSelector = token ? "[" + token + "-host]" : "";
  return (useActualHostSelector ? ":host {" : hostSelector + " {") + "--sds-c-button-spacing-gap: var(--lume-c-button-spacing-gap);--sds-c-button-color-background: var(--lume-c-button-color-background);--sds-c-button-text-color: var(--lume-c-button-text-color);--sds-c-button-font-weight: var(--lume-c-button-font-weight);--sds-c-button-font-lineheight: var(--lume-c-button-font-line-height);--sds-c-button-sizing-height: var(--lume-c-button-sizing-height);--sds-c-button-sizing-width: var(--lume-c-button-sizing-width);--sds-c-button-spacing-inline: var(--lume-c-button-spacing-inline);--sds-c-button-spacing-inlinestart: var(--lume-c-button-spacing-inline-start);--sds-c-button-spacing-inlineend: var(--lume-c-button-spacing-inline-end);--sds-c-button-spacing-block: var(--lume-c-button-spacing-block);--sds-c-button-spacing-blockstart: var(--lume-c-button-spacing-block-start);--sds-c-button-spacing-blockend: var(--lume-c-button-spacing-block-end);--sds-c-button-sizing-border: var(--lume-c-button-sizing-border);--sds-c-button-color-border: var(--lume-c-button-color-border);--sds-c-button-radius-border: var(--lume-c-button-radius-border);--sds-c-button-radius-border-startstart: var(--lume-c-button-radius-border-startstart);--sds-c-button-radius-border-startend: var(--lume-c-button-radius-border-startend);--sds-c-button-radius-border-endstart: var(--lume-c-button-radius-border-endstart);--sds-c-button-radius-border-endend: var(--lume-c-button-radius-border-endend);--sds-c-button-shadow: var(--lume-c-button-shadow);--sds-c-button-font-decoration: var(--lume-c-button-text-decoration);--sds-c-button-text-color-hover: var(--lume-c-button-text-color-hover);--sds-c-button-color-background-hover: var(--lume-c-button-color-background-hover);--sds-c-button-color-border-hover: var(--lume-c-button-color-border-hover);--sds-c-button-color-background-focus: var(--lume-c-button-color-background-focus);--sds-c-button-color-border-focus: var(--lume-c-button-color-border-focus);--sds-c-button-text-color-focus: var(--lume-c-button-text-color-focus);--sds-c-button-shadow-focus: var(--lume-c-button-shadow-focus);--sds-c-button-text-color-active: var(--lume-c-button-text-color-active);--sds-c-button-color-background-active: var(--lume-c-button-color-background-active);--sds-c-button-color-border-active: var(--lume-c-button-color-border-active);--sds-c-button-shadow-active: var(--lume-c-button-shadow-active);--sds-c-button-text-color-disabled: var(--lume-c-button-text-color-disabled);--sds-c-button-color-background-disabled: var(--lume-c-button-color-background-disabled);--sds-c-button-color-border-disabled: var(--lume-c-button-color-border-disabled);--sds-c-button-shadow-disabled: var(--lume-c-button-shadow-disabled);--sds-c-button-text-color-pressed: var(--lume-c-button-text-color-pressed);--sds-c-button-color-background-pressed: var(--lume-c-button-color-background-pressed);--sds-c-button-color-border-pressed: var(--lume-c-button-color-border-pressed);--sds-c-button-shadow-pressed: var(--lume-c-button-shadow-pressed);}";
  /*LWC compiler v6.6.3*/
}
var mappings = [stylesheet$a];
var Button$1 = /*#__PURE__*/function (_LightningElement3) {
  _inherits(Button, _LightningElement3);
  var _super11 = _createSuper(Button);
  function Button() {
    var _this11;
    _classCallCheck(this, Button);
    for (var _len6 = arguments.length, args = new Array(_len6), _key4 = 0; _key4 < _len6; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this11 = _super11.call.apply(_super11, [this].concat(args));
    /**
     * Internal component fields
     */
    _this11._disabled = false;
    _this11._form = void 0;
    _this11._tabIndex = void 0;
    _this11._type = void 0;
    _this11._variant = void 0;
    /**
     * Defines a string value that describes or annotates the current element.
     * Not currently supported by LWC so we implement it manually.
     *
     * @type {string}
     */
    _this11.ariaDescription = void 0;
    /**
     * Optional identifier for the button.
     *
     * @type {string}
     */
    _this11.name = void 0;
    /**
     * Provides semantic meaning to content, allowing screen readers and other
     * tools to present and support interaction with object in a way that is
     * consistent with user expectations of that type of object.
     *
     * @type {string}
     */
    _this11.role = void 0;
    /**
     * Text representing advisory information related to the element it belongs to.
     *
     * @type {string}
     */
    _this11.title = void 0;
    /**
     * Optional value for the button to be submitted with a form.
     *
     * @type {string}
     */
    _this11.value = void 0;
    return _this11;
  }
  /**
   * Makes the element not mutable, interactable, or focusable.
   *
   * @type {boolean}
   * @default false
   */
  _createClass(Button, [{
    key: "disabled",
    get: function get() {
      return this._disabled;
    },
    set: function set(value) {
      this._disabled = normalizeBoolean(value);
      reflectAttribute(this, 'disabled', this._disabled);
    }

    /**
     * The id of the form that the button belongs to.
     *
     * @type {string}
     */
  }, {
    key: "form",
    get: function get() {
      return this._form;
    },
    set: function set(value) {
      this._form = value;
    }
    /**
     * Allows HTML elements to be focusable or prevent them from being
     * sequentially focusable
     *
     * @type {number}
     */
  }, {
    key: "tabIndex",
    get: function get() {
      return this._tabIndex;
    },
    set: function set(value) {
      this._tabIndex = normalizeInput(value);
    }
    /**
     * Specifies the type of button.
     *
     * @type {string}
     */
  }, {
    key: "type",
    get: function get() {
      return this._type;
    },
    set: function set(value) {
      this._type = normalizeString(value, {
        fallbackValue: 'button',
        validValues: ['button', 'reset', 'submit']
      });
    }
    /**
     * Optional interface to define a button variant.
     *
     * @type {string}
     */
  }, {
    key: "variant",
    get: function get() {
      return this._variant;
    },
    set: function set(value) {
      this._variant = value;
      reflectAttribute(this, 'variant', this._variant);
    }

    /**
     * Retrieve the form element that this button belongs to.
     *
     * @return {HTMLElement} - The form element.
     */
  }, {
    key: "getForm",
    value: function getForm() {
      return this._form && this.template.host.closest("#".concat(this._form));
    }

    /**
     * Retrieve the button element.
     * @return {HTMLElement} - The button element.
     */
  }, {
    key: "button",
    get: function get() {
      return this.template.querySelector('button');
    }

    /**
     * Handle the standard click event
     *
     * Workaround for lack of elementInternals support in LWC. Tradeoff is finding
     * the form will fail if the form element lives in a shadow root outside of the
     * shadow boundary that contains this component's host element.
     */
  }, {
    key: "handleClick",
    value: function handleClick() {
      var form = this.getForm();
      if (form) {
        form.requestSubmit();
      }
      if (this.button.hasAttribute('aria-pressed')) {
        if (this.ariaPressed === 'false') {
          this.ariaPressed = 'true';
        } else {
          this.ariaPressed = 'false';
        }
      }
    }

    /**
     * Handle the standard focus event
     */
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setAttribute('focus', '');
    }

    /**
     * Handle the standard blur event
     */
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.removeAttribute('focus');
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Button;
}(LightningElement);
Button$1.shadowSupportMode = 'native';
registerDecorators(Button$1, {
  publicProps: {
    ariaDescription: {
      config: 0
    },
    disabled: {
      config: 3
    },
    form: {
      config: 3
    },
    name: {
      config: 0
    },
    role: {
      config: 0
    },
    tabIndex: {
      config: 3
    },
    title: {
      config: 0
    },
    type: {
      config: 3
    },
    value: {
      config: 0
    },
    variant: {
      config: 3
    }
  },
  fields: ["_disabled", "_form", "_tabIndex", "_type", "_variant"]
});
var SdsButton = registerComponent(Button$1, {
  tmpl: _tmpl$a,
  sel: "sds-button",
  apiVersion: 62
});
var Button = /*#__PURE__*/function (_SdsButton) {
  _inherits(Button, _SdsButton);
  var _super12 = _createSuper(Button);
  function Button() {
    var _this12;
    _classCallCheck(this, Button);
    for (var _len7 = arguments.length, args = new Array(_len7), _key5 = 0; _key5 < _len7; _key5++) {
      args[_key5] = arguments[_key5];
    }
    _this12 = _super12.call.apply(_super12, [this].concat(args));
    /**
     * Available Button sizes.
     */
    _this12.sizes = ["small", "medium", "large"];
    /**
     * Available Button variants.
     */
    _this12.variants = ["primary", "secondary", "tertiary", "minimal"];
    /**
     * Default button properties.
     */
    _this12.defaultProps = {
      size: "medium",
      variant: "secondary"
    };
    return _this12;
  }
  /**
   * Whether the destructive visual style should be enabled.
   *
   * @default false
   */
  _createClass(Button, [{
    key: "destructive",
    get: function get() {
      return this._destructive;
    },
    set: function set(destructive) {
      this._destructive = normalizeBoolean(destructive);
      reflectAttribute(this, "destructive", this._destructive);
    }

    /**
     * Defines the size of the Button.
     *
     * @default "medium"
     */
  }, {
    key: "size",
    get: function get() {
      return this._size;
    },
    set: function set(size) {
      this._size = normalizeString(size, {
        fallbackValue: this.defaultProps.size,
        validValues: this.sizes
      });
      reflectAttribute(this, "size", this._size);
    }

    /**
     * Defines the visual style of the Button.
     *
     * @default "secondary"
     */
  }, {
    key: "variant",
    get: function get() {
      return this._variant;
    },
    set: function set(variant) {
      this._variant = normalizeString(variant, {
        fallbackValue: this.defaultProps.variant,
        validValues: this.variants
      });
      reflectAttribute(this, "variant", this._variant);
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Button;
}(SdsButton); // Inject Styles
Button.stylesheets = [mappings, styles];
registerDecorators(Button, {
  publicProps: {
    destructive: {
      config: 3
    },
    size: {
      config: 3
    },
    variant: {
      config: 3
    }
  },
  fields: ["sizes", "variants", "defaultProps"]
});
var LumeButton = registerComponent(Button, {
  tmpl: _tmpl$a,
  sel: "lume-button",
  apiVersion: 62
});
function stylesheet$9(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  return "*" + shadowSelector + ",*" + shadowSelector + "::before,*" + shadowSelector + "::after {box-sizing: border-box;}@media (prefers-reduced-motion) {transition: none;}[part=\"container\"]" + shadowSelector + " {padding-block: var(--lume-s-container-spacing-block, var(--lume-g-spacing-6));padding-inline: var(--lume-s-container-spacing-inline, var(--lume-g-spacing-6));background-color: var(\n --lume-c-card-color-background,\n var(--lume-s-container-color-background, var(--lume-g-color-neutral-100))\n );border-width: var(\n --lume-c-card-sizing-border,\n var(--lume-s-container-sizing-border, var(--lume-g-sizing-border-1))\n );border-style: var(--lume-s-container-border-style, solid);border-color: var(--lume-c-card-color-border, var(--lume-s-container-color-border, transparent));border-radius: var(\n --lume-c-card-radius-border,\n var(--lume-s-container-radius-border, var(--lume-g-radius-border-2))\n );background-clip: padding-box;color: var(--lume-c-card-text-color, var(--lume-s-container-text-color, var(--lume-g-color-neutral-30)));box-shadow: var(--lume-c-card-shadow);outline: var(--lume-c-card-outline);outline-offset: var(--lume-c-card-outline-offset);}[part=\"header\"]" + shadowSelector + " {font-size: var(--lume-g-font-scale-1);margin-block-end: var(--lume-g-spacing-2);color: var(--lume-g-color-neutral-30);display: flex;align-items: center;}[part=\"header-title\"]" + shadowSelector + " {flex: 1 1 auto;display: flex;}[part=\"header-start\"]" + shadowSelector + " {display: flex;margin-block: 0;margin-inline-start: 0;margin-inline-end: var(--lume-g-spacing-4);padding-block: 0;padding-inline: 0;}[part=\"header-end\"]" + shadowSelector + " {display: flex;margin-block: 0;margin-inline-start: var(--lume-g-spacing-4);margin-inline-end: 0;padding-block: 0;padding-inline: 0;}[part=\"body\"]" + shadowSelector + " {color: var(--lume-g-color-neutral-40);font-size: var(--lume-g-font-scale-neg-2);display: flex;}[part=\"footer\"]" + shadowSelector + " {color: var(--lume-g-color-neutral-40);font-size: var(--lume-g-font-scale-neg-2);margin-block-start: var(--lume-g-spacing-5);display: flex;}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$9 = [stylesheet$9];
var stc0$7 = {
  attrs: {
    "part": "container"
  },
  key: 0
};
var stc1$7 = {
  attrs: {
    "part": "header"
  },
  key: 1
};
var stc2$7 = {
  attrs: {
    "part": "header-start"
  },
  key: 2
};
var stc3$6 = {
  attrs: {
    "name": "header-start"
  },
  key: 3
};
var stc4$4 = [];
var stc5$4 = {
  attrs: {
    "part": "header-title"
  },
  key: 4
};
var stc6$3 = {
  key: 5
};
var stc7$2 = {
  attrs: {
    "part": "header-end"
  },
  key: 6
};
var stc8$2 = {
  attrs: {
    "name": "header-end"
  },
  key: 7
};
var stc9$1 = {
  attrs: {
    "part": "body"
  },
  key: 8
};
var stc10$1 = {
  attrs: {
    "name": "body"
  },
  key: 9
};
var stc11 = {
  attrs: {
    "part": "footer"
  },
  key: 10
};
var stc12 = {
  attrs: {
    "name": "footer"
  },
  key: 11
};
function tmpl$9($api, $cmp, $slotset, $ctx) {
  var api_slot = $api.s,
    api_element = $api.h;
  return [api_element("div", stc0$7, [api_element("div", stc1$7, [api_element("div", stc2$7, [api_slot("header-start", stc3$6, stc4$4, $slotset)]), api_element("div", stc5$4, [api_slot("", stc6$3, stc4$4, $slotset)]), api_element("div", stc7$2, [api_slot("header-end", stc8$2, stc4$4, $slotset)])]), api_element("div", stc9$1, [api_slot("body", stc10$1, stc4$4, $slotset)]), api_element("div", stc11, [api_slot("footer", stc12, stc4$4, $slotset)])])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$9 = registerTemplate(tmpl$9);
tmpl$9.slots = ["", "body", "footer", "header-end", "header-start"];
tmpl$9.stylesheets = [];
if (_implicitStylesheets$9) {
  tmpl$9.stylesheets.push.apply(tmpl$9.stylesheets, _implicitStylesheets$9);
}
tmpl$9.stylesheetToken = "lwc-3lajtdrgn9b";
tmpl$9.legacyStylesheetToken = "lume-card_card";
freezeTemplate(tmpl$9);
var Card = /*#__PURE__*/function (_LightningElement4) {
  _inherits(Card, _LightningElement4);
  var _super13 = _createSuper(Card);
  function Card() {
    _classCallCheck(this, Card);
    return _super13.apply(this, arguments);
  }
  return _createClass(Card);
}(LightningElement);
var LumeCard = registerComponent(Card, {
  tmpl: _tmpl$9,
  sel: "lume-card",
  apiVersion: 62
});
function stylesheet$8(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return "@media (prefers-reduced-motion) {transition: none;}" + (useActualHostSelector ? ":host([disabled]) {" : hostSelector + "[disabled] {") + "cursor: not-allowed;}lume-card" + shadowSelector + "::part(container) {transition-duration: var(--lume-g-kinetics-transition-duration);transition-timing-function: var(--lume-g-kinetics-transition-timing-function);transition-property: background-color, border-radius;--lume-c-card-sizing-border: 0px;}[part~=\"button\"]" + shadowSelector + " {display: inline-flex;border: none;white-space: normal;user-select: none;appearance: none;background: none;cursor: pointer;font-family: var(--lume-g-font-family);padding: 0;margin: 0;text-align: unset;}[part~=\"button\"]:hover" + shadowSelector + " {--lume-c-card-color-background: var(--lume-g-color-neutral-95);--lume-c-card-text-color: var(--lume-g-color-neutral-20);--lume-c-card-shadow: var(--lume-g-shadow-level-2);}[part~=\"button\"]:focus" + shadowSelector + ",[part~=\"button\"]:focus-visible" + shadowSelector + " {outline: 0;--lume-c-card-radius-border: var(--lume-g-radius-border-4);--lume-c-card-outline: var(--lume-g-outline-focus-ring);--lume-c-card-outline-offset: var(--lume-g-outline-offset-focus-ring);--lume-c-card-shadow: var(--lume-g-shadow-focus-ring);}[part~=\"button\"]:active" + shadowSelector + " {--lume-c-card-color-background: var(--lume-g-color-neutral-95);--lume-c-card-text-color: var(--lume-g-color-neutral-20);--lume-c-card-shadow: var(--lume-g-shadow-level-2);}[part~=\"button\"]:disabled" + shadowSelector + " {opacity: var(--lume-g-color-opacity-disabled);pointer-events: none;cursor: not-allowed;}[part~=\"button\"]:disabled" + shadowSelector + " *" + shadowSelector + " {pointer-events: none;}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$8 = [stylesheet$8];
var stc0$6 = {
  key: 1,
  external: true
};
var stc1$6 = {
  slotAssignment: "header-start",
  attrs: {
    "name": "header-start"
  },
  key: 2
};
var stc2$6 = [];
var stc3$5 = {
  key: 3
};
var stc4$3 = {
  slotAssignment: "header-end",
  attrs: {
    "name": "header-end"
  },
  key: 4
};
var stc5$3 = {
  slotAssignment: "body",
  attrs: {
    "name": "body"
  },
  key: 5
};
var stc6$2 = {
  slotAssignment: "footer",
  attrs: {
    "name": "footer"
  },
  key: 6
};
function tmpl$8($api, $cmp, $slotset, $ctx) {
  var api_tab_index = $api.ti,
    api_bind = $api.b,
    api_slot = $api.s,
    api_element = $api.h;
  var _m0 = $ctx._m0,
    _m1 = $ctx._m1,
    _m2 = $ctx._m2;
  return [api_element("button", {
    attrs: {
      "part": "button",
      "disabled": $cmp.disabled ? "" : null,
      "name": $cmp.name,
      "role": $cmp.role,
      "tabindex": api_tab_index($cmp.tabIndex),
      "title": $cmp.title,
      "type": $cmp.type,
      "value": $cmp.value,
      "aria-haspopup": $cmp.ariaHasPopup,
      "aria-expanded": $cmp.ariaExpanded,
      "aria-pressed": $cmp.ariaPressed,
      "aria-current": $cmp.ariaCurrent,
      "aria-description": $cmp.ariaDescription,
      "aria-keyshortcuts": $cmp.ariaKeyShortcuts,
      "aria-roledescription": $cmp.ariaRoleDescription
    },
    key: 0,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClick)),
      "focus": _m1 || ($ctx._m1 = api_bind($cmp.handleFocus)),
      "blur": _m2 || ($ctx._m2 = api_bind($cmp.handleBlur))
    }
  }, [api_element("lume-card", stc0$6, [api_slot("header-start", stc1$6, stc2$6, $slotset), api_slot("", stc3$5, stc2$6, $slotset), api_slot("header-end", stc4$3, stc2$6, $slotset), api_slot("body", stc5$3, stc2$6, $slotset), api_slot("footer", stc6$2, stc2$6, $slotset)])])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$8 = registerTemplate(tmpl$8);
tmpl$8.slots = ["", "body", "footer", "header-end", "header-start"];
tmpl$8.stylesheets = [];
if (_implicitStylesheets$8) {
  tmpl$8.stylesheets.push.apply(tmpl$8.stylesheets, _implicitStylesheets$8);
}
tmpl$8.stylesheetToken = "lwc-5kk4453badl";
tmpl$8.legacyStylesheetToken = "lume-cardButton_cardButton";
freezeTemplate(tmpl$8);

/**
 * A button that displays content like a card.
 * Extends SDS Button to leverage it's API.
 */
var CardButton = /*#__PURE__*/function (_SdsButton2) {
  _inherits(CardButton, _SdsButton2);
  var _super14 = _createSuper(CardButton);
  function CardButton() {
    _classCallCheck(this, CardButton);
    return _super14.apply(this, arguments);
  }
  _createClass(CardButton, [{
    key: "connectedCallback",
    value:
    /**
     * LWC lifecycle callback called when the element is inserted into a document.
     * This hook flows from parent to child.
     * Can’t access child elements because they don’t exist yet.
     */
    function connectedCallback() {
      // Register LumeCard if it's not on the document already.
      if (!customElements.get("lume-card")) {
        customElements.define("lume-card", LumeCard.CustomElementConstructor);
      }
    }
    /*LWC compiler v6.6.3*/
  }]);
  return CardButton;
}(SdsButton); // Delegates the focus from any internal element to the button element
CardButton.delegatesFocus = true;
var cardButton = registerComponent(CardButton, {
  tmpl: _tmpl$8,
  sel: "lume-card-button",
  apiVersion: 62
});
function stylesheet$7(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return "@media (prefers-reduced-motion) {transition: none;}" + (useActualHostSelector ? ":host([disabled]) {" : hostSelector + "[disabled] {") + "cursor: not-allowed;}lume-card" + shadowSelector + "::part(container) {transition-duration: var(--lume-g-kinetics-transition-duration);transition-timing-function: var(--lume-g-kinetics-transition-timing-function);transition-property: background-color, border-radius, box-shadow;--lume-c-card-sizing-border: 0px;}lume-icon" + shadowSelector + " {transition-duration: var(--lume-g-kinetics-transition-duration);transition-timing-function: var(--lume-g-kinetics-transition-timing-function);transition-property: visibility;position: absolute;}input" + shadowSelector + " {position: absolute;width: 100%;height: 100%;margin: 0px;background: transparent;appearance: none;padding: 0px;border: none;z-index: 1;}input:focus-visible" + shadowSelector + " {outline: 0;}lume-icon[symbol=\"check-circle\"]" + shadowSelector + " {color: var(--lume-g-color-indigo-50);}lume-icon[symbol=\"record\"]" + shadowSelector + " {--lume-c-icon-sizing: 1.23em;color: var(--lume-g-color-neutral-50);}[part=\"input\"]:has(:checked)" + shadowSelector + " lume-icon:last-of-type" + shadowSelector + ",lume-icon:first-of-type" + shadowSelector + " {visibility: hidden;}[part=\"input\"]:has(:checked)" + shadowSelector + " lume-icon:first-of-type" + shadowSelector + ",lume-icon:last-of-type" + shadowSelector + " {visibility: visible;}[slot=\"header-end\"]" + shadowSelector + " {display: inline-flex;align-items: center;justify-content: center;width: 1.25rem;}[part=\"input\"]" + shadowSelector + " {display: inline-flex;align-items: center;justify-content: center;position: relative;}[part=\"input\"]:has(:hover)" + shadowSelector + " {--lume-c-card-color-background: var(--lume-g-color-neutral-95);--lume-c-card-text-color: var(--lume-g-color-neutral-20);--lume-c-card-shadow: var(--lume-g-shadow-level-2);}[part=\"input\"]:has(:focus)" + shadowSelector + ",[part=\"input\"]:has(:focus-visible)" + shadowSelector + " {--lume-c-card-radius-border: var(--lume-g-radius-border-4);--lume-c-card-shadow: var(--lume-g-shadow-focus-ring);}[part=\"input\"]:has(:active)" + shadowSelector + " {--lume-c-card-color-background: var(--lume-g-color-neutral-95);--lume-c-card-text-color: var(--lume-g-color-neutral-20);--lume-c-card-shadow: var(--lume-g-shadow-level-2);}[part=\"input\"]:has(:disabled)" + shadowSelector + " {opacity: var(--lume-g-color-opacity-disabled);pointer-events: none;cursor: not-allowed;}[part=\"input\"]:has(:disabled)" + shadowSelector + " *" + shadowSelector + " {pointer-events: none;user-select: none;}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$7 = [stylesheet$7];
var stc0$5 = {
  attrs: {
    "part": "input"
  },
  key: 0
};
var stc1$5 = {
  key: 1,
  external: true
};
var stc2$5 = {
  slotAssignment: "header-start",
  attrs: {
    "name": "header-start"
  },
  key: 2
};
var stc3$4 = [];
var stc4$2 = {
  slotAssignment: "header-end",
  key: 5
};
var stc5$2 = {
  attrs: {
    "set": "utility",
    "symbol": "check-circle",
    "size": "medium"
  },
  key: 6,
  external: true
};
var stc6$1 = {
  attrs: {
    "set": "utility",
    "symbol": "record",
    "size": "medium"
  },
  key: 7,
  external: true
};
var stc7$1 = {
  slotAssignment: "body",
  attrs: {
    "name": "body"
  },
  key: 8
};
var stc8$1 = {
  slotAssignment: "footer",
  attrs: {
    "name": "footer"
  },
  key: 9
};
function tmpl$7($api, $cmp, $slotset, $ctx) {
  var api_slot = $api.s,
    api_scoped_id = $api.gid,
    api_bind = $api.b,
    api_element = $api.h;
  var _m0 = $ctx._m0,
    _m1 = $ctx._m1,
    _m2 = $ctx._m2,
    _m3 = $ctx._m3;
  return [api_element("div", stc0$5, [api_element("lume-card", stc1$5, [api_slot("header-start", stc2$5, stc3$4, $slotset), api_element("label", {
    attrs: {
      "part": "label",
      "for": api_scoped_id($cmp.id)
    },
    key: 3
  }, [api_slot("", {
    key: 4,
    on: {
      "slotchange": _m0 || ($ctx._m0 = api_bind($cmp.handleLabelSlotChange))
    }
  }, stc3$4, $slotset)]), api_element("div", stc4$2, [api_element("lume-icon", stc5$2), api_element("lume-icon", stc6$1)]), api_slot("body", stc7$1, stc3$4, $slotset), api_slot("footer", stc8$1, stc3$4, $slotset)]), api_element("input", {
    attrs: {
      "type": $cmp.type,
      "id": api_scoped_id($cmp.id),
      "disabled": $cmp.disabled ? "" : null,
      "required": $cmp.required ? "" : null,
      "name": $cmp.name,
      "aria-invalid": $cmp.invalid
    },
    props: {
      "value": $cmp.value,
      "checked": $cmp.checked
    },
    key: 10,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleChange)),
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleClick)),
      "blur": _m3 || ($ctx._m3 = api_bind($cmp.handleBlur))
    }
  })])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$7 = registerTemplate(tmpl$7);
tmpl$7.slots = ["", "body", "footer", "header-start"];
tmpl$7.stylesheets = [];
if (_implicitStylesheets$7) {
  tmpl$7.stylesheets.push.apply(tmpl$7.stylesheets, _implicitStylesheets$7);
}
tmpl$7.stylesheetToken = "lwc-5h9rlnuc5sq";
tmpl$7.legacyStylesheetToken = "lume-cardInput_cardInput";
freezeTemplate(tmpl$7);
function stylesheet$6(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return "*" + shadowSelector + ",*" + shadowSelector + "::before,*" + shadowSelector + "::after {box-sizing: border-box;}[part~='input-checkbox']" + shadowSelector + " {display: inline-flex;align-items: center;gap: var(--sds-c-inputcheckbox-spacing-gap, var(--sds-s-input-spacing-gap));}[part='checkbox']" + shadowSelector + " {display: inline-flex;align-items: center;justify-content: center;position: relative;background-color: var(--sds-c-inputcheckbox-color-background, var(--sds-s-input-color-background));box-shadow: var(--sds-c-inputcheckbox-shadow);width: var(--sds-c-inputcheckbox-sizing, 1rem);height: var(--sds-c-inputcheckbox-sizing, 1rem);border: var(--sds-c-inputcheckbox-sizing-border, var(--sds-s-input-sizing-border, 1px)) solid\n var(--sds-c-inputcheckbox-color-border, var(--sds-s-input-color-border, currentColor));border-radius: var(--sds-c-inputcheckbox-radius-border);}[part='checkbox']:has(:focus)" + shadowSelector + " {--sds-c-inputcheckbox-shadow: var(\n --sds-c-inputcheckbox-shadow-focus,\n var(--sds-s-input-shadow-focus, revert)\n );--sds-c-inputcheckbox-color-background: var(\n --sds-c-inputcheckbox-color-background-focus,\n var(--sds-s-input-color-background-focus, revert)\n );--sds-c-inputcheckbox-color-border: var(\n --sds-c-inputcheckbox-color-border-focus,\n var(--sds-s-input-color-border-focus, revert)\n );}[part='checkbox']:has(:checked)" + shadowSelector + " {--sds-c-inputcheckbox-shadow: var(--sds-c-inputcheckbox-shadow-checked, revert);--sds-c-inputcheckbox-color-background: var(--sds-c-inputcheckbox-color-background-checked, revert);--sds-c-inputcheckbox-color-border: var(--sds-c-inputcheckbox-color-border-checked, revert);}[part='checkbox']:has(:indeterminate)" + shadowSelector + " {--sds-c-inputcheckbox-shadow: var(--sds-c-inputcheckbox-shadow-indeterminate, revert);--sds-c-inputcheckbox-color-background: var(--sds-c-inputcheckbox-color-background-indeterminate, revert);--sds-c-inputcheckbox-color-border: var(--sds-c-inputcheckbox-color-border-indeterminate, revert);}[part='mark']" + shadowSelector + " {display: inline-flex;opacity: 0;color: var(--sds-c-inputcheckbox-mark-color-foreground, var(--sds-s-mark-color-foreground));background-color: var(--sds-c-inputcheckbox-mark-color-background, var(--sds-s-mark-color-background));width: var(--sds-c-inputcheckbox-mark-sizing, var(--sds-s-mark-sizing, 1em));height: var(--sds-c-inputcheckbox-mark-sizing, var(--sds-s-mark-sizing, 1em));}[part='checkbox']:has(:checked)" + shadowSelector + " [part='mark']" + shadowSelector + " {opacity: 1;--sds-c-inputcheckbox-mark-color-background: var(\n --sds-c-inputcheckbox-mark-color-background-checked,\n var(--sds-s-mark-color-background-checked, revert)\n );}[part='checkbox']:has(:indeterminate)" + shadowSelector + " [part='mark']" + shadowSelector + " {--sds-c-inputcheckbox-mark-color-foreground: var(\n --sds-c-inputcheckbox-mark-color-foreground-indeterminate,\n revert\n );--sds-c-inputcheckbox-mark-color-background: var(\n --sds-c-inputcheckbox-mark-color-background-indeterminate,\n revert\n );}[part~='label']" + shadowSelector + " {color: var(--sds-c-inputcheckbox-label-color, var(--sds-s-label-color));font-size: var(--sds-c-inputcheckbox-label-font-size, var(--sds-s-label-font-size));}" + (useActualHostSelector ? ":host([label-hidden]) [part~='label']" : hostSelector + "[label-hidden] [part~='label']") + shadowSelector + " {position: absolute !important;margin: -1px !important;border: 0 !important;padding: 0 !important;width: 1px !important;height: 1px !important;overflow: hidden !important;clip: rect(0 0 0 0) !important;text-transform: none !important;white-space: nowrap !important;}[part='help-text visible']" + shadowSelector + " {font-size: var(--sds-c-inputcheckbox-helptext-font-size, var(--sds-s-helptext-font-size));color: var(--sds-c-inputcheckbox-helptext-text-color, var(--sds-s-helptext-color));padding-inline-start: var(\n --sds-c-inputcheckbox-helptext-spacing-inlinestart,\n var(--sds-c-inputcheckbox-helptext-spacing-inline, var(--sds-s-helptext-spacing))\n );padding-inline-end: var(\n --sds-c-inputcheckbox-helptext-spacing-inlineend,\n var(--sds-c-inputcheckbox-helptext-spacing-inline, var(--sds-s-helptext-spacing))\n );padding-block-start: var(\n --sds-c-inputcheckbox-helptext-spacing-blockstart,\n var(--sds-c-inputcheckbox-helptext-spacing-block, var(--sds-s-helptext-spacing))\n );padding-block-end: var(\n --sds-c-inputcheckbox-helptext-spacing-blockend,\n var(--sds-c-inputcheckbox-helptext-spacing-block, var(--sds-s-helptext-spacing))\n );}input[type='checkbox']" + shadowSelector + " {position: absolute;width: 100%;height: 100%;margin: 0;z-index: 1;opacity: 0;}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$6 = [stylesheet$6];
var $fragment1$2 = parseFragment(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" focusable=\"false\"", "><path fill=\"currentColor\" d=\"M19 13H5v-2h14v2z\"", "/></svg>"])), 3, 3);
var $fragment2 = parseFragment(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" focusable=\"false\"", "><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" d=\"M1.73 12.91l6.37 6.37L22.79 4.59\"", "/></svg>"])), 3, 3);
var stc0$4 = {
  attrs: {
    "part": "input-checkbox"
  },
  key: 0
};
var stc1$4 = {
  attrs: {
    "part": "checkbox"
  },
  key: 1
};
var stc2$4 = {
  attrs: {
    "part": "mark"
  },
  key: 3
};
var stc3$3 = {
  attrs: {
    "name": "mark"
  },
  key: 4
};
var stc4$1 = {
  attrs: {
    "part": "label-container"
  },
  key: 10
};
var stc5$1 = {
  attrs: {
    "name": "label-start"
  },
  key: 11
};
var stc6 = [];
var stc7 = {
  key: 13
};
var stc8 = {
  attrs: {
    "name": "label-end"
  },
  key: 14
};
var stc9 = {
  attrs: {
    "part": "help-text"
  },
  key: 15
};
var stc10 = {
  "name": "help-text"
};
function tmpl$6($api, $cmp, $slotset, $ctx) {
  var api_scoped_id = $api.gid,
    api_bind = $api.b,
    api_element = $api.h,
    api_static_fragment = $api.st,
    api_fragment = $api.fr,
    api_slot = $api.s;
  var _m0 = $ctx._m0,
    _m1 = $ctx._m1,
    _m2 = $ctx._m2,
    _m3 = $ctx._m3;
  return [api_element("div", stc0$4, [api_element("div", stc1$4, [api_element("input", {
    attrs: {
      "type": "checkbox",
      "id": api_scoped_id($cmp.id),
      "disabled": $cmp.disabled ? "" : null,
      "required": $cmp.required ? "" : null,
      "name": $cmp.name,
      "aria-invalid": $cmp.invalid
    },
    props: {
      "value": $cmp.value
    },
    key: 2,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleChange)),
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick)),
      "blur": _m2 || ($ctx._m2 = api_bind($cmp.handleBlur))
    }
  }), api_element("div", stc2$4, [api_slot("mark", stc3$3, [$cmp.indeterminate ? api_fragment(5, [api_static_fragment($fragment1$2, 7)], 0) : api_fragment(5, [api_static_fragment($fragment2, 9)], 0)], $slotset)])]), api_element("div", stc4$1, [api_slot("label-start", stc5$1, stc6, $slotset), api_element("label", {
    attrs: {
      "part": "label",
      "for": api_scoped_id($cmp.id)
    },
    key: 12
  }, [api_slot("", stc7, stc6, $slotset)]), api_slot("label-end", stc8, stc6, $slotset)])]), api_element("div", stc9, [api_slot("help-text", {
    attrs: stc10,
    key: 16,
    on: {
      "slotchange": _m3 || ($ctx._m3 = api_bind($cmp.handleHelpTextSlotChange))
    }
  }, stc6, $slotset)])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$6 = registerTemplate(tmpl$6);
tmpl$6.slots = ["", "help-text", "label-end", "label-start", "mark"];
tmpl$6.stylesheets = [];
if (_implicitStylesheets$6) {
  tmpl$6.stylesheets.push.apply(tmpl$6.stylesheets, _implicitStylesheets$6);
}
tmpl$6.stylesheetToken = "lwc-tgf10itbcg";
tmpl$6.legacyStylesheetToken = "sds-inputCheckbox_inputCheckbox";
freezeTemplate(tmpl$6);
var InputCheckbox = /*#__PURE__*/function (_LightningElement5) {
  _inherits(InputCheckbox, _LightningElement5);
  var _super15 = _createSuper(InputCheckbox);
  function InputCheckbox() {
    var _this13;
    _classCallCheck(this, InputCheckbox);
    for (var _len8 = arguments.length, args = new Array(_len8), _key6 = 0; _key6 < _len8; _key6++) {
      args[_key6] = arguments[_key6];
    }
    _this13 = _super15.call.apply(_super15, [this].concat(args));
    _this13._name = 'checkbox-name';
    _this13._value = 'checkbox-value';
    _this13._disabled = false;
    _this13._required = false;
    _this13._invalid = false;
    _this13._indeterminate = false;
    _this13._checked = false;
    _this13._labelHidden = false;
    _this13._validityMessage = void 0;
    /**
     * The id of the inner input checkbox element.
     *
     * @type {string}
     */
    _this13.id = 'checkbox-id';
    return _this13;
  }
  /**
   * Makes the checkbox not mutable, interactable, or focusable.
   *
   * @type {boolean}
   * @default false
   */
  _createClass(InputCheckbox, [{
    key: "disabled",
    get: function get() {
      return this._disabled;
    },
    set: function set(value) {
      this._disabled = normalizeBoolean(value);
      reflectAttribute(this, 'disabled', this._disabled);
    }

    /**
     * Determines if the form control is required or not.
     *
     * @type {boolean}
     * @default false
     */
  }, {
    key: "required",
    get: function get() {
      return this._required;
    },
    set: function set(value) {
      this._required = normalizeBoolean(value);
      reflectAttribute(this, 'required', this._required);
    }

    /**
     * The name of the input element, used on form submit.
     * Name attribute is removed from custom element and delegated to the input element
     *
     * @type {string}
     */
  }, {
    key: "name",
    get: function get() {
      return this._name;
    },
    set: function set(value) {
      this._name = normalizeInput(value);
    }

    /**
     * The value of the input element
     * Value attribute is removed from custom element and delegated to the input element
     *
     * @type {string}
     */
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      this._value = normalizeInput(value);
    }

    /**
     * Method to set the indeterminate state of the checkbox.
     *
     * @returns {void}
     */
  }, {
    key: "setIndeterminate",
    value: function setIndeterminate() {
      this._indeterminate = true;
      this.checkbox.indeterminate = true;
    }

    /**
     * Method to remove the indeterminate state of the checkbox.
     *
     * @returns {void}
     */
  }, {
    key: "removeIndeterminate",
    value: function removeIndeterminate() {
      this._indeterminate = false;
      this.checkbox.indeterminate = false;
    }

    /**
     * Method to get the indeterminate state of the checkbox.
     *
     * @returns {boolean} - true if indeterminate, false if not
     */
  }, {
    key: "indeterminate",
    get: function get() {
      return this._indeterminate;
    },
    set: function set(value) {
      this._indeterminate = normalizeBoolean(value);
      reflectAttribute(this, 'indeterminate', this._indeterminate);
    }

    /**
     * Determines if the checkbox is checked or not.
     *
     * @type {boolean}
     * @default false
     */
  }, {
    key: "checked",
    get: function get() {
      return this._checked;
    },
    set: function set(value) {
      this._checked = normalizeBoolean(value);
      reflectAttribute(this, 'checked', this._checked);
    }

    /**
     * Visually hides the label.
     *
     * @type {boolean}
     */
  }, {
    key: "labelHidden",
    get: function get() {
      return this._labelHidden;
    },
    set: function set(value) {
      this._labelHidden = normalizeBoolean(value);
      reflectAttribute(this, 'label-hidden', this._labelHidden);
    }

    /**
     * Allows customer to set invalid state on input
     * An example would be if the input is required and the value is empty on form submit,
     * since we are not using native form validation, we need to offer the ability set the invalid state on the input
     */
  }, {
    key: "invalid",
    get: function get() {
      return this._invalid;
    },
    set: function set(value) {
      this._invalid = normalizeBoolean(value);
      reflectAttribute(this, 'invalid', this._invalid);
    }

    /**
     * Property to get the checkbox element.
     *
     * @returns {HTMLElement} - the checkbox element
     */
  }, {
    key: "checkbox",
    get: function get() {
      return this.template.querySelector('input[type="checkbox"]');
    }

    /**
     * Property to get the help text element.
     *
     * @returns {HTMLElement} - the help text element
     * @private
     */
  }, {
    key: "helpText",
    get: function get() {
      return this.template.querySelector('[part="help-text"]');
    }

    /**
     * Returns the validity error of the input element
     */
  }, {
    key: "validity",
    get: function get() {
      var _this14 = this;
      return Promise.resolve().then(function () {
        return _this14.checkbox.validity;
      });
    }

    /**
     * Returns the validity error of the input element
     */
  }, {
    key: "validityMessage",
    get: function get() {
      return this._validityMessage;
    }

    /**
     * Returns the closest form element
     * @returns {HTMLElement} - the form element
     * @private
     */
  }, {
    key: "form",
    get: function get() {
      return this.template.host.closest('form');
    }

    /**
     * If invalid, sets the aria-invalid attribute on the input element
     * and sets invalid attribute on custom element
     *
     * @private
     */
  }, {
    key: "isInvalid",
    value: function isInvalid() {
      if (!this.checkbox.validity.valid) {
        this.invalid = true;
      } else {
        this.invalid = false;
      }
    }

    /**
     * Event handler for the checkbox change event.
     * Used to dynmically set the checked attribute on the host element
     *
     * @param {*} e
     */
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      if (this.hasAttribute('checked')) {
        this._checked = false;
        this.removeAttribute('checked');
      } else {
        this._checked = true;
        this.setAttribute('checked', '');
      }
      this.dispatchEvent(new CustomEvent('change'));
      this.isInvalid();
      this.handleValidity();
    }

    /**
     * Event handler for the checkbox click event.
     * Used to dynmically set the focus attribute on the host element
     * @param {*} e
     */
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      this.setAttribute('focus', '');
    }

    /**
     * Event handler for the checkbox blur event.
     * Used to dynmically remove the focus attribute on the host element
     * @param {*} e
     */
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      this.removeAttribute('focus');
    }

    /**
     * Set the validity message based on the validity state of the input element
     */
  }, {
    key: "handleValidity",
    value: function handleValidity() {
      if (this.checkbox.validity.valueMissing) {
        this._validityMessage = "This field is required.";
      } else {
        this._validityMessage = null;
      }
    }

    /**
     * Slot change event on help text slot
     * Used to dynamically add/remove the associated ID to the input element if help text is present
     * Used to dynamically add "visible" part to the help text element if help text is found in the slot
     *
     * @param {*} e - slot change event
     */
  }, {
    key: "handleHelpTextSlotChange",
    value: function handleHelpTextSlotChange(e) {
      var childElements = e.target.assignedElements({
        flatten: true
      });
      if (childElements.length > 0) {
        if (this.helpText) {
          this.helpText.id = 'id-help-text';
          this.checkbox.setAttribute('aria-describedby', 'id-help-text');
          this.helpText.setAttribute('part', 'helptext visible');
        }
      }
    }
  }, {
    key: "renderedCallback",
    value: function renderedCallback() {
      var _this15 = this;
      if (this.form) {
        this.form.addEventListener('submit', function () {
          _this15.handleValidity();
        });
      }
    }
    /*LWC compiler v6.6.3*/
  }]);
  return InputCheckbox;
}(LightningElement);
InputCheckbox.shadowSupportMode = 'native';
registerDecorators(InputCheckbox, {
  publicProps: {
    id: {
      config: 0
    },
    disabled: {
      config: 3
    },
    required: {
      config: 3
    },
    name: {
      config: 3
    },
    value: {
      config: 3
    },
    indeterminate: {
      config: 3
    },
    checked: {
      config: 3
    },
    labelHidden: {
      config: 3
    },
    invalid: {
      config: 3
    },
    validity: {
      config: 1
    },
    validityMessage: {
      config: 1
    }
  },
  publicMethods: ["setIndeterminate", "removeIndeterminate"],
  fields: ["_name", "_value", "_disabled", "_required", "_invalid", "_indeterminate", "_checked", "_labelHidden", "_validityMessage"]
});
var SdsInputCheckbox = registerComponent(InputCheckbox, {
  tmpl: _tmpl$6,
  sel: "sds-input-checkbox",
  apiVersion: 62
});

/**
 * An input that displays content like a card.
 * Extends SDS input checkbox to leverage it's API.
 */
var CardInput = /*#__PURE__*/function (_SdsInputCheckbox) {
  _inherits(CardInput, _SdsInputCheckbox);
  var _super16 = _createSuper(CardInput);
  function CardInput() {
    var _this16;
    _classCallCheck(this, CardInput);
    for (var _len9 = arguments.length, args = new Array(_len9), _key7 = 0; _key7 < _len9; _key7++) {
      args[_key7] = arguments[_key7];
    }
    _this16 = _super16.call.apply(_super16, [this].concat(args));
    /**
     * Available card input types.
     */
    _this16.types = ["checkbox", "radio"];
    /**
     * Default card input properties.
     */
    _this16.defaultProps = {
      type: "checkbox"
    };
    // Set the default type on the component
    _this16._type = _this16.defaultProps.type;
    // Remove default name and value set by SdsInputCheckbox
    _this16._name = null;
    _this16._value = null;
    return _this16;
  }
  /**
   * LWC lifecycle callback called when the element is inserted into a document.
   * This hook flows from parent to child.
   * Can’t access child elements because they don’t exist yet.
   */
  _createClass(CardInput, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // Register LumeCard if it's not on the document already.
      if (!customElements.get("lume-card")) {
        customElements.define("lume-card", LumeCard.CustomElementConstructor);
      }

      // Register LumeIcon if it's not on the document already.
      if (!customElements.get("lume-icon")) {
        window.customElements.define("lume-icon", LumeIcon.CustomElementConstructor);
      }
    }

    /**
     * The type of the input.
     * Currently only supports checkbox and radio.
     *
     * @default checkbox
     */
  }, {
    key: "type",
    get: function get() {
      return this._type;
    },
    set: function set(type) {
      this._type = normalizeString(type, {
        fallbackValue: this.defaultProps.type,
        validValues: this.types
      });
      reflectAttribute(this, "type", this._type);
    }

    /**
     * Property to get the radio element.
     * @returns {HTMLInputElement} - the radio element
     */
  }, {
    key: "radio",
    get: function get() {
      if (!this._cachedRadio) {
        this._cachedRadio = this.template.querySelector('input[type="radio"]');
      }
      return this._cachedRadio;
    }

    /**
     * Returns the validity error of the input element
     */
  }, {
    key: "validity",
    get: function get() {
      var _this17 = this;
      return Promise.resolve().then(function () {
        return _this17._type === "radio" ? _this17.radio.validity : _this17.checkbox.validity;
      });
    }

    /**
     * If invalid, sets the aria-invalid attribute on the input element
     * and sets invalid attribute on custom element
     * @private
     */
  }, {
    key: "isInvalid",
    value: function isInvalid() {
      var valid;
      if (this._type === "radio") {
        valid = this.radio.validity.valid;
      } else {
        valid = this.checkbox.validity.valid;
      }
      if (!valid) {
        this.invalid = true;
      } else {
        this.invalid = false;
      }
    }

    /**
     * Handle slot change event on the label slot
     * Used to check if the label has a slotted value, if not, we throw an error that one must be included
     *
     * @param {*} e - slot change event
     */
  }, {
    key: "handleLabelSlotChange",
    value: function handleLabelSlotChange(e) {
      var slotElement = e.target;
      var slotContent = slotElement.assignedNodes({
        flatten: true
      });
      if (!slotContent.some(function (node) {
        var _node$textContent;
        return ((_node$textContent = node.textContent) === null || _node$textContent === void 0 ? void 0 : _node$textContent.trim()) !== "";
      })) {
        console.error(CardInput.labels.titleRequired);
      }
    }

    /**
     * Store validity message in private variable
     * @private
     */
  }, {
    key: "handleValidity",
    value: function handleValidity() {
      var _this18 = this;
      this.validity.then(function (validity) {
        if (validity.valueMissing) {
          _this18._validityMessage = CardInput.labels.requiredField;
        } else {
          _this18._validityMessage = null;
        }
      });
    }

    /**
     * Event handler for the input change event.
     * Used to dynmically set the checked attribute on the host element.
     * Also used to control the radio selection to desselect other radio buttons with the same name.
     *
     * @param {*} e
     */
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      if (this.hasAttribute("checked")) {
        this._checked = false;
        this.removeAttribute("checked");
      } else {
        this._checked = true;

        // Only desselect another input if it's a radio button AND the component is being used
        // inside a form AND the component has a name.
        if (this.type === "radio" && this.form && this.name) {
          var checkedRadio = this.form.querySelector("".concat(this.tagName, "[checked][name=").concat(this.name, "]"));
          if (checkedRadio) {
            checkedRadio.checked = false;
          }
        }
        this.setAttribute("checked", "");
      }
      this.dispatchEvent(new CustomEvent("change"));
      this.isInvalid();
      this.handleValidity();
    }
    /*LWC compiler v6.6.3*/
  }]);
  return CardInput;
}(SdsInputCheckbox); // Delegates the focus from any internal element to the input element
CardInput.delegatesFocus = true;
/**
 * Labels used for console messages
 */
CardInput.labels = {
  requiredField: "This field is required.",
  titleRequired: "The title attribute must be specified for this element."
};
registerDecorators(CardInput, {
  publicProps: {
    type: {
      config: 3
    },
    validity: {
      config: 1
    }
  },
  fields: ["types", "defaultProps", "_type", "_name", "_value"]
});
var cardInput = registerComponent(CardInput, {
  tmpl: _tmpl$7,
  sel: "lume-card-input",
  apiVersion: 62
});
function stylesheet$5(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  return "[part~=\"container\"]" + shadowSelector + " {background-color: var(\n --lume-c-container-color-background,\n var(--lume-s-container-color-background, var(--lume-g-color-neutral-100))\n );border-color: var(--lume-c-container-color-border, var(--lume-s-container-color-border, transparent));border-radius: var(--lume-c-container-radius-border, var(--lume-s-container-radius-border, 0.5rem));border-style: var(--lume-c-container-border-style, var(--lume-s-container-border-style, solid));border-width: var(--lume-c-container-sizing-border, var(--lume-s-container-sizing-border, 1px));color: var(\n --lume-c-container-text-color,\n var(--lume-s-container-text-color, var(--lume-g-color-neutral-20))\n );padding-block-start: var(\n --lume-c-container-spacing-block-start,\n var(--lume-c-container-spacing-block, var(--lume-s-container-spacing-block, 1rem))\n );padding-block-end: var(\n --lume-c-container-spacing-block-end,\n var(--lume-c-container-spacing-block, var(--lume-s-container-spacing-block, 1rem))\n );padding-inline-start: var(\n --lume-c-container-spacing-inline-start,\n var(--lume-c-container-spacing-inline, var(--lume-s-container-spacing-inline, 1rem))\n );padding-inline-end: var(\n --lume-c-container-spacing-inline-end,\n var(--lume-c-container-spacing-inline, var(--lume-s-container-spacing-inline, 1rem))\n );}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$5 = [stylesheet$5];
var stc0$3 = {
  attrs: {
    "part": "container"
  },
  key: 0
};
var stc1$3 = {
  key: 1
};
var stc2$3 = [];
function tmpl$5($api, $cmp, $slotset, $ctx) {
  var api_slot = $api.s,
    api_element = $api.h;
  return [api_element("div", stc0$3, [api_slot("", stc1$3, stc2$3, $slotset)])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$5 = registerTemplate(tmpl$5);
tmpl$5.slots = [""];
tmpl$5.stylesheets = [];
if (_implicitStylesheets$5) {
  tmpl$5.stylesheets.push.apply(tmpl$5.stylesheets, _implicitStylesheets$5);
}
tmpl$5.stylesheetToken = "lwc-50t7kanjsqq";
tmpl$5.legacyStylesheetToken = "lume-container_container";
freezeTemplate(tmpl$5);
var Container = /*#__PURE__*/function (_LightningElement6) {
  _inherits(Container, _LightningElement6);
  var _super17 = _createSuper(Container);
  function Container() {
    _classCallCheck(this, Container);
    return _super17.apply(this, arguments);
  }
  return _createClass(Container);
}(LightningElement);
var container = registerComponent(Container, {
  tmpl: _tmpl$5,
  sel: "lume-container",
  apiVersion: 62
});
function stylesheet$4(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return (useActualHostSelector ? ":host {" : hostSelector + " {") + "display: flex;}" + (useActualHostSelector ? ":host [part=\"button\"]" : hostSelector + " [part=\"button\"]") + shadowSelector + " {--lume-c-button-spacing-inline: 0;}" + (useActualHostSelector ? ":host([size~=\"small\"]) [part=\"button\"]" : hostSelector + "[size~=\"small\"] [part=\"button\"]") + shadowSelector + " {--lume-c-icon-sizing: 1rem;--lume-c-button-sizing-min-height: 1.75rem;--lume-c-button-sizing-min-width: 1.75rem;}" + (useActualHostSelector ? ":host([size~=\"medium\"]) [part=\"button\"]" : hostSelector + "[size~=\"medium\"] [part=\"button\"]") + shadowSelector + " {--lume-c-icon-sizing: 1.25rem;--lume-c-button-sizing-min-height: 2.25rem;--lume-c-button-sizing-min-width: 2.25rem;}" + (useActualHostSelector ? ":host([size~=\"large\"]) [part=\"button\"]" : hostSelector + "[size~=\"large\"] [part=\"button\"]") + shadowSelector + " {--lume-c-icon-sizing: 1.25rem;--lume-c-button-sizing-min-height: 2.75rem;--lume-c-button-sizing-min-width: 2.75rem;}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$4 = [stylesheet$4];
function tmpl$4($api, $cmp, $slotset, $ctx) {
  var api_element = $api.h;
  return [api_element("lume-button", {
    attrs: {
      "part": "button",
      "name": $cmp.name,
      "role": $cmp.role,
      "title": $cmp.title,
      "type": $cmp.type,
      "value": $cmp.value,
      "tab-index": $cmp.tabIndex,
      "disabled": $cmp.disabled,
      "size": $cmp.size,
      "variant": $cmp.variant,
      "destructive": $cmp.destructive,
      "aria-label": $cmp.ariaLabel,
      "aria-description": $cmp.ariaDescription,
      "aria-roledescription": $cmp.ariaRoleDescription,
      "aria-haspopup": $cmp.ariaHasPopup,
      "aria-expanded": $cmp.ariaExpanded,
      "aria-pressed": $cmp.ariaPressed,
      "aria-current": $cmp.ariaCurrent,
      "aria-keyshortcuts": $cmp.ariaKeyShortcuts
    },
    key: 0,
    external: true
  }, [api_element("lume-icon", {
    attrs: {
      "part": "icon",
      "set": $cmp.iconSet,
      "symbol": $cmp.iconSymbol,
      "variant": $cmp.iconVariant
    },
    key: 1,
    external: true
  })])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$4 = registerTemplate(tmpl$4);
tmpl$4.stylesheets = [];
if (_implicitStylesheets$4) {
  tmpl$4.stylesheets.push.apply(tmpl$4.stylesheets, _implicitStylesheets$4);
}
tmpl$4.stylesheetToken = "lwc-7d25u3n9kig";
tmpl$4.legacyStylesheetToken = "lume-iconButton_iconButton";
freezeTemplate(tmpl$4);
var IconButton = /*#__PURE__*/function (_LightningElement7) {
  _inherits(IconButton, _LightningElement7);
  var _super18 = _createSuper(IconButton);
  function IconButton() {
    var _this19;
    _classCallCheck(this, IconButton);
    for (var _len10 = arguments.length, args = new Array(_len10), _key8 = 0; _key8 < _len10; _key8++) {
      args[_key8] = arguments[_key8];
    }
    _this19 = _super18.call.apply(_super18, [this].concat(args));
    /**
     * The name of the icon set to use when resolving the icon.
     */
    _this19.iconSet = void 0;
    /**
     * The name of the icon to resolve.
     */
    _this19.iconSymbol = void 0;
    /**
     * Defines the variant for the Icon.
     * Currently only applies to icons in the product set.
     */
    _this19.iconVariant = void 0;
    /**
     * Optional identifier for the button.
     */
    _this19.name = void 0;
    /**
     * Provides semantic meaning to content, allowing screen readers and other
     * tools to present and support interaction with object in a way that is
     * consistent with user expectations of that type of object.
     */
    _this19.role = void 0;
    /**
     * Text representing advisory information related to the element it belongs to.
     */
    _this19.title = void 0;
    /**
     * Specifies the type of button.
     */
    _this19.type = void 0;
    /**
     * Optional value for the button to be submitted with a form.
     */
    _this19.value = void 0;
    /**
     * Allows HTML elements to be focusable or prevent them from being
     * sequentially focusable
     */
    _this19.tabIndex = void 0;
    /**
     * Makes the element not mutable, interactable, or focusable.
     */
    _this19.disabled = void 0;
    /**
     * Defines the size of the Button.
     */
    _this19.size = void 0;
    /**
     * Defines the visual style of the Button.
     */
    _this19.variant = void 0;
    /**
     * Whether the destructive visual style should be enabled.
     */
    _this19.destructive = void 0;
    return _this19;
  }
  /**
   * LWC lifecycle callback called when the element is inserted into a document.
   * This hook flows from parent to child.
   * Can’t access child elements because they don’t exist yet.
   */
  _createClass(IconButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // Register LumeButton if it's not on the document already.
      if (!customElements.get("lume-button")) {
        customElements.define("lume-button", LumeButton.CustomElementConstructor);
      }

      // Register LumeIcon if it's not on the document already.
      if (!customElements.get("lume-icon")) {
        window.customElements.define("lume-icon", LumeIcon.CustomElementConstructor);
      }

      // Warn if aria-label is not used
      if (this.ariaLabel === null) {
        console.warn(IconButton.labels.ariaLabelMissing);
      }
    }
    /*LWC compiler v6.6.3*/
  }]);
  return IconButton;
}(LightningElement);
IconButton.labels = {
  ariaLabelMissing: "Consider using the aria-label attribute to provide a label for assistive technology."
};
registerDecorators(IconButton, {
  publicProps: {
    iconSet: {
      config: 0
    },
    iconSymbol: {
      config: 0
    },
    iconVariant: {
      config: 0
    },
    name: {
      config: 0
    },
    role: {
      config: 0
    },
    title: {
      config: 0
    },
    type: {
      config: 0
    },
    value: {
      config: 0
    },
    tabIndex: {
      config: 0
    },
    disabled: {
      config: 0
    },
    size: {
      config: 0
    },
    variant: {
      config: 0
    },
    destructive: {
      config: 0
    }
  }
});
var iconButton = registerComponent(IconButton, {
  tmpl: _tmpl$4,
  sel: "lume-icon-button",
  apiVersion: 62
});
function stylesheet$3(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  return "[part~=\"panel\"]" + shadowSelector + " {box-sizing: border-box;background-color: var(--lume-g-color-neutral-100);border-radius: 0rem;border-right: 1px solid var(--lume-g-color-neutral-80);color: var(--lume-g-color-neutral-20);padding-block-start: var(--lume-c-side-panel-spacing-block-start, var(--lume-g-spacing-6));padding-block-end: var(--lume-c-side-panel-spacing-block-end, var(--lume-g-spacing-6));padding-inline-start: var(--lume-c-side-panel-spacing-inline-start, var(--lume-g-spacing-6));padding-inline-end: var(--lume-c-side-panel-spacing-inline-end, var(--lume-g-spacing-6));width: var(--lume-c-side-panel-sizing-width, 16.875rem);min-width: var(--lume-c-side-panel-sizing-min-width, 16.875rem);height: 100%;display: flex;flex-direction: column;}[part~=\"header\"]" + shadowSelector + " {display: flex;flex-direction: column;}.header-part-spacing" + shadowSelector + " {padding-block-end: var(--lume-c-side-panel-header-spacing-block-end, var(--lume-g-spacing-6));}.product-branding-part-spacing" + shadowSelector + " {padding-block-end: var(--lume-c-side-panel-product-branding-spacing-block-end, var(--lume-g-spacing-6));}[part~=\"product-branding\"]" + shadowSelector + " {--lume-c-icon-spacing-inline-end: var(\n --lume-c-side-panel-product-icon-spacing-inline-end,\n var(--lume-g-spacing-2)\n );}[part~=\"product-branding\"]" + shadowSelector + "::part(link) {display: flex;box-sizing: border-box;width: 100%;padding-block: var(--lume-c-side-panel-product-name-spacing-block, 0.375rem);border-radius: var(--lume-c-side-panel-product-name-radius-border, var(--lume-g-radius-border-2));}[part~=\"product-branding\"]::part(link):hover" + shadowSelector + " {background: var(--lume-g-color-neutral-95);}[part~=\"product-name\"]" + shadowSelector + " {font-family: var(--lume-g-font-family);font-weight: var(--lume-g-font-weight-bold);font-size: var(--lume-c-side-panel-product-name-font-size, var(--lume-g-font-size-base));color: var(--lume-g-color-neutral-20);margin-block: auto;}[part~=\"body\"]" + shadowSelector + " {height: 100%;display: flex;flex-direction: column;flex: 1 1 auto;}[part~=\"product-icon\"]" + shadowSelector + " {--lume-c-icon-sizing: var(--lume-c-side-panel-product-icon-sizing, 1.5rem);}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$3 = [stylesheet$3];
var $fragment1$1 = parseFragment(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<h1 part=\"product-name\"", ">", "</h1>"])), 3, "t1");
var stc0$2 = {
  attrs: {
    "part": "panel"
  },
  key: 0
};
var stc1$2 = {
  "part": "header"
};
var stc2$2 = {
  "name": "header"
};
var stc3$2 = [];
var stc4 = {
  attrs: {
    "part": "body"
  },
  key: 8
};
var stc5 = {
  key: 9
};
function tmpl$3($api, $cmp, $slotset, $ctx) {
  var api_bind = $api.b,
    api_element = $api.h,
    api_dynamic_text = $api.d,
    api_static_part = $api.sp,
    api_static_fragment = $api.st,
    api_fragment = $api.fr,
    api_slot = $api.s;
  var _m0 = $ctx._m0,
    _m1 = $ctx._m1;
  return [api_element("aside", stc0$2, [api_element("div", {
    className: $cmp.headerPartStyles,
    attrs: stc1$2,
    key: 1
  }, [$cmp.state.showProductHeader ? api_fragment(2, [api_element("sds-link", {
    className: $cmp.productBrandingPartStyles,
    attrs: {
      "href": $cmp.state.productLink,
      "label": $cmp.productName,
      "part": "product-branding"
    },
    key: 3,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleProductHeaderClick))
    },
    external: true
  }, [api_element("lume-icon", {
    slotAssignment: "start",
    attrs: {
      "part": "product-icon",
      "set": "product",
      "symbol": $cmp.productIcon,
      "variant": "color"
    },
    key: 4,
    external: true
  }), api_static_fragment($fragment1$1, 6, [api_static_part(1, null, api_dynamic_text($cmp.productName))])])], 0) : null, api_slot("header", {
    attrs: stc2$2,
    key: 7,
    on: {
      "slotchange": _m1 || ($ctx._m1 = api_bind($cmp.handleHeaderSlotChange))
    }
  }, stc3$2, $slotset)]), api_element("div", stc4, [api_slot("", stc5, stc3$2, $slotset)])])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$3 = registerTemplate(tmpl$3);
tmpl$3.slots = ["", "header"];
tmpl$3.stylesheets = [];
if (_implicitStylesheets$3) {
  tmpl$3.stylesheets.push.apply(tmpl$3.stylesheets, _implicitStylesheets$3);
}
tmpl$3.stylesheetToken = "lwc-4b4k26tgb05";
tmpl$3.legacyStylesheetToken = "lume-sidePanel_sidePanel";
freezeTemplate(tmpl$3);
function stylesheet$2(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  return "[part='link']" + shadowSelector + " {color: var(--sds-c-link-color, var(--sds-s-link-color));background-color: var(--sds-c-link-color-background, var(--sds-s-link-color-background));text-decoration: var(--sds-c-link-font-decoration, var(--sds-s-link-font-decoration));box-shadow: var(--sds-c-link-shadow, var(--sds-s-link-shadow));border-block-start: var(\n --sds-c-link-sizing-border-blockstart,\n var(--sds-c-link-sizing-border-block, var(--sds-c-link-sizing-border, var(--sds-s-link-sizing-border)))\n )\n solid\n var(--sds-c-link-color-border-blockstart, var(--sds-c-link-color-border, var(--sds-s-link-color-border)));border-inline-start: var(\n --sds-c-link-sizing-border-inlinestart,\n var(--sds-c-link-sizing-border-inline, var(--sds-c-link-sizing-border, var(--sds-s-link-sizing-border)))\n )\n solid\n var(--sds-c-link-color-border-inlinestart, var(--sds-c-link-color-border, var(--sds-s-link-color-border)));border-inline-end: var(\n --sds-c-link-sizing-border-inlineend,\n var(--sds-c-link-sizing-border-inline, var(--sds-c-link-sizing-border, var(--sds-s-link-sizing-border)))\n solid\n var(--sds-c-link-color-border-inlineend, var(--sds-c-link-color-border, var(--sds-s-link-color-border)))\n );border-block-end: var(\n --sds-c-link-sizing-border-blockend,\n var(--sds-c-link-sizing-border-block, var(--sds-c-link-sizing-border, var(--sds-s-link-sizing-border)))\n )\n solid\n var(--sds-c-link-color-border-blockend, var(--sds-c-link-color-border, var(--sds-s-link-color-border)));font-family: var(--sds-c-link-font-family, var(--sds-s-link-font-family));font-size: var(--sds-c-link-font-size, var(--sds-s-link-font-size));font-weight: var(--sds-c-link-font-weight, var(--sds-s-link-font-weight));cursor: pointer;}[part='link'][aria-disabled='true']" + shadowSelector + " {pointer-events: none;}[part='link']:hover" + shadowSelector + " {--sds-c-link-color: var(--sds-c-link-color-hover, var(--sds-s-link-color-hover, revert));--sds-c-link-color-background: var(\n --sds-c-link-color-background-hover,\n var(--sds-s-link-color-background-hover, revert)\n );--sds-c-link-font-decoration: var(\n --sds-c-link-font-decoration-hover,\n var(--sds-s-link-font-decoration-hover, revert)\n );--sds-c-link-shadow: var(--sds-c-link-shadow-hover, var(--sds-s-link-shadow-hover, revert));--sds-c-link-color-border: var(\n --sds-c-link-color-border-hover,\n var(--sds-s-link-color-border-hover, revert)\n );--sds-c-link-sizing-border: var(\n --sds-c-link-sizing-border-hover,\n var(--sds-s-link-sizing-border-hover, revert)\n );}[part='link']:focus" + shadowSelector + " {--sds-c-link-color: var(--sds-c-link-color-focus, var(--sds-s-link-color-focus, revert));--sds-c-link-color-background: var(\n --sds-c-link-color-background-focus,\n var(--sds-s-link-color-background-focus, revert)\n );--sds-c-link-font-decoration: var(\n --sds-c-link-font-decoration-focus,\n var(--sds-s-link-font-decoration-focus, revert)\n );--sds-c-link-shadow: var(--sds-c-link-shadow-focus, var(--sds-s-link-shadow-focus, revert));--sds-c-link-color-border: var(\n --sds-c-link-color-border-focus,\n var(--sds-s-link-color-border-focus, revert)\n );--sds-c-link-sizing-border: var(\n --sds-c-link-sizing-border-focus,\n var(--sds-s-link-sizing-border-focus, revert)\n );}[part='link']:active" + shadowSelector + " {--sds-c-link-color: var(--sds-c-link-color-active, var(--sds-s-link-color-active, revert));--sds-c-link-color-background: var(\n --sds-c-link-color-background-active,\n var(--sds-s-link-color-background-active, revert)\n );--sds-c-link-font-decoration: var(\n --sds-c-link-font-decoration-active,\n var(--sds-s-link-font-decoration-active, revert)\n );--sds-c-link-shadow: var(--sds-c-link-shadow-active, var(--sds-s-link-shadow-active, revert));--sds-c-link-color-border: var(\n --sds-c-link-color-border-active,\n var(--sds-s-link-color-border-active, revert)\n );--sds-c-link-sizing-border: var(\n --sds-c-link-sizing-border-active,\n var(--sds-s-link-sizing-border-active, revert)\n );}[part='link']:visited" + shadowSelector + " {--sds-c-link-color: var(--sds-c-link-color-visited, var(--sds-s-link-color-visited, revert));--sds-c-link-color-background: var(\n --sds-c-link-color-background-visited,\n var(--sds-s-link-color-background-visited, revert)\n );--sds-c-link-font-decoration: var(\n --sds-c-link-font-decoration-visited,\n var(--sds-s-link-font-decoration-visited, revert)\n );--sds-c-link-shadow: var(--sds-c-link-shadow-visited, var(--sds-s-link-shadow-visited, revert));--sds-c-link-color-border: var(\n --sds-c-link-color-border-visited,\n var(--sds-s-link-color-border-visited, revert)\n );--sds-c-link-sizing-border: var(\n --sds-c-link-sizing-border-visited,\n var(--sds-s-link-sizing-border-visited, revert)\n );}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$2 = [stylesheet$2];
var stc0$1 = {
  attrs: {
    "name": "start"
  },
  key: 1
};
var stc1$1 = [];
var stc2$1 = {
  key: 2
};
var stc3$1 = {
  attrs: {
    "name": "end"
  },
  key: 3
};
function tmpl$2($api, $cmp, $slotset, $ctx) {
  var api_bind = $api.b,
    api_slot = $api.s,
    api_element = $api.h;
  var _m0 = $ctx._m0,
    _m1 = $ctx._m1,
    _m2 = $ctx._m2,
    _m3 = $ctx._m3,
    _m4 = $ctx._m4;
  return [api_element("a", {
    attrs: {
      "part": "link",
      "href": $cmp.href,
      "target": $cmp.target,
      "rel": $cmp.rel,
      "download": $cmp.download,
      "type": $cmp.type,
      "hreflang": $cmp.hreflang,
      "referrerpolicy": $cmp.referrerpolicy,
      "ping": $cmp.ping,
      "aria-disabled": $cmp.ariaDisabled,
      "aria-haspopup": $cmp.ariaHasPopup,
      "aria-expanded": $cmp.ariaExpanded,
      "aria-pressed": $cmp.ariaPressed,
      "aria-current": $cmp.ariaCurrent
    },
    key: 0,
    on: {
      "slotchange": _m0 || ($ctx._m0 = api_bind($cmp.handleSlotChange)),
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleKeyDown)),
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleClick)),
      "blur": _m3 || ($ctx._m3 = api_bind($cmp.handleBlur)),
      "focus": _m4 || ($ctx._m4 = api_bind($cmp.handleFocus))
    }
  }, [api_slot("start", stc0$1, stc1$1, $slotset), api_slot("", stc2$1, stc1$1, $slotset), api_slot("end", stc3$1, stc1$1, $slotset)])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$2 = registerTemplate(tmpl$2);
tmpl$2.slots = ["", "end", "start"];
tmpl$2.stylesheets = [];
if (_implicitStylesheets$2) {
  tmpl$2.stylesheets.push.apply(tmpl$2.stylesheets, _implicitStylesheets$2);
}
tmpl$2.stylesheetToken = "lwc-28e20ud3h09";
tmpl$2.legacyStylesheetToken = "sds-link_link";
freezeTemplate(tmpl$2);
var Link$1 = /*#__PURE__*/function (_LightningElement8) {
  _inherits(Link, _LightningElement8);
  var _super19 = _createSuper(Link);
  function Link() {
    var _this20;
    _classCallCheck(this, Link);
    for (var _len11 = arguments.length, args = new Array(_len11), _key9 = 0; _key9 < _len11; _key9++) {
      args[_key9] = arguments[_key9];
    }
    _this20 = _super19.call.apply(_super19, [this].concat(args));
    _this20._href = '#';
    _this20._ariaDisabled = void 0;
    _this20.target = void 0;
    _this20.rel = void 0;
    _this20.download = void 0;
    _this20.hreflang = void 0;
    _this20.type = void 0;
    _this20.referrerpolicy = void 0;
    _this20.ping = void 0;
    return _this20;
  }
  _createClass(Link, [{
    key: "href",
    get: function get() {
      return this._href;
    },
    set: function set(value) {
      this._href = normalizeInput(value);
    }
  }, {
    key: "disabled",
    get: function get() {
      return this._disabled;
    },
    set: function set(value) {
      this._disabled = normalizeBoolean(value);
      this._ariaDisabled = this._disabled ? 'true' : 'false';
      reflectAttribute(this, 'disabled', this._disabled);
    }
  }, {
    key: "ariaDisabled",
    get: function get() {
      return this._ariaDisabled;
    }
  }, {
    key: "link",
    get: function get() {
      return this.template.querySelector('[part="link"]');
    }
  }, {
    key: "handleSlotChange",
    value: function handleSlotChange(e) {
      var nodes = e.target.assignedElements({
        flatten: true
      });
      nodes.find(function (node) {
        if (node instanceof HTMLAnchorElement || node instanceof HTMLButtonElement) {
          console.error('Anchor element found in slot. Slotted children cannot be interactive elements.');
        }
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (this._href === '#' || this._href === 'javascript:void(0)' || this._disabled) {
        e.preventDefault();
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      this.setAttribute('focus', '');
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      this.removeAttribute('focus');
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        this.link.click();
      }
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Link;
}(LightningElement);
Link$1.shadowSupportMode = 'native';
registerDecorators(Link$1, {
  publicProps: {
    target: {
      config: 0
    },
    rel: {
      config: 0
    },
    download: {
      config: 0
    },
    hreflang: {
      config: 0
    },
    type: {
      config: 0
    },
    referrerpolicy: {
      config: 0
    },
    ping: {
      config: 0
    },
    href: {
      config: 3
    },
    disabled: {
      config: 3
    }
  },
  fields: ["_href", "_ariaDisabled"]
});
var SdsLink = registerComponent(Link$1, {
  tmpl: _tmpl$2,
  sel: "sds-link",
  apiVersion: 62
});
var SidePanel = /*#__PURE__*/function (_LightningElement9) {
  _inherits(SidePanel, _LightningElement9);
  var _super20 = _createSuper(SidePanel);
  function SidePanel() {
    var _this21;
    _classCallCheck(this, SidePanel);
    for (var _len12 = arguments.length, args = new Array(_len12), _key10 = 0; _key10 < _len12; _key10++) {
      args[_key10] = arguments[_key10];
    }
    _this21 = _super20.call.apply(_super20, [this].concat(args));
    /**
     * Internal component fields
     */
    _this21._productName = void 0;
    _this21._productIcon = void 0;
    /**
     * Trackes internal state variables that cause the template to rehydrate
     * if the variable values change.
     */
    _this21.state = {
      headerSlotHasChildren: false,
      showProductHeader: false,
      productLink: "#"
    };
    return _this21;
  }
  /**
   * The name of the product in the header.
   */
  _createClass(SidePanel, [{
    key: "productName",
    get: function get() {
      return this._productName;
    },
    set: function set(value) {
      this._productName = value;
      reflectAttribute(this, "product-name", this._productName);
    }

    /**
     * The name of the product icon to resolve.
     */
  }, {
    key: "productIcon",
    get: function get() {
      return this._productIcon;
    },
    set: function set(value) {
      this._productIcon = value;
      reflectAttribute(this, "product-icon", this._productIcon);
    }

    /**
     * Handles the click event on the product branding.
     */
  }, {
    key: "handleProductHeaderClick",
    value: function handleProductHeaderClick(event) {
      if (this.state.productLink === "#") {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent("branding_click"));
      }
    }

    /**
     * LWC lifecycle callback called when the element is inserted into the DOM.
     * This hook flows from parent to child.
     * Can’t access child elements because they don’t exist yet.
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // Register SdsButton and LumeIcon if it's not on the document already.
      if (!customElements.get("sds-link")) {
        customElements.define("sds-link", SdsLink.CustomElementConstructor);
      }
      if (!customElements.get("lume-icon")) {
        customElements.define("lume-icon", LumeIcon.CustomElementConstructor);
      }

      // Add event listener on document so NavBar can fire this event when the new
      // NavBar is introduced.
      document.addEventListener("togglelumesidepanelheader", this.handleToggleSidePanelHeader.bind(this));

      // Dispatch event to tell NavBar this component has been loaded, in case NavBar
      // was loaded before this component.
      document.dispatchEvent(new CustomEvent("lumesidepanelload"));
    }

    /**
     * LWC lifecycle callback calld when the element is removed from the DOM.
     * This hooks flows from parent to child.
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener("togglelumesidepanelheader", this.handleToggleSidePanelHeader.bind(this));
    }

    /**
     * Handles the slotchange event generated by the header slot.
     *
     * @param {Event} event
     */
  }, {
    key: "handleHeaderSlotChange",
    value: function handleHeaderSlotChange(event) {
      var _slot$assignedNodes;
      var slot = event.target;
      this.state.headerSlotHasChildren = ((_slot$assignedNodes = slot.assignedNodes()) === null || _slot$assignedNodes === void 0 ? void 0 : _slot$assignedNodes.length) > 0;
    }

    /**
     * Computes the CSS classes to be applied to the header part.
     */
  }, {
    key: "headerPartStyles",
    get: function get() {
      return this.state.headerSlotHasChildren || this.state.showProductHeader ? "header-part-spacing" : "";
    }

    /**
     * Computes the CSS classes to be applied to the product branding part.
     */
  }, {
    key: "productBrandingPartStyles",
    get: function get() {
      return this.state.headerSlotHasChildren ? "product-branding-part-spacing" : "";
    }

    /**
     * Updates the showProductHeader state based on the Event details.
     */
  }, {
    key: "handleToggleSidePanelHeader",
    value: function handleToggleSidePanelHeader(event) {
      var _event$detail, _event$detail2;
      this.state.showProductHeader = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.showProductHeader;
      this.state.productLink = ((_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : _event$detail2.productLink) || "#";
    }
    /*LWC compiler v6.6.3*/
  }]);
  return SidePanel;
}(LightningElement);
registerDecorators(SidePanel, {
  publicProps: {
    productName: {
      config: 3
    },
    productIcon: {
      config: 3
    }
  },
  track: {
    state: 1
  },
  fields: ["_productName", "_productIcon"]
});
var sidePanel = registerComponent(SidePanel, {
  tmpl: _tmpl$3,
  sel: "lume-side-panel",
  apiVersion: 62
});
function stylesheet$1(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  var suffixToken = token ? "-" + token : "";
  return "@keyframes spinner" + suffixToken + " {0% {transform: rotate(0deg);}100% {transform: rotate(360deg);}}[part=\"spinner\"]" + shadowSelector + " {display: flex;}[part=\"spinner\"]" + shadowSelector + " svg" + shadowSelector + " {animation: spinner" + suffixToken + " 0.8s infinite linear;}[part=\"label\"]" + shadowSelector + " {font-weight: var(--lume-g-font-weight-semibold);color: var(--lume-g-color-text-primary);}" + (useActualHostSelector ? ":host([size=\"small\"]) [part=\"spinner\"]" : hostSelector + "[size=\"small\"] [part=\"spinner\"]") + shadowSelector + " {width: 1rem;height: 1rem;}" + (useActualHostSelector ? ":host([size=\"small\"]) [part=\"label\"]" : hostSelector + "[size=\"small\"] [part=\"label\"]") + shadowSelector + " {font-size: var(--lume-g-font-scale-neg-1);}" + (useActualHostSelector ? ":host([size=\"medium\"]) [part=\"spinner\"]" : hostSelector + "[size=\"medium\"] [part=\"spinner\"]") + shadowSelector + " {width: 1.25rem;height: 1.25rem;}" + (useActualHostSelector ? ":host([size=\"medium\"]) [part=\"label\"]" : hostSelector + "[size=\"medium\"] [part=\"label\"]") + shadowSelector + " {font-size: var(--lume-g-font-size-base);}" + (useActualHostSelector ? ":host([size=\"large\"]) [part=\"spinner\"]" : hostSelector + "[size=\"large\"] [part=\"spinner\"]") + shadowSelector + " {width: 1.5rem;height: 1.5rem;}" + (useActualHostSelector ? ":host([size=\"large\"]) [part=\"label\"]" : hostSelector + "[size=\"large\"] [part=\"label\"]") + shadowSelector + " {font-size: var(--lume-g-font-size-base);}" + (useActualHostSelector ? ":host([size=\"x-large\"]) [part=\"spinner\"]" : hostSelector + "[size=\"x-large\"] [part=\"spinner\"]") + shadowSelector + " {width: 3rem;height: 3rem;}" + (useActualHostSelector ? ":host([size=\"x-large\"]) [part=\"label\"]" : hostSelector + "[size=\"x-large\"] [part=\"label\"]") + shadowSelector + " {font-size: var(--lume-g-font-scale-1);}" + (useActualHostSelector ? ":host([size=\"xx-large\"]) [part=\"spinner\"]" : hostSelector + "[size=\"xx-large\"] [part=\"spinner\"]") + shadowSelector + " {width: 4rem;height: 4rem;}" + (useActualHostSelector ? ":host([size=\"xx-large\"]) [part=\"label\"]" : hostSelector + "[size=\"xx-large\"] [part=\"label\"]") + shadowSelector + " {font-size: var(--lume-g-font-scale-1);}" + (useActualHostSelector ? ":host([variant=\"color\"]) [part=\"segment\"]" : hostSelector + "[variant=\"color\"] [part=\"segment\"]") + shadowSelector + " {fill: var(--lume-g-color-indigo-50);}" + (useActualHostSelector ? ":host([variant=\"color\"]) [part=\"track\"]" : hostSelector + "[variant=\"color\"] [part=\"track\"]") + shadowSelector + " {fill: var(--lume-g-color-indigo-80);}" + (useActualHostSelector ? ":host([variant=\"neutral\"]) [part=\"segment\"]" : hostSelector + "[variant=\"neutral\"] [part=\"segment\"]") + shadowSelector + " {fill: var(--lume-g-color-neutral-20);}" + (useActualHostSelector ? ":host([variant=\"neutral\"]) [part=\"track\"]" : hostSelector + "[variant=\"neutral\"] [part=\"track\"]") + shadowSelector + " {fill: var(--lume-g-color-neutral-80);}" + (useActualHostSelector ? ":host([variant=\"inverse\"]) [part=\"segment\"]" : hostSelector + "[variant=\"inverse\"] [part=\"segment\"]") + shadowSelector + " {fill: var(--lume-g-color-neutral-100);}" + (useActualHostSelector ? ":host([variant=\"inverse\"]) [part=\"track\"]" : hostSelector + "[variant=\"inverse\"] [part=\"track\"]") + shadowSelector + " {fill: var(--lume-g-color-indigo-60);}" + (useActualHostSelector ? ":host([variant=\"inverse\"]) [part=\"label\"]" : hostSelector + "[variant=\"inverse\"] [part=\"label\"]") + shadowSelector + " {color: var(--lume-g-color-text-inverse);}[part=\"container\"]" + shadowSelector + " {display: flex;align-items: center;justify-content: center;}" + (useActualHostSelector ? ":host([label-position=\"inline-end\"]) [part=\"container\"]" : hostSelector + "[label-position=\"inline-end\"] [part=\"container\"]") + shadowSelector + " {flex-direction: row;}" + (useActualHostSelector ? ":host([label-position=\"inline-end\"]) [part=\"label\"]" : hostSelector + "[label-position=\"inline-end\"] [part=\"label\"]") + shadowSelector + " {margin-inline-start: var(--lume-g-spacing-4);}" + (useActualHostSelector ? ":host([label-position=\"inline-start\"]) [part=\"container\"]" : hostSelector + "[label-position=\"inline-start\"] [part=\"container\"]") + shadowSelector + " {flex-direction: row-reverse;}" + (useActualHostSelector ? ":host([label-position=\"inline-start\"]) [part=\"label\"]" : hostSelector + "[label-position=\"inline-start\"] [part=\"label\"]") + shadowSelector + " {margin-inline-end: var(--lume-g-spacing-4);}" + (useActualHostSelector ? ":host([label-position=\"block-end\"]) [part=\"container\"]" : hostSelector + "[label-position=\"block-end\"] [part=\"container\"]") + shadowSelector + " {flex-direction: column;}" + (useActualHostSelector ? ":host([label-position=\"block-end\"]) [part=\"label\"]" : hostSelector + "[label-position=\"block-end\"] [part=\"label\"]") + shadowSelector + " {margin-block-start: var(--lume-g-spacing-4);}" + (useActualHostSelector ? ":host([label-position=\"block-start\"]) [part=\"container\"]" : hostSelector + "[label-position=\"block-start\"] [part=\"container\"]") + shadowSelector + " {flex-direction: column-reverse;}" + (useActualHostSelector ? ":host([label-position=\"block-start\"]) [part=\"label\"]" : hostSelector + "[label-position=\"block-start\"] [part=\"label\"]") + shadowSelector + " {margin-block-end: var(--lume-g-spacing-4);}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets$1 = [stylesheet$1];
var $fragment1 = parseFragment(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<div part=\"container\"", "><div part=\"spinner\"", "><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"", "><path part=\"track\" d=\"M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z\"", "/><path part=\"segment\" d=\"M11 3a1 1 0 0 1 1-1c5.552 0 10 4.448 10 10a1 1 0 1 1-2 0c0-4.448-3.552-8-8-8a1 1 0 0 1-1-1Z\"", "/></svg></div><span part=\"label\"", ">", "</span></div>"])), 3, 3, 3, 3, 3, 3, "t6");
function tmpl$1($api, $cmp, $slotset, $ctx) {
  var api_dynamic_text = $api.d,
    api_static_part = $api.sp,
    api_static_fragment = $api.st;
  return [api_static_fragment($fragment1, 1, [api_static_part(6, null, api_dynamic_text($cmp.state.label))])];
  /*LWC compiler v6.6.3*/
}
var _tmpl$1 = registerTemplate(tmpl$1);
tmpl$1.stylesheets = [];
if (_implicitStylesheets$1) {
  tmpl$1.stylesheets.push.apply(tmpl$1.stylesheets, _implicitStylesheets$1);
}
tmpl$1.stylesheetToken = "lwc-7hlltnro7vb";
tmpl$1.legacyStylesheetToken = "lume-spinner_spinner";
freezeTemplate(tmpl$1);
function _classPrivateFieldLooseBase$1(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id$1 = 0;
function _classPrivateFieldLooseKey$1(name) {
  return "__private_" + id$1++ + "_" + name;
}
var _size = /*#__PURE__*/_classPrivateFieldLooseKey$1("size");
var _variant$1 = /*#__PURE__*/_classPrivateFieldLooseKey$1("variant");
var _labelPosition = /*#__PURE__*/_classPrivateFieldLooseKey$1("labelPosition");
var Spinner = /*#__PURE__*/function (_LightningElement10) {
  _inherits(Spinner, _LightningElement10);
  var _super21 = _createSuper(Spinner);
  function Spinner() {
    var _this22;
    _classCallCheck(this, Spinner);
    for (var _len13 = arguments.length, args = new Array(_len13), _key11 = 0; _key11 < _len13; _key11++) {
      args[_key11] = arguments[_key11];
    }
    _this22 = _super21.call.apply(_super21, [this].concat(args));
    /**
     * Available Spinner sizes.
     */
    _this22.sizes = ["small", "medium", "large", "x-large", "xx-large"];
    /**
     * Available Spinner variants.
     */
    _this22.variants = ["color", "neutral", "inverse"];
    /**
     * Available Spinner label positions.
     */
    _this22.labelPositions = ["block-start", "inline-end", "block-end", "inline-start"];
    /**
     * Default Spinner properties.
     */
    _this22.defaultProps = {
      size: "medium",
      variant: "color",
      labelPosition: "inline-end"
    };
    Object.defineProperty(_assertThisInitialized(_this22), _size, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this22), _variant$1, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this22), _labelPosition, {
      writable: true,
      value: void 0
    });
    _this22.state = {};
    return _this22;
  }
  /**
   * LWC lifecycle callback called when the element is inserted into the DOM.
   * This hook flows from parent to child.
   * Can’t access child elements because they don’t exist yet.
   */
  _createClass(Spinner, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.size) {
        this.size = this.defaultProps.size;
      }
      if (!this.variant) {
        this.variant = this.defaultProps.variant;
      }
      if (!this.labelPosition) {
        this.labelPosition = this.defaultProps.labelPosition;
      }
      reflectAttribute(this, "role", "status");
    }

    /**
     * Defines the size of the Spinner.
     *
     * @default "medium"
     */
  }, {
    key: "size",
    get: function get() {
      return _classPrivateFieldLooseBase$1(this, _size)[_size];
    },
    set: function set(size) {
      _classPrivateFieldLooseBase$1(this, _size)[_size] = normalizeString(size, {
        fallbackValue: this.defaultProps.size,
        validValues: this.sizes
      });
      reflectAttribute(this, "size", _classPrivateFieldLooseBase$1(this, _size)[_size]);
    }

    /**
     * Defines the visual style of the Spinner.
     *
     * @default "color"
     */
  }, {
    key: "variant",
    get: function get() {
      return _classPrivateFieldLooseBase$1(this, _variant$1)[_variant$1];
    },
    set: function set(variant) {
      _classPrivateFieldLooseBase$1(this, _variant$1)[_variant$1] = normalizeString(variant, {
        fallbackValue: this.defaultProps.variant,
        validValues: this.variants
      });
      reflectAttribute(this, "variant", _classPrivateFieldLooseBase$1(this, _variant$1)[_variant$1]);
    }

    /**
     * Defines the Spinner's label position.
     *
     * @default "block-end"
     */
  }, {
    key: "labelPosition",
    get: function get() {
      return _classPrivateFieldLooseBase$1(this, _labelPosition)[_labelPosition];
    },
    set: function set(position) {
      _classPrivateFieldLooseBase$1(this, _labelPosition)[_labelPosition] = normalizeString(position, {
        fallbackValue: this.defaultProps.labelPosition,
        validValues: this.labelPositions
      });
      reflectAttribute(this, "label-position", _classPrivateFieldLooseBase$1(this, _labelPosition)[_labelPosition]);
    }

    /**
     * Defines the Spinner's label content.
     *
     * @default null
     */
  }, {
    key: "label",
    get: function get() {
      return this.state.label;
    },
    set: function set(label) {
      this.state.label = label;
      reflectAttribute(this, "label", this.state.label);
      if (!this.ariaLabel) {
        reflectAttribute(this, "aria-label", this.state.label);
      }
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Spinner;
}(LightningElement);
registerDecorators(Spinner, {
  publicProps: {
    size: {
      config: 3
    },
    variant: {
      config: 3
    },
    labelPosition: {
      config: 3
    },
    label: {
      config: 3
    }
  },
  track: {
    state: 1
  },
  fields: ["sizes", "variants", "labelPositions", "defaultProps"]
});
var spinner = registerComponent(Spinner, {
  tmpl: _tmpl$1,
  sel: "lume-spinner",
  apiVersion: 62
});
function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? "[" + token + "]" : "";
  var hostSelector = token ? "[" + token + "-host]" : "";
  return "[part~=\"link\"]" + shadowSelector + " {display: inline-flex;align-items: center;cursor: pointer;text-decoration: underline;text-underline-offset: var(--lume-g-spacing-1);}[part~=\"link\"]:focus" + shadowSelector + ",[part~=\"link\"]:focus-visible" + shadowSelector + " {outline: var(--lume-g-outline-focus-ring);outline-offset: var(--lume-g-outline-offset-focus-ring);border-radius: 0.125rem;box-shadow: var(--lume-g-shadow-focus-ring);}" + (useActualHostSelector ? ":host " : hostSelector + " ") + shadowSelector + "::slotted([slot~=\"start\"]) {padding-inline-end: 0.375rem;}" + (useActualHostSelector ? ":host " : hostSelector + " ") + shadowSelector + "::slotted([slot~=\"end\"]) {padding-inline-start: 0.375rem;}" + (useActualHostSelector ? ":host([variant=\"primary\"]) [part=\"link\"]" : hostSelector + "[variant=\"primary\"] [part=\"link\"]") + shadowSelector + " {color: var(--lume-g-color-text-link);}" + (useActualHostSelector ? ":host([variant=\"primary\"]) [part~=\"link\"]:hover" : hostSelector + "[variant=\"primary\"] [part~=\"link\"]:hover") + shadowSelector + " {color: var(--lume-g-color-text-link-hover);}" + (useActualHostSelector ? ":host([variant~=\"secondary\"]) [part=\"link\"]" : hostSelector + "[variant~=\"secondary\"] [part=\"link\"]") + shadowSelector + " {color: var(--lume-g-color-text-tertiary);}" + (useActualHostSelector ? ":host([variant=\"secondary\"]) [part~=\"link\"]:hover" : hostSelector + "[variant=\"secondary\"] [part~=\"link\"]:hover") + shadowSelector + " {color: var(--lume-g-color-text-secondary);}" + (useActualHostSelector ? ":host([decoration=\"underline\"]) [part=\"link\"]" : hostSelector + "[decoration=\"underline\"] [part=\"link\"]") + shadowSelector + " {text-decoration: underline;}" + (useActualHostSelector ? ":host([decoration=\"none\"]) [part=\"link\"]" : hostSelector + "[decoration=\"none\"] [part=\"link\"]") + shadowSelector + " {text-decoration: none;}";
  /*LWC compiler v6.6.3*/
}
var _implicitStylesheets = [stylesheet];
var stc0 = {
  attrs: {
    "name": "start"
  },
  key: 1
};
var stc1 = [];
var stc2 = {
  key: 2
};
var stc3 = {
  attrs: {
    "name": "end"
  },
  key: 3
};
function tmpl($api, $cmp, $slotset, $ctx) {
  var api_slot = $api.s,
    api_element = $api.h;
  return [api_element("a", {
    attrs: {
      "part": "link",
      "href": $cmp.href,
      "target": $cmp.target,
      "decoration": $cmp.decoration
    },
    key: 0
  }, [api_slot("start", stc0, stc1, $slotset), api_slot("", stc2, stc1, $slotset), api_slot("end", stc3, stc1, $slotset)])];
  /*LWC compiler v6.6.3*/
}
var _tmpl = registerTemplate(tmpl);
tmpl.slots = ["", "end", "start"];
tmpl.stylesheets = [];
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
tmpl.stylesheetToken = "lwc-7s72tmqonmv";
tmpl.legacyStylesheetToken = "lume-link_link";
freezeTemplate(tmpl);
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
var _variant = /*#__PURE__*/_classPrivateFieldLooseKey("variant");
var _decoration = /*#__PURE__*/_classPrivateFieldLooseKey("decoration");
var Link = /*#__PURE__*/function (_SdsLink) {
  _inherits(Link, _SdsLink);
  var _super22 = _createSuper(Link);
  function Link() {
    var _this23;
    _classCallCheck(this, Link);
    for (var _len14 = arguments.length, args = new Array(_len14), _key12 = 0; _key12 < _len14; _key12++) {
      args[_key12] = arguments[_key12];
    }
    _this23 = _super22.call.apply(_super22, [this].concat(args));
    /**
     * Available Link variants.
     */
    _this23.variants = ["primary", "secondary"];
    /**
     * Available Link decorations.
     */
    _this23.decorations = ["underline", "none"];
    /**
     * Default Link properties.
     */
    _this23.defaultProps = {
      variant: "primary",
      decoration: "underline"
    };
    Object.defineProperty(_assertThisInitialized(_this23), _variant, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this23), _decoration, {
      writable: true,
      value: void 0
    });
    return _this23;
  }
  /**
   * LWC lifecycle callback called when the element is inserted into the DOM.
   * This hook flows from parent to child.
   * Can’t access child elements because they don’t exist yet.
   */
  _createClass(Link, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.variant) {
        this.variant = this.defaultProps.variant;
      }
      if (!this.decoration) {
        this.decoration = this.defaultProps.decoration;
      }
    }

    /**
     * Defines the visual style of the Link.
     *
     * @default "primary"
     */
  }, {
    key: "variant",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _variant)[_variant];
    },
    set: function set(variant) {
      _classPrivateFieldLooseBase(this, _variant)[_variant] = normalizeString(variant, {
        fallbackValue: this.defaultProps.variant,
        validValues: this.variants
      });
      reflectAttribute(this, "variant", _classPrivateFieldLooseBase(this, _variant)[_variant]);
    }

    /**
     * Defines the decoration.
     *
     * @default "underline"
     */
  }, {
    key: "decoration",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _decoration)[_decoration];
    },
    set: function set(decoration) {
      _classPrivateFieldLooseBase(this, _decoration)[_decoration] = normalizeString(decoration, {
        fallbackValue: this.defaultProps.decoration,
        validValues: this.decorations
      });
      reflectAttribute(this, "decoration", _classPrivateFieldLooseBase(this, _decoration)[_decoration]);
    }
    /*LWC compiler v6.6.3*/
  }]);
  return Link;
}(SdsLink);
registerDecorators(Link, {
  publicProps: {
    variant: {
      config: 3
    },
    decoration: {
      config: 3
    }
  },
  fields: ["variants", "decorations", "defaultProps"]
});
var link = registerComponent(Link, {
  tmpl: _tmpl,
  sel: "lume-link",
  apiVersion: 62
});
exports.Avatar = avatar;
exports.Button = LumeButton;
exports.Card = LumeCard;
exports.CardButton = cardButton;
exports.CardInput = cardInput;
exports.Container = container;
exports.Icon = LumeIcon;
exports.IconButton = iconButton;
exports.Link = link;
exports.SidePanel = sidePanel;
exports.Spinner = spinner;
